function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@asgerb/apparatus_ui"] = t() : e["@asgerb/apparatus_ui"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(i) {
      if (t[i]) return t[i].exports;
      var r = t[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, i) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(i, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 46);
  }([function (e, t, n) {
    (function (t) {
      e.exports = t.$ = n(9);
    }).call(this, n(3));
  }, function (e, t, n) {
    "use strict";

    var i = function () {
      function e(e, t) {
        this.eventTarget = e, this.eventName = t, this.unorderedBindings = new Set();
      }

      return e.prototype.connect = function () {
        this.eventTarget.addEventListener(this.eventName, this, !1);
      }, e.prototype.disconnect = function () {
        this.eventTarget.removeEventListener(this.eventName, this, !1);
      }, e.prototype.bindingConnected = function (e) {
        this.unorderedBindings.add(e);
      }, e.prototype.bindingDisconnected = function (e) {
        this.unorderedBindings["delete"](e);
      }, e.prototype.handleEvent = function (e) {
        for (var t = function (e) {
          if (("immediatePropagationStopped" in e)) return e;
          var t = e.stopImmediatePropagation;
          return Object.assign(e, {
            immediatePropagationStopped: !1,
            stopImmediatePropagation: function stopImmediatePropagation() {
              this.immediatePropagationStopped = !0, t.call(this);
            }
          });
        }(e), n = 0, i = this.bindings; n < i.length; n++) {
          var r = i[n];
          if (t.immediatePropagationStopped) break;
          r.handleEvent(t);
        }
      }, Object.defineProperty(e.prototype, "bindings", {
        get: function get() {
          return Array.from(this.unorderedBindings).sort(function (e, t) {
            var n = e.index,
                i = t.index;
            return n < i ? -1 : n > i ? 1 : 0;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    var r = function () {
      function e(e) {
        this.application = e, this.eventListenerMaps = new Map(), this.started = !1;
      }

      return e.prototype.start = function () {
        this.started || (this.started = !0, this.eventListeners.forEach(function (e) {
          return e.connect();
        }));
      }, e.prototype.stop = function () {
        this.started && (this.started = !1, this.eventListeners.forEach(function (e) {
          return e.disconnect();
        }));
      }, Object.defineProperty(e.prototype, "eventListeners", {
        get: function get() {
          return Array.from(this.eventListenerMaps.values()).reduce(function (e, t) {
            return e.concat(Array.from(t.values()));
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.bindingConnected = function (e) {
        this.fetchEventListenerForBinding(e).bindingConnected(e);
      }, e.prototype.bindingDisconnected = function (e) {
        this.fetchEventListenerForBinding(e).bindingDisconnected(e);
      }, e.prototype.handleError = function (e, t, n) {
        void 0 === n && (n = {}), this.application.handleError(e, "Error " + t, n);
      }, e.prototype.fetchEventListenerForBinding = function (e) {
        var t = e.eventTarget,
            n = e.eventName;
        return this.fetchEventListener(t, n);
      }, e.prototype.fetchEventListener = function (e, t) {
        var n = this.fetchEventListenerMapForEventTarget(e),
            i = n.get(t);
        return i || (i = this.createEventListener(e, t), n.set(t, i)), i;
      }, e.prototype.createEventListener = function (e, t) {
        var n = new i(e, t);
        return this.started && n.connect(), n;
      }, e.prototype.fetchEventListenerMapForEventTarget = function (e) {
        var t = this.eventListenerMaps.get(e);
        return t || (t = new Map(), this.eventListenerMaps.set(e, t)), t;
      }, e;
    }(),
        o = /^((.+?)(@(window|document))?->)?(.+?)(#(.+))?$/;

    var a = function () {
      function e(e, t, n) {
        this.element = e, this.index = t, this.eventTarget = n.eventTarget || e, this.eventName = n.eventName || function (e) {
          var t = e.tagName.toLowerCase();
          if (t in s) return s[t](e);
        }(e) || l("missing event name"), this.identifier = n.identifier || l("missing identifier"), this.methodName = n.methodName || l("missing method name");
      }

      return e.forToken = function (e) {
        return new this(e.element, e.index, (t = e.content, n = t.trim().match(o) || [], {
          eventTarget: (i = n[4], "window" == i ? window : "document" == i ? document : void 0),
          eventName: n[2],
          identifier: n[5],
          methodName: n[7]
        }));
        var t, n, i;
      }, e.prototype.toString = function () {
        var e = this.eventTargetName ? "@" + this.eventTargetName : "";
        return "" + this.eventName + e + "->" + this.identifier + "#" + this.methodName;
      }, Object.defineProperty(e.prototype, "eventTargetName", {
        get: function get() {
          return (e = this.eventTarget) == window ? "window" : e == document ? "document" : void 0;
          var e;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        s = {
      a: function a(e) {
        return "click";
      },
      button: function button(e) {
        return "click";
      },
      form: function form(e) {
        return "submit";
      },
      input: function input(e) {
        return "submit" == e.getAttribute("type") ? "click" : "change";
      },
      select: function select(e) {
        return "change";
      },
      textarea: function textarea(e) {
        return "change";
      }
    };

    function l(e) {
      throw new Error(e);
    }

    var c = function () {
      function e(e, t) {
        this.context = e, this.action = t;
      }

      return Object.defineProperty(e.prototype, "index", {
        get: function get() {
          return this.action.index;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "eventTarget", {
        get: function get() {
          return this.action.eventTarget;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.context.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.handleEvent = function (e) {
        this.willBeInvokedByEvent(e) && this.invokeWithEvent(e);
      }, Object.defineProperty(e.prototype, "eventName", {
        get: function get() {
          return this.action.eventName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "method", {
        get: function get() {
          var e = this.controller[this.methodName];
          if ("function" == typeof e) return e;
          throw new Error('Action "' + this.action + '" references undefined method "' + this.methodName + '"');
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.invokeWithEvent = function (e) {
        try {
          this.method.call(this.controller, e);
        } catch (n) {
          var t = {
            identifier: this.identifier,
            controller: this.controller,
            element: this.element,
            index: this.index,
            event: e
          };
          this.context.handleError(n, 'invoking action "' + this.action + '"', t);
        }
      }, e.prototype.willBeInvokedByEvent = function (e) {
        var t = e.target;
        return this.element === t || !(t instanceof Element && this.element.contains(t)) || this.scope.containsElement(t);
      }, Object.defineProperty(e.prototype, "controller", {
        get: function get() {
          return this.context.controller;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "methodName", {
        get: function get() {
          return this.action.methodName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "scope", {
        get: function get() {
          return this.context.scope;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        u = function () {
      function e(e, t) {
        var n = this;
        this.element = e, this.started = !1, this.delegate = t, this.elements = new Set(), this.mutationObserver = new MutationObserver(function (e) {
          return n.processMutations(e);
        });
      }

      return e.prototype.start = function () {
        this.started || (this.started = !0, this.mutationObserver.observe(this.element, {
          attributes: !0,
          childList: !0,
          subtree: !0
        }), this.refresh());
      }, e.prototype.stop = function () {
        this.started && (this.mutationObserver.takeRecords(), this.mutationObserver.disconnect(), this.started = !1);
      }, e.prototype.refresh = function () {
        if (this.started) {
          for (var e = new Set(this.matchElementsInTree()), t = 0, n = Array.from(this.elements); t < n.length; t++) {
            var i = n[t];
            e.has(i) || this.removeElement(i);
          }

          for (var r = 0, o = Array.from(e); r < o.length; r++) {
            i = o[r];
            this.addElement(i);
          }
        }
      }, e.prototype.processMutations = function (e) {
        if (this.started) for (var t = 0, n = e; t < n.length; t++) {
          var i = n[t];
          this.processMutation(i);
        }
      }, e.prototype.processMutation = function (e) {
        "attributes" == e.type ? this.processAttributeChange(e.target, e.attributeName) : "childList" == e.type && (this.processRemovedNodes(e.removedNodes), this.processAddedNodes(e.addedNodes));
      }, e.prototype.processAttributeChange = function (e, t) {
        var n = e;
        this.elements.has(n) ? this.delegate.elementAttributeChanged && this.matchElement(n) ? this.delegate.elementAttributeChanged(n, t) : this.removeElement(n) : this.matchElement(n) && this.addElement(n);
      }, e.prototype.processRemovedNodes = function (e) {
        for (var t = 0, n = Array.from(e); t < n.length; t++) {
          var i = n[t],
              r = this.elementFromNode(i);
          r && this.processTree(r, this.removeElement);
        }
      }, e.prototype.processAddedNodes = function (e) {
        for (var t = 0, n = Array.from(e); t < n.length; t++) {
          var i = n[t],
              r = this.elementFromNode(i);
          r && this.elementIsActive(r) && this.processTree(r, this.addElement);
        }
      }, e.prototype.matchElement = function (e) {
        return this.delegate.matchElement(e);
      }, e.prototype.matchElementsInTree = function (e) {
        return void 0 === e && (e = this.element), this.delegate.matchElementsInTree(e);
      }, e.prototype.processTree = function (e, t) {
        for (var n = 0, i = this.matchElementsInTree(e); n < i.length; n++) {
          var r = i[n];
          t.call(this, r);
        }
      }, e.prototype.elementFromNode = function (e) {
        if (e.nodeType == Node.ELEMENT_NODE) return e;
      }, e.prototype.elementIsActive = function (e) {
        return e.isConnected == this.element.isConnected && this.element.contains(e);
      }, e.prototype.addElement = function (e) {
        this.elements.has(e) || this.elementIsActive(e) && (this.elements.add(e), this.delegate.elementMatched && this.delegate.elementMatched(e));
      }, e.prototype.removeElement = function (e) {
        this.elements.has(e) && (this.elements["delete"](e), this.delegate.elementUnmatched && this.delegate.elementUnmatched(e));
      }, e;
    }(),
        d = function () {
      function e(e, t, n) {
        this.attributeName = t, this.delegate = n, this.elementObserver = new u(e, this);
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.elementObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "selector", {
        get: function get() {
          return "[" + this.attributeName + "]";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.elementObserver.start();
      }, e.prototype.stop = function () {
        this.elementObserver.stop();
      }, e.prototype.refresh = function () {
        this.elementObserver.refresh();
      }, Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.elementObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.matchElement = function (e) {
        return e.hasAttribute(this.attributeName);
      }, e.prototype.matchElementsInTree = function (e) {
        var t = this.matchElement(e) ? [e] : [],
            n = Array.from(e.querySelectorAll(this.selector));
        return t.concat(n);
      }, e.prototype.elementMatched = function (e) {
        this.delegate.elementMatchedAttribute && this.delegate.elementMatchedAttribute(e, this.attributeName);
      }, e.prototype.elementUnmatched = function (e) {
        this.delegate.elementUnmatchedAttribute && this.delegate.elementUnmatchedAttribute(e, this.attributeName);
      }, e.prototype.elementAttributeChanged = function (e, t) {
        this.delegate.elementAttributeValueChanged && this.attributeName == t && this.delegate.elementAttributeValueChanged(e, t);
      }, e;
    }();

    function p(e, t, n) {
      f(e, t).add(n);
    }

    function h(e, t, n) {
      f(e, t)["delete"](n), function (e, t) {
        var n = e.get(t);
        null != n && 0 == n.size && e["delete"](t);
      }(e, t);
    }

    function f(e, t) {
      var n = e.get(t);
      return n || (n = new Set(), e.set(t, n)), n;
    }

    var m,
        g = function () {
      function e() {
        this.valuesByKey = new Map();
      }

      return Object.defineProperty(e.prototype, "values", {
        get: function get() {
          return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
            return e.concat(Array.from(t));
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
            return e + t.size;
          }, 0);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.add = function (e, t) {
        p(this.valuesByKey, e, t);
      }, e.prototype["delete"] = function (e, t) {
        h(this.valuesByKey, e, t);
      }, e.prototype.has = function (e, t) {
        var n = this.valuesByKey.get(e);
        return null != n && n.has(t);
      }, e.prototype.hasKey = function (e) {
        return this.valuesByKey.has(e);
      }, e.prototype.hasValue = function (e) {
        return Array.from(this.valuesByKey.values()).some(function (t) {
          return t.has(e);
        });
      }, e.prototype.getValuesForKey = function (e) {
        var t = this.valuesByKey.get(e);
        return t ? Array.from(t) : [];
      }, e.prototype.getKeysForValue = function (e) {
        return Array.from(this.valuesByKey).filter(function (t) {
          t[0];
          return t[1].has(e);
        }).map(function (e) {
          var t = e[0];
          e[1];
          return t;
        });
      }, e;
    }(),
        v = (m = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      m(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        b = (function (e) {
      function t() {
        var t = e.call(this) || this;
        return t.keysByValue = new Map(), t;
      }

      v(t, e), Object.defineProperty(t.prototype, "values", {
        get: function get() {
          return Array.from(this.keysByValue.keys());
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.add = function (t, n) {
        e.prototype.add.call(this, t, n), p(this.keysByValue, n, t);
      }, t.prototype["delete"] = function (t, n) {
        e.prototype["delete"].call(this, t, n), h(this.keysByValue, n, t);
      }, t.prototype.hasValue = function (e) {
        return this.keysByValue.has(e);
      }, t.prototype.getKeysForValue = function (e) {
        var t = this.keysByValue.get(e);
        return t ? Array.from(t) : [];
      };
    }(g), function () {
      function e(e, t, n) {
        this.attributeObserver = new d(e, t, this), this.delegate = n, this.tokensByElement = new g();
      }

      return Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.attributeObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.attributeObserver.start();
      }, e.prototype.stop = function () {
        this.attributeObserver.stop();
      }, e.prototype.refresh = function () {
        this.attributeObserver.refresh();
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.attributeObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributeName", {
        get: function get() {
          return this.attributeObserver.attributeName;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.elementMatchedAttribute = function (e) {
        this.tokensMatched(this.readTokensForElement(e));
      }, e.prototype.elementAttributeValueChanged = function (e) {
        var t = this.refreshTokensForElement(e),
            n = t[0],
            i = t[1];
        this.tokensUnmatched(n), this.tokensMatched(i);
      }, e.prototype.elementUnmatchedAttribute = function (e) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(e));
      }, e.prototype.tokensMatched = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.tokenMatched(e);
        });
      }, e.prototype.tokensUnmatched = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.tokenUnmatched(e);
        });
      }, e.prototype.tokenMatched = function (e) {
        this.delegate.tokenMatched(e), this.tokensByElement.add(e.element, e);
      }, e.prototype.tokenUnmatched = function (e) {
        this.delegate.tokenUnmatched(e), this.tokensByElement["delete"](e.element, e);
      }, e.prototype.refreshTokensForElement = function (e) {
        var t,
            n,
            i,
            r = this.tokensByElement.getValuesForKey(e),
            o = this.readTokensForElement(e),
            a = (t = r, n = o, i = Math.max(t.length, n.length), Array.from({
          length: i
        }, function (e, i) {
          return [t[i], n[i]];
        })).findIndex(function (e) {
          return !function (e, t) {
            return e && t && e.index == t.index && e.content == t.content;
          }(e[0], e[1]);
        });
        return -1 == a ? [[], []] : [r.slice(a), o.slice(a)];
      }, e.prototype.readTokensForElement = function (e) {
        var t = this.attributeName;
        return function (e, t, n) {
          return e.trim().split(/\s+/).filter(function (e) {
            return e.length;
          }).map(function (e, i) {
            return {
              element: t,
              attributeName: n,
              content: e,
              index: i
            };
          });
        }(e.getAttribute(t) || "", e, t);
      }, e;
    }());

    var y = function () {
      function e(e, t, n) {
        this.tokenListObserver = new b(e, t, this), this.delegate = n, this.parseResultsByToken = new WeakMap(), this.valuesByTokenByElement = new WeakMap();
      }

      return Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.tokenListObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.tokenListObserver.start();
      }, e.prototype.stop = function () {
        this.tokenListObserver.stop();
      }, e.prototype.refresh = function () {
        this.tokenListObserver.refresh();
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.tokenListObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributeName", {
        get: function get() {
          return this.tokenListObserver.attributeName;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.tokenMatched = function (e) {
        var t = e.element,
            n = this.fetchParseResultForToken(e).value;
        n && (this.fetchValuesByTokenForElement(t).set(e, n), this.delegate.elementMatchedValue(t, n));
      }, e.prototype.tokenUnmatched = function (e) {
        var t = e.element,
            n = this.fetchParseResultForToken(e).value;
        n && (this.fetchValuesByTokenForElement(t)["delete"](e), this.delegate.elementUnmatchedValue(t, n));
      }, e.prototype.fetchParseResultForToken = function (e) {
        var t = this.parseResultsByToken.get(e);
        return t || (t = this.parseToken(e), this.parseResultsByToken.set(e, t)), t;
      }, e.prototype.fetchValuesByTokenForElement = function (e) {
        var t = this.valuesByTokenByElement.get(e);
        return t || (t = new Map(), this.valuesByTokenByElement.set(e, t)), t;
      }, e.prototype.parseToken = function (e) {
        try {
          return {
            value: this.delegate.parseValueForToken(e)
          };
        } catch (e) {
          return {
            error: e
          };
        }
      }, e;
    }(),
        _ = function () {
      function e(e, t) {
        this.context = e, this.delegate = t, this.bindingsByAction = new Map();
      }

      return e.prototype.start = function () {
        this.valueListObserver || (this.valueListObserver = new y(this.element, this.actionAttribute, this), this.valueListObserver.start());
      }, e.prototype.stop = function () {
        this.valueListObserver && (this.valueListObserver.stop(), delete this.valueListObserver, this.disconnectAllActions());
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.context.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.context.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "actionAttribute", {
        get: function get() {
          return this.schema.actionAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.context.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "bindings", {
        get: function get() {
          return Array.from(this.bindingsByAction.values());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.connectAction = function (e) {
        var t = new c(this.context, e);
        this.bindingsByAction.set(e, t), this.delegate.bindingConnected(t);
      }, e.prototype.disconnectAction = function (e) {
        var t = this.bindingsByAction.get(e);
        t && (this.bindingsByAction["delete"](e), this.delegate.bindingDisconnected(t));
      }, e.prototype.disconnectAllActions = function () {
        var e = this;
        this.bindings.forEach(function (t) {
          return e.delegate.bindingDisconnected(t);
        }), this.bindingsByAction.clear();
      }, e.prototype.parseValueForToken = function (e) {
        var t = a.forToken(e);
        if (t.identifier == this.identifier) return t;
      }, e.prototype.elementMatchedValue = function (e, t) {
        this.connectAction(t);
      }, e.prototype.elementUnmatchedValue = function (e, t) {
        this.disconnectAction(t);
      }, e;
    }(),
        w = function () {
      function e(e, t) {
        this.module = e, this.scope = t, this.controller = new e.controllerConstructor(this), this.bindingObserver = new _(this, this.dispatcher);

        try {
          this.controller.initialize();
        } catch (e) {
          this.handleError(e, "initializing controller");
        }
      }

      return e.prototype.connect = function () {
        this.bindingObserver.start();

        try {
          this.controller.connect();
        } catch (e) {
          this.handleError(e, "connecting controller");
        }
      }, e.prototype.disconnect = function () {
        try {
          this.controller.disconnect();
        } catch (e) {
          this.handleError(e, "disconnecting controller");
        }

        this.bindingObserver.stop();
      }, Object.defineProperty(e.prototype, "application", {
        get: function get() {
          return this.module.application;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.module.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.application.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dispatcher", {
        get: function get() {
          return this.application.dispatcher;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "parentElement", {
        get: function get() {
          return this.element.parentElement;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.handleError = function (e, t, n) {
        void 0 === n && (n = {});
        var i = this.identifier,
            r = this.controller,
            o = this.element;
        n = Object.assign({
          identifier: i,
          controller: r,
          element: o
        }, n), this.application.handleError(e, "Error " + t, n);
      }, e;
    }(),
        x = function () {
      var e = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      };

      return function (t, n) {
        function i() {
          this.constructor = t;
        }

        e(t, n), t.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
      };
    }();

    var C = function () {
      function e(e) {
        function t() {
          var n = this && this instanceof t ? this.constructor : void 0;
          return Reflect.construct(e, arguments, n);
        }

        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t
          }
        }), Reflect.setPrototypeOf(t, e), t;
      }

      try {
        return (t = e(function () {
          this.a.call(this);
        })).prototype.a = function () {}, new t(), e;
      } catch (e) {
        return function (e) {
          return function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return x(t, e), t;
          }(e);
        };
      }

      var t;
    }(),
        S = function () {
      function e(e, t) {
        this.application = e, this.definition = function (e) {
          return {
            identifier: e.identifier,
            controllerConstructor: (t = e.controllerConstructor, n = C(t), n.bless(), n)
          };
          var t, n;
        }(t), this.contextsByScope = new WeakMap(), this.connectedContexts = new Set();
      }

      return Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.definition.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "controllerConstructor", {
        get: function get() {
          return this.definition.controllerConstructor;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "contexts", {
        get: function get() {
          return Array.from(this.connectedContexts);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.connectContextForScope = function (e) {
        var t = this.fetchContextForScope(e);
        this.connectedContexts.add(t), t.connect();
      }, e.prototype.disconnectContextForScope = function (e) {
        var t = this.contextsByScope.get(e);
        t && (this.connectedContexts["delete"](t), t.disconnect());
      }, e.prototype.fetchContextForScope = function (e) {
        var t = this.contextsByScope.get(e);
        return t || (t = new w(this, e), this.contextsByScope.set(e, t)), t;
      }, e;
    }(),
        D = function () {
      function e(e) {
        this.scope = e;
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function (e) {
        return e = this.getFormattedKey(e), this.element.getAttribute(e);
      }, e.prototype.set = function (e, t) {
        return e = this.getFormattedKey(e), this.element.setAttribute(e, t), this.get(e);
      }, e.prototype.has = function (e) {
        return e = this.getFormattedKey(e), this.element.hasAttribute(e);
      }, e.prototype["delete"] = function (e) {
        return !!this.has(e) && (e = this.getFormattedKey(e), this.element.removeAttribute(e), !0);
      }, e.prototype.getFormattedKey = function (e) {
        return "data-" + this.identifier + "-" + e.replace(/([A-Z])/g, function (e, t) {
          return "-" + t.toLowerCase();
        });
      }, e;
    }();

    function E(e, t) {
      return "[" + e + '~="' + t + '"]';
    }

    var k = function () {
      function e(e) {
        this.scope = e;
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.scope.schema;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.has = function (e) {
        return null != this.find(e);
      }, e.prototype.find = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = this.getSelectorForTargetNames(e);
        return this.scope.findElement(n);
      }, e.prototype.findAll = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = this.getSelectorForTargetNames(e);
        return this.scope.findAllElements(n);
      }, e.prototype.getSelectorForTargetNames = function (e) {
        var t = this;
        return e.map(function (e) {
          return t.getSelectorForTargetName(e);
        }).join(", ");
      }, e.prototype.getSelectorForTargetName = function (e) {
        var t = this.identifier + "." + e;
        return E(this.schema.targetAttribute, t);
      }, e;
    }(),
        T = function () {
      function e(e, t, n) {
        this.schema = e, this.identifier = t, this.element = n, this.targets = new k(this), this.data = new D(this);
      }

      return e.prototype.findElement = function (e) {
        return this.findAllElements(e)[0];
      }, e.prototype.findAllElements = function (e) {
        var t = this.element.matches(e) ? [this.element] : [],
            n = this.filterElements(Array.from(this.element.querySelectorAll(e)));
        return t.concat(n);
      }, e.prototype.filterElements = function (e) {
        var t = this;
        return e.filter(function (e) {
          return t.containsElement(e);
        });
      }, e.prototype.containsElement = function (e) {
        return e.closest(this.controllerSelector) === this.element;
      }, Object.defineProperty(e.prototype, "controllerSelector", {
        get: function get() {
          return E(this.schema.controllerAttribute, this.identifier);
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        O = function () {
      function e(e, t, n) {
        this.element = e, this.schema = t, this.delegate = n, this.valueListObserver = new y(this.element, this.controllerAttribute, this), this.scopesByIdentifierByElement = new WeakMap(), this.scopeReferenceCounts = new WeakMap();
      }

      return e.prototype.start = function () {
        this.valueListObserver.start();
      }, e.prototype.stop = function () {
        this.valueListObserver.stop();
      }, Object.defineProperty(e.prototype, "controllerAttribute", {
        get: function get() {
          return this.schema.controllerAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.parseValueForToken = function (e) {
        var t = e.element,
            n = e.content,
            i = this.fetchScopesByIdentifierForElement(t),
            r = i.get(n);
        return r || (r = new T(this.schema, n, t), i.set(n, r)), r;
      }, e.prototype.elementMatchedValue = function (e, t) {
        var n = (this.scopeReferenceCounts.get(t) || 0) + 1;
        this.scopeReferenceCounts.set(t, n), 1 == n && this.delegate.scopeConnected(t);
      }, e.prototype.elementUnmatchedValue = function (e, t) {
        var n = this.scopeReferenceCounts.get(t);
        n && (this.scopeReferenceCounts.set(t, n - 1), 1 == n && this.delegate.scopeDisconnected(t));
      }, e.prototype.fetchScopesByIdentifierForElement = function (e) {
        var t = this.scopesByIdentifierByElement.get(e);
        return t || (t = new Map(), this.scopesByIdentifierByElement.set(e, t)), t;
      }, e;
    }(),
        P = function () {
      function e(e) {
        this.application = e, this.scopeObserver = new O(this.element, this.schema, this), this.scopesByIdentifier = new g(), this.modulesByIdentifier = new Map();
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.application.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.application.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "controllerAttribute", {
        get: function get() {
          return this.schema.controllerAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "modules", {
        get: function get() {
          return Array.from(this.modulesByIdentifier.values());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "contexts", {
        get: function get() {
          return this.modules.reduce(function (e, t) {
            return e.concat(t.contexts);
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.scopeObserver.start();
      }, e.prototype.stop = function () {
        this.scopeObserver.stop();
      }, e.prototype.loadDefinition = function (e) {
        this.unloadIdentifier(e.identifier);
        var t = new S(this.application, e);
        this.connectModule(t);
      }, e.prototype.unloadIdentifier = function (e) {
        var t = this.modulesByIdentifier.get(e);
        t && this.disconnectModule(t);
      }, e.prototype.getContextForElementAndIdentifier = function (e, t) {
        var n = this.modulesByIdentifier.get(t);
        if (n) return n.contexts.find(function (t) {
          return t.element == e;
        });
      }, e.prototype.handleError = function (e, t, n) {
        this.application.handleError(e, t, n);
      }, e.prototype.scopeConnected = function (e) {
        this.scopesByIdentifier.add(e.identifier, e);
        var t = this.modulesByIdentifier.get(e.identifier);
        t && t.connectContextForScope(e);
      }, e.prototype.scopeDisconnected = function (e) {
        this.scopesByIdentifier["delete"](e.identifier, e);
        var t = this.modulesByIdentifier.get(e.identifier);
        t && t.disconnectContextForScope(e);
      }, e.prototype.connectModule = function (e) {
        this.modulesByIdentifier.set(e.identifier, e), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
          return e.connectContextForScope(t);
        });
      }, e.prototype.disconnectModule = function (e) {
        this.modulesByIdentifier["delete"](e.identifier), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
          return e.disconnectContextForScope(t);
        });
      }, e;
    }(),
        A = {
      controllerAttribute: "data-controller",
      actionAttribute: "data-action",
      targetAttribute: "data-target"
    },
        M = function M(e, t, n, i) {
      return new (n || (n = Promise))(function (r, o) {
        function a(e) {
          try {
            l(i.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            l(i["throw"](e));
          } catch (e) {
            o(e);
          }
        }

        function l(e) {
          e.done ? r(e.value) : new n(function (t) {
            t(e.value);
          }).then(a, s);
        }

        l((i = i.apply(e, t || [])).next());
      });
    },
        N = function N(e, t) {
      var n,
          i,
          r,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & r[0]) throw r[1];
          return r[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        "throw": s(1),
        "return": s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, i && (r = i[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(r = r.call(i, o[1])).done) return r;

                switch (i = 0, r && (o = [0, r.value]), o[0]) {
                  case 0:
                  case 1:
                    r = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, i = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(r = (r = a.trys).length > 0 && r[r.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < r[1]) {
                      a.label = r[1], r = o;
                      break;
                    }

                    if (r && a.label < r[2]) {
                      a.label = r[2], a.ops.push(o);
                      break;
                    }

                    r[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], i = 0;
              } finally {
                n = r = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    },
        I = function () {
      function e(e, t) {
        void 0 === e && (e = document.documentElement), void 0 === t && (t = A), this.element = e, this.schema = t, this.dispatcher = new r(this), this.router = new P(this);
      }

      return e.start = function (t, n) {
        var i = new e(t, n);
        return i.start(), i;
      }, e.prototype.start = function () {
        return M(this, void 0, void 0, function () {
          return N(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, new Promise(function (e) {
                  "loading" == document.readyState ? document.addEventListener("DOMContentLoaded", e) : e();
                })];

              case 1:
                return e.sent(), this.router.start(), this.dispatcher.start(), [2];
            }
          });
        });
      }, e.prototype.stop = function () {
        this.router.stop(), this.dispatcher.stop();
      }, e.prototype.register = function (e, t) {
        this.load({
          identifier: e,
          controllerConstructor: t
        });
      }, e.prototype.load = function (e) {
        for (var t = this, n = [], i = 1; i < arguments.length; i++) {
          n[i - 1] = arguments[i];
        }

        var r = Array.isArray(e) ? e : [e].concat(n);
        r.forEach(function (e) {
          return t.router.loadDefinition(e);
        });
      }, e.prototype.unload = function (e) {
        for (var t = this, n = [], i = 1; i < arguments.length; i++) {
          n[i - 1] = arguments[i];
        }

        var r = Array.isArray(e) ? e : [e].concat(n);
        r.forEach(function (e) {
          return t.router.unloadIdentifier(e);
        });
      }, Object.defineProperty(e.prototype, "controllers", {
        get: function get() {
          return this.router.contexts.map(function (e) {
            return e.controller;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getControllerForElementAndIdentifier = function (e, t) {
        var n = this.router.getContextForElementAndIdentifier(e, t);
        return n ? n.controller : null;
      }, e.prototype.handleError = function (e, t, n) {
        console.error("%s\n\n%o\n\n%o", t, e, n);
      }, e;
    }();

    function F(e) {
      var t = e.prototype;
      (function (e) {
        var t = function (e) {
          var t = [];

          for (; e;) {
            t.push(e), e = Object.getPrototypeOf(e);
          }

          return t;
        }(e);

        return Array.from(t.reduce(function (e, t) {
          return function (e) {
            var t = e.targets;
            return Array.isArray(t) ? t : [];
          }(t).forEach(function (t) {
            return e.add(t);
          }), e;
        }, new Set()));
      })(e).forEach(function (e) {
        var n, i, r;
        return i = t, (n = {})[e + "Target"] = {
          get: function get() {
            var t = this.targets.find(e);
            if (t) return t;
            throw new Error('Missing target element "' + this.identifier + "." + e + '"');
          }
        }, n[e + "Targets"] = {
          get: function get() {
            return this.targets.findAll(e);
          }
        }, n["has" + function (e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        }(e) + "Target"] = {
          get: function get() {
            return this.targets.has(e);
          }
        }, r = n, void Object.keys(r).forEach(function (e) {
          if (!(e in i)) {
            var t = r[e];
            Object.defineProperty(i, e, t);
          }
        });
      });
    }

    var j = function () {
      function e(e) {
        this.context = e;
      }

      return e.bless = function () {
        F(this);
      }, Object.defineProperty(e.prototype, "application", {
        get: function get() {
          return this.context.application;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "scope", {
        get: function get() {
          return this.context.scope;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "targets", {
        get: function get() {
          return this.scope.targets;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "data", {
        get: function get() {
          return this.scope.data;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.initialize = function () {}, e.prototype.connect = function () {}, e.prototype.disconnect = function () {}, e.targets = [], e;
    }();

    n.d(t, "a", function () {
      return I;
    }), n.d(t, "b", function () {
      return j;
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(1),
        r = n(7),
        o = n.n(r),
        a = ["altFormat", "ariaDateFormat", "dateFormat"],
        s = {
      string: ["altInputClass", "conjunction", "defaultDate", "mode", "nextArrow", "position", "prevArrow"],
      "boolean": ["allowInput", "altInput", "animate", "clickOpens", "closeOnSelect", "disableMobile", "enableSeconds", "enableTime", "inline", "noCalendar", "shorthandCurrentMonth", "static", "time_24hr", "weekNumbers", "wrap"],
      date: ["maxDate", "minDate", "maxTime", "minTime", "now"],
      array: ["disable", "enable"],
      number: ["defaultHour", "defaultMinute", "defaultSeconds", "hourIncrement", "minuteIncrement", "showMonths"]
    },
        l = ["change", "open", "close", "monthChange", "yearChange", "ready", "valueUpdate", "dayCreate"],
        c = ["calendarContainer", "currentYearElement", "days", "daysContainer", "input", "nextMonthNav", "monthNav", "prevMonthNav", "rContainer", "selectedDateElem", "todayDateElem", "weekdayContainer"],
        u = {
      "%Y": "Y",
      "%y": "y",
      "%C": "Y",
      "%m": "m",
      "%-m": "n",
      "%_m": "n",
      "%B": "F",
      "%^B": "F",
      "%b": "M",
      "%^b": "M",
      "%h": "M",
      "%^h": "M",
      "%d": "d",
      "%-d": "j",
      "%e": "j",
      "%H": "H",
      "%k": "H",
      "%I": "h",
      "%l": "h",
      "%P": "K",
      "%p": "K",
      "%M": "i",
      "%S": "S",
      "%A": "l",
      "%a": "D",
      "%w": "w"
    },
        d = new RegExp(Object.keys(u).join("|").replace(new RegExp("\\^", "g"), "\\^"), "g"),
        p = function (e) {
      function t() {
        e.apply(this, arguments);
      }

      return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.initialize = function () {
        this.config = {};
      }, t.prototype.connect = function () {
        this._initializeEvents(), this._initializeOptions(), this._initializeDateFormats(), this.fp = o()(this.element, Object.assign({}, this.config)), this._initializeElements();
      }, t.prototype.disconnect = function () {
        this.fp.destroy();
      }, t.prototype.change = function () {}, t.prototype.open = function () {}, t.prototype.close = function () {}, t.prototype.monthChange = function () {}, t.prototype.yearChange = function () {}, t.prototype.ready = function () {}, t.prototype.valueUpdate = function () {}, t.prototype.dayCreate = function () {}, t.prototype._initializeEvents = function () {
        var e = this;
        l.forEach(function (t) {
          var n,
              i = "on" + ((n = t).charAt(0).toUpperCase() + n.slice(1));
          e.config[i] = e[t].bind(e);
        });
      }, t.prototype._initializeOptions = function () {
        var e = this;
        Object.keys(s).forEach(function (t) {
          s[t].forEach(function (n) {
            var i = n.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
            e.data.has(i) && (e.config[n] = e["_" + t](i));
          });
        });
      }, t.prototype._initializeDateFormats = function () {
        var e = this;
        a.forEach(function (t) {
          e.data.has(t) && (e.config[t] = e.data.get(t).replace(d, function (e) {
            return u[e];
          }));
        });
      }, t.prototype._initializeElements = function () {
        var e = this;
        c.forEach(function (t) {
          e[t + "Target"] = e.fp[t];
        });
      }, t.prototype._string = function (e) {
        return this.data.get(e);
      }, t.prototype._date = function (e) {
        return this.data.get(e);
      }, t.prototype._boolean = function (e) {
        return "true" === this.data.get(e);
      }, t.prototype._array = function (e) {
        return JSON.parse(this.data.get(e));
      }, t.prototype._number = function (e) {
        return parseInt(this.data.get(e));
      }, t;
    }(i.b);

    t.a = p;
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    var i, r, o;
    !function (a) {
      "use strict";

      r = [n(0), n(26)], void 0 === (o = "function" == typeof (i = function i(e) {
        function t(t) {
          var n = "dragover" === t;
          return function (i) {
            i.dataTransfer = i.originalEvent && i.originalEvent.dataTransfer;
            var r = i.dataTransfer;
            r && -1 !== e.inArray("Files", r.types) && !1 !== this._trigger(t, e.Event(t, {
              delegatedEvent: i
            })) && (i.preventDefault(), n && (r.dropEffect = "copy"));
          };
        }

        e.support.fileInput = !(new RegExp("(Android (1\\.[0156]|2\\.[01]))|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)|(w(eb)?OSBrowser)|(webOS)|(Kindle/(1\\.0|2\\.[05]|3\\.0))").test(window.navigator.userAgent) || e('<input type="file"/>').prop("disabled")), e.support.xhrFileUpload = !(!window.ProgressEvent || !window.FileReader), e.support.xhrFormDataFileUpload = !!window.FormData, e.support.blobSlice = window.Blob && (Blob.prototype.slice || Blob.prototype.webkitSlice || Blob.prototype.mozSlice), e.widget("blueimp.fileupload", {
          options: {
            dropZone: e(document),
            pasteZone: void 0,
            fileInput: void 0,
            replaceFileInput: !0,
            paramName: void 0,
            singleFileUploads: !0,
            limitMultiFileUploads: void 0,
            limitMultiFileUploadSize: void 0,
            limitMultiFileUploadSizeOverhead: 512,
            sequentialUploads: !1,
            limitConcurrentUploads: void 0,
            forceIframeTransport: !1,
            redirect: void 0,
            redirectParamName: void 0,
            postMessage: void 0,
            multipart: !0,
            maxChunkSize: void 0,
            uploadedBytes: void 0,
            recalculateProgress: !0,
            progressInterval: 100,
            bitrateInterval: 500,
            autoUpload: !0,
            uniqueFilenames: void 0,
            messages: {
              uploadedBytes: "Uploaded bytes exceed file size"
            },
            i18n: function i18n(t, n) {
              return t = this.messages[t] || t.toString(), n && e.each(n, function (e, n) {
                t = t.replace("{" + e + "}", n);
              }), t;
            },
            formData: function formData(e) {
              return e.serializeArray();
            },
            add: function add(t, n) {
              if (t.isDefaultPrevented()) return !1;
              (n.autoUpload || !1 !== n.autoUpload && e(this).fileupload("option", "autoUpload")) && n.process().done(function () {
                n.submit();
              });
            },
            processData: !1,
            contentType: !1,
            cache: !1,
            timeout: 0
          },
          _specialOptions: ["fileInput", "dropZone", "pasteZone", "multipart", "forceIframeTransport"],
          _blobSlice: e.support.blobSlice && function () {
            var e = this.slice || this.webkitSlice || this.mozSlice;
            return e.apply(this, arguments);
          },
          _BitrateTimer: function _BitrateTimer() {
            this.timestamp = Date.now ? Date.now() : new Date().getTime(), this.loaded = 0, this.bitrate = 0, this.getBitrate = function (e, t, n) {
              var i = e - this.timestamp;
              return (!this.bitrate || !n || i > n) && (this.bitrate = (t - this.loaded) * (1e3 / i) * 8, this.loaded = t, this.timestamp = e), this.bitrate;
            };
          },
          _isXHRUpload: function _isXHRUpload(t) {
            return !t.forceIframeTransport && (!t.multipart && e.support.xhrFileUpload || e.support.xhrFormDataFileUpload);
          },
          _getFormData: function _getFormData(t) {
            var n;
            return "function" === e.type(t.formData) ? t.formData(t.form) : e.isArray(t.formData) ? t.formData : "object" === e.type(t.formData) ? (n = [], e.each(t.formData, function (e, t) {
              n.push({
                name: e,
                value: t
              });
            }), n) : [];
          },
          _getTotal: function _getTotal(t) {
            var n = 0;
            return e.each(t, function (e, t) {
              n += t.size || 1;
            }), n;
          },
          _initProgressObject: function _initProgressObject(t) {
            var n = {
              loaded: 0,
              total: 0,
              bitrate: 0
            };
            t._progress ? e.extend(t._progress, n) : t._progress = n;
          },
          _initResponseObject: function _initResponseObject(e) {
            var t;
            if (e._response) for (t in e._response) {
              e._response.hasOwnProperty(t) && delete e._response[t];
            } else e._response = {};
          },
          _onProgress: function _onProgress(t, n) {
            if (t.lengthComputable) {
              var i,
                  r = Date.now ? Date.now() : new Date().getTime();
              if (n._time && n.progressInterval && r - n._time < n.progressInterval && t.loaded !== t.total) return;
              n._time = r, i = Math.floor(t.loaded / t.total * (n.chunkSize || n._progress.total)) + (n.uploadedBytes || 0), this._progress.loaded += i - n._progress.loaded, this._progress.bitrate = this._bitrateTimer.getBitrate(r, this._progress.loaded, n.bitrateInterval), n._progress.loaded = n.loaded = i, n._progress.bitrate = n.bitrate = n._bitrateTimer.getBitrate(r, i, n.bitrateInterval), this._trigger("progress", e.Event("progress", {
                delegatedEvent: t
              }), n), this._trigger("progressall", e.Event("progressall", {
                delegatedEvent: t
              }), this._progress);
            }
          },
          _initProgressListener: function _initProgressListener(t) {
            var n = this,
                i = t.xhr ? t.xhr() : e.ajaxSettings.xhr();
            i.upload && (e(i.upload).bind("progress", function (e) {
              var i = e.originalEvent;
              e.lengthComputable = i.lengthComputable, e.loaded = i.loaded, e.total = i.total, n._onProgress(e, t);
            }), t.xhr = function () {
              return i;
            });
          },
          _deinitProgressListener: function _deinitProgressListener(t) {
            var n = t.xhr ? t.xhr() : e.ajaxSettings.xhr();
            n.upload && e(n.upload).unbind("progress");
          },
          _isInstanceOf: function _isInstanceOf(e, t) {
            return Object.prototype.toString.call(t) === "[object " + e + "]";
          },
          _getUniqueFilename: function _getUniqueFilename(e, t) {
            return e = String(e), t[e] ? (e = e.replace(/(?: \(([\d]+)\))?(\.[^.]+)?$/, function (e, t, n) {
              var i = t ? Number(t) + 1 : 1,
                  r = n || "";
              return " (" + i + ")" + r;
            }), this._getUniqueFilename(e, t)) : (t[e] = !0, e);
          },
          _initXHRData: function _initXHRData(t) {
            var n,
                i = this,
                r = t.files[0],
                o = t.multipart || !e.support.xhrFileUpload,
                a = "array" === e.type(t.paramName) ? t.paramName[0] : t.paramName;
            t.headers = e.extend({}, t.headers), t.contentRange && (t.headers["Content-Range"] = t.contentRange), o && !t.blob && this._isInstanceOf("File", r) || (t.headers["Content-Disposition"] = 'attachment; filename="' + encodeURI(r.uploadName || r.name) + '"'), o ? e.support.xhrFormDataFileUpload && (t.postMessage ? (n = this._getFormData(t), t.blob ? n.push({
              name: a,
              value: t.blob
            }) : e.each(t.files, function (i, r) {
              n.push({
                name: "array" === e.type(t.paramName) && t.paramName[i] || a,
                value: r
              });
            })) : (i._isInstanceOf("FormData", t.formData) ? n = t.formData : (n = new FormData(), e.each(this._getFormData(t), function (e, t) {
              n.append(t.name, t.value);
            })), t.blob ? n.append(a, t.blob, r.uploadName || r.name) : e.each(t.files, function (r, o) {
              if (i._isInstanceOf("File", o) || i._isInstanceOf("Blob", o)) {
                var s = o.uploadName || o.name;
                t.uniqueFilenames && (s = i._getUniqueFilename(s, t.uniqueFilenames)), n.append("array" === e.type(t.paramName) && t.paramName[r] || a, o, s);
              }
            })), t.data = n) : (t.contentType = r.type || "application/octet-stream", t.data = t.blob || r), t.blob = null;
          },
          _initIframeSettings: function _initIframeSettings(t) {
            var n = e("<a></a>").prop("href", t.url).prop("host");
            t.dataType = "iframe " + (t.dataType || ""), t.formData = this._getFormData(t), t.redirect && n && n !== location.host && t.formData.push({
              name: t.redirectParamName || "redirect",
              value: t.redirect
            });
          },
          _initDataSettings: function _initDataSettings(e) {
            this._isXHRUpload(e) ? (this._chunkedUpload(e, !0) || (e.data || this._initXHRData(e), this._initProgressListener(e)), e.postMessage && (e.dataType = "postmessage " + (e.dataType || ""))) : this._initIframeSettings(e);
          },
          _getParamName: function _getParamName(t) {
            var n = e(t.fileInput),
                i = t.paramName;
            return i ? e.isArray(i) || (i = [i]) : (i = [], n.each(function () {
              for (var t = e(this), n = t.prop("name") || "files[]", r = (t.prop("files") || [1]).length; r;) {
                i.push(n), r -= 1;
              }
            }), i.length || (i = [n.prop("name") || "files[]"])), i;
          },
          _initFormSettings: function _initFormSettings(t) {
            t.form && t.form.length || (t.form = e(t.fileInput.prop("form")), t.form.length || (t.form = e(this.options.fileInput.prop("form")))), t.paramName = this._getParamName(t), t.url || (t.url = t.form.prop("action") || location.href), t.type = (t.type || "string" === e.type(t.form.prop("method")) && t.form.prop("method") || "").toUpperCase(), "POST" !== t.type && "PUT" !== t.type && "PATCH" !== t.type && (t.type = "POST"), t.formAcceptCharset || (t.formAcceptCharset = t.form.attr("accept-charset"));
          },
          _getAJAXSettings: function _getAJAXSettings(t) {
            var n = e.extend({}, this.options, t);
            return this._initFormSettings(n), this._initDataSettings(n), n;
          },
          _getDeferredState: function _getDeferredState(e) {
            return e.state ? e.state() : e.isResolved() ? "resolved" : e.isRejected() ? "rejected" : "pending";
          },
          _enhancePromise: function _enhancePromise(e) {
            return e.success = e.done, e.error = e.fail, e.complete = e.always, e;
          },
          _getXHRPromise: function _getXHRPromise(t, n, i) {
            var r = e.Deferred(),
                o = r.promise();
            return n = n || this.options.context || o, !0 === t ? r.resolveWith(n, i) : !1 === t && r.rejectWith(n, i), o.abort = r.promise, this._enhancePromise(o);
          },
          _addConvenienceMethods: function _addConvenienceMethods(t, n) {
            var i = this,
                r = function r(t) {
              return e.Deferred().resolveWith(i, t).promise();
            };

            n.process = function (t, o) {
              return (t || o) && (n._processQueue = this._processQueue = (this._processQueue || r([this])).then(function () {
                return n.errorThrown ? e.Deferred().rejectWith(i, [n]).promise() : r(arguments);
              }).then(t, o)), this._processQueue || r([this]);
            }, n.submit = function () {
              return "pending" !== this.state() && (n.jqXHR = this.jqXHR = !1 !== i._trigger("submit", e.Event("submit", {
                delegatedEvent: t
              }), this) && i._onSend(t, this)), this.jqXHR || i._getXHRPromise();
            }, n.abort = function () {
              return this.jqXHR ? this.jqXHR.abort() : (this.errorThrown = "abort", i._trigger("fail", null, this), i._getXHRPromise(!1));
            }, n.state = function () {
              return this.jqXHR ? i._getDeferredState(this.jqXHR) : this._processQueue ? i._getDeferredState(this._processQueue) : void 0;
            }, n.processing = function () {
              return !this.jqXHR && this._processQueue && "pending" === i._getDeferredState(this._processQueue);
            }, n.progress = function () {
              return this._progress;
            }, n.response = function () {
              return this._response;
            };
          },
          _getUploadedBytes: function _getUploadedBytes(e) {
            var t = e.getResponseHeader("Range"),
                n = t && t.split("-"),
                i = n && n.length > 1 && parseInt(n[1], 10);
            return i && i + 1;
          },
          _chunkedUpload: function _chunkedUpload(t, n) {
            t.uploadedBytes = t.uploadedBytes || 0;

            var i,
                _r,
                o = this,
                a = t.files[0],
                s = a.size,
                l = t.uploadedBytes,
                c = t.maxChunkSize || s,
                u = this._blobSlice,
                d = e.Deferred(),
                p = d.promise();

            return !(!(this._isXHRUpload(t) && u && (l || ("function" === e.type(c) ? c(t) : c) < s)) || t.data) && (!!n || (l >= s ? (a.error = t.i18n("uploadedBytes"), this._getXHRPromise(!1, t.context, [null, "error", a.error])) : (_r = function r() {
              var n = e.extend({}, t),
                  p = n._progress.loaded;
              n.blob = u.call(a, l, l + ("function" === e.type(c) ? c(n) : c), a.type), n.chunkSize = n.blob.size, n.contentRange = "bytes " + l + "-" + (l + n.chunkSize - 1) + "/" + s, o._trigger("chunkbeforesend", null, n), o._initXHRData(n), o._initProgressListener(n), i = (!1 !== o._trigger("chunksend", null, n) && e.ajax(n) || o._getXHRPromise(!1, n.context)).done(function (i, a, c) {
                l = o._getUploadedBytes(c) || l + n.chunkSize, p + n.chunkSize - n._progress.loaded && o._onProgress(e.Event("progress", {
                  lengthComputable: !0,
                  loaded: l - n.uploadedBytes,
                  total: l - n.uploadedBytes
                }), n), t.uploadedBytes = n.uploadedBytes = l, n.result = i, n.textStatus = a, n.jqXHR = c, o._trigger("chunkdone", null, n), o._trigger("chunkalways", null, n), l < s ? _r() : d.resolveWith(n.context, [i, a, c]);
              }).fail(function (e, t, i) {
                n.jqXHR = e, n.textStatus = t, n.errorThrown = i, o._trigger("chunkfail", null, n), o._trigger("chunkalways", null, n), d.rejectWith(n.context, [e, t, i]);
              }).always(function () {
                o._deinitProgressListener(n);
              });
            }, this._enhancePromise(p), p.abort = function () {
              return i.abort();
            }, _r(), p)));
          },
          _beforeSend: function _beforeSend(e, t) {
            0 === this._active && (this._trigger("start"), this._bitrateTimer = new this._BitrateTimer(), this._progress.loaded = this._progress.total = 0, this._progress.bitrate = 0), this._initResponseObject(t), this._initProgressObject(t), t._progress.loaded = t.loaded = t.uploadedBytes || 0, t._progress.total = t.total = this._getTotal(t.files) || 1, t._progress.bitrate = t.bitrate = 0, this._active += 1, this._progress.loaded += t.loaded, this._progress.total += t.total;
          },
          _onDone: function _onDone(t, n, i, r) {
            var o = r._progress.total,
                a = r._response;
            r._progress.loaded < o && this._onProgress(e.Event("progress", {
              lengthComputable: !0,
              loaded: o,
              total: o
            }), r), a.result = r.result = t, a.textStatus = r.textStatus = n, a.jqXHR = r.jqXHR = i, this._trigger("done", null, r);
          },
          _onFail: function _onFail(e, t, n, i) {
            var r = i._response;
            i.recalculateProgress && (this._progress.loaded -= i._progress.loaded, this._progress.total -= i._progress.total), r.jqXHR = i.jqXHR = e, r.textStatus = i.textStatus = t, r.errorThrown = i.errorThrown = n, this._trigger("fail", null, i);
          },
          _onAlways: function _onAlways(e, t, n, i) {
            this._trigger("always", null, i);
          },
          _onSend: function _onSend(t, n) {
            n.submit || this._addConvenienceMethods(t, n);

            var i,
                r,
                o,
                a,
                s = this,
                l = s._getAJAXSettings(n),
                c = function c() {
              return s._sending += 1, l._bitrateTimer = new s._BitrateTimer(), i = i || ((r || !1 === s._trigger("send", e.Event("send", {
                delegatedEvent: t
              }), l)) && s._getXHRPromise(!1, l.context, r) || s._chunkedUpload(l) || e.ajax(l)).done(function (e, t, n) {
                s._onDone(e, t, n, l);
              }).fail(function (e, t, n) {
                s._onFail(e, t, n, l);
              }).always(function (e, t, n) {
                if (s._deinitProgressListener(l), s._onAlways(e, t, n, l), s._sending -= 1, s._active -= 1, l.limitConcurrentUploads && l.limitConcurrentUploads > s._sending) for (var i = s._slots.shift(); i;) {
                  if ("pending" === s._getDeferredState(i)) {
                    i.resolve();
                    break;
                  }

                  i = s._slots.shift();
                }
                0 === s._active && s._trigger("stop");
              });
            };

            return this._beforeSend(t, l), this.options.sequentialUploads || this.options.limitConcurrentUploads && this.options.limitConcurrentUploads <= this._sending ? (this.options.limitConcurrentUploads > 1 ? (o = e.Deferred(), this._slots.push(o), a = o.then(c)) : (this._sequence = this._sequence.then(c, c), a = this._sequence), a.abort = function () {
              return r = [void 0, "abort", "abort"], i ? i.abort() : (o && o.rejectWith(l.context, r), c());
            }, this._enhancePromise(a)) : c();
          },
          _onAdd: function _onAdd(t, n) {
            var i,
                r,
                o,
                a,
                s = this,
                l = !0,
                c = e.extend({}, this.options, n),
                u = n.files,
                d = u.length,
                p = c.limitMultiFileUploads,
                h = c.limitMultiFileUploadSize,
                f = c.limitMultiFileUploadSizeOverhead,
                m = 0,
                g = this._getParamName(c),
                v = 0;

            if (!d) return !1;
            if (h && void 0 === u[0].size && (h = void 0), (c.singleFileUploads || p || h) && this._isXHRUpload(c)) {
              if (c.singleFileUploads || h || !p) {
                if (!c.singleFileUploads && h) for (o = [], i = [], a = 0; a < d; a += 1) {
                  m += u[a].size + f, (a + 1 === d || m + u[a + 1].size + f > h || p && a + 1 - v >= p) && (o.push(u.slice(v, a + 1)), (r = g.slice(v, a + 1)).length || (r = g), i.push(r), v = a + 1, m = 0);
                } else i = g;
              } else for (o = [], i = [], a = 0; a < d; a += p) {
                o.push(u.slice(a, a + p)), (r = g.slice(a, a + p)).length || (r = g), i.push(r);
              }
            } else o = [u], i = [g];
            return n.originalFiles = u, e.each(o || u, function (r, a) {
              var c = e.extend({}, n);
              return c.files = o ? a : [a], c.paramName = i[r], s._initResponseObject(c), s._initProgressObject(c), s._addConvenienceMethods(t, c), l = s._trigger("add", e.Event("add", {
                delegatedEvent: t
              }), c);
            }), l;
          },
          _replaceFileInput: function _replaceFileInput(t) {
            var n = t.fileInput,
                i = n.clone(!0),
                r = n.is(document.activeElement);
            t.fileInputClone = i, e("<form></form>").append(i)[0].reset(), n.after(i).detach(), r && i.focus(), e.cleanData(n.unbind("remove")), this.options.fileInput = this.options.fileInput.map(function (e, t) {
              return t === n[0] ? i[0] : t;
            }), n[0] === this.element[0] && (this.element = i);
          },
          _handleFileTreeEntry: function _handleFileTreeEntry(t, n) {
            var i,
                r = this,
                o = e.Deferred(),
                a = [],
                s = function s(e) {
              e && !e.entry && (e.entry = t), o.resolve([e]);
            },
                l = function l() {
              i.readEntries(function (e) {
                e.length ? (a = a.concat(e), l()) : function (e) {
                  r._handleFileTreeEntries(e, n + t.name + "/").done(function (e) {
                    o.resolve(e);
                  }).fail(s);
                }(a);
              }, s);
            };

            return n = n || "", t.isFile ? t._file ? (t._file.relativePath = n, o.resolve(t._file)) : t.file(function (e) {
              e.relativePath = n, o.resolve(e);
            }, s) : t.isDirectory ? (i = t.createReader(), l()) : o.resolve([]), o.promise();
          },
          _handleFileTreeEntries: function _handleFileTreeEntries(t, n) {
            var i = this;
            return e.when.apply(e, e.map(t, function (e) {
              return i._handleFileTreeEntry(e, n);
            })).then(function () {
              return Array.prototype.concat.apply([], arguments);
            });
          },
          _getDroppedFiles: function _getDroppedFiles(t) {
            var n = (t = t || {}).items;
            return n && n.length && (n[0].webkitGetAsEntry || n[0].getAsEntry) ? this._handleFileTreeEntries(e.map(n, function (e) {
              var t;
              return e.webkitGetAsEntry ? ((t = e.webkitGetAsEntry()) && (t._file = e.getAsFile()), t) : e.getAsEntry();
            })) : e.Deferred().resolve(e.makeArray(t.files)).promise();
          },
          _getSingleFileInputFiles: function _getSingleFileInputFiles(t) {
            var n,
                i,
                r = (t = e(t)).prop("webkitEntries") || t.prop("entries");
            if (r && r.length) return this._handleFileTreeEntries(r);
            if ((n = e.makeArray(t.prop("files"))).length) void 0 === n[0].name && n[0].fileName && e.each(n, function (e, t) {
              t.name = t.fileName, t.size = t.fileSize;
            });else {
              if (!(i = t.prop("value"))) return e.Deferred().resolve([]).promise();
              n = [{
                name: i.replace(/^.*\\/, "")
              }];
            }
            return e.Deferred().resolve(n).promise();
          },
          _getFileInputFiles: function _getFileInputFiles(t) {
            return t instanceof e && 1 !== t.length ? e.when.apply(e, e.map(t, this._getSingleFileInputFiles)).then(function () {
              return Array.prototype.concat.apply([], arguments);
            }) : this._getSingleFileInputFiles(t);
          },
          _onChange: function _onChange(t) {
            var n = this,
                i = {
              fileInput: e(t.target),
              form: e(t.target.form)
            };

            this._getFileInputFiles(i.fileInput).always(function (r) {
              i.files = r, n.options.replaceFileInput && n._replaceFileInput(i), !1 !== n._trigger("change", e.Event("change", {
                delegatedEvent: t
              }), i) && n._onAdd(t, i);
            });
          },
          _onPaste: function _onPaste(t) {
            var n = t.originalEvent && t.originalEvent.clipboardData && t.originalEvent.clipboardData.items,
                i = {
              files: []
            };
            n && n.length && (e.each(n, function (e, t) {
              var n = t.getAsFile && t.getAsFile();
              n && i.files.push(n);
            }), !1 !== this._trigger("paste", e.Event("paste", {
              delegatedEvent: t
            }), i) && this._onAdd(t, i));
          },
          _onDrop: function _onDrop(t) {
            t.dataTransfer = t.originalEvent && t.originalEvent.dataTransfer;
            var n = this,
                i = t.dataTransfer,
                r = {};
            i && i.files && i.files.length && (t.preventDefault(), this._getDroppedFiles(i).always(function (i) {
              r.files = i, !1 !== n._trigger("drop", e.Event("drop", {
                delegatedEvent: t
              }), r) && n._onAdd(t, r);
            }));
          },
          _onDragOver: t("dragover"),
          _onDragEnter: t("dragenter"),
          _onDragLeave: t("dragleave"),
          _initEventHandlers: function _initEventHandlers() {
            this._isXHRUpload(this.options) && (this._on(this.options.dropZone, {
              dragover: this._onDragOver,
              drop: this._onDrop,
              dragenter: this._onDragEnter,
              dragleave: this._onDragLeave
            }), this._on(this.options.pasteZone, {
              paste: this._onPaste
            })), e.support.fileInput && this._on(this.options.fileInput, {
              change: this._onChange
            });
          },
          _destroyEventHandlers: function _destroyEventHandlers() {
            this._off(this.options.dropZone, "dragenter dragleave dragover drop"), this._off(this.options.pasteZone, "paste"), this._off(this.options.fileInput, "change");
          },
          _destroy: function _destroy() {
            this._destroyEventHandlers();
          },
          _setOption: function _setOption(t, n) {
            var i = -1 !== e.inArray(t, this._specialOptions);
            i && this._destroyEventHandlers(), this._super(t, n), i && (this._initSpecialOptions(), this._initEventHandlers());
          },
          _initSpecialOptions: function _initSpecialOptions() {
            var t = this.options;
            void 0 === t.fileInput ? t.fileInput = this.element.is('input[type="file"]') ? this.element : this.element.find('input[type="file"]') : t.fileInput instanceof e || (t.fileInput = e(t.fileInput)), t.dropZone instanceof e || (t.dropZone = e(t.dropZone)), t.pasteZone instanceof e || (t.pasteZone = e(t.pasteZone));
          },
          _getRegExp: function _getRegExp(e) {
            var t = e.split("/"),
                n = t.pop();
            return t.shift(), new RegExp(t.join("/"), n);
          },
          _isRegExpOption: function _isRegExpOption(t, n) {
            return "url" !== t && "string" === e.type(n) && /^\/.*\/[igm]{0,3}$/.test(n);
          },
          _initDataAttributes: function _initDataAttributes() {
            var t = this,
                n = this.options,
                i = this.element.data();
            e.each(this.element[0].attributes, function (e, r) {
              var o,
                  a = r.name.toLowerCase();
              /^data-/.test(a) && (a = a.slice(5).replace(/-[a-z]/g, function (e) {
                return e.charAt(1).toUpperCase();
              }), o = i[a], t._isRegExpOption(a, o) && (o = t._getRegExp(o)), n[a] = o);
            });
          },
          _create: function _create() {
            this._initDataAttributes(), this._initSpecialOptions(), this._slots = [], this._sequence = this._getXHRPromise(!0), this._sending = this._active = 0, this._initProgressObject(this), this._initEventHandlers();
          },
          active: function active() {
            return this._active;
          },
          progress: function progress() {
            return this._progress;
          },
          add: function add(t) {
            var n = this;
            t && !this.options.disabled && (t.fileInput && !t.files ? this._getFileInputFiles(t.fileInput).always(function (e) {
              t.files = e, n._onAdd(null, t);
            }) : (t.files = e.makeArray(t.files), this._onAdd(null, t)));
          },
          send: function send(t) {
            if (t && !this.options.disabled) {
              if (t.fileInput && !t.files) {
                var n,
                    i,
                    r = this,
                    o = e.Deferred(),
                    a = o.promise();
                return a.abort = function () {
                  return i = !0, n ? n.abort() : (o.reject(null, "abort", "abort"), a);
                }, this._getFileInputFiles(t.fileInput).always(function (e) {
                  i || (e.length ? (t.files = e, (n = r._onSend(null, t)).then(function (e, t, n) {
                    o.resolve(e, t, n);
                  }, function (e, t, n) {
                    o.reject(e, t, n);
                  })) : o.reject());
                }), this._enhancePromise(a);
              }

              if (t.files = e.makeArray(t.files), t.files.length) return this._onSend(null, t);
            }

            return this._getXHRPromise(!1, t && t.context);
          }
        });
      }) ? i.apply(t, r) : i) || (e.exports = o);
    }();
  }, function (e, t, n) {
    window, e.exports = function (e, t, n, i, r, o, a, s, l) {
      return function (e) {
        var t = {};

        function n(i) {
          if (t[i]) return t[i].exports;
          var r = t[i] = {
            i: i,
            l: !1,
            exports: {}
          };
          return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
        }

        return n.m = e, n.c = t, n.d = function (e, t, i) {
          n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: i
          });
        }, n.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, n.t = function (e, t) {
          if (1 & t && (e = n(e)), 8 & t) return e;
          if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
          var i = Object.create(null);
          if (n.r(i), Object.defineProperty(i, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var r in e) {
            n.d(i, r, function (t) {
              return e[t];
            }.bind(null, r));
          }
          return i;
        }, n.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e["default"];
          } : function () {
            return e;
          };
          return n.d(t, "a", t), t;
        }, n.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 6);
      }([function (t, n) {
        t.exports = e;
      }, function (e, n) {
        e.exports = t;
      }, function (e, t, n) {
        "use strict";

        (function (e) {
          var i = n(3),
              r = n.n(i),
              o = n(0),
              a = n.n(o),
              s = n(4),
              l = n.n(s),
              c = n(5),
              u = function u(e, t) {
            if (!(e instanceof t)) throw new Error("Bound instance method accessed before binding");
          };

          n(21), n(22), n(23), n(24), n(25), t.a = function () {
            var t =
            /*#__PURE__*/
            function (_c$a) {
              _inherits(t, _c$a);

              function t() {
                var _this;

                _classCallCheck(this, t);

                _this = _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments)), _this.get_attachment_template = _this.get_attachment_template.bind(_assertThisInitialized(_this)), _this.get_upload_error_template = _this.get_upload_error_template.bind(_assertThisInitialized(_this));
                return _this;
              }

              _createClass(t, [{
                key: "init",
                value: function init() {
                  var _this2 = this;

                  return this.attachments_counter = 0, this.set_unique_ids(), this.get_file_input().on("fileuploadalways.simple_form_attachments", function (e) {
                    if (_this2.is_sortable()) return _this2.init_sortable();
                  }), this.is_sortable() && this.init_sortable(), this.init_fileupload();
                }
              }, {
                key: "init_sortable",
                value: function init_sortable() {
                  return this.sortable = new l.a(this.get_attachment_list()[0], this.options.sortable_options);
                }
              }, {
                key: "init_fileupload",
                value: function init_fileupload() {
                  var _this3 = this;

                  return this.options.debug && console.log("init jQuery.fileupload"), this.get_file_input().fileupload({
                    dataType: "json",
                    dropZone: this.$element,
                    formData: {
                      "attachment_type]": this.get_attachment_type_input().val(),
                      "attachment_parent[name]": this.get_attachment_parent_name_input().val(),
                      "attachment_parent[class]": this.get_attachment_parent_class_input().val(),
                      "attachment_relation[type]": this.get_attachment_relation_type_input().val(),
                      "attachment_relation[key]": this.get_attachment_relation_key_input().val(),
                      "attachment_relation[name]": this.get_attachment_relation_name_input().val(),
                      "attachment_relation[referenced]": this.get_attachment_relation_referenced_input().val(),
                      authenticity_token: e('meta[name="csrf-token"]').attr("content"),
                      "attachment_relation[multiple]": this.is_multiple()
                    },
                    namespace: "simple_form_attachments",
                    url: this.get_attachments_path(),
                    acceptFileTypes: this.get_accept_file_types(),
                    maxFileSize: this.get_max_file_size(),
                    minFileSize: this.get_min_file_size(),
                    maxNumberOfFiles: this.get_max_number_of_files(),
                    add: function add(t, n) {
                      return _this3.options.debug && _this3.set_logs(t, n), _this3.is_multiple() || _this3.get_attachment_list().find(".simple_form_attachments__attachment").remove(), n.process(function () {
                        return _this3.get_file_input().fileupload("process", n);
                      }), !t.isDefaultPrevented() && (n.autoUpload || !1 !== n.autoUpload && _this3.get_file_input().fileupload("option", "autoUpload") ? (n.process().done(function () {
                        var t, i, r, o, a, s, l;

                        for (r = 0, o = (s = n.files).length; r < o; r++) {
                          a = {
                            error: (i = s[r]).error,
                            mime_type: i.type,
                            multiple: _this3.is_multiple(),
                            size: i.size,
                            size_human: _this3.get_size_human(i.size),
                            thumb_url: URL.createObjectURL(i)
                          }, l = e.extend({}, i, a), t = _this3.get_attachment_template(l).addClass("simple_form_attachments__attachment__is_uploading"), n.context = t, t.data("data", n), _this3.get_attachment_list().append(t);
                        }

                        return n.submit();
                      }), n.process().fail(function () {
                        var t, i, r, o, a, s, l, c;

                        for (c = [], r = 0, o = (s = n.files).length; r < o; r++) {
                          a = {
                            error: (i = s[r]).error,
                            mime_type: i.type,
                            multiple: _this3.is_multiple(),
                            size: i.size,
                            size_human: _this3.get_size_human(i.size),
                            thumb_url: URL.createObjectURL(i)
                          }, l = e.extend({}, i, a), t = _this3.get_upload_error_template(l), n.context = t, t.data("data", n), c.push(_this3.get_attachment_list().append(t));
                        }

                        return c;
                      })) : void 0);
                    },
                    start: function start(e, t) {
                      return _this3.options.debug && _this3.set_logs(e, t), _this3.disable_form_submit();
                    },
                    fail: function fail(t, n) {
                      var i;
                      if (_this3.options.debug && _this3.set_logs(t, n), n.jqXHR.responseText) return (i = e(JSON.parse(n.jqXHR.responseText).html).addClass("simple_form_attachments__attachment__has_error")).find(".simple_form_attachments__attachment__col__errors"), n.context.replaceWith(i);
                    },
                    progress: function progress(e, t) {
                      var n;
                      return _this3.options.debug && _this3.set_logs(e, t), n = parseInt(t.loaded / t.total * 100, 10), t.context.find(".simple_form_attachments__attachment__col__progress__bar").width(n + "%");
                    },
                    done: function done(t, n) {
                      var i;
                      return _this3.options.debug && _this3.set_logs(t, n), _this3.options.debug && console.log(n.result.html), i = e(n.result.html).addClass("simple_form_attachments__attachment__is_uploaded"), n.context.replaceWith(i);
                    },
                    stop: function stop(e, t) {
                      return _this3.options.debug && _this3.set_logs(e, t), _this3.enable_form_submit();
                    }
                  }), this.$element.on("click.simple_form_attachments", ".simple_form_attachments__button__delete, .simple_form_attachments__button__close, .simple_form_attachments__button__dismiss", function (t) {
                    var n;
                    return t.preventDefault(), t.stopPropagation(), n = e(t.currentTarget).closest(".simple_form_attachments__attachment"), _this3.remove_template(n);
                  }), this.$element.on("click.simple_form_attachments", ".simple_form_attachments__button__cancel", function (t) {
                    var n, i;
                    return t.preventDefault(), t.stopPropagation(), i = (n = e(t.currentTarget).closest(".simple_form_attachments__attachment")).data("data") || {}, _this3.enable_form_submit(), i.jqXHR ? i.jqXHR.abort() : (i.errorThrown = "abort", t.data.fileupload._trigger("fail", t, i)), _this3.remove_template(n);
                  }), this.$element.on("dragover.simple_form_attachments", function (e) {
                    return e.preventDefault(), _this3.$element.addClass("dragover");
                  }), this.$element.on("dragleave.simple_form_attachments", function (e) {
                    return e.preventDefault(), _this3.$element.removeClass("dragover");
                  }), this.$element.on("drop.simple_form_attachments", function (e) {
                    return e.preventDefault(), _this3.$element.removeClass("dragover");
                  });
                }
              }, {
                key: "destroy",
                value: function destroy() {
                  return this.get_file_input().off(".simple_form_attachments"), this.$element.off(".simple_form_attachments");
                }
              }, {
                key: "get_accept_file_types",
                value: function get_accept_file_types() {
                  var e, t, n;

                  if (e = this.$element.data("accept-file-types")) {
                    for (t = 0, n = e.length; t < n; t++) {
                      e[t].replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    }

                    return new RegExp(e.join("|"), "i");
                  }
                }
              }, {
                key: "get_max_file_size",
                value: function get_max_file_size() {
                  return this.$element.data("max-file-size");
                }
              }, {
                key: "get_min_file_size",
                value: function get_min_file_size() {
                  return this.$element.data("min-file-size");
                }
              }, {
                key: "get_max_number_of_files",
                value: function get_max_number_of_files() {
                  return this.$element.data("max-number-of-files");
                }
              }, {
                key: "get_attachment_list",
                value: function get_attachment_list() {
                  return this.$element.find(".simple_form_attachments__attachment_list");
                }
              }, {
                key: "get_attachments_path",
                value: function get_attachments_path() {
                  return this.$element.data("attachments-path");
                }
              }, {
                key: "get_disabled_submit_text",
                value: function get_disabled_submit_text() {
                  return this.$element.data("disabled-submit-text");
                }
              }, {
                key: "get_file_input",
                value: function get_file_input() {
                  return this.$element.find("input.file");
                }
              }, {
                key: "get_form",
                value: function get_form() {
                  return this.$element.parents("form").first();
                }
              }, {
                key: "get_form_submit",
                value: function get_form_submit() {
                  return this.get_form().find('input[type="submit"]').first();
                }
              }, {
                key: "get_number_of_files",
                value: function get_number_of_files() {
                  return this.get_attachment_list().children(".simple_form_attachments__attachment").not(".simple_form_attachments__attachment__has_error").length;
                }
              }, {
                key: "get_attachment_type_input",
                value: function get_attachment_type_input() {
                  return this.$element.find('input[name="attachment_type"]');
                }
              }, {
                key: "get_attachment_multiple_input",
                value: function get_attachment_multiple_input() {
                  return this.$element.find('input[name="attachment[multiple]"]');
                }
              }, {
                key: "get_attachment_parent_class_input",
                value: function get_attachment_parent_class_input() {
                  return this.$element.find('input[name="attachment_parent[class]"]');
                }
              }, {
                key: "get_attachment_parent_name_input",
                value: function get_attachment_parent_name_input() {
                  return this.$element.find('input[name="attachment_parent[name]"]');
                }
              }, {
                key: "get_attachment_relation_key_input",
                value: function get_attachment_relation_key_input() {
                  return this.$element.find('input[name="attachment_relation[key]"]');
                }
              }, {
                key: "get_attachment_relation_name_input",
                value: function get_attachment_relation_name_input() {
                  return this.$element.find('input[name="attachment_relation[name]"]');
                }
              }, {
                key: "get_attachment_relation_type_input",
                value: function get_attachment_relation_type_input() {
                  return this.$element.find('input[name="attachment_relation[type]"]');
                }
              }, {
                key: "get_attachment_relation_referenced_input",
                value: function get_attachment_relation_referenced_input() {
                  return this.$element.find('input[name="attachment_relation[referenced]"]');
                }
              }, {
                key: "get_relation_name",
                value: function get_relation_name() {
                  return this.$element.data("relation-name");
                }
              }, {
                key: "get_relation_key",
                value: function get_relation_key() {
                  return this.$element.data("relation-key");
                }
              }, {
                key: "get_size_human",
                value: function get_size_human(e) {
                  return r()(e).format("0.0 b");
                }
              }, {
                key: "get_attachment_template",
                value: function get_attachment_template(n) {
                  var i;
                  return u(this, t), i = a.a.compile(this.$element.find("script#simple_form_attachments__attachment_template").html()), e(i(n));
                }
              }, {
                key: "get_upload_error_template",
                value: function get_upload_error_template(n) {
                  var i;
                  return u(this, t), i = a.a.compile(this.$element.find("script#simple_form_attachments__upload_error_template").html()), e(i(n));
                }
              }, {
                key: "set_logs",
                value: function set_logs(e, t) {
                  return console.log(e.type), console.log(e), console.log(t);
                }
              }, {
                key: "enable_form_submit",
                value: function enable_form_submit() {
                  var e, t;
                  return t = (e = this.get_form_submit()).data("submit-text"), e.removeAttr("disabled"), e.val(t);
                }
              }, {
                key: "disable_form_submit",
                value: function disable_form_submit() {
                  var e;
                  return (e = this.get_form_submit()).attr("data-submit-text", e.val()), e.val(this.get_disabled_submit_text()).attr("disabled", "disabled");
                }
              }, {
                key: "remove_template",
                value: function remove_template(t) {
                  return t.slideUp(this.options.slide_speed).promise().done(function () {
                    return e(this).remove();
                  });
                }
              }, {
                key: "create_index",
                value: function create_index() {
                  return new Date().getTime() + this.attachments_counter++;
                }
              }, {
                key: "is_multiple",
                value: function is_multiple() {
                  return void 0 !== this.get_file_input().attr("multiple");
                }
              }, {
                key: "is_sortable",
                value: function is_sortable() {
                  return this.get_attachment_list().hasClass("simple_form_attachments__attachment_list__is_sortable");
                }
              }, {
                key: "set_unique_ids",
                value: function set_unique_ids() {
                  var e, t, n, i;
                  return n = (e = this.get_file_input()).attr("id"), t = this.$element.find("[for='".concat(n, "']")), e.data("default-id", n), t.data("default-for", n), i = "".concat(n, "__").concat(this.guid()), e.attr("id", i), t.attr("for", i);
                }
              }, {
                key: "guid",
                value: function guid() {
                  return this.s4() + this.s4() + "-" + this.s4() + "-" + this.s4() + "-" + this.s4() + "-" + this.s4() + this.s4() + this.s4();
                }
              }, {
                key: "s4",
                value: function s4() {
                  return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
                }
              }]);

              return t;
            }(c.a);

            return t.defaults = {
              name: "SimpleFormAttachments",
              debug: !1,
              sortable_options: {
                animation: 150,
                draggable: ".simple_form_attachments__attachment",
                forcePlaceholderSize: !0,
                ghostClass: "simple_form_attachments__attachment__ghost",
                handle: ".simple_form_attachments__attachment__col__handle"
              },
              slide_speed: "fast"
            }, t;
          }();
        }).call(this, n(1));
      }, function (e, t) {
        e.exports = n;
      }, function (e, t) {
        e.exports = i;
      }, function (e, t, n) {
        "use strict";

        (function (e) {
          t.a =
          /*#__PURE__*/
          function () {
            _createClass(_class, null, [{
              key: "register",
              value: function register() {
                var e, t, n;
                return t = (e = null != (n = this.defaults) ? n : {}).name || (e.name = /function ([^(]*)/.exec(this + "")[1]), Array.prototype.slice.call(arguments).slice(1), null != arguments[0] || this.selector, this.init_plugin(this, t);
              }
            }, {
              key: "init_plugin",
              value: function init_plugin(t, n) {
                if (void 0 === e.fn[n]) return e.fn[n] = function (e) {
                  var i, r, o;
                  return i = arguments, r = "plugin_".concat(n), void 0 === e || "object" == _typeof(e) ? this.each(function () {
                    var n;
                    if (this.pluginInstances || (this.pluginInstances = {}), !this.pluginInstances[r]) return n = new t(this, e), this.pluginInstances[r] = n;
                  }) : "string" == typeof e && "_" !== e[0] && "init" !== e ? (o = void 0, this.each(function () {
                    var n;
                    if (this.pluginInstances || (this.pluginInstances = {}), (n = this.pluginInstances[r]) instanceof t && "function" == typeof n[e] && (o = n[e].apply(n, Array.prototype.slice.call(i, 1))), "destroy" === e) return this.pluginInstances[r] = null;
                  }), void 0 !== o ? o : this) : void 0;
                };
              }
            }]);

            function _class(t, n) {
              _classCallCheck(this, _class);

              this.element = t, this.options = e.extend({}, this.constructor.defaults, n), this.$element = e(this.element), this.init();
            }

            return _class;
          }();
        }).call(this, n(1));
      }, function (e, t, n) {
        "use strict";

        n.r(t), n(7), n(8), n(9), n(10), n(11), n(12), n(13), n(14), n(15), n(16), n(17), n(18), n(19), n(20);
        var i = n(2);
        t["default"] = i.a;
      }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t) {
        e.exports = r;
      }, function (e, t) {
        e.exports = o;
      }, function (e, t) {
        e.exports = a;
      }, function (e, t) {
        e.exports = s;
      }, function (e, t) {
        e.exports = l;
      }]);
    }(n(18), n(0), n(19), n(20), n(21), n(22), n(23), n(25), n(28));
  }, function (e, t, n) {
    var i, r;
    window, e.exports = (i = n(0), r = n(33), function (e) {
      var t = {};

      function n(i) {
        if (t[i]) return t[i].exports;
        var r = t[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, i) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: i
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var r in e) {
          n.d(i, r, function (t) {
            return e[t];
          }.bind(null, r));
        }
        return i;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 5);
    }([function (e, t, n) {
      "use strict";

      (function (e) {
        t.a =
        /*#__PURE__*/
        function () {
          _createClass(_class2, null, [{
            key: "register",
            value: function register() {
              var e, t, n;
              return t = (e = null != (n = this.defaults) ? n : {}).name || (e.name = /function ([^(]*)/.exec(this + "")[1]), Array.prototype.slice.call(arguments).slice(1), null != arguments[0] || this.selector, this.init_plugin(this, t);
            }
          }, {
            key: "init_plugin",
            value: function init_plugin(t, n) {
              if (void 0 === e.fn[n]) return e.fn[n] = function (e) {
                var i, r, o;
                return i = arguments, r = "plugin_".concat(n), void 0 === e || "object" == _typeof(e) ? this.each(function () {
                  var n;
                  if (this.pluginInstances || (this.pluginInstances = {}), !this.pluginInstances[r]) return n = new t(this, e), this.pluginInstances[r] = n;
                }) : "string" == typeof e && "_" !== e[0] && "init" !== e ? (o = void 0, this.each(function () {
                  var n;
                  if (this.pluginInstances || (this.pluginInstances = {}), (n = this.pluginInstances[r]) instanceof t && "function" == typeof n[e] && (o = n[e].apply(n, Array.prototype.slice.call(i, 1))), "destroy" === e) return this.pluginInstances[r] = null;
                }), void 0 !== o ? o : this) : void 0;
              };
            }
          }]);

          function _class2(t, n) {
            _classCallCheck(this, _class2);

            this.element = t, this.options = e.extend({}, this.constructor.defaults, n), this.$element = e(this.element), this.init();
          }

          return _class2;
        }();
      }).call(this, n(1));
    }, function (e, t) {
      e.exports = i;
    }, function (e, t, n) {
      "use strict";

      (function (e) {
        var i = n(0);

        t.a = function () {
          var t =
          /*#__PURE__*/
          function (_i$a) {
            _inherits(t, _i$a);

            function t() {
              _classCallCheck(this, t);

              return _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
            }

            _createClass(t, [{
              key: "init",
              value: function init() {
                var _this4 = this;

                return this.$element.on("click.SimpleFormNestedFields__Links", ".simple_form_nested_fields__link", function (e) {
                  var t;

                  switch (e.preventDefault(), e.stopImmediatePropagation(), t = e.target, !1) {
                    case !t.classList.contains("simple_form_nested_fields__link--add"):
                      return _this4.add_new_item(t);

                    case !t.classList.contains("simple_form_nested_fields__link--remove"):
                      return _this4.remove_item(t);
                  }
                });
              }
            }, {
              key: "destroy",
              value: function destroy() {
                return this.$element.off(".SimpleFormNestedFields__Links");
              }
            }, {
              key: "get_index",
              value: function get_index() {
                return new Date().getTime();
              }
            }, {
              key: "get_item_class_name",
              value: function get_item_class_name(e) {
                return this.get_select(e).val();
              }
            }, {
              key: "get_items_container",
              value: function get_items_container() {
                return this.$element.children(".simple_form_nested_fields__items");
              }
            }, {
              key: "get_template",
              value: function get_template(e) {
                var t;
                return t = this.get_item_class_name(e), this.$element.find("template[data-class='".concat(t, "']")).first().html().replace(this.options.regexp, this.get_index());
              }
            }, {
              key: "get_select",
              value: function get_select(t) {
                return e(t).siblings(".simple_form_nested_fields__select--add");
              }
            }, {
              key: "add_new_item",
              value: function add_new_item(t) {
                var n;
                return (n = e(this.get_template(t))).addClass(this.options.new_item_class_name), this.get_items_container().append(n);
              }
            }, {
              key: "remove_item",
              value: function remove_item(t) {
                var n;
                return (n = e(t).closest(".simple_form_nested_fields__item")).hasClass(this.options.new_item_class_name) ? n.remove() : (n.find("input[type=hidden]").val("1"), n.hide());
              }
            }]);

            return t;
          }(i.a);

          return t.defaults = {
            name: "SimpleFormNestedFields__Links",
            debug: !1,
            new_item_class_name: "simple_form_nested_fields__item--new",
            regexp: new RegExp("__INDEX_PLACEHOLDER__", "g")
          }, t;
        }.call(void 0);
      }).call(this, n(1));
    }, function (e, t, n) {
      "use strict";

      (function (e) {
        var i = n(0),
            r = n(4),
            o = n.n(r);

        t.a = function () {
          var t =
          /*#__PURE__*/
          function (_i$a2) {
            _inherits(t, _i$a2);

            function t() {
              _classCallCheck(this, t);

              return _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
            }

            _createClass(t, [{
              key: "init",
              value: function init() {
                var _this5 = this;

                if (!this.sortable) return this.sortable = new o.a(this.get_items_container()[0], {
                  animation: 150,
                  draggable: ".simple_form_nested_fields__item",
                  ghostClass: "simple_form_nested_fields__item_ghost",
                  handle: ".simple_form_nested_fields__item_handle",
                  onAdd: function onAdd(e) {
                    return _this5.update_item_positions();
                  },
                  onUpdate: function onUpdate(e) {
                    return _this5.update_item_positions();
                  },
                  onRemove: function onRemove(e) {
                    return _this5.update_item_positions();
                  }
                }), this.$element.on("update_item_positions.SimpleFormNestedFields__SortableFields", function (e) {
                  return e.stopPropagation(), _this5.update_item_positions();
                }), this.update_item_positions();
              }
            }, {
              key: "destroy",
              value: function destroy() {
                if (this.$element.off(".SimpleFormNestedFields__SortableFields"), this.sortable) return this.sortable.destroy();
              }
            }, {
              key: "update_item_positions",
              value: function update_item_positions() {
                return this.get_items().each(function (t, n) {
                  return e(n).find('input[name*="position"]').val(t + 1);
                });
              }
            }, {
              key: "get_items",
              value: function get_items() {
                return this.get_items_container().find(".simple_form_nested_fields__item");
              }
            }, {
              key: "get_items_container",
              value: function get_items_container() {
                return this.$element.find(".simple_form_nested_fields__items");
              }
            }]);

            return t;
          }(i.a);

          return t.defaults = {
            name: "SimpleFormNestedFields__SortableFields",
            debug: !1
          }, t;
        }.call(void 0);
      }).call(this, n(1));
    }, function (e, t) {
      e.exports = r;
    }, function (e, t, n) {
      "use strict";

      n.r(t);

      var i = n(0),
          r = n(2),
          o = n(3),
          a = function () {
        var e =
        /*#__PURE__*/
        function (_i$a3) {
          _inherits(e, _i$a3);

          function e() {
            _classCallCheck(this, e);

            return _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
          }

          _createClass(e, [{
            key: "init",
            value: function init() {
              if (this.Links || (this.Links = new r.a(this.element)), this.is_sortable() && !this.SortableFields) return this.SortableFields = new o.a(this.element);
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this.Links && this.Links.destroy(), this.Links = void 0, this.SortableFields && this.SortableFields.destroy(), this.SortableFields = void 0;
            }
          }, {
            key: "is_sortable",
            value: function is_sortable() {
              return this.element.classList.contains("simple_form_nested_fields--sortable");
            }
          }]);

          return e;
        }(i.a);

        return e.defaults = {
          name: "simple_form_nested_fields",
          debug: !1
        }, e;
      }.call(void 0);

      t["default"] = a;
    }]));
  }, function (e, t, n) {
    (function (t) {
      /* flatpickr v4.6.2, @license MIT */
      e.exports = function () {
        "use strict";
        /*! *****************************************************************************
            Copyright (c) Microsoft Corporation. All rights reserved.
            Licensed under the Apache License, Version 2.0 (the "License"); you may not use
            this file except in compliance with the License. You may obtain a copy of the
            License at http://www.apache.org/licenses/LICENSE-2.0
        
            THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
            KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
            WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
            MERCHANTABLITY OR NON-INFRINGEMENT.
        
            See the Apache Version 2.0 License for specific language governing permissions
            and limitations under the License.
            ***************************************************************************** */

        var _e2 = function e() {
          return (_e2 = Object.assign || function (e) {
            for (var t, n = 1, i = arguments.length; n < i; n++) {
              for (var r in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }

            return e;
          }).apply(this, arguments);
        },
            n = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"],
            i = {
          _disable: [],
          _enable: [],
          allowInput: !1,
          altFormat: "F j, Y",
          altInput: !1,
          altInputClass: "form-control input",
          animate: "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && -1 === window.navigator.userAgent.indexOf("MSIE"),
          ariaDateFormat: "F j, Y",
          clickOpens: !0,
          closeOnSelect: !0,
          conjunction: ", ",
          dateFormat: "Y-m-d",
          defaultHour: 12,
          defaultMinute: 0,
          defaultSeconds: 0,
          disable: [],
          disableMobile: !1,
          enable: [],
          enableSeconds: !1,
          enableTime: !1,
          errorHandler: function errorHandler(e) {
            return "undefined" != typeof console && console.warn(e);
          },
          getWeek: function getWeek(e) {
            var t = new Date(e.getTime());
            t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7);
            var n = new Date(t.getFullYear(), 0, 4);
            return 1 + Math.round(((t.getTime() - n.getTime()) / 864e5 - 3 + (n.getDay() + 6) % 7) / 7);
          },
          hourIncrement: 1,
          ignoredFocusElements: [],
          inline: !1,
          locale: "default",
          minuteIncrement: 5,
          mode: "single",
          monthSelectorType: "dropdown",
          nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
          noCalendar: !1,
          now: new Date(),
          onChange: [],
          onClose: [],
          onDayCreate: [],
          onDestroy: [],
          onKeyDown: [],
          onMonthChange: [],
          onOpen: [],
          onParseConfig: [],
          onReady: [],
          onValueUpdate: [],
          onYearChange: [],
          onPreCalendarPosition: [],
          plugins: [],
          position: "auto",
          positionElement: void 0,
          prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
          shorthandCurrentMonth: !1,
          showMonths: 1,
          "static": !1,
          time_24hr: !1,
          weekNumbers: !1,
          wrap: !1
        },
            r = {
          weekdays: {
            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
          },
          daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
          firstDayOfWeek: 0,
          ordinal: function ordinal(e) {
            var t = e % 100;
            if (t > 3 && t < 21) return "th";

            switch (t % 10) {
              case 1:
                return "st";

              case 2:
                return "nd";

              case 3:
                return "rd";

              default:
                return "th";
            }
          },
          rangeSeparator: " to ",
          weekAbbreviation: "Wk",
          scrollTitle: "Scroll to increment",
          toggleTitle: "Click to toggle",
          amPM: ["AM", "PM"],
          yearAriaLabel: "Year",
          hourAriaLabel: "Hour",
          minuteAriaLabel: "Minute",
          time_24hr: !1
        },
            o = function o(e) {
          return ("0" + e).slice(-2);
        },
            a = function a(e) {
          return !0 === e ? 1 : 0;
        };

        function s(e, t, n) {
          var i;
          return void 0 === n && (n = !1), function () {
            var r = this,
                o = arguments;
            null !== i && clearTimeout(i), i = window.setTimeout(function () {
              i = null, n || e.apply(r, o);
            }, t), n && !i && e.apply(r, o);
          };
        }

        var l = function l(e) {
          return e instanceof Array ? e : [e];
        };

        function c(e, t, n) {
          if (!0 === n) return e.classList.add(t);
          e.classList.remove(t);
        }

        function u(e, t, n) {
          var i = window.document.createElement(e);
          return t = t || "", n = n || "", i.className = t, void 0 !== n && (i.textContent = n), i;
        }

        function d(e) {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }
        }

        function p(e, t) {
          var n = u("div", "numInputWrapper"),
              i = u("input", "numInput " + e),
              r = u("span", "arrowUp"),
              o = u("span", "arrowDown");
          if (-1 === navigator.userAgent.indexOf("MSIE 9.0") ? i.type = "number" : (i.type = "text", i.pattern = "\\d*"), void 0 !== t) for (var a in t) {
            i.setAttribute(a, t[a]);
          }
          return n.appendChild(i), n.appendChild(r), n.appendChild(o), n;
        }

        var h = function h() {},
            f = function f(e, t, n) {
          return n.months[t ? "shorthand" : "longhand"][e];
        },
            m = {
          D: h,
          F: function F(e, t, n) {
            e.setMonth(n.months.longhand.indexOf(t));
          },
          G: function G(e, t) {
            e.setHours(parseFloat(t));
          },
          H: function H(e, t) {
            e.setHours(parseFloat(t));
          },
          J: function J(e, t) {
            e.setDate(parseFloat(t));
          },
          K: function K(e, t, n) {
            e.setHours(e.getHours() % 12 + 12 * a(new RegExp(n.amPM[1], "i").test(t)));
          },
          M: function M(e, t, n) {
            e.setMonth(n.months.shorthand.indexOf(t));
          },
          S: function S(e, t) {
            e.setSeconds(parseFloat(t));
          },
          U: function U(e, t) {
            return new Date(1e3 * parseFloat(t));
          },
          W: function W(e, t, n) {
            var i = parseInt(t),
                r = new Date(e.getFullYear(), 0, 2 + 7 * (i - 1), 0, 0, 0, 0);
            return r.setDate(r.getDate() - r.getDay() + n.firstDayOfWeek), r;
          },
          Y: function Y(e, t) {
            e.setFullYear(parseFloat(t));
          },
          Z: function Z(e, t) {
            return new Date(t);
          },
          d: function d(e, t) {
            e.setDate(parseFloat(t));
          },
          h: function h(e, t) {
            e.setHours(parseFloat(t));
          },
          i: function i(e, t) {
            e.setMinutes(parseFloat(t));
          },
          j: function j(e, t) {
            e.setDate(parseFloat(t));
          },
          l: h,
          m: function m(e, t) {
            e.setMonth(parseFloat(t) - 1);
          },
          n: function n(e, t) {
            e.setMonth(parseFloat(t) - 1);
          },
          s: function s(e, t) {
            e.setSeconds(parseFloat(t));
          },
          u: function u(e, t) {
            return new Date(parseFloat(t));
          },
          w: h,
          y: function y(e, t) {
            e.setFullYear(2e3 + parseFloat(t));
          }
        },
            g = {
          D: "(\\w+)",
          F: "(\\w+)",
          G: "(\\d\\d|\\d)",
          H: "(\\d\\d|\\d)",
          J: "(\\d\\d|\\d)\\w+",
          K: "",
          M: "(\\w+)",
          S: "(\\d\\d|\\d)",
          U: "(.+)",
          W: "(\\d\\d|\\d)",
          Y: "(\\d{4})",
          Z: "(.+)",
          d: "(\\d\\d|\\d)",
          h: "(\\d\\d|\\d)",
          i: "(\\d\\d|\\d)",
          j: "(\\d\\d|\\d)",
          l: "(\\w+)",
          m: "(\\d\\d|\\d)",
          n: "(\\d\\d|\\d)",
          s: "(\\d\\d|\\d)",
          u: "(.+)",
          w: "(\\d\\d|\\d)",
          y: "(\\d{2})"
        },
            v = {
          Z: function Z(e) {
            return e.toISOString();
          },
          D: function D(e, t, n) {
            return t.weekdays.shorthand[v.w(e, t, n)];
          },
          F: function F(e, t, n) {
            return f(v.n(e, t, n) - 1, !1, t);
          },
          G: function G(e, t, n) {
            return o(v.h(e, t, n));
          },
          H: function H(e) {
            return o(e.getHours());
          },
          J: function J(e, t) {
            return void 0 !== t.ordinal ? e.getDate() + t.ordinal(e.getDate()) : e.getDate();
          },
          K: function K(e, t) {
            return t.amPM[a(e.getHours() > 11)];
          },
          M: function M(e, t) {
            return f(e.getMonth(), !0, t);
          },
          S: function S(e) {
            return o(e.getSeconds());
          },
          U: function U(e) {
            return e.getTime() / 1e3;
          },
          W: function W(e, t, n) {
            return n.getWeek(e);
          },
          Y: function Y(e) {
            return e.getFullYear();
          },
          d: function d(e) {
            return o(e.getDate());
          },
          h: function h(e) {
            return e.getHours() % 12 ? e.getHours() % 12 : 12;
          },
          i: function i(e) {
            return o(e.getMinutes());
          },
          j: function j(e) {
            return e.getDate();
          },
          l: function l(e, t) {
            return t.weekdays.longhand[e.getDay()];
          },
          m: function m(e) {
            return o(e.getMonth() + 1);
          },
          n: function n(e) {
            return e.getMonth() + 1;
          },
          s: function s(e) {
            return e.getSeconds();
          },
          u: function u(e) {
            return e.getTime();
          },
          w: function w(e) {
            return e.getDay();
          },
          y: function y(e) {
            return String(e.getFullYear()).substring(2);
          }
        },
            b = function b(e) {
          var t = e.config,
              n = void 0 === t ? i : t,
              o = e.l10n,
              a = void 0 === o ? r : o;
          return function (e, t, i) {
            var r = i || a;
            return void 0 !== n.formatDate ? n.formatDate(e, t, r) : t.split("").map(function (t, i, o) {
              return v[t] && "\\" !== o[i - 1] ? v[t](e, r, n) : "\\" !== t ? t : "";
            }).join("");
          };
        },
            y = function y(e) {
          var t = e.config,
              n = void 0 === t ? i : t,
              o = e.l10n,
              a = void 0 === o ? r : o;
          return function (e, t, r, o) {
            if (0 === e || e) {
              var s,
                  l = o || a,
                  c = e;
              if (e instanceof Date) s = new Date(e.getTime());else if ("string" != typeof e && void 0 !== e.toFixed) s = new Date(e);else if ("string" == typeof e) {
                var u = t || (n || i).dateFormat,
                    d = String(e).trim();
                if ("today" === d) s = new Date(), r = !0;else if (/Z$/.test(d) || /GMT$/.test(d)) s = new Date(e);else if (n && n.parseDate) s = n.parseDate(e, u);else {
                  s = n && n.noCalendar ? new Date(new Date().setHours(0, 0, 0, 0)) : new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);

                  for (var p = void 0, h = [], f = 0, v = 0, b = ""; f < u.length; f++) {
                    var y = u[f],
                        _ = "\\" === y,
                        w = "\\" === u[f - 1] || _;

                    if (g[y] && !w) {
                      b += g[y];
                      var x = new RegExp(b).exec(e);
                      x && (p = !0) && h["Y" !== y ? "push" : "unshift"]({
                        fn: m[y],
                        val: x[++v]
                      });
                    } else _ || (b += ".");

                    h.forEach(function (e) {
                      var t = e.fn,
                          n = e.val;
                      return s = t(s, n, l) || s;
                    });
                  }

                  s = p ? s : void 0;
                }
              }
              if (s instanceof Date && !isNaN(s.getTime())) return !0 === r && s.setHours(0, 0, 0, 0), s;
              n.errorHandler(new Error("Invalid date provided: " + c));
            }
          };
        };

        function _(e, t, n) {
          return void 0 === n && (n = !0), !1 !== n ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : e.getTime() - t.getTime();
        }

        var w = function w(e, t, n) {
          return e > Math.min(t, n) && e < Math.max(t, n);
        },
            x = {
          DAY: 864e5
        };

        "function" != typeof Object.assign && (Object.assign = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) {
            t[n - 1] = arguments[n];
          }

          if (!e) throw TypeError("Cannot convert undefined or null to object");

          for (var i = function i(t) {
            t && Object.keys(t).forEach(function (n) {
              return e[n] = t[n];
            });
          }, r = 0, o = t; r < o.length; r++) {
            var a = o[r];
            i(a);
          }

          return e;
        });
        var C = 300;

        function S(t, h) {
          var m = {
            config: _e2({}, i, E.defaultConfig),
            l10n: r
          };

          function v(e) {
            return e.bind(m);
          }

          function S() {
            var e = m.config;
            !1 === e.weekNumbers && 1 === e.showMonths || !0 !== e.noCalendar && window.requestAnimationFrame(function () {
              if (void 0 !== m.calendarContainer && (m.calendarContainer.style.visibility = "hidden", m.calendarContainer.style.display = "block"), void 0 !== m.daysContainer) {
                var t = (m.days.offsetWidth + 1) * e.showMonths;
                m.daysContainer.style.width = t + "px", m.calendarContainer.style.width = t + (void 0 !== m.weekWrapper ? m.weekWrapper.offsetWidth : 0) + "px", m.calendarContainer.style.removeProperty("visibility"), m.calendarContainer.style.removeProperty("display");
              }
            });
          }

          function D(e) {
            0 === m.selectedDates.length && ae(), void 0 !== e && "blur" !== e.type && function (e) {
              e.preventDefault();
              var t = "keydown" === e.type,
                  n = e.target;
              void 0 !== m.amPM && e.target === m.amPM && (m.amPM.textContent = m.l10n.amPM[a(m.amPM.textContent === m.l10n.amPM[0])]);
              var i = parseFloat(n.getAttribute("min")),
                  r = parseFloat(n.getAttribute("max")),
                  s = parseFloat(n.getAttribute("step")),
                  l = parseInt(n.value, 10),
                  c = e.delta || (t ? 38 === e.which ? 1 : -1 : 0),
                  u = l + s * c;

              if (void 0 !== n.value && 2 === n.value.length) {
                var d = n === m.hourElement,
                    p = n === m.minuteElement;
                u < i ? (u = r + u + a(!d) + (a(d) && a(!m.amPM)), p && R(void 0, -1, m.hourElement)) : u > r && (u = n === m.hourElement ? u - r - a(!m.amPM) : i, p && R(void 0, 1, m.hourElement)), m.amPM && d && (1 === s ? u + l === 23 : Math.abs(u - l) > s) && (m.amPM.textContent = m.l10n.amPM[a(m.amPM.textContent === m.l10n.amPM[0])]), n.value = o(u);
              }
            }(e);
            var t = m._input.value;
            k(), we(), m._input.value !== t && m._debouncedChange();
          }

          function k() {
            if (void 0 !== m.hourElement && void 0 !== m.minuteElement) {
              var e,
                  t,
                  n = (parseInt(m.hourElement.value.slice(-2), 10) || 0) % 24,
                  i = (parseInt(m.minuteElement.value, 10) || 0) % 60,
                  r = void 0 !== m.secondElement ? (parseInt(m.secondElement.value, 10) || 0) % 60 : 0;
              void 0 !== m.amPM && (e = n, t = m.amPM.textContent, n = e % 12 + 12 * a(t === m.l10n.amPM[1]));

              var o = void 0 !== m.config.minTime || m.config.minDate && m.minDateHasTime && m.latestSelectedDateObj && 0 === _(m.latestSelectedDateObj, m.config.minDate, !0),
                  s = void 0 !== m.config.maxTime || m.config.maxDate && m.maxDateHasTime && m.latestSelectedDateObj && 0 === _(m.latestSelectedDateObj, m.config.maxDate, !0);

              if (s) {
                var l = void 0 !== m.config.maxTime ? m.config.maxTime : m.config.maxDate;
                (n = Math.min(n, l.getHours())) === l.getHours() && (i = Math.min(i, l.getMinutes())), i === l.getMinutes() && (r = Math.min(r, l.getSeconds()));
              }

              if (o) {
                var c = void 0 !== m.config.minTime ? m.config.minTime : m.config.minDate;
                (n = Math.max(n, c.getHours())) === c.getHours() && (i = Math.max(i, c.getMinutes())), i === c.getMinutes() && (r = Math.max(r, c.getSeconds()));
              }

              P(n, i, r);
            }
          }

          function T(e) {
            var t = e || m.latestSelectedDateObj;
            t && P(t.getHours(), t.getMinutes(), t.getSeconds());
          }

          function O() {
            var e = m.config.defaultHour,
                t = m.config.defaultMinute,
                n = m.config.defaultSeconds;

            if (void 0 !== m.config.minDate) {
              var i = m.config.minDate.getHours(),
                  r = m.config.minDate.getMinutes();
              (e = Math.max(e, i)) === i && (t = Math.max(r, t)), e === i && t === r && (n = m.config.minDate.getSeconds());
            }

            if (void 0 !== m.config.maxDate) {
              var o = m.config.maxDate.getHours(),
                  a = m.config.maxDate.getMinutes();
              (e = Math.min(e, o)) === o && (t = Math.min(a, t)), e === o && t === a && (n = m.config.maxDate.getSeconds());
            }

            P(e, t, n);
          }

          function P(e, t, n) {
            void 0 !== m.latestSelectedDateObj && m.latestSelectedDateObj.setHours(e % 24, t, n || 0, 0), m.hourElement && m.minuteElement && !m.isMobile && (m.hourElement.value = o(m.config.time_24hr ? e : (12 + e) % 12 + 12 * a(e % 12 == 0)), m.minuteElement.value = o(t), void 0 !== m.amPM && (m.amPM.textContent = m.l10n.amPM[a(e >= 12)]), void 0 !== m.secondElement && (m.secondElement.value = o(n)));
          }

          function A(e) {
            var t = parseInt(e.target.value) + (e.delta || 0);
            (t / 1e3 > 1 || "Enter" === e.key && !/[^\d]/.test(t.toString())) && ee(t);
          }

          function M(e, t, n, i) {
            return t instanceof Array ? t.forEach(function (t) {
              return M(e, t, n, i);
            }) : e instanceof Array ? e.forEach(function (e) {
              return M(e, t, n, i);
            }) : (e.addEventListener(t, n, i), void m._handlers.push({
              element: e,
              event: t,
              handler: n,
              options: i
            }));
          }

          function N(e) {
            return function (t) {
              1 === t.which && e(t);
            };
          }

          function I() {
            ge("onChange");
          }

          function F() {
            if (m.config.wrap && ["open", "close", "toggle", "clear"].forEach(function (e) {
              Array.prototype.forEach.call(m.element.querySelectorAll("[data-" + e + "]"), function (t) {
                return M(t, "click", m[e]);
              });
            }), m.isMobile) !function () {
              var e = m.config.enableTime ? m.config.noCalendar ? "time" : "datetime-local" : "date";
              m.mobileInput = u("input", m.input.className + " flatpickr-mobile"), m.mobileInput.step = m.input.getAttribute("step") || "any", m.mobileInput.tabIndex = 1, m.mobileInput.type = e, m.mobileInput.disabled = m.input.disabled, m.mobileInput.required = m.input.required, m.mobileInput.placeholder = m.input.placeholder, m.mobileFormatStr = "datetime-local" === e ? "Y-m-d\\TH:i:S" : "date" === e ? "Y-m-d" : "H:i:S", m.selectedDates.length > 0 && (m.mobileInput.defaultValue = m.mobileInput.value = m.formatDate(m.selectedDates[0], m.mobileFormatStr)), m.config.minDate && (m.mobileInput.min = m.formatDate(m.config.minDate, "Y-m-d")), m.config.maxDate && (m.mobileInput.max = m.formatDate(m.config.maxDate, "Y-m-d")), m.input.type = "hidden", void 0 !== m.altInput && (m.altInput.type = "hidden");

              try {
                m.input.parentNode && m.input.parentNode.insertBefore(m.mobileInput, m.input.nextSibling);
              } catch (e) {}

              M(m.mobileInput, "change", function (e) {
                m.setDate(e.target.value, !1, m.mobileFormatStr), ge("onChange"), ge("onClose");
              });
            }();else {
              var e = s(oe, 50);
              m._debouncedChange = s(I, C), m.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && M(m.daysContainer, "mouseover", function (e) {
                "range" === m.config.mode && re(e.target);
              }), M(window.document.body, "keydown", ie), m.config.inline || m.config["static"] || M(window, "resize", e), void 0 !== window.ontouchstart ? M(window.document, "touchstart", J) : M(window.document, "mousedown", N(J)), M(window.document, "focus", J, {
                capture: !0
              }), !0 === m.config.clickOpens && (M(m._input, "focus", m.open), M(m._input, "mousedown", N(m.open))), void 0 !== m.daysContainer && (M(m.monthNav, "mousedown", N(xe)), M(m.monthNav, ["keyup", "increment"], A), M(m.daysContainer, "mousedown", N(pe))), void 0 !== m.timeContainer && void 0 !== m.minuteElement && void 0 !== m.hourElement && (M(m.timeContainer, ["increment"], D), M(m.timeContainer, "blur", D, {
                capture: !0
              }), M(m.timeContainer, "mousedown", N(L)), M([m.hourElement, m.minuteElement], ["focus", "click"], function (e) {
                return e.target.select();
              }), void 0 !== m.secondElement && M(m.secondElement, "focus", function () {
                return m.secondElement && m.secondElement.select();
              }), void 0 !== m.amPM && M(m.amPM, "mousedown", N(function (e) {
                D(e), I();
              })));
            }
          }

          function j(e, t) {
            var n = void 0 !== e ? m.parseDate(e) : m.latestSelectedDateObj || (m.config.minDate && m.config.minDate > m.now ? m.config.minDate : m.config.maxDate && m.config.maxDate < m.now ? m.config.maxDate : m.now),
                i = m.currentYear,
                r = m.currentMonth;

            try {
              void 0 !== n && (m.currentYear = n.getFullYear(), m.currentMonth = n.getMonth());
            } catch (e) {
              e.message = "Invalid date supplied: " + n, m.config.errorHandler(e);
            }

            t && m.currentYear !== i && (ge("onYearChange"), X()), !t || m.currentYear === i && m.currentMonth === r || ge("onMonthChange"), m.redraw();
          }

          function L(e) {
            ~e.target.className.indexOf("arrow") && R(e, e.target.classList.contains("arrowUp") ? 1 : -1);
          }

          function R(e, t, n) {
            var i = e && e.target,
                r = n || i && i.parentNode && i.parentNode.firstChild,
                o = ve("increment");
            o.delta = t, r && r.dispatchEvent(o);
          }

          function H() {
            var e = window.document.createDocumentFragment();

            if (m.calendarContainer = u("div", "flatpickr-calendar"), m.calendarContainer.tabIndex = -1, !m.config.noCalendar) {
              if (e.appendChild((m.monthNav = u("div", "flatpickr-months"), m.yearElements = [], m.monthElements = [], m.prevMonthNav = u("span", "flatpickr-prev-month"), m.prevMonthNav.innerHTML = m.config.prevArrow, m.nextMonthNav = u("span", "flatpickr-next-month"), m.nextMonthNav.innerHTML = m.config.nextArrow, V(), Object.defineProperty(m, "_hidePrevMonthArrow", {
                get: function get() {
                  return m.__hidePrevMonthArrow;
                },
                set: function set(e) {
                  m.__hidePrevMonthArrow !== e && (c(m.prevMonthNav, "flatpickr-disabled", e), m.__hidePrevMonthArrow = e);
                }
              }), Object.defineProperty(m, "_hideNextMonthArrow", {
                get: function get() {
                  return m.__hideNextMonthArrow;
                },
                set: function set(e) {
                  m.__hideNextMonthArrow !== e && (c(m.nextMonthNav, "flatpickr-disabled", e), m.__hideNextMonthArrow = e);
                }
              }), m.currentYearElement = m.yearElements[0], ye(), m.monthNav)), m.innerContainer = u("div", "flatpickr-innerContainer"), m.config.weekNumbers) {
                var t = function () {
                  m.calendarContainer.classList.add("hasWeeks");
                  var e = u("div", "flatpickr-weekwrapper");
                  e.appendChild(u("span", "flatpickr-weekday", m.l10n.weekAbbreviation));
                  var t = u("div", "flatpickr-weeks");
                  return e.appendChild(t), {
                    weekWrapper: e,
                    weekNumbers: t
                  };
                }(),
                    n = t.weekWrapper,
                    i = t.weekNumbers;

                m.innerContainer.appendChild(n), m.weekNumbers = i, m.weekWrapper = n;
              }

              m.rContainer = u("div", "flatpickr-rContainer"), m.rContainer.appendChild(K()), m.daysContainer || (m.daysContainer = u("div", "flatpickr-days"), m.daysContainer.tabIndex = -1), Y(), m.rContainer.appendChild(m.daysContainer), m.innerContainer.appendChild(m.rContainer), e.appendChild(m.innerContainer);
            }

            m.config.enableTime && e.appendChild(function () {
              m.calendarContainer.classList.add("hasTime"), m.config.noCalendar && m.calendarContainer.classList.add("noCalendar"), m.timeContainer = u("div", "flatpickr-time"), m.timeContainer.tabIndex = -1;
              var e = u("span", "flatpickr-time-separator", ":"),
                  t = p("flatpickr-hour", {
                "aria-label": m.l10n.hourAriaLabel
              });
              m.hourElement = t.getElementsByTagName("input")[0];
              var n = p("flatpickr-minute", {
                "aria-label": m.l10n.minuteAriaLabel
              });

              if (m.minuteElement = n.getElementsByTagName("input")[0], m.hourElement.tabIndex = m.minuteElement.tabIndex = -1, m.hourElement.value = o(m.latestSelectedDateObj ? m.latestSelectedDateObj.getHours() : m.config.time_24hr ? m.config.defaultHour : function (e) {
                switch (e % 24) {
                  case 0:
                  case 12:
                    return 12;

                  default:
                    return e % 12;
                }
              }(m.config.defaultHour)), m.minuteElement.value = o(m.latestSelectedDateObj ? m.latestSelectedDateObj.getMinutes() : m.config.defaultMinute), m.hourElement.setAttribute("step", m.config.hourIncrement.toString()), m.minuteElement.setAttribute("step", m.config.minuteIncrement.toString()), m.hourElement.setAttribute("min", m.config.time_24hr ? "0" : "1"), m.hourElement.setAttribute("max", m.config.time_24hr ? "23" : "12"), m.minuteElement.setAttribute("min", "0"), m.minuteElement.setAttribute("max", "59"), m.timeContainer.appendChild(t), m.timeContainer.appendChild(e), m.timeContainer.appendChild(n), m.config.time_24hr && m.timeContainer.classList.add("time24hr"), m.config.enableSeconds) {
                m.timeContainer.classList.add("hasSeconds");
                var i = p("flatpickr-second");
                m.secondElement = i.getElementsByTagName("input")[0], m.secondElement.value = o(m.latestSelectedDateObj ? m.latestSelectedDateObj.getSeconds() : m.config.defaultSeconds), m.secondElement.setAttribute("step", m.minuteElement.getAttribute("step")), m.secondElement.setAttribute("min", "0"), m.secondElement.setAttribute("max", "59"), m.timeContainer.appendChild(u("span", "flatpickr-time-separator", ":")), m.timeContainer.appendChild(i);
              }

              return m.config.time_24hr || (m.amPM = u("span", "flatpickr-am-pm", m.l10n.amPM[a((m.latestSelectedDateObj ? m.hourElement.value : m.config.defaultHour) > 11)]), m.amPM.title = m.l10n.toggleTitle, m.amPM.tabIndex = -1, m.timeContainer.appendChild(m.amPM)), m.timeContainer;
            }()), c(m.calendarContainer, "rangeMode", "range" === m.config.mode), c(m.calendarContainer, "animate", !0 === m.config.animate), c(m.calendarContainer, "multiMonth", m.config.showMonths > 1), m.calendarContainer.appendChild(e);
            var r = void 0 !== m.config.appendTo && void 0 !== m.config.appendTo.nodeType;

            if ((m.config.inline || m.config["static"]) && (m.calendarContainer.classList.add(m.config.inline ? "inline" : "static"), m.config.inline && (!r && m.element.parentNode ? m.element.parentNode.insertBefore(m.calendarContainer, m._input.nextSibling) : void 0 !== m.config.appendTo && m.config.appendTo.appendChild(m.calendarContainer)), m.config["static"])) {
              var s = u("div", "flatpickr-wrapper");
              m.element.parentNode && m.element.parentNode.insertBefore(s, m.element), s.appendChild(m.element), m.altInput && s.appendChild(m.altInput), s.appendChild(m.calendarContainer);
            }

            m.config["static"] || m.config.inline || (void 0 !== m.config.appendTo ? m.config.appendTo : window.document.body).appendChild(m.calendarContainer);
          }

          function B(e, t, n, i) {
            var r = te(t, !0),
                o = u("span", "flatpickr-day " + e, t.getDate().toString());
            return o.dateObj = t, o.$i = i, o.setAttribute("aria-label", m.formatDate(t, m.config.ariaDateFormat)), -1 === e.indexOf("hidden") && 0 === _(t, m.now) && (m.todayDateElem = o, o.classList.add("today"), o.setAttribute("aria-current", "date")), r ? (o.tabIndex = -1, be(t) && (o.classList.add("selected"), m.selectedDateElem = o, "range" === m.config.mode && (c(o, "startRange", m.selectedDates[0] && 0 === _(t, m.selectedDates[0], !0)), c(o, "endRange", m.selectedDates[1] && 0 === _(t, m.selectedDates[1], !0)), "nextMonthDay" === e && o.classList.add("inRange")))) : o.classList.add("flatpickr-disabled"), "range" === m.config.mode && function (e) {
              return !("range" !== m.config.mode || m.selectedDates.length < 2) && _(e, m.selectedDates[0]) >= 0 && _(e, m.selectedDates[1]) <= 0;
            }(t) && !be(t) && o.classList.add("inRange"), m.weekNumbers && 1 === m.config.showMonths && "prevMonthDay" !== e && n % 7 == 1 && m.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + m.config.getWeek(t) + "</span>"), ge("onDayCreate", o), o;
          }

          function q(e) {
            e.focus(), "range" === m.config.mode && re(e);
          }

          function $(e) {
            for (var t = e > 0 ? 0 : m.config.showMonths - 1, n = e > 0 ? m.config.showMonths : -1, i = t; i != n; i += e) {
              for (var r = m.daysContainer.children[i], o = e > 0 ? 0 : r.children.length - 1, a = e > 0 ? r.children.length : -1, s = o; s != a; s += e) {
                var l = r.children[s];
                if (-1 === l.className.indexOf("hidden") && te(l.dateObj)) return l;
              }
            }
          }

          function W(e, t) {
            var n = ne(document.activeElement || document.body),
                i = void 0 !== e ? e : n ? document.activeElement : void 0 !== m.selectedDateElem && ne(m.selectedDateElem) ? m.selectedDateElem : void 0 !== m.todayDateElem && ne(m.todayDateElem) ? m.todayDateElem : $(t > 0 ? 1 : -1);
            return void 0 === i ? m._input.focus() : n ? void function (e, t) {
              for (var n = -1 === e.className.indexOf("Month") ? e.dateObj.getMonth() : m.currentMonth, i = t > 0 ? m.config.showMonths : -1, r = t > 0 ? 1 : -1, o = n - m.currentMonth; o != i; o += r) {
                for (var a = m.daysContainer.children[o], s = n - m.currentMonth === o ? e.$i + t : t < 0 ? a.children.length - 1 : 0, l = a.children.length, c = s; c >= 0 && c < l && c != (t > 0 ? l : -1); c += r) {
                  var u = a.children[c];
                  if (-1 === u.className.indexOf("hidden") && te(u.dateObj) && Math.abs(e.$i - c) >= Math.abs(t)) return q(u);
                }
              }

              m.changeMonth(r), W($(r), 0);
            }(i, t) : q(i);
          }

          function U(e, t) {
            for (var n = (new Date(e, t, 1).getDay() - m.l10n.firstDayOfWeek + 7) % 7, i = m.utils.getDaysInMonth((t - 1 + 12) % 12), r = m.utils.getDaysInMonth(t), o = window.document.createDocumentFragment(), a = m.config.showMonths > 1, s = a ? "prevMonthDay hidden" : "prevMonthDay", l = a ? "nextMonthDay hidden" : "nextMonthDay", c = i + 1 - n, d = 0; c <= i; c++, d++) {
              o.appendChild(B(s, new Date(e, t - 1, c), c, d));
            }

            for (c = 1; c <= r; c++, d++) {
              o.appendChild(B("", new Date(e, t, c), c, d));
            }

            for (var p = r + 1; p <= 42 - n && (1 === m.config.showMonths || d % 7 != 0); p++, d++) {
              o.appendChild(B(l, new Date(e, t + 1, p % r), p, d));
            }

            var h = u("div", "dayContainer");
            return h.appendChild(o), h;
          }

          function Y() {
            if (void 0 !== m.daysContainer) {
              d(m.daysContainer), m.weekNumbers && d(m.weekNumbers);

              for (var e = document.createDocumentFragment(), t = 0; t < m.config.showMonths; t++) {
                var n = new Date(m.currentYear, m.currentMonth, 1);
                n.setMonth(m.currentMonth + t), e.appendChild(U(n.getFullYear(), n.getMonth()));
              }

              m.daysContainer.appendChild(e), m.days = m.daysContainer.firstChild, "range" === m.config.mode && 1 === m.selectedDates.length && re();
            }
          }

          function X() {
            if (!(m.config.showMonths > 1 || "dropdown" !== m.config.monthSelectorType)) {
              var e = function e(_e3) {
                return !(void 0 !== m.config.minDate && m.currentYear === m.config.minDate.getFullYear() && _e3 < m.config.minDate.getMonth() || void 0 !== m.config.maxDate && m.currentYear === m.config.maxDate.getFullYear() && _e3 > m.config.maxDate.getMonth());
              };

              m.monthsDropdownContainer.tabIndex = -1, m.monthsDropdownContainer.innerHTML = "";

              for (var t = 0; t < 12; t++) {
                if (e(t)) {
                  var n = u("option", "flatpickr-monthDropdown-month");
                  n.value = new Date(m.currentYear, t).getMonth().toString(), n.textContent = f(t, m.config.shorthandCurrentMonth, m.l10n), n.tabIndex = -1, m.currentMonth === t && (n.selected = !0), m.monthsDropdownContainer.appendChild(n);
                }
              }
            }
          }

          function z() {
            var e,
                t = u("div", "flatpickr-month"),
                n = window.document.createDocumentFragment();
            m.config.showMonths > 1 || "static" === m.config.monthSelectorType ? e = u("span", "cur-month") : (m.monthsDropdownContainer = u("select", "flatpickr-monthDropdown-months"), M(m.monthsDropdownContainer, "change", function (e) {
              var t = e.target,
                  n = parseInt(t.value, 10);
              m.changeMonth(n - m.currentMonth), ge("onMonthChange");
            }), X(), e = m.monthsDropdownContainer);
            var i = p("cur-year", {
              tabindex: "-1"
            }),
                r = i.getElementsByTagName("input")[0];
            r.setAttribute("aria-label", m.l10n.yearAriaLabel), m.config.minDate && r.setAttribute("min", m.config.minDate.getFullYear().toString()), m.config.maxDate && (r.setAttribute("max", m.config.maxDate.getFullYear().toString()), r.disabled = !!m.config.minDate && m.config.minDate.getFullYear() === m.config.maxDate.getFullYear());
            var o = u("div", "flatpickr-current-month");
            return o.appendChild(e), o.appendChild(i), n.appendChild(o), t.appendChild(n), {
              container: t,
              yearElement: r,
              monthElement: e
            };
          }

          function V() {
            d(m.monthNav), m.monthNav.appendChild(m.prevMonthNav), m.config.showMonths && (m.yearElements = [], m.monthElements = []);

            for (var e = m.config.showMonths; e--;) {
              var t = z();
              m.yearElements.push(t.yearElement), m.monthElements.push(t.monthElement), m.monthNav.appendChild(t.container);
            }

            m.monthNav.appendChild(m.nextMonthNav);
          }

          function K() {
            m.weekdayContainer ? d(m.weekdayContainer) : m.weekdayContainer = u("div", "flatpickr-weekdays");

            for (var e = m.config.showMonths; e--;) {
              var t = u("div", "flatpickr-weekdaycontainer");
              m.weekdayContainer.appendChild(t);
            }

            return Q(), m.weekdayContainer;
          }

          function Q() {
            var e = m.l10n.firstDayOfWeek,
                t = m.l10n.weekdays.shorthand.slice();
            e > 0 && e < t.length && (t = t.splice(e, t.length).concat(t.splice(0, e)));

            for (var n = m.config.showMonths; n--;) {
              m.weekdayContainer.children[n].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + t.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
            }
          }

          function Z(e, t) {
            void 0 === t && (t = !0);
            var n = t ? e : e - m.currentMonth;
            n < 0 && !0 === m._hidePrevMonthArrow || n > 0 && !0 === m._hideNextMonthArrow || (m.currentMonth += n, (m.currentMonth < 0 || m.currentMonth > 11) && (m.currentYear += m.currentMonth > 11 ? 1 : -1, m.currentMonth = (m.currentMonth + 12) % 12, ge("onYearChange"), X()), Y(), ge("onMonthChange"), ye());
          }

          function G(e) {
            return !(!m.config.appendTo || !m.config.appendTo.contains(e)) || m.calendarContainer.contains(e);
          }

          function J(e) {
            if (m.isOpen && !m.config.inline) {
              var t = function (e) {
                if ("function" == typeof e.composedPath) {
                  var t = e.composedPath();
                  return t[0];
                }

                return e.target;
              }(e),
                  n = G(t),
                  i = t === m.input || t === m.altInput || m.element.contains(t) || e.path && e.path.indexOf && (~e.path.indexOf(m.input) || ~e.path.indexOf(m.altInput)),
                  r = "blur" === e.type ? i && e.relatedTarget && !G(e.relatedTarget) : !i && !n && !G(e.relatedTarget),
                  o = !m.config.ignoredFocusElements.some(function (e) {
                return e.contains(t);
              });

              r && o && (m.close(), "range" === m.config.mode && 1 === m.selectedDates.length && (m.clear(!1), m.redraw()));
            }
          }

          function ee(e) {
            if (!(!e || m.config.minDate && e < m.config.minDate.getFullYear() || m.config.maxDate && e > m.config.maxDate.getFullYear())) {
              var t = e,
                  n = m.currentYear !== t;
              m.currentYear = t || m.currentYear, m.config.maxDate && m.currentYear === m.config.maxDate.getFullYear() ? m.currentMonth = Math.min(m.config.maxDate.getMonth(), m.currentMonth) : m.config.minDate && m.currentYear === m.config.minDate.getFullYear() && (m.currentMonth = Math.max(m.config.minDate.getMonth(), m.currentMonth)), n && (m.redraw(), ge("onYearChange"), X());
            }
          }

          function te(e, t) {
            void 0 === t && (t = !0);
            var n = m.parseDate(e, void 0, t);
            if (m.config.minDate && n && _(n, m.config.minDate, void 0 !== t ? t : !m.minDateHasTime) < 0 || m.config.maxDate && n && _(n, m.config.maxDate, void 0 !== t ? t : !m.maxDateHasTime) > 0) return !1;
            if (0 === m.config.enable.length && 0 === m.config.disable.length) return !0;
            if (void 0 === n) return !1;

            for (var i = m.config.enable.length > 0, r = i ? m.config.enable : m.config.disable, o = 0, a = void 0; o < r.length; o++) {
              if ("function" == typeof (a = r[o]) && a(n)) return i;
              if (a instanceof Date && void 0 !== n && a.getTime() === n.getTime()) return i;

              if ("string" == typeof a && void 0 !== n) {
                var s = m.parseDate(a, void 0, !0);
                return s && s.getTime() === n.getTime() ? i : !i;
              }

              if ("object" == _typeof(a) && void 0 !== n && a.from && a.to && n.getTime() >= a.from.getTime() && n.getTime() <= a.to.getTime()) return i;
            }

            return !i;
          }

          function ne(e) {
            return void 0 !== m.daysContainer && -1 === e.className.indexOf("hidden") && m.daysContainer.contains(e);
          }

          function ie(e) {
            var t = e.target === m._input,
                n = m.config.allowInput,
                i = m.isOpen && (!n || !t),
                r = m.config.inline && t && !n;

            if (13 === e.keyCode && t) {
              if (n) return m.setDate(m._input.value, !0, e.target === m.altInput ? m.config.altFormat : m.config.dateFormat), e.target.blur();
              m.open();
            } else if (G(e.target) || i || r) {
              var o = !!m.timeContainer && m.timeContainer.contains(e.target);

              switch (e.keyCode) {
                case 13:
                  o ? (e.preventDefault(), D(), de()) : pe(e);
                  break;

                case 27:
                  e.preventDefault(), de();
                  break;

                case 8:
                case 46:
                  t && !m.config.allowInput && (e.preventDefault(), m.clear());
                  break;

                case 37:
                case 39:
                  if (o || t) m.hourElement && m.hourElement.focus();else if (e.preventDefault(), void 0 !== m.daysContainer && (!1 === n || document.activeElement && ne(document.activeElement))) {
                    var a = 39 === e.keyCode ? 1 : -1;
                    e.ctrlKey ? (e.stopPropagation(), Z(a), W($(1), 0)) : W(void 0, a);
                  }
                  break;

                case 38:
                case 40:
                  e.preventDefault();
                  var s = 40 === e.keyCode ? 1 : -1;
                  m.daysContainer && void 0 !== e.target.$i || e.target === m.input ? e.ctrlKey ? (e.stopPropagation(), ee(m.currentYear - s), W($(1), 0)) : o || W(void 0, 7 * s) : e.target === m.currentYearElement ? ee(m.currentYear - s) : m.config.enableTime && (!o && m.hourElement && m.hourElement.focus(), D(e), m._debouncedChange());
                  break;

                case 9:
                  if (o) {
                    var l = [m.hourElement, m.minuteElement, m.secondElement, m.amPM].concat(m.pluginElements).filter(function (e) {
                      return e;
                    }),
                        c = l.indexOf(e.target);

                    if (-1 !== c) {
                      var u = l[c + (e.shiftKey ? -1 : 1)];
                      e.preventDefault(), (u || m._input).focus();
                    }
                  } else !m.config.noCalendar && m.daysContainer && m.daysContainer.contains(e.target) && e.shiftKey && (e.preventDefault(), m._input.focus());

              }
            }

            if (void 0 !== m.amPM && e.target === m.amPM) switch (e.key) {
              case m.l10n.amPM[0].charAt(0):
              case m.l10n.amPM[0].charAt(0).toLowerCase():
                m.amPM.textContent = m.l10n.amPM[0], k(), we();
                break;

              case m.l10n.amPM[1].charAt(0):
              case m.l10n.amPM[1].charAt(0).toLowerCase():
                m.amPM.textContent = m.l10n.amPM[1], k(), we();
            }
            (t || G(e.target)) && ge("onKeyDown", e);
          }

          function re(e) {
            if (1 === m.selectedDates.length && (!e || e.classList.contains("flatpickr-day") && !e.classList.contains("flatpickr-disabled"))) {
              for (var t = e ? e.dateObj.getTime() : m.days.firstElementChild.dateObj.getTime(), n = m.parseDate(m.selectedDates[0], void 0, !0).getTime(), i = Math.min(t, m.selectedDates[0].getTime()), r = Math.max(t, m.selectedDates[0].getTime()), o = !1, a = 0, s = 0, l = i; l < r; l += x.DAY) {
                te(new Date(l), !0) || (o = o || l > i && l < r, l < n && (!a || l > a) ? a = l : l > n && (!s || l < s) && (s = l));
              }

              for (var c = 0; c < m.config.showMonths; c++) {
                for (var u = m.daysContainer.children[c], d = function d(i, r) {
                  var l = u.children[i],
                      c = l.dateObj,
                      d = c.getTime(),
                      p = a > 0 && d < a || s > 0 && d > s;
                  return p ? (l.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function (e) {
                    l.classList.remove(e);
                  }), "continue") : o && !p ? "continue" : (["startRange", "inRange", "endRange", "notAllowed"].forEach(function (e) {
                    l.classList.remove(e);
                  }), void (void 0 !== e && (e.classList.add(t <= m.selectedDates[0].getTime() ? "startRange" : "endRange"), n < t && d === n ? l.classList.add("startRange") : n > t && d === n && l.classList.add("endRange"), d >= a && (0 === s || d <= s) && w(d, n, t) && l.classList.add("inRange"))));
                }, p = 0, h = u.children.length; p < h; p++) {
                  d(p);
                }
              }
            }
          }

          function oe() {
            !m.isOpen || m.config["static"] || m.config.inline || ce();
          }

          function ae() {
            m.setDate(void 0 !== m.config.minDate ? new Date(m.config.minDate.getTime()) : new Date(), !0), O(), we();
          }

          function se(e) {
            return function (t) {
              var n = m.config["_" + e + "Date"] = m.parseDate(t, m.config.dateFormat),
                  i = m.config["_" + ("min" === e ? "max" : "min") + "Date"];
              void 0 !== n && (m["min" === e ? "minDateHasTime" : "maxDateHasTime"] = n.getHours() > 0 || n.getMinutes() > 0 || n.getSeconds() > 0), m.selectedDates && (m.selectedDates = m.selectedDates.filter(function (e) {
                return te(e);
              }), m.selectedDates.length || "min" !== e || T(n), we()), m.daysContainer && (ue(), void 0 !== n ? m.currentYearElement[e] = n.getFullYear().toString() : m.currentYearElement.removeAttribute(e), m.currentYearElement.disabled = !!i && void 0 !== n && i.getFullYear() === n.getFullYear());
            };
          }

          function le() {
            "object" != _typeof(m.config.locale) && void 0 === E.l10ns[m.config.locale] && m.config.errorHandler(new Error("flatpickr: invalid locale " + m.config.locale)), m.l10n = _e2({}, E.l10ns["default"], "object" == _typeof(m.config.locale) ? m.config.locale : "default" !== m.config.locale ? E.l10ns[m.config.locale] : void 0), g.K = "(" + m.l10n.amPM[0] + "|" + m.l10n.amPM[1] + "|" + m.l10n.amPM[0].toLowerCase() + "|" + m.l10n.amPM[1].toLowerCase() + ")";

            var n = _e2({}, h, JSON.parse(JSON.stringify(t.dataset || {})));

            void 0 === n.time_24hr && void 0 === E.defaultConfig.time_24hr && (m.config.time_24hr = m.l10n.time_24hr), m.formatDate = b(m), m.parseDate = y({
              config: m.config,
              l10n: m.l10n
            });
          }

          function ce(e) {
            if (void 0 !== m.calendarContainer) {
              ge("onPreCalendarPosition");
              var t = e || m._positionElement,
                  n = Array.prototype.reduce.call(m.calendarContainer.children, function (e, t) {
                return e + t.offsetHeight;
              }, 0),
                  i = m.calendarContainer.offsetWidth,
                  r = m.config.position.split(" "),
                  o = r[0],
                  a = r.length > 1 ? r[1] : null,
                  s = t.getBoundingClientRect(),
                  l = window.innerHeight - s.bottom,
                  u = "above" === o || "below" !== o && l < n && s.top > n,
                  d = window.pageYOffset + s.top + (u ? -n - 2 : t.offsetHeight + 2);

              if (c(m.calendarContainer, "arrowTop", !u), c(m.calendarContainer, "arrowBottom", u), !m.config.inline) {
                var p = window.pageXOffset + s.left - (null != a && "center" === a ? (i - s.width) / 2 : 0),
                    h = window.document.body.offsetWidth - s.right,
                    f = p + i > window.document.body.offsetWidth,
                    g = h + i > window.document.body.offsetWidth;
                if (c(m.calendarContainer, "rightMost", f), !m.config["static"]) if (m.calendarContainer.style.top = d + "px", f) {
                  if (g) {
                    var v = document.styleSheets[0];
                    if (void 0 === v) return;
                    var b = window.document.body.offsetWidth,
                        y = Math.max(0, b / 2 - i / 2),
                        _ = v.cssRules.length,
                        w = "{left:" + s.left + "px;right:auto;}";
                    c(m.calendarContainer, "rightMost", !1), c(m.calendarContainer, "centerMost", !0), v.insertRule(".flatpickr-calendar.centerMost:before,.flatpickr-calendar.centerMost:after" + w, _), m.calendarContainer.style.left = y + "px", m.calendarContainer.style.right = "auto";
                  } else m.calendarContainer.style.left = "auto", m.calendarContainer.style.right = h + "px";
                } else m.calendarContainer.style.left = p + "px", m.calendarContainer.style.right = "auto";
              }
            }
          }

          function ue() {
            m.config.noCalendar || m.isMobile || (ye(), Y());
          }

          function de() {
            m._input.focus(), -1 !== window.navigator.userAgent.indexOf("MSIE") || void 0 !== navigator.msMaxTouchPoints ? setTimeout(m.close, 0) : m.close();
          }

          function pe(e) {
            e.preventDefault(), e.stopPropagation();

            var t = function e(t, n) {
              return n(t) ? t : t.parentNode ? e(t.parentNode, n) : void 0;
            }(e.target, function (e) {
              return e.classList && e.classList.contains("flatpickr-day") && !e.classList.contains("flatpickr-disabled") && !e.classList.contains("notAllowed");
            });

            if (void 0 !== t) {
              var n = t,
                  i = m.latestSelectedDateObj = new Date(n.dateObj.getTime()),
                  r = (i.getMonth() < m.currentMonth || i.getMonth() > m.currentMonth + m.config.showMonths - 1) && "range" !== m.config.mode;
              if (m.selectedDateElem = n, "single" === m.config.mode) m.selectedDates = [i];else if ("multiple" === m.config.mode) {
                var o = be(i);
                o ? m.selectedDates.splice(parseInt(o), 1) : m.selectedDates.push(i);
              } else "range" === m.config.mode && (2 === m.selectedDates.length && m.clear(!1, !1), m.latestSelectedDateObj = i, m.selectedDates.push(i), 0 !== _(i, m.selectedDates[0], !0) && m.selectedDates.sort(function (e, t) {
                return e.getTime() - t.getTime();
              }));

              if (k(), r) {
                var a = m.currentYear !== i.getFullYear();
                m.currentYear = i.getFullYear(), m.currentMonth = i.getMonth(), a && (ge("onYearChange"), X()), ge("onMonthChange");
              }

              if (ye(), Y(), we(), m.config.enableTime && setTimeout(function () {
                return m.showTimeInput = !0;
              }, 50), r || "range" === m.config.mode || 1 !== m.config.showMonths ? void 0 !== m.selectedDateElem && void 0 === m.hourElement && m.selectedDateElem && m.selectedDateElem.focus() : q(n), void 0 !== m.hourElement && void 0 !== m.hourElement && m.hourElement.focus(), m.config.closeOnSelect) {
                var s = "single" === m.config.mode && !m.config.enableTime,
                    l = "range" === m.config.mode && 2 === m.selectedDates.length && !m.config.enableTime;
                (s || l) && de();
              }

              I();
            }
          }

          m.parseDate = y({
            config: m.config,
            l10n: m.l10n
          }), m._handlers = [], m.pluginElements = [], m.loadedPlugins = [], m._bind = M, m._setHoursFromDate = T, m._positionCalendar = ce, m.changeMonth = Z, m.changeYear = ee, m.clear = function (e, t) {
            void 0 === e && (e = !0), void 0 === t && (t = !0), m.input.value = "", void 0 !== m.altInput && (m.altInput.value = ""), void 0 !== m.mobileInput && (m.mobileInput.value = ""), m.selectedDates = [], m.latestSelectedDateObj = void 0, !0 === t && (m.currentYear = m._initialDate.getFullYear(), m.currentMonth = m._initialDate.getMonth()), m.showTimeInput = !1, !0 === m.config.enableTime && O(), m.redraw(), e && ge("onChange");
          }, m.close = function () {
            m.isOpen = !1, m.isMobile || (void 0 !== m.calendarContainer && m.calendarContainer.classList.remove("open"), void 0 !== m._input && m._input.classList.remove("active")), ge("onClose");
          }, m._createElement = u, m.destroy = function () {
            void 0 !== m.config && ge("onDestroy");

            for (var e = m._handlers.length; e--;) {
              var t = m._handlers[e];
              t.element.removeEventListener(t.event, t.handler, t.options);
            }

            if (m._handlers = [], m.mobileInput) m.mobileInput.parentNode && m.mobileInput.parentNode.removeChild(m.mobileInput), m.mobileInput = void 0;else if (m.calendarContainer && m.calendarContainer.parentNode) if (m.config["static"] && m.calendarContainer.parentNode) {
              var n = m.calendarContainer.parentNode;

              if (n.lastChild && n.removeChild(n.lastChild), n.parentNode) {
                for (; n.firstChild;) {
                  n.parentNode.insertBefore(n.firstChild, n);
                }

                n.parentNode.removeChild(n);
              }
            } else m.calendarContainer.parentNode.removeChild(m.calendarContainer);
            m.altInput && (m.input.type = "text", m.altInput.parentNode && m.altInput.parentNode.removeChild(m.altInput), delete m.altInput), m.input && (m.input.type = m.input._type, m.input.classList.remove("flatpickr-input"), m.input.removeAttribute("readonly"), m.input.value = ""), ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (e) {
              try {
                delete m[e];
              } catch (e) {}
            });
          }, m.isEnabled = te, m.jumpToDate = j, m.open = function (e, t) {
            if (void 0 === t && (t = m._positionElement), !0 === m.isMobile) return e && (e.preventDefault(), e.target && e.target.blur()), void 0 !== m.mobileInput && (m.mobileInput.focus(), m.mobileInput.click()), void ge("onOpen");

            if (!m._input.disabled && !m.config.inline) {
              var n = m.isOpen;
              m.isOpen = !0, n || (m.calendarContainer.classList.add("open"), m._input.classList.add("active"), ge("onOpen"), ce(t)), !0 === m.config.enableTime && !0 === m.config.noCalendar && (0 === m.selectedDates.length && ae(), !1 !== m.config.allowInput || void 0 !== e && m.timeContainer.contains(e.relatedTarget) || setTimeout(function () {
                return m.hourElement.select();
              }, 50));
            }
          }, m.redraw = ue, m.set = function (e, t) {
            if (null !== e && "object" == _typeof(e)) for (var i in Object.assign(m.config, e), e) {
              void 0 !== he[i] && he[i].forEach(function (e) {
                return e();
              });
            } else m.config[e] = t, void 0 !== he[e] ? he[e].forEach(function (e) {
              return e();
            }) : n.indexOf(e) > -1 && (m.config[e] = l(t));
            m.redraw(), we(!1);
          }, m.setDate = function (e, t, n) {
            if (void 0 === t && (t = !1), void 0 === n && (n = m.config.dateFormat), 0 !== e && !e || e instanceof Array && 0 === e.length) return m.clear(t);
            fe(e, n), m.showTimeInput = m.selectedDates.length > 0, m.latestSelectedDateObj = m.selectedDates[m.selectedDates.length - 1], m.redraw(), j(), T(), 0 === m.selectedDates.length && m.clear(!1), we(t), t && ge("onChange");
          }, m.toggle = function (e) {
            if (!0 === m.isOpen) return m.close();
            m.open(e);
          };
          var he = {
            locale: [le, Q],
            showMonths: [V, S, K],
            minDate: [j],
            maxDate: [j]
          };

          function fe(e, t) {
            var n = [];
            if (e instanceof Array) n = e.map(function (e) {
              return m.parseDate(e, t);
            });else if (e instanceof Date || "number" == typeof e) n = [m.parseDate(e, t)];else if ("string" == typeof e) switch (m.config.mode) {
              case "single":
              case "time":
                n = [m.parseDate(e, t)];
                break;

              case "multiple":
                n = e.split(m.config.conjunction).map(function (e) {
                  return m.parseDate(e, t);
                });
                break;

              case "range":
                n = e.split(m.l10n.rangeSeparator).map(function (e) {
                  return m.parseDate(e, t);
                });
            } else m.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(e)));
            m.selectedDates = n.filter(function (e) {
              return e instanceof Date && te(e, !1);
            }), "range" === m.config.mode && m.selectedDates.sort(function (e, t) {
              return e.getTime() - t.getTime();
            });
          }

          function me(e) {
            return e.slice().map(function (e) {
              return "string" == typeof e || "number" == typeof e || e instanceof Date ? m.parseDate(e, void 0, !0) : e && "object" == _typeof(e) && e.from && e.to ? {
                from: m.parseDate(e.from, void 0),
                to: m.parseDate(e.to, void 0)
              } : e;
            }).filter(function (e) {
              return e;
            });
          }

          function ge(e, t) {
            if (void 0 !== m.config) {
              var n = m.config[e];
              if (void 0 !== n && n.length > 0) for (var i = 0; n[i] && i < n.length; i++) {
                n[i](m.selectedDates, m.input.value, m, t);
              }
              "onChange" === e && (m.input.dispatchEvent(ve("change")), m.input.dispatchEvent(ve("input")));
            }
          }

          function ve(e) {
            var t = document.createEvent("Event");
            return t.initEvent(e, !0, !0), t;
          }

          function be(e) {
            for (var t = 0; t < m.selectedDates.length; t++) {
              if (0 === _(m.selectedDates[t], e)) return "" + t;
            }

            return !1;
          }

          function ye() {
            m.config.noCalendar || m.isMobile || !m.monthNav || (m.yearElements.forEach(function (e, t) {
              var n = new Date(m.currentYear, m.currentMonth, 1);
              n.setMonth(m.currentMonth + t), m.config.showMonths > 1 || "static" === m.config.monthSelectorType ? m.monthElements[t].textContent = f(n.getMonth(), m.config.shorthandCurrentMonth, m.l10n) + " " : m.monthsDropdownContainer.value = n.getMonth().toString(), e.value = n.getFullYear().toString();
            }), m._hidePrevMonthArrow = void 0 !== m.config.minDate && (m.currentYear === m.config.minDate.getFullYear() ? m.currentMonth <= m.config.minDate.getMonth() : m.currentYear < m.config.minDate.getFullYear()), m._hideNextMonthArrow = void 0 !== m.config.maxDate && (m.currentYear === m.config.maxDate.getFullYear() ? m.currentMonth + 1 > m.config.maxDate.getMonth() : m.currentYear > m.config.maxDate.getFullYear()));
          }

          function _e(e) {
            return m.selectedDates.map(function (t) {
              return m.formatDate(t, e);
            }).filter(function (e, t, n) {
              return "range" !== m.config.mode || m.config.enableTime || n.indexOf(e) === t;
            }).join("range" !== m.config.mode ? m.config.conjunction : m.l10n.rangeSeparator);
          }

          function we(e) {
            void 0 === e && (e = !0), void 0 !== m.mobileInput && m.mobileFormatStr && (m.mobileInput.value = void 0 !== m.latestSelectedDateObj ? m.formatDate(m.latestSelectedDateObj, m.mobileFormatStr) : ""), m.input.value = _e(m.config.dateFormat), void 0 !== m.altInput && (m.altInput.value = _e(m.config.altFormat)), !1 !== e && ge("onValueUpdate");
          }

          function xe(e) {
            var t = m.prevMonthNav.contains(e.target),
                n = m.nextMonthNav.contains(e.target);
            t || n ? Z(t ? -1 : 1) : m.yearElements.indexOf(e.target) >= 0 ? e.target.select() : e.target.classList.contains("arrowUp") ? m.changeYear(m.currentYear + 1) : e.target.classList.contains("arrowDown") && m.changeYear(m.currentYear - 1);
          }

          return function () {
            m.element = m.input = t, m.isOpen = !1, function () {
              var r = ["wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"],
                  o = _e2({}, h, JSON.parse(JSON.stringify(t.dataset || {}))),
                  a = {};

              m.config.parseDate = o.parseDate, m.config.formatDate = o.formatDate, Object.defineProperty(m.config, "enable", {
                get: function get() {
                  return m.config._enable;
                },
                set: function set(e) {
                  m.config._enable = me(e);
                }
              }), Object.defineProperty(m.config, "disable", {
                get: function get() {
                  return m.config._disable;
                },
                set: function set(e) {
                  m.config._disable = me(e);
                }
              });
              var s = "time" === o.mode;

              if (!o.dateFormat && (o.enableTime || s)) {
                var c = E.defaultConfig.dateFormat || i.dateFormat;
                a.dateFormat = o.noCalendar || s ? "H:i" + (o.enableSeconds ? ":S" : "") : c + " H:i" + (o.enableSeconds ? ":S" : "");
              }

              if (o.altInput && (o.enableTime || s) && !o.altFormat) {
                var u = E.defaultConfig.altFormat || i.altFormat;
                a.altFormat = o.noCalendar || s ? "h:i" + (o.enableSeconds ? ":S K" : " K") : u + " h:i" + (o.enableSeconds ? ":S" : "") + " K";
              }

              o.altInputClass || (m.config.altInputClass = m.input.className + " " + m.config.altInputClass), Object.defineProperty(m.config, "minDate", {
                get: function get() {
                  return m.config._minDate;
                },
                set: se("min")
              }), Object.defineProperty(m.config, "maxDate", {
                get: function get() {
                  return m.config._maxDate;
                },
                set: se("max")
              });

              var d = function d(e) {
                return function (t) {
                  m.config["min" === e ? "_minTime" : "_maxTime"] = m.parseDate(t, "H:i");
                };
              };

              Object.defineProperty(m.config, "minTime", {
                get: function get() {
                  return m.config._minTime;
                },
                set: d("min")
              }), Object.defineProperty(m.config, "maxTime", {
                get: function get() {
                  return m.config._maxTime;
                },
                set: d("max")
              }), "time" === o.mode && (m.config.noCalendar = !0, m.config.enableTime = !0), Object.assign(m.config, a, o);

              for (var p = 0; p < r.length; p++) {
                m.config[r[p]] = !0 === m.config[r[p]] || "true" === m.config[r[p]];
              }

              n.filter(function (e) {
                return void 0 !== m.config[e];
              }).forEach(function (e) {
                m.config[e] = l(m.config[e] || []).map(v);
              }), m.isMobile = !m.config.disableMobile && !m.config.inline && "single" === m.config.mode && !m.config.disable.length && !m.config.enable.length && !m.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

              for (var p = 0; p < m.config.plugins.length; p++) {
                var f = m.config.plugins[p](m) || {};

                for (var g in f) {
                  n.indexOf(g) > -1 ? m.config[g] = l(f[g]).map(v).concat(m.config[g]) : void 0 === o[g] && (m.config[g] = f[g]);
                }
              }

              ge("onParseConfig");
            }(), le(), m.input = m.config.wrap ? t.querySelector("[data-input]") : t, m.input ? (m.input._type = m.input.type, m.input.type = "text", m.input.classList.add("flatpickr-input"), m._input = m.input, m.config.altInput && (m.altInput = u(m.input.nodeName, m.config.altInputClass), m._input = m.altInput, m.altInput.placeholder = m.input.placeholder, m.altInput.disabled = m.input.disabled, m.altInput.required = m.input.required, m.altInput.tabIndex = m.input.tabIndex, m.altInput.type = "text", m.input.setAttribute("type", "hidden"), !m.config["static"] && m.input.parentNode && m.input.parentNode.insertBefore(m.altInput, m.input.nextSibling)), m.config.allowInput || m._input.setAttribute("readonly", "readonly"), m._positionElement = m.config.positionElement || m._input) : m.config.errorHandler(new Error("Invalid input element specified")), function () {
              m.selectedDates = [], m.now = m.parseDate(m.config.now) || new Date();
              var e = m.config.defaultDate || ("INPUT" !== m.input.nodeName && "TEXTAREA" !== m.input.nodeName || !m.input.placeholder || m.input.value !== m.input.placeholder ? m.input.value : null);
              e && fe(e, m.config.dateFormat), m._initialDate = m.selectedDates.length > 0 ? m.selectedDates[0] : m.config.minDate && m.config.minDate.getTime() > m.now.getTime() ? m.config.minDate : m.config.maxDate && m.config.maxDate.getTime() < m.now.getTime() ? m.config.maxDate : m.now, m.currentYear = m._initialDate.getFullYear(), m.currentMonth = m._initialDate.getMonth(), m.selectedDates.length > 0 && (m.latestSelectedDateObj = m.selectedDates[0]), void 0 !== m.config.minTime && (m.config.minTime = m.parseDate(m.config.minTime, "H:i")), void 0 !== m.config.maxTime && (m.config.maxTime = m.parseDate(m.config.maxTime, "H:i")), m.minDateHasTime = !!m.config.minDate && (m.config.minDate.getHours() > 0 || m.config.minDate.getMinutes() > 0 || m.config.minDate.getSeconds() > 0), m.maxDateHasTime = !!m.config.maxDate && (m.config.maxDate.getHours() > 0 || m.config.maxDate.getMinutes() > 0 || m.config.maxDate.getSeconds() > 0), Object.defineProperty(m, "showTimeInput", {
                get: function get() {
                  return m._showTimeInput;
                },
                set: function set(e) {
                  m._showTimeInput = e, m.calendarContainer && c(m.calendarContainer, "showTimeInput", e), m.isOpen && ce();
                }
              });
            }(), m.utils = {
              getDaysInMonth: function getDaysInMonth(e, t) {
                return void 0 === e && (e = m.currentMonth), void 0 === t && (t = m.currentYear), 1 === e && (t % 4 == 0 && t % 100 != 0 || t % 400 == 0) ? 29 : m.l10n.daysInMonth[e];
              }
            }, m.isMobile || H(), F(), (m.selectedDates.length || m.config.noCalendar) && (m.config.enableTime && T(m.config.noCalendar ? m.latestSelectedDateObj || m.config.minDate : void 0), we(!1)), S(), m.showTimeInput = m.selectedDates.length > 0 || m.config.noCalendar;
            var r = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            !m.isMobile && r && ce(), ge("onReady");
          }(), m;
        }

        function D(e, t) {
          for (var n = Array.prototype.slice.call(e).filter(function (e) {
            return e instanceof HTMLElement;
          }), i = [], r = 0; r < n.length; r++) {
            var o = n[r];

            try {
              if (null !== o.getAttribute("data-fp-omit")) continue;
              void 0 !== o._flatpickr && (o._flatpickr.destroy(), o._flatpickr = void 0), o._flatpickr = S(o, t || {}), i.push(o._flatpickr);
            } catch (e) {
              console.error(e);
            }
          }

          return 1 === i.length ? i[0] : i;
        }

        "undefined" != typeof HTMLElement && "undefined" != typeof HTMLCollection && "undefined" != typeof NodeList && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (e) {
          return D(this, e);
        }, HTMLElement.prototype.flatpickr = function (e) {
          return D([this], e);
        });

        var E = function E(e, t) {
          return "string" == typeof e ? D(window.document.querySelectorAll(e), t) : e instanceof Node ? D([e], t) : D(e, t);
        };

        return E.defaultConfig = {}, E.l10ns = {
          en: _e2({}, r),
          "default": _e2({}, r)
        }, E.localize = function (t) {
          E.l10ns["default"] = _e2({}, E.l10ns["default"], t);
        }, E.setDefaults = function (t) {
          E.defaultConfig = _e2({}, E.defaultConfig, t);
        }, E.parseDate = y({}), E.formatDate = b({}), E.compareDates = _, void 0 !== t && void 0 !== t.fn && (t.fn.flatpickr = function (e) {
          return D(this, e);
        }), Date.prototype.fp_incr = function (e) {
          return new Date(this.getFullYear(), this.getMonth(), this.getDate() + ("string" == typeof e ? parseInt(e, 10) : e));
        }, "undefined" != typeof window && (window.flatpickr = E), E;
      }();
    }).call(this, n(0));
  }, function (e, t, n) {
    (function (e, t) {
      !function (e, t, n) {
        var i, r;
        "auto_height", r = {
          debug: !1
        }, i =
        /*#__PURE__*/
        function () {
          function i(t, n) {
            _classCallCheck(this, i);

            this.element = t, this.settings = e.extend({}, r, n), this._defaults = r, this._name = "auto_height", this.$element = e(this.element), this.init();
          }

          _createClass(i, [{
            key: "init",
            value: function init() {
              var _this6 = this;

              return this.set_textarea_height(), this.$element.on("keydown.auto_height", function (e) {
                return _this6.set_textarea_height();
              }), this.$element.on("paste.auto_height", function (e) {
                return _this6.set_textarea_height();
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this.$element.off("keydown.auto_height"), this.$element.off("paste.auto_height");
            }
          }, {
            key: "set_textarea_height",
            value: function set_textarea_height() {
              var _this7 = this;

              return setTimeout(function () {
                return _this7.element.style.cssText = "height:auto; padding:0", _this7.element.style.cssText = "height:" + _this7.element.scrollHeight + "px";
              }, 0);
            }
          }]);

          return i;
        }(), e.fn.auto_height = function (t) {
          return this.each(function () {
            if (!e.data(this, "plugin_auto_height")) return e.data(this, "plugin_auto_height", new i(this, t));
          });
        };
      }(e, window, document), t(function () {
        return "textarea.auto_height", t("textarea.auto_height").auto_height(), new MutationObserver(function (e) {
          return e.forEach(function (e) {
            return t("textarea.auto_height").auto_height();
          });
        }).observe(document.documentElement, {
          childList: !0,
          subtree: !0
        });
      });
    }).call(this, n(0), n(0));
  }, function (e, t, n) {
    (function (t) {
      e.exports = t.jQuery = n(10);
    }).call(this, n(3));
  }, function (e, t, n) {
    var i;
    /*!
     * jQuery JavaScript Library v3.4.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2019-05-01T21:04Z
     */

    /*!
     * jQuery JavaScript Library v3.4.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2019-05-01T21:04Z
     */

    !function (t, n) {
      "use strict";

      "object" == _typeof(e.exports) ? e.exports = t.document ? n(t, !0) : function (e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return n(e);
      } : n(t);
    }("undefined" != typeof window ? window : this, function (n, r) {
      "use strict";

      var o = [],
          a = n.document,
          s = Object.getPrototypeOf,
          l = o.slice,
          c = o.concat,
          u = o.push,
          d = o.indexOf,
          p = {},
          h = p.toString,
          f = p.hasOwnProperty,
          m = f.toString,
          g = m.call(Object),
          v = {},
          b = function b(e) {
        return "function" == typeof e && "number" != typeof e.nodeType;
      },
          y = function y(e) {
        return null != e && e === e.window;
      },
          _ = {
        type: !0,
        src: !0,
        nonce: !0,
        noModule: !0
      };

      function w(e, t, n) {
        var i,
            r,
            o = (n = n || a).createElement("script");
        if (o.text = e, t) for (i in _) {
          (r = t[i] || t.getAttribute && t.getAttribute(i)) && o.setAttribute(i, r);
        }
        n.head.appendChild(o).parentNode.removeChild(o);
      }

      function x(e) {
        return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? p[h.call(e)] || "object" : _typeof(e);
      }

      var C = function C(e, t) {
        return new C.fn.init(e, t);
      },
          S = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

      function D(e) {
        var t = !!e && "length" in e && e.length,
            n = x(e);
        return !b(e) && !y(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
      }

      C.fn = C.prototype = {
        jquery: "3.4.1",
        constructor: C,
        length: 0,
        toArray: function toArray() {
          return l.call(this);
        },
        get: function get(e) {
          return null == e ? l.call(this) : e < 0 ? this[e + this.length] : this[e];
        },
        pushStack: function pushStack(e) {
          var t = C.merge(this.constructor(), e);
          return t.prevObject = this, t;
        },
        each: function each(e) {
          return C.each(this, e);
        },
        map: function map(e) {
          return this.pushStack(C.map(this, function (t, n) {
            return e.call(t, n, t);
          }));
        },
        slice: function slice() {
          return this.pushStack(l.apply(this, arguments));
        },
        first: function first() {
          return this.eq(0);
        },
        last: function last() {
          return this.eq(-1);
        },
        eq: function eq(e) {
          var t = this.length,
              n = +e + (e < 0 ? t : 0);
          return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
        },
        end: function end() {
          return this.prevObject || this.constructor();
        },
        push: u,
        sort: o.sort,
        splice: o.splice
      }, C.extend = C.fn.extend = function () {
        var e,
            t,
            n,
            i,
            r,
            o,
            a = arguments[0] || {},
            s = 1,
            l = arguments.length,
            c = !1;

        for ("boolean" == typeof a && (c = a, a = arguments[s] || {}, s++), "object" == _typeof(a) || b(a) || (a = {}), s === l && (a = this, s--); s < l; s++) {
          if (null != (e = arguments[s])) for (t in e) {
            i = e[t], "__proto__" !== t && a !== i && (c && i && (C.isPlainObject(i) || (r = Array.isArray(i))) ? (n = a[t], o = r && !Array.isArray(n) ? [] : r || C.isPlainObject(n) ? n : {}, r = !1, a[t] = C.extend(c, o, i)) : void 0 !== i && (a[t] = i));
          }
        }

        return a;
      }, C.extend({
        expando: "jQuery" + ("3.4.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function error(e) {
          throw new Error(e);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(e) {
          var t, n;
          return !(!e || "[object Object]" !== h.call(e)) && (!(t = s(e)) || "function" == typeof (n = f.call(t, "constructor") && t.constructor) && m.call(n) === g);
        },
        isEmptyObject: function isEmptyObject(e) {
          var t;

          for (t in e) {
            return !1;
          }

          return !0;
        },
        globalEval: function globalEval(e, t) {
          w(e, {
            nonce: t && t.nonce
          });
        },
        each: function each(e, t) {
          var n,
              i = 0;
          if (D(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++) {
            ;
          } else for (i in e) {
            if (!1 === t.call(e[i], i, e[i])) break;
          }
          return e;
        },
        trim: function trim(e) {
          return null == e ? "" : (e + "").replace(S, "");
        },
        makeArray: function makeArray(e, t) {
          var n = t || [];
          return null != e && (D(Object(e)) ? C.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
        },
        inArray: function inArray(e, t, n) {
          return null == t ? -1 : d.call(t, e, n);
        },
        merge: function merge(e, t) {
          for (var n = +t.length, i = 0, r = e.length; i < n; i++) {
            e[r++] = t[i];
          }

          return e.length = r, e;
        },
        grep: function grep(e, t, n) {
          for (var i = [], r = 0, o = e.length, a = !n; r < o; r++) {
            !t(e[r], r) !== a && i.push(e[r]);
          }

          return i;
        },
        map: function map(e, t, n) {
          var i,
              r,
              o = 0,
              a = [];
          if (D(e)) for (i = e.length; o < i; o++) {
            null != (r = t(e[o], o, n)) && a.push(r);
          } else for (o in e) {
            null != (r = t(e[o], o, n)) && a.push(r);
          }
          return c.apply([], a);
        },
        guid: 1,
        support: v
      }), "function" == typeof Symbol && (C.fn[Symbol.iterator] = o[Symbol.iterator]), C.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
        p["[object " + t + "]"] = t.toLowerCase();
      });

      var E =
      /*!
       * Sizzle CSS Selector Engine v2.3.4
       * https://sizzlejs.com/
       *
       * Copyright JS Foundation and other contributors
       * Released under the MIT license
       * https://js.foundation/
       *
       * Date: 2019-04-08
       */
      function (e) {
        var t,
            n,
            i,
            r,
            o,
            a,
            s,
            l,
            c,
            u,
            d,
            p,
            h,
            f,
            m,
            g,
            v,
            b,
            y,
            _ = "sizzle" + 1 * new Date(),
            w = e.document,
            x = 0,
            C = 0,
            S = le(),
            D = le(),
            E = le(),
            k = le(),
            T = function T(e, t) {
          return e === t && (d = !0), 0;
        },
            O = {}.hasOwnProperty,
            P = [],
            A = P.pop,
            M = P.push,
            N = P.push,
            I = P.slice,
            F = function F(e, t) {
          for (var n = 0, i = e.length; n < i; n++) {
            if (e[n] === t) return n;
          }

          return -1;
        },
            j = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            L = "[\\x20\\t\\r\\n\\f]",
            R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
            H = "\\[" + L + "*(" + R + ")(?:" + L + "*([*^$|!~]?=)" + L + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + L + "*\\]",
            B = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + H + ")*)|.*)\\)|)",
            q = new RegExp(L + "+", "g"),
            $ = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
            W = new RegExp("^" + L + "*," + L + "*"),
            U = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
            Y = new RegExp(L + "|>"),
            X = new RegExp(B),
            z = new RegExp("^" + R + "$"),
            V = {
          ID: new RegExp("^#(" + R + ")"),
          CLASS: new RegExp("^\\.(" + R + ")"),
          TAG: new RegExp("^(" + R + "|[*])"),
          ATTR: new RegExp("^" + H),
          PSEUDO: new RegExp("^" + B),
          CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L + "*(even|odd|(([+-]|)(\\d*)n|)" + L + "*(?:([+-]|)" + L + "*(\\d+)|))" + L + "*\\)|)", "i"),
          bool: new RegExp("^(?:" + j + ")$", "i"),
          needsContext: new RegExp("^" + L + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L + "*((?:-\\d)?\\d*)" + L + "*\\)|)(?=[^-]|$)", "i")
        },
            K = /HTML$/i,
            Q = /^(?:input|select|textarea|button)$/i,
            Z = /^h\d$/i,
            G = /^[^{]+\{\s*\[native \w/,
            J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
            ne = function ne(e, t, n) {
          var i = "0x" + t - 65536;
          return i != i || n ? t : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320);
        },
            ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            re = function re(e, t) {
          return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
        },
            oe = function oe() {
          p();
        },
            ae = _e(function (e) {
          return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
        }, {
          dir: "parentNode",
          next: "legend"
        });

        try {
          N.apply(P = I.call(w.childNodes), w.childNodes), P[w.childNodes.length].nodeType;
        } catch (e) {
          N = {
            apply: P.length ? function (e, t) {
              M.apply(e, I.call(t));
            } : function (e, t) {
              for (var n = e.length, i = 0; e[n++] = t[i++];) {
                ;
              }

              e.length = n - 1;
            }
          };
        }

        function se(e, t, i, r) {
          var o,
              s,
              c,
              u,
              d,
              f,
              v,
              b = t && t.ownerDocument,
              x = t ? t.nodeType : 9;
          if (i = i || [], "string" != typeof e || !e || 1 !== x && 9 !== x && 11 !== x) return i;

          if (!r && ((t ? t.ownerDocument || t : w) !== h && p(t), t = t || h, m)) {
            if (11 !== x && (d = J.exec(e))) if (o = d[1]) {
              if (9 === x) {
                if (!(c = t.getElementById(o))) return i;
                if (c.id === o) return i.push(c), i;
              } else if (b && (c = b.getElementById(o)) && y(t, c) && c.id === o) return i.push(c), i;
            } else {
              if (d[2]) return N.apply(i, t.getElementsByTagName(e)), i;
              if ((o = d[3]) && n.getElementsByClassName && t.getElementsByClassName) return N.apply(i, t.getElementsByClassName(o)), i;
            }

            if (n.qsa && !k[e + " "] && (!g || !g.test(e)) && (1 !== x || "object" !== t.nodeName.toLowerCase())) {
              if (v = e, b = t, 1 === x && Y.test(e)) {
                for ((u = t.getAttribute("id")) ? u = u.replace(ie, re) : t.setAttribute("id", u = _), s = (f = a(e)).length; s--;) {
                  f[s] = "#" + u + " " + ye(f[s]);
                }

                v = f.join(","), b = ee.test(e) && ve(t.parentNode) || t;
              }

              try {
                return N.apply(i, b.querySelectorAll(v)), i;
              } catch (t) {
                k(e, !0);
              } finally {
                u === _ && t.removeAttribute("id");
              }
            }
          }

          return l(e.replace($, "$1"), t, i, r);
        }

        function le() {
          var e = [];
          return function t(n, r) {
            return e.push(n + " ") > i.cacheLength && delete t[e.shift()], t[n + " "] = r;
          };
        }

        function ce(e) {
          return e[_] = !0, e;
        }

        function ue(e) {
          var t = h.createElement("fieldset");

          try {
            return !!e(t);
          } catch (e) {
            return !1;
          } finally {
            t.parentNode && t.parentNode.removeChild(t), t = null;
          }
        }

        function de(e, t) {
          for (var n = e.split("|"), r = n.length; r--;) {
            i.attrHandle[n[r]] = t;
          }
        }

        function pe(e, t) {
          var n = t && e,
              i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
          if (i) return i;
          if (n) for (; n = n.nextSibling;) {
            if (n === t) return -1;
          }
          return e ? 1 : -1;
        }

        function he(e) {
          return function (t) {
            return "input" === t.nodeName.toLowerCase() && t.type === e;
          };
        }

        function fe(e) {
          return function (t) {
            var n = t.nodeName.toLowerCase();
            return ("input" === n || "button" === n) && t.type === e;
          };
        }

        function me(e) {
          return function (t) {
            return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ae(t) === e : t.disabled === e : "label" in t && t.disabled === e;
          };
        }

        function ge(e) {
          return ce(function (t) {
            return t = +t, ce(function (n, i) {
              for (var r, o = e([], n.length, t), a = o.length; a--;) {
                n[r = o[a]] && (n[r] = !(i[r] = n[r]));
              }
            });
          });
        }

        function ve(e) {
          return e && void 0 !== e.getElementsByTagName && e;
        }

        for (t in n = se.support = {}, o = se.isXML = function (e) {
          var t = e.namespaceURI,
              n = (e.ownerDocument || e).documentElement;
          return !K.test(t || n && n.nodeName || "HTML");
        }, p = se.setDocument = function (e) {
          var t,
              r,
              a = e ? e.ownerDocument || e : w;
          return a !== h && 9 === a.nodeType && a.documentElement ? (f = (h = a).documentElement, m = !o(h), w !== h && (r = h.defaultView) && r.top !== r && (r.addEventListener ? r.addEventListener("unload", oe, !1) : r.attachEvent && r.attachEvent("onunload", oe)), n.attributes = ue(function (e) {
            return e.className = "i", !e.getAttribute("className");
          }), n.getElementsByTagName = ue(function (e) {
            return e.appendChild(h.createComment("")), !e.getElementsByTagName("*").length;
          }), n.getElementsByClassName = G.test(h.getElementsByClassName), n.getById = ue(function (e) {
            return f.appendChild(e).id = _, !h.getElementsByName || !h.getElementsByName(_).length;
          }), n.getById ? (i.filter.ID = function (e) {
            var t = e.replace(te, ne);
            return function (e) {
              return e.getAttribute("id") === t;
            };
          }, i.find.ID = function (e, t) {
            if (void 0 !== t.getElementById && m) {
              var n = t.getElementById(e);
              return n ? [n] : [];
            }
          }) : (i.filter.ID = function (e) {
            var t = e.replace(te, ne);
            return function (e) {
              var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
              return n && n.value === t;
            };
          }, i.find.ID = function (e, t) {
            if (void 0 !== t.getElementById && m) {
              var n,
                  i,
                  r,
                  o = t.getElementById(e);

              if (o) {
                if ((n = o.getAttributeNode("id")) && n.value === e) return [o];

                for (r = t.getElementsByName(e), i = 0; o = r[i++];) {
                  if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                }
              }

              return [];
            }
          }), i.find.TAG = n.getElementsByTagName ? function (e, t) {
            return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
          } : function (e, t) {
            var n,
                i = [],
                r = 0,
                o = t.getElementsByTagName(e);

            if ("*" === e) {
              for (; n = o[r++];) {
                1 === n.nodeType && i.push(n);
              }

              return i;
            }

            return o;
          }, i.find.CLASS = n.getElementsByClassName && function (e, t) {
            if (void 0 !== t.getElementsByClassName && m) return t.getElementsByClassName(e);
          }, v = [], g = [], (n.qsa = G.test(h.querySelectorAll)) && (ue(function (e) {
            f.appendChild(e).innerHTML = "<a id='" + _ + "'></a><select id='" + _ + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + L + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + L + "*(?:value|" + j + ")"), e.querySelectorAll("[id~=" + _ + "-]").length || g.push("~="), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + _ + "+*").length || g.push(".#.+[+~]");
          }), ue(function (e) {
            e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
            var t = h.createElement("input");
            t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + L + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), f.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:");
          })), (n.matchesSelector = G.test(b = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && ue(function (e) {
            n.disconnectedMatch = b.call(e, "*"), b.call(e, "[s!='']:x"), v.push("!=", B);
          }), g = g.length && new RegExp(g.join("|")), v = v.length && new RegExp(v.join("|")), t = G.test(f.compareDocumentPosition), y = t || G.test(f.contains) ? function (e, t) {
            var n = 9 === e.nodeType ? e.documentElement : e,
                i = t && t.parentNode;
            return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
          } : function (e, t) {
            if (t) for (; t = t.parentNode;) {
              if (t === e) return !0;
            }
            return !1;
          }, T = t ? function (e, t) {
            if (e === t) return d = !0, 0;
            var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
            return i || (1 & (i = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === i ? e === h || e.ownerDocument === w && y(w, e) ? -1 : t === h || t.ownerDocument === w && y(w, t) ? 1 : u ? F(u, e) - F(u, t) : 0 : 4 & i ? -1 : 1);
          } : function (e, t) {
            if (e === t) return d = !0, 0;
            var n,
                i = 0,
                r = e.parentNode,
                o = t.parentNode,
                a = [e],
                s = [t];
            if (!r || !o) return e === h ? -1 : t === h ? 1 : r ? -1 : o ? 1 : u ? F(u, e) - F(u, t) : 0;
            if (r === o) return pe(e, t);

            for (n = e; n = n.parentNode;) {
              a.unshift(n);
            }

            for (n = t; n = n.parentNode;) {
              s.unshift(n);
            }

            for (; a[i] === s[i];) {
              i++;
            }

            return i ? pe(a[i], s[i]) : a[i] === w ? -1 : s[i] === w ? 1 : 0;
          }, h) : h;
        }, se.matches = function (e, t) {
          return se(e, null, null, t);
        }, se.matchesSelector = function (e, t) {
          if ((e.ownerDocument || e) !== h && p(e), n.matchesSelector && m && !k[t + " "] && (!v || !v.test(t)) && (!g || !g.test(t))) try {
            var i = b.call(e, t);
            if (i || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i;
          } catch (e) {
            k(t, !0);
          }
          return se(t, h, null, [e]).length > 0;
        }, se.contains = function (e, t) {
          return (e.ownerDocument || e) !== h && p(e), y(e, t);
        }, se.attr = function (e, t) {
          (e.ownerDocument || e) !== h && p(e);
          var r = i.attrHandle[t.toLowerCase()],
              o = r && O.call(i.attrHandle, t.toLowerCase()) ? r(e, t, !m) : void 0;
          return void 0 !== o ? o : n.attributes || !m ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
        }, se.escape = function (e) {
          return (e + "").replace(ie, re);
        }, se.error = function (e) {
          throw new Error("Syntax error, unrecognized expression: " + e);
        }, se.uniqueSort = function (e) {
          var t,
              i = [],
              r = 0,
              o = 0;

          if (d = !n.detectDuplicates, u = !n.sortStable && e.slice(0), e.sort(T), d) {
            for (; t = e[o++];) {
              t === e[o] && (r = i.push(o));
            }

            for (; r--;) {
              e.splice(i[r], 1);
            }
          }

          return u = null, e;
        }, r = se.getText = function (e) {
          var t,
              n = "",
              i = 0,
              o = e.nodeType;

          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof e.textContent) return e.textContent;

              for (e = e.firstChild; e; e = e.nextSibling) {
                n += r(e);
              }
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else for (; t = e[i++];) {
            n += r(t);
          }

          return n;
        }, (i = se.selectors = {
          cacheLength: 50,
          createPseudo: ce,
          match: V,
          attrHandle: {},
          find: {},
          relative: {
            ">": {
              dir: "parentNode",
              first: !0
            },
            " ": {
              dir: "parentNode"
            },
            "+": {
              dir: "previousSibling",
              first: !0
            },
            "~": {
              dir: "previousSibling"
            }
          },
          preFilter: {
            ATTR: function ATTR(e) {
              return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
            },
            CHILD: function CHILD(e) {
              return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && se.error(e[0]), e;
            },
            PSEUDO: function PSEUDO(e) {
              var t,
                  n = !e[6] && e[2];
              return V.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
            }
          },
          filter: {
            TAG: function TAG(e) {
              var t = e.replace(te, ne).toLowerCase();
              return "*" === e ? function () {
                return !0;
              } : function (e) {
                return e.nodeName && e.nodeName.toLowerCase() === t;
              };
            },
            CLASS: function CLASS(e) {
              var t = S[e + " "];
              return t || (t = new RegExp("(^|" + L + ")" + e + "(" + L + "|$)")) && S(e, function (e) {
                return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
              });
            },
            ATTR: function ATTR(e, t, n) {
              return function (i) {
                var r = se.attr(i, e);
                return null == r ? "!=" === t : !t || (r += "", "=" === t ? r === n : "!=" === t ? r !== n : "^=" === t ? n && 0 === r.indexOf(n) : "*=" === t ? n && r.indexOf(n) > -1 : "$=" === t ? n && r.slice(-n.length) === n : "~=" === t ? (" " + r.replace(q, " ") + " ").indexOf(n) > -1 : "|=" === t && (r === n || r.slice(0, n.length + 1) === n + "-"));
              };
            },
            CHILD: function CHILD(e, t, n, i, r) {
              var o = "nth" !== e.slice(0, 3),
                  a = "last" !== e.slice(-4),
                  s = "of-type" === t;
              return 1 === i && 0 === r ? function (e) {
                return !!e.parentNode;
              } : function (t, n, l) {
                var c,
                    u,
                    d,
                    p,
                    h,
                    f,
                    m = o !== a ? "nextSibling" : "previousSibling",
                    g = t.parentNode,
                    v = s && t.nodeName.toLowerCase(),
                    b = !l && !s,
                    y = !1;

                if (g) {
                  if (o) {
                    for (; m;) {
                      for (p = t; p = p[m];) {
                        if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                      }

                      f = m = "only" === e && !f && "nextSibling";
                    }

                    return !0;
                  }

                  if (f = [a ? g.firstChild : g.lastChild], a && b) {
                    for (y = (h = (c = (u = (d = (p = g)[_] || (p[_] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === x && c[1]) && c[2], p = h && g.childNodes[h]; p = ++h && p && p[m] || (y = h = 0) || f.pop();) {
                      if (1 === p.nodeType && ++y && p === t) {
                        u[e] = [x, h, y];
                        break;
                      }
                    }
                  } else if (b && (y = h = (c = (u = (d = (p = t)[_] || (p[_] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === x && c[1]), !1 === y) for (; (p = ++h && p && p[m] || (y = h = 0) || f.pop()) && ((s ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++y || (b && ((u = (d = p[_] || (p[_] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] = [x, y]), p !== t));) {
                    ;
                  }

                  return (y -= r) === i || y % i == 0 && y / i >= 0;
                }
              };
            },
            PSEUDO: function PSEUDO(e, t) {
              var n,
                  r = i.pseudos[e] || i.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
              return r[_] ? r(t) : r.length > 1 ? (n = [e, e, "", t], i.setFilters.hasOwnProperty(e.toLowerCase()) ? ce(function (e, n) {
                for (var i, o = r(e, t), a = o.length; a--;) {
                  e[i = F(e, o[a])] = !(n[i] = o[a]);
                }
              }) : function (e) {
                return r(e, 0, n);
              }) : r;
            }
          },
          pseudos: {
            not: ce(function (e) {
              var t = [],
                  n = [],
                  i = s(e.replace($, "$1"));
              return i[_] ? ce(function (e, t, n, r) {
                for (var o, a = i(e, null, r, []), s = e.length; s--;) {
                  (o = a[s]) && (e[s] = !(t[s] = o));
                }
              }) : function (e, r, o) {
                return t[0] = e, i(t, null, o, n), t[0] = null, !n.pop();
              };
            }),
            has: ce(function (e) {
              return function (t) {
                return se(e, t).length > 0;
              };
            }),
            contains: ce(function (e) {
              return e = e.replace(te, ne), function (t) {
                return (t.textContent || r(t)).indexOf(e) > -1;
              };
            }),
            lang: ce(function (e) {
              return z.test(e || "") || se.error("unsupported lang: " + e), e = e.replace(te, ne).toLowerCase(), function (t) {
                var n;

                do {
                  if (n = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                } while ((t = t.parentNode) && 1 === t.nodeType);

                return !1;
              };
            }),
            target: function target(t) {
              var n = e.location && e.location.hash;
              return n && n.slice(1) === t.id;
            },
            root: function root(e) {
              return e === f;
            },
            focus: function focus(e) {
              return e === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
            },
            enabled: me(!1),
            disabled: me(!0),
            checked: function checked(e) {
              var t = e.nodeName.toLowerCase();
              return "input" === t && !!e.checked || "option" === t && !!e.selected;
            },
            selected: function selected(e) {
              return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
            },
            empty: function empty(e) {
              for (e = e.firstChild; e; e = e.nextSibling) {
                if (e.nodeType < 6) return !1;
              }

              return !0;
            },
            parent: function parent(e) {
              return !i.pseudos.empty(e);
            },
            header: function header(e) {
              return Z.test(e.nodeName);
            },
            input: function input(e) {
              return Q.test(e.nodeName);
            },
            button: function button(e) {
              var t = e.nodeName.toLowerCase();
              return "input" === t && "button" === e.type || "button" === t;
            },
            text: function text(e) {
              var t;
              return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
            },
            first: ge(function () {
              return [0];
            }),
            last: ge(function (e, t) {
              return [t - 1];
            }),
            eq: ge(function (e, t, n) {
              return [n < 0 ? n + t : n];
            }),
            even: ge(function (e, t) {
              for (var n = 0; n < t; n += 2) {
                e.push(n);
              }

              return e;
            }),
            odd: ge(function (e, t) {
              for (var n = 1; n < t; n += 2) {
                e.push(n);
              }

              return e;
            }),
            lt: ge(function (e, t, n) {
              for (var i = n < 0 ? n + t : n > t ? t : n; --i >= 0;) {
                e.push(i);
              }

              return e;
            }),
            gt: ge(function (e, t, n) {
              for (var i = n < 0 ? n + t : n; ++i < t;) {
                e.push(i);
              }

              return e;
            })
          }
        }).pseudos.nth = i.pseudos.eq, {
          radio: !0,
          checkbox: !0,
          file: !0,
          password: !0,
          image: !0
        }) {
          i.pseudos[t] = he(t);
        }

        for (t in {
          submit: !0,
          reset: !0
        }) {
          i.pseudos[t] = fe(t);
        }

        function be() {}

        function ye(e) {
          for (var t = 0, n = e.length, i = ""; t < n; t++) {
            i += e[t].value;
          }

          return i;
        }

        function _e(e, t, n) {
          var i = t.dir,
              r = t.next,
              o = r || i,
              a = n && "parentNode" === o,
              s = C++;
          return t.first ? function (t, n, r) {
            for (; t = t[i];) {
              if (1 === t.nodeType || a) return e(t, n, r);
            }

            return !1;
          } : function (t, n, l) {
            var c,
                u,
                d,
                p = [x, s];

            if (l) {
              for (; t = t[i];) {
                if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
              }
            } else for (; t = t[i];) {
              if (1 === t.nodeType || a) if (u = (d = t[_] || (t[_] = {}))[t.uniqueID] || (d[t.uniqueID] = {}), r && r === t.nodeName.toLowerCase()) t = t[i] || t;else {
                if ((c = u[o]) && c[0] === x && c[1] === s) return p[2] = c[2];
                if (u[o] = p, p[2] = e(t, n, l)) return !0;
              }
            }

            return !1;
          };
        }

        function we(e) {
          return e.length > 1 ? function (t, n, i) {
            for (var r = e.length; r--;) {
              if (!e[r](t, n, i)) return !1;
            }

            return !0;
          } : e[0];
        }

        function xe(e, t, n, i, r) {
          for (var o, a = [], s = 0, l = e.length, c = null != t; s < l; s++) {
            (o = e[s]) && (n && !n(o, i, r) || (a.push(o), c && t.push(s)));
          }

          return a;
        }

        function Ce(e, t, n, i, r, o) {
          return i && !i[_] && (i = Ce(i)), r && !r[_] && (r = Ce(r, o)), ce(function (o, a, s, l) {
            var c,
                u,
                d,
                p = [],
                h = [],
                f = a.length,
                m = o || function (e, t, n) {
              for (var i = 0, r = t.length; i < r; i++) {
                se(e, t[i], n);
              }

              return n;
            }(t || "*", s.nodeType ? [s] : s, []),
                g = !e || !o && t ? m : xe(m, p, e, s, l),
                v = n ? r || (o ? e : f || i) ? [] : a : g;

            if (n && n(g, v, s, l), i) for (c = xe(v, h), i(c, [], s, l), u = c.length; u--;) {
              (d = c[u]) && (v[h[u]] = !(g[h[u]] = d));
            }

            if (o) {
              if (r || e) {
                if (r) {
                  for (c = [], u = v.length; u--;) {
                    (d = v[u]) && c.push(g[u] = d);
                  }

                  r(null, v = [], c, l);
                }

                for (u = v.length; u--;) {
                  (d = v[u]) && (c = r ? F(o, d) : p[u]) > -1 && (o[c] = !(a[c] = d));
                }
              }
            } else v = xe(v === a ? v.splice(f, v.length) : v), r ? r(null, a, v, l) : N.apply(a, v);
          });
        }

        function Se(e) {
          for (var t, n, r, o = e.length, a = i.relative[e[0].type], s = a || i.relative[" "], l = a ? 1 : 0, u = _e(function (e) {
            return e === t;
          }, s, !0), d = _e(function (e) {
            return F(t, e) > -1;
          }, s, !0), p = [function (e, n, i) {
            var r = !a && (i || n !== c) || ((t = n).nodeType ? u(e, n, i) : d(e, n, i));
            return t = null, r;
          }]; l < o; l++) {
            if (n = i.relative[e[l].type]) p = [_e(we(p), n)];else {
              if ((n = i.filter[e[l].type].apply(null, e[l].matches))[_]) {
                for (r = ++l; r < o && !i.relative[e[r].type]; r++) {
                  ;
                }

                return Ce(l > 1 && we(p), l > 1 && ye(e.slice(0, l - 1).concat({
                  value: " " === e[l - 2].type ? "*" : ""
                })).replace($, "$1"), n, l < r && Se(e.slice(l, r)), r < o && Se(e = e.slice(r)), r < o && ye(e));
              }

              p.push(n);
            }
          }

          return we(p);
        }

        return be.prototype = i.filters = i.pseudos, i.setFilters = new be(), a = se.tokenize = function (e, t) {
          var n,
              r,
              o,
              a,
              s,
              l,
              c,
              u = D[e + " "];
          if (u) return t ? 0 : u.slice(0);

          for (s = e, l = [], c = i.preFilter; s;) {
            for (a in n && !(r = W.exec(s)) || (r && (s = s.slice(r[0].length) || s), l.push(o = [])), n = !1, (r = U.exec(s)) && (n = r.shift(), o.push({
              value: n,
              type: r[0].replace($, " ")
            }), s = s.slice(n.length)), i.filter) {
              !(r = V[a].exec(s)) || c[a] && !(r = c[a](r)) || (n = r.shift(), o.push({
                value: n,
                type: a,
                matches: r
              }), s = s.slice(n.length));
            }

            if (!n) break;
          }

          return t ? s.length : s ? se.error(e) : D(e, l).slice(0);
        }, s = se.compile = function (e, t) {
          var n,
              r = [],
              o = [],
              s = E[e + " "];

          if (!s) {
            for (t || (t = a(e)), n = t.length; n--;) {
              (s = Se(t[n]))[_] ? r.push(s) : o.push(s);
            }

            (s = E(e, function (e, t) {
              var n = t.length > 0,
                  r = e.length > 0,
                  o = function o(_o, a, s, l, u) {
                var d,
                    f,
                    g,
                    v = 0,
                    b = "0",
                    y = _o && [],
                    _ = [],
                    w = c,
                    C = _o || r && i.find.TAG("*", u),
                    S = x += null == w ? 1 : Math.random() || .1,
                    D = C.length;

                for (u && (c = a === h || a || u); b !== D && null != (d = C[b]); b++) {
                  if (r && d) {
                    for (f = 0, a || d.ownerDocument === h || (p(d), s = !m); g = e[f++];) {
                      if (g(d, a || h, s)) {
                        l.push(d);
                        break;
                      }
                    }

                    u && (x = S);
                  }

                  n && ((d = !g && d) && v--, _o && y.push(d));
                }

                if (v += b, n && b !== v) {
                  for (f = 0; g = t[f++];) {
                    g(y, _, a, s);
                  }

                  if (_o) {
                    if (v > 0) for (; b--;) {
                      y[b] || _[b] || (_[b] = A.call(l));
                    }
                    _ = xe(_);
                  }

                  N.apply(l, _), u && !_o && _.length > 0 && v + t.length > 1 && se.uniqueSort(l);
                }

                return u && (x = S, c = w), y;
              };

              return n ? ce(o) : o;
            }(o, r))).selector = e;
          }

          return s;
        }, l = se.select = function (e, t, n, r) {
          var o,
              l,
              c,
              u,
              d,
              p = "function" == typeof e && e,
              h = !r && a(e = p.selector || e);

          if (n = n || [], 1 === h.length) {
            if ((l = h[0] = h[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && 9 === t.nodeType && m && i.relative[l[1].type]) {
              if (!(t = (i.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
              p && (t = t.parentNode), e = e.slice(l.shift().value.length);
            }

            for (o = V.needsContext.test(e) ? 0 : l.length; o-- && (c = l[o], !i.relative[u = c.type]);) {
              if ((d = i.find[u]) && (r = d(c.matches[0].replace(te, ne), ee.test(l[0].type) && ve(t.parentNode) || t))) {
                if (l.splice(o, 1), !(e = r.length && ye(l))) return N.apply(n, r), n;
                break;
              }
            }
          }

          return (p || s(e, h))(r, t, !m, n, !t || ee.test(e) && ve(t.parentNode) || t), n;
        }, n.sortStable = _.split("").sort(T).join("") === _, n.detectDuplicates = !!d, p(), n.sortDetached = ue(function (e) {
          return 1 & e.compareDocumentPosition(h.createElement("fieldset"));
        }), ue(function (e) {
          return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
        }) || de("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }), n.attributes && ue(function (e) {
          return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
        }) || de("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }), ue(function (e) {
          return null == e.getAttribute("disabled");
        }) || de(j, function (e, t, n) {
          var i;
          if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
        }), se;
      }(n);

      C.find = E, C.expr = E.selectors, C.expr[":"] = C.expr.pseudos, C.uniqueSort = C.unique = E.uniqueSort, C.text = E.getText, C.isXMLDoc = E.isXML, C.contains = E.contains, C.escapeSelector = E.escape;

      var k = function k(e, t, n) {
        for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) {
          if (1 === e.nodeType) {
            if (r && C(e).is(n)) break;
            i.push(e);
          }
        }

        return i;
      },
          T = function T(e, t) {
        for (var n = []; e; e = e.nextSibling) {
          1 === e.nodeType && e !== t && n.push(e);
        }

        return n;
      },
          O = C.expr.match.needsContext;

      function P(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
      }

      var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

      function M(e, t, n) {
        return b(t) ? C.grep(e, function (e, i) {
          return !!t.call(e, i, e) !== n;
        }) : t.nodeType ? C.grep(e, function (e) {
          return e === t !== n;
        }) : "string" != typeof t ? C.grep(e, function (e) {
          return d.call(t, e) > -1 !== n;
        }) : C.filter(t, e, n);
      }

      C.filter = function (e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? C.find.matchesSelector(i, e) ? [i] : [] : C.find.matches(e, C.grep(t, function (e) {
          return 1 === e.nodeType;
        }));
      }, C.fn.extend({
        find: function find(e) {
          var t,
              n,
              i = this.length,
              r = this;
          if ("string" != typeof e) return this.pushStack(C(e).filter(function () {
            for (t = 0; t < i; t++) {
              if (C.contains(r[t], this)) return !0;
            }
          }));

          for (n = this.pushStack([]), t = 0; t < i; t++) {
            C.find(e, r[t], n);
          }

          return i > 1 ? C.uniqueSort(n) : n;
        },
        filter: function filter(e) {
          return this.pushStack(M(this, e || [], !1));
        },
        not: function not(e) {
          return this.pushStack(M(this, e || [], !0));
        },
        is: function is(e) {
          return !!M(this, "string" == typeof e && O.test(e) ? C(e) : e || [], !1).length;
        }
      });
      var N,
          I = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
      (C.fn.init = function (e, t, n) {
        var i, r;
        if (!e) return this;

        if (n = n || N, "string" == typeof e) {
          if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : I.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);

          if (i[1]) {
            if (t = t instanceof C ? t[0] : t, C.merge(this, C.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : a, !0)), A.test(i[1]) && C.isPlainObject(t)) for (i in t) {
              b(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            }
            return this;
          }

          return (r = a.getElementById(i[2])) && (this[0] = r, this.length = 1), this;
        }

        return e.nodeType ? (this[0] = e, this.length = 1, this) : b(e) ? void 0 !== n.ready ? n.ready(e) : e(C) : C.makeArray(e, this);
      }).prototype = C.fn, N = C(a);
      var F = /^(?:parents|prev(?:Until|All))/,
          j = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
      };

      function L(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType;) {
          ;
        }

        return e;
      }

      C.fn.extend({
        has: function has(e) {
          var t = C(e, this),
              n = t.length;
          return this.filter(function () {
            for (var e = 0; e < n; e++) {
              if (C.contains(this, t[e])) return !0;
            }
          });
        },
        closest: function closest(e, t) {
          var n,
              i = 0,
              r = this.length,
              o = [],
              a = "string" != typeof e && C(e);
          if (!O.test(e)) for (; i < r; i++) {
            for (n = this[i]; n && n !== t; n = n.parentNode) {
              if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && C.find.matchesSelector(n, e))) {
                o.push(n);
                break;
              }
            }
          }
          return this.pushStack(o.length > 1 ? C.uniqueSort(o) : o);
        },
        index: function index(e) {
          return e ? "string" == typeof e ? d.call(C(e), this[0]) : d.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function add(e, t) {
          return this.pushStack(C.uniqueSort(C.merge(this.get(), C(e, t))));
        },
        addBack: function addBack(e) {
          return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        }
      }), C.each({
        parent: function parent(e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function parents(e) {
          return k(e, "parentNode");
        },
        parentsUntil: function parentsUntil(e, t, n) {
          return k(e, "parentNode", n);
        },
        next: function next(e) {
          return L(e, "nextSibling");
        },
        prev: function prev(e) {
          return L(e, "previousSibling");
        },
        nextAll: function nextAll(e) {
          return k(e, "nextSibling");
        },
        prevAll: function prevAll(e) {
          return k(e, "previousSibling");
        },
        nextUntil: function nextUntil(e, t, n) {
          return k(e, "nextSibling", n);
        },
        prevUntil: function prevUntil(e, t, n) {
          return k(e, "previousSibling", n);
        },
        siblings: function siblings(e) {
          return T((e.parentNode || {}).firstChild, e);
        },
        children: function children(e) {
          return T(e.firstChild);
        },
        contents: function contents(e) {
          return void 0 !== e.contentDocument ? e.contentDocument : (P(e, "template") && (e = e.content || e), C.merge([], e.childNodes));
        }
      }, function (e, t) {
        C.fn[e] = function (n, i) {
          var r = C.map(this, t, n);
          return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (r = C.filter(i, r)), this.length > 1 && (j[e] || C.uniqueSort(r), F.test(e) && r.reverse()), this.pushStack(r);
        };
      });
      var R = /[^\x20\t\r\n\f]+/g;

      function H(e) {
        return e;
      }

      function B(e) {
        throw e;
      }

      function q(e, t, n, i) {
        var r;

        try {
          e && b(r = e.promise) ? r.call(e).done(t).fail(n) : e && b(r = e.then) ? r.call(e, t, n) : t.apply(void 0, [e].slice(i));
        } catch (e) {
          n.apply(void 0, [e]);
        }
      }

      C.Callbacks = function (e) {
        e = "string" == typeof e ? function (e) {
          var t = {};
          return C.each(e.match(R) || [], function (e, n) {
            t[n] = !0;
          }), t;
        }(e) : C.extend({}, e);

        var t,
            n,
            i,
            r,
            o = [],
            a = [],
            s = -1,
            l = function l() {
          for (r = r || e.once, i = t = !0; a.length; s = -1) {
            for (n = a.shift(); ++s < o.length;) {
              !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length, n = !1);
            }
          }

          e.memory || (n = !1), t = !1, r && (o = n ? [] : "");
        },
            c = {
          add: function add() {
            return o && (n && !t && (s = o.length - 1, a.push(n)), function t(n) {
              C.each(n, function (n, i) {
                b(i) ? e.unique && c.has(i) || o.push(i) : i && i.length && "string" !== x(i) && t(i);
              });
            }(arguments), n && !t && l()), this;
          },
          remove: function remove() {
            return C.each(arguments, function (e, t) {
              for (var n; (n = C.inArray(t, o, n)) > -1;) {
                o.splice(n, 1), n <= s && s--;
              }
            }), this;
          },
          has: function has(e) {
            return e ? C.inArray(e, o) > -1 : o.length > 0;
          },
          empty: function empty() {
            return o && (o = []), this;
          },
          disable: function disable() {
            return r = a = [], o = n = "", this;
          },
          disabled: function disabled() {
            return !o;
          },
          lock: function lock() {
            return r = a = [], n || t || (o = n = ""), this;
          },
          locked: function locked() {
            return !!r;
          },
          fireWith: function fireWith(e, n) {
            return r || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || l()), this;
          },
          fire: function fire() {
            return c.fireWith(this, arguments), this;
          },
          fired: function fired() {
            return !!i;
          }
        };

        return c;
      }, C.extend({
        Deferred: function Deferred(e) {
          var t = [["notify", "progress", C.Callbacks("memory"), C.Callbacks("memory"), 2], ["resolve", "done", C.Callbacks("once memory"), C.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", C.Callbacks("once memory"), C.Callbacks("once memory"), 1, "rejected"]],
              i = "pending",
              r = {
            state: function state() {
              return i;
            },
            always: function always() {
              return o.done(arguments).fail(arguments), this;
            },
            "catch": function _catch(e) {
              return r.then(null, e);
            },
            pipe: function pipe() {
              var e = arguments;
              return C.Deferred(function (n) {
                C.each(t, function (t, i) {
                  var r = b(e[i[4]]) && e[i[4]];
                  o[i[1]](function () {
                    var e = r && r.apply(this, arguments);
                    e && b(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this, r ? [e] : arguments);
                  });
                }), e = null;
              }).promise();
            },
            then: function then(e, i, r) {
              var o = 0;

              function a(e, t, i, r) {
                return function () {
                  var s = this,
                      l = arguments,
                      c = function c() {
                    var n, c;

                    if (!(e < o)) {
                      if ((n = i.apply(s, l)) === t.promise()) throw new TypeError("Thenable self-resolution");
                      c = n && ("object" == _typeof(n) || "function" == typeof n) && n.then, b(c) ? r ? c.call(n, a(o, t, H, r), a(o, t, B, r)) : (o++, c.call(n, a(o, t, H, r), a(o, t, B, r), a(o, t, H, t.notifyWith))) : (i !== H && (s = void 0, l = [n]), (r || t.resolveWith)(s, l));
                    }
                  },
                      u = r ? c : function () {
                    try {
                      c();
                    } catch (n) {
                      C.Deferred.exceptionHook && C.Deferred.exceptionHook(n, u.stackTrace), e + 1 >= o && (i !== B && (s = void 0, l = [n]), t.rejectWith(s, l));
                    }
                  };

                  e ? u() : (C.Deferred.getStackHook && (u.stackTrace = C.Deferred.getStackHook()), n.setTimeout(u));
                };
              }

              return C.Deferred(function (n) {
                t[0][3].add(a(0, n, b(r) ? r : H, n.notifyWith)), t[1][3].add(a(0, n, b(e) ? e : H)), t[2][3].add(a(0, n, b(i) ? i : B));
              }).promise();
            },
            promise: function promise(e) {
              return null != e ? C.extend(e, r) : r;
            }
          },
              o = {};
          return C.each(t, function (e, n) {
            var a = n[2],
                s = n[5];
            r[n[1]] = a.add, s && a.add(function () {
              i = s;
            }, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock), a.add(n[3].fire), o[n[0]] = function () {
              return o[n[0] + "With"](this === o ? void 0 : this, arguments), this;
            }, o[n[0] + "With"] = a.fireWith;
          }), r.promise(o), e && e.call(o, o), o;
        },
        when: function when(e) {
          var t = arguments.length,
              n = t,
              i = Array(n),
              r = l.call(arguments),
              o = C.Deferred(),
              a = function a(e) {
            return function (n) {
              i[e] = this, r[e] = arguments.length > 1 ? l.call(arguments) : n, --t || o.resolveWith(i, r);
            };
          };

          if (t <= 1 && (q(e, o.done(a(n)).resolve, o.reject, !t), "pending" === o.state() || b(r[n] && r[n].then))) return o.then();

          for (; n--;) {
            q(r[n], a(n), o.reject);
          }

          return o.promise();
        }
      });
      var $ = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      C.Deferred.exceptionHook = function (e, t) {
        n.console && n.console.warn && e && $.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
      }, C.readyException = function (e) {
        n.setTimeout(function () {
          throw e;
        });
      };
      var W = C.Deferred();

      function U() {
        a.removeEventListener("DOMContentLoaded", U), n.removeEventListener("load", U), C.ready();
      }

      C.fn.ready = function (e) {
        return W.then(e)["catch"](function (e) {
          C.readyException(e);
        }), this;
      }, C.extend({
        isReady: !1,
        readyWait: 1,
        ready: function ready(e) {
          (!0 === e ? --C.readyWait : C.isReady) || (C.isReady = !0, !0 !== e && --C.readyWait > 0 || W.resolveWith(a, [C]));
        }
      }), C.ready.then = W.then, "complete" === a.readyState || "loading" !== a.readyState && !a.documentElement.doScroll ? n.setTimeout(C.ready) : (a.addEventListener("DOMContentLoaded", U), n.addEventListener("load", U));

      var Y = function Y(e, t, n, i, r, o, a) {
        var s = 0,
            l = e.length,
            c = null == n;
        if ("object" === x(n)) for (s in r = !0, n) {
          Y(e, t, s, n[s], !0, o, a);
        } else if (void 0 !== i && (r = !0, b(i) || (a = !0), c && (a ? (t.call(e, i), t = null) : (c = t, t = function t(e, _t2, n) {
          return c.call(C(e), n);
        })), t)) for (; s < l; s++) {
          t(e[s], n, a ? i : i.call(e[s], s, t(e[s], n)));
        }
        return r ? e : c ? t.call(e) : l ? t(e[0], n) : o;
      },
          X = /^-ms-/,
          z = /-([a-z])/g;

      function V(e, t) {
        return t.toUpperCase();
      }

      function K(e) {
        return e.replace(X, "ms-").replace(z, V);
      }

      var Q = function Q(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
      };

      function Z() {
        this.expando = C.expando + Z.uid++;
      }

      Z.uid = 1, Z.prototype = {
        cache: function cache(e) {
          var t = e[this.expando];
          return t || (t = {}, Q(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
            value: t,
            configurable: !0
          }))), t;
        },
        set: function set(e, t, n) {
          var i,
              r = this.cache(e);
          if ("string" == typeof t) r[K(t)] = n;else for (i in t) {
            r[K(i)] = t[i];
          }
          return r;
        },
        get: function get(e, t) {
          return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][K(t)];
        },
        access: function access(e, t, n) {
          return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
        },
        remove: function remove(e, t) {
          var n,
              i = e[this.expando];

          if (void 0 !== i) {
            if (void 0 !== t) {
              n = (t = Array.isArray(t) ? t.map(K) : (t = K(t)) in i ? [t] : t.match(R) || []).length;

              for (; n--;) {
                delete i[t[n]];
              }
            }

            (void 0 === t || C.isEmptyObject(i)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
          }
        },
        hasData: function hasData(e) {
          var t = e[this.expando];
          return void 0 !== t && !C.isEmptyObject(t);
        }
      };
      var G = new Z(),
          J = new Z(),
          ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
          te = /[A-Z]/g;

      function ne(e, t, n) {
        var i;
        if (void 0 === n && 1 === e.nodeType) if (i = "data-" + t.replace(te, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(i))) {
          try {
            n = function (e) {
              return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e);
            }(n);
          } catch (e) {}

          J.set(e, t, n);
        } else n = void 0;
        return n;
      }

      C.extend({
        hasData: function hasData(e) {
          return J.hasData(e) || G.hasData(e);
        },
        data: function data(e, t, n) {
          return J.access(e, t, n);
        },
        removeData: function removeData(e, t) {
          J.remove(e, t);
        },
        _data: function _data(e, t, n) {
          return G.access(e, t, n);
        },
        _removeData: function _removeData(e, t) {
          G.remove(e, t);
        }
      }), C.fn.extend({
        data: function data(e, t) {
          var n,
              i,
              r,
              o = this[0],
              a = o && o.attributes;

          if (void 0 === e) {
            if (this.length && (r = J.get(o), 1 === o.nodeType && !G.get(o, "hasDataAttrs"))) {
              for (n = a.length; n--;) {
                a[n] && 0 === (i = a[n].name).indexOf("data-") && (i = K(i.slice(5)), ne(o, i, r[i]));
              }

              G.set(o, "hasDataAttrs", !0);
            }

            return r;
          }

          return "object" == _typeof(e) ? this.each(function () {
            J.set(this, e);
          }) : Y(this, function (t) {
            var n;
            if (o && void 0 === t) return void 0 !== (n = J.get(o, e)) ? n : void 0 !== (n = ne(o, e)) ? n : void 0;
            this.each(function () {
              J.set(this, e, t);
            });
          }, null, t, arguments.length > 1, null, !0);
        },
        removeData: function removeData(e) {
          return this.each(function () {
            J.remove(this, e);
          });
        }
      }), C.extend({
        queue: function queue(e, t, n) {
          var i;
          if (e) return t = (t || "fx") + "queue", i = G.get(e, t), n && (!i || Array.isArray(n) ? i = G.access(e, t, C.makeArray(n)) : i.push(n)), i || [];
        },
        dequeue: function dequeue(e, t) {
          t = t || "fx";

          var n = C.queue(e, t),
              i = n.length,
              r = n.shift(),
              o = C._queueHooks(e, t);

          "inprogress" === r && (r = n.shift(), i--), r && ("fx" === t && n.unshift("inprogress"), delete o.stop, r.call(e, function () {
            C.dequeue(e, t);
          }, o)), !i && o && o.empty.fire();
        },
        _queueHooks: function _queueHooks(e, t) {
          var n = t + "queueHooks";
          return G.get(e, n) || G.access(e, n, {
            empty: C.Callbacks("once memory").add(function () {
              G.remove(e, [t + "queue", n]);
            })
          });
        }
      }), C.fn.extend({
        queue: function queue(e, t) {
          var n = 2;
          return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? C.queue(this[0], e) : void 0 === t ? this : this.each(function () {
            var n = C.queue(this, e, t);
            C._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && C.dequeue(this, e);
          });
        },
        dequeue: function dequeue(e) {
          return this.each(function () {
            C.dequeue(this, e);
          });
        },
        clearQueue: function clearQueue(e) {
          return this.queue(e || "fx", []);
        },
        promise: function promise(e, t) {
          var n,
              i = 1,
              r = C.Deferred(),
              o = this,
              a = this.length,
              s = function s() {
            --i || r.resolveWith(o, [o]);
          };

          for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;) {
            (n = G.get(o[a], e + "queueHooks")) && n.empty && (i++, n.empty.add(s));
          }

          return s(), r.promise(t);
        }
      });

      var ie = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
          re = new RegExp("^(?:([+-])=|)(" + ie + ")([a-z%]*)$", "i"),
          oe = ["Top", "Right", "Bottom", "Left"],
          ae = a.documentElement,
          se = function se(e) {
        return C.contains(e.ownerDocument, e);
      },
          le = {
        composed: !0
      };

      ae.getRootNode && (se = function se(e) {
        return C.contains(e.ownerDocument, e) || e.getRootNode(le) === e.ownerDocument;
      });

      var ce = function ce(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && se(e) && "none" === C.css(e, "display");
      },
          ue = function ue(e, t, n, i) {
        var r,
            o,
            a = {};

        for (o in t) {
          a[o] = e.style[o], e.style[o] = t[o];
        }

        for (o in r = n.apply(e, i || []), t) {
          e.style[o] = a[o];
        }

        return r;
      };

      function de(e, t, n, i) {
        var r,
            o,
            a = 20,
            s = i ? function () {
          return i.cur();
        } : function () {
          return C.css(e, t, "");
        },
            l = s(),
            c = n && n[3] || (C.cssNumber[t] ? "" : "px"),
            u = e.nodeType && (C.cssNumber[t] || "px" !== c && +l) && re.exec(C.css(e, t));

        if (u && u[3] !== c) {
          for (l /= 2, c = c || u[3], u = +l || 1; a--;) {
            C.style(e, t, u + c), (1 - o) * (1 - (o = s() / l || .5)) <= 0 && (a = 0), u /= o;
          }

          u *= 2, C.style(e, t, u + c), n = n || [];
        }

        return n && (u = +u || +l || 0, r = n[1] ? u + (n[1] + 1) * n[2] : +n[2], i && (i.unit = c, i.start = u, i.end = r)), r;
      }

      var pe = {};

      function he(e) {
        var t,
            n = e.ownerDocument,
            i = e.nodeName,
            r = pe[i];
        return r || (t = n.body.appendChild(n.createElement(i)), r = C.css(t, "display"), t.parentNode.removeChild(t), "none" === r && (r = "block"), pe[i] = r, r);
      }

      function fe(e, t) {
        for (var n, i, r = [], o = 0, a = e.length; o < a; o++) {
          (i = e[o]).style && (n = i.style.display, t ? ("none" === n && (r[o] = G.get(i, "display") || null, r[o] || (i.style.display = "")), "" === i.style.display && ce(i) && (r[o] = he(i))) : "none" !== n && (r[o] = "none", G.set(i, "display", n)));
        }

        for (o = 0; o < a; o++) {
          null != r[o] && (e[o].style.display = r[o]);
        }

        return e;
      }

      C.fn.extend({
        show: function show() {
          return fe(this, !0);
        },
        hide: function hide() {
          return fe(this);
        },
        toggle: function toggle(e) {
          return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
            ce(this) ? C(this).show() : C(this).hide();
          });
        }
      });
      var me = /^(?:checkbox|radio)$/i,
          ge = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
          ve = /^$|^module$|\/(?:java|ecma)script/i,
          be = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
      };

      function ye(e, t) {
        var n;
        return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && P(e, t) ? C.merge([e], n) : n;
      }

      function _e(e, t) {
        for (var n = 0, i = e.length; n < i; n++) {
          G.set(e[n], "globalEval", !t || G.get(t[n], "globalEval"));
        }
      }

      be.optgroup = be.option, be.tbody = be.tfoot = be.colgroup = be.caption = be.thead, be.th = be.td;
      var we,
          xe,
          Ce = /<|&#?\w+;/;

      function Se(e, t, n, i, r) {
        for (var o, a, s, l, c, u, d = t.createDocumentFragment(), p = [], h = 0, f = e.length; h < f; h++) {
          if ((o = e[h]) || 0 === o) if ("object" === x(o)) C.merge(p, o.nodeType ? [o] : o);else if (Ce.test(o)) {
            for (a = a || d.appendChild(t.createElement("div")), s = (ge.exec(o) || ["", ""])[1].toLowerCase(), l = be[s] || be._default, a.innerHTML = l[1] + C.htmlPrefilter(o) + l[2], u = l[0]; u--;) {
              a = a.lastChild;
            }

            C.merge(p, a.childNodes), (a = d.firstChild).textContent = "";
          } else p.push(t.createTextNode(o));
        }

        for (d.textContent = "", h = 0; o = p[h++];) {
          if (i && C.inArray(o, i) > -1) r && r.push(o);else if (c = se(o), a = ye(d.appendChild(o), "script"), c && _e(a), n) for (u = 0; o = a[u++];) {
            ve.test(o.type || "") && n.push(o);
          }
        }

        return d;
      }

      we = a.createDocumentFragment().appendChild(a.createElement("div")), (xe = a.createElement("input")).setAttribute("type", "radio"), xe.setAttribute("checked", "checked"), xe.setAttribute("name", "t"), we.appendChild(xe), v.checkClone = we.cloneNode(!0).cloneNode(!0).lastChild.checked, we.innerHTML = "<textarea>x</textarea>", v.noCloneChecked = !!we.cloneNode(!0).lastChild.defaultValue;
      var De = /^key/,
          Ee = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
          ke = /^([^.]*)(?:\.(.+)|)/;

      function Te() {
        return !0;
      }

      function Oe() {
        return !1;
      }

      function Pe(e, t) {
        return e === function () {
          try {
            return a.activeElement;
          } catch (e) {}
        }() == ("focus" === t);
      }

      function Ae(e, t, n, i, r, o) {
        var a, s;

        if ("object" == _typeof(t)) {
          for (s in "string" != typeof n && (i = i || n, n = void 0), t) {
            Ae(e, s, n, i, t[s], o);
          }

          return e;
        }

        if (null == i && null == r ? (r = n, i = n = void 0) : null == r && ("string" == typeof n ? (r = i, i = void 0) : (r = i, i = n, n = void 0)), !1 === r) r = Oe;else if (!r) return e;
        return 1 === o && (a = r, (r = function r(e) {
          return C().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = C.guid++)), e.each(function () {
          C.event.add(this, t, r, i, n);
        });
      }

      function Me(e, t, n) {
        n ? (G.set(e, t, !1), C.event.add(e, t, {
          namespace: !1,
          handler: function handler(e) {
            var i,
                r,
                o = G.get(this, t);

            if (1 & e.isTrigger && this[t]) {
              if (o.length) (C.event.special[t] || {}).delegateType && e.stopPropagation();else if (o = l.call(arguments), G.set(this, t, o), i = n(this, t), this[t](), o !== (r = G.get(this, t)) || i ? G.set(this, t, !1) : r = {}, o !== r) return e.stopImmediatePropagation(), e.preventDefault(), r.value;
            } else o.length && (G.set(this, t, {
              value: C.event.trigger(C.extend(o[0], C.Event.prototype), o.slice(1), this)
            }), e.stopImmediatePropagation());
          }
        })) : void 0 === G.get(e, t) && C.event.add(e, t, Te);
      }

      C.event = {
        global: {},
        add: function add(e, t, n, i, r) {
          var o,
              a,
              s,
              l,
              c,
              u,
              d,
              p,
              h,
              f,
              m,
              g = G.get(e);
          if (g) for (n.handler && (n = (o = n).handler, r = o.selector), r && C.find.matchesSelector(ae, r), n.guid || (n.guid = C.guid++), (l = g.events) || (l = g.events = {}), (a = g.handle) || (a = g.handle = function (t) {
            return void 0 !== C && C.event.triggered !== t.type ? C.event.dispatch.apply(e, arguments) : void 0;
          }), c = (t = (t || "").match(R) || [""]).length; c--;) {
            h = m = (s = ke.exec(t[c]) || [])[1], f = (s[2] || "").split(".").sort(), h && (d = C.event.special[h] || {}, h = (r ? d.delegateType : d.bindType) || h, d = C.event.special[h] || {}, u = C.extend({
              type: h,
              origType: m,
              data: i,
              handler: n,
              guid: n.guid,
              selector: r,
              needsContext: r && C.expr.match.needsContext.test(r),
              namespace: f.join(".")
            }, o), (p = l[h]) || ((p = l[h] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(e, i, f, a) || e.addEventListener && e.addEventListener(h, a)), d.add && (d.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)), r ? p.splice(p.delegateCount++, 0, u) : p.push(u), C.event.global[h] = !0);
          }
        },
        remove: function remove(e, t, n, i, r) {
          var o,
              a,
              s,
              l,
              c,
              u,
              d,
              p,
              h,
              f,
              m,
              g = G.hasData(e) && G.get(e);

          if (g && (l = g.events)) {
            for (c = (t = (t || "").match(R) || [""]).length; c--;) {
              if (h = m = (s = ke.exec(t[c]) || [])[1], f = (s[2] || "").split(".").sort(), h) {
                for (d = C.event.special[h] || {}, p = l[h = (i ? d.delegateType : d.bindType) || h] || [], s = s[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length; o--;) {
                  u = p[o], !r && m !== u.origType || n && n.guid !== u.guid || s && !s.test(u.namespace) || i && i !== u.selector && ("**" !== i || !u.selector) || (p.splice(o, 1), u.selector && p.delegateCount--, d.remove && d.remove.call(e, u));
                }

                a && !p.length && (d.teardown && !1 !== d.teardown.call(e, f, g.handle) || C.removeEvent(e, h, g.handle), delete l[h]);
              } else for (h in l) {
                C.event.remove(e, h + t[c], n, i, !0);
              }
            }

            C.isEmptyObject(l) && G.remove(e, "handle events");
          }
        },
        dispatch: function dispatch(e) {
          var t,
              n,
              i,
              r,
              o,
              a,
              s = C.event.fix(e),
              l = new Array(arguments.length),
              c = (G.get(this, "events") || {})[s.type] || [],
              u = C.event.special[s.type] || {};

          for (l[0] = s, t = 1; t < arguments.length; t++) {
            l[t] = arguments[t];
          }

          if (s.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, s)) {
            for (a = C.event.handlers.call(this, s, c), t = 0; (r = a[t++]) && !s.isPropagationStopped();) {
              for (s.currentTarget = r.elem, n = 0; (o = r.handlers[n++]) && !s.isImmediatePropagationStopped();) {
                s.rnamespace && !1 !== o.namespace && !s.rnamespace.test(o.namespace) || (s.handleObj = o, s.data = o.data, void 0 !== (i = ((C.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, l)) && !1 === (s.result = i) && (s.preventDefault(), s.stopPropagation()));
              }
            }

            return u.postDispatch && u.postDispatch.call(this, s), s.result;
          }
        },
        handlers: function handlers(e, t) {
          var n,
              i,
              r,
              o,
              a,
              s = [],
              l = t.delegateCount,
              c = e.target;
          if (l && c.nodeType && !("click" === e.type && e.button >= 1)) for (; c !== this; c = c.parentNode || this) {
            if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
              for (o = [], a = {}, n = 0; n < l; n++) {
                void 0 === a[r = (i = t[n]).selector + " "] && (a[r] = i.needsContext ? C(r, this).index(c) > -1 : C.find(r, this, null, [c]).length), a[r] && o.push(i);
              }

              o.length && s.push({
                elem: c,
                handlers: o
              });
            }
          }
          return c = this, l < t.length && s.push({
            elem: c,
            handlers: t.slice(l)
          }), s;
        },
        addProp: function addProp(e, t) {
          Object.defineProperty(C.Event.prototype, e, {
            enumerable: !0,
            configurable: !0,
            get: b(t) ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            } : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
            set: function set(t) {
              Object.defineProperty(this, e, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: t
              });
            }
          });
        },
        fix: function fix(e) {
          return e[C.expando] ? e : new C.Event(e);
        },
        special: {
          load: {
            noBubble: !0
          },
          click: {
            setup: function setup(e) {
              var t = this || e;
              return me.test(t.type) && t.click && P(t, "input") && Me(t, "click", Te), !1;
            },
            trigger: function trigger(e) {
              var t = this || e;
              return me.test(t.type) && t.click && P(t, "input") && Me(t, "click"), !0;
            },
            _default: function _default(e) {
              var t = e.target;
              return me.test(t.type) && t.click && P(t, "input") && G.get(t, "click") || P(t, "a");
            }
          },
          beforeunload: {
            postDispatch: function postDispatch(e) {
              void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
            }
          }
        }
      }, C.removeEvent = function (e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n);
      }, C.Event = function (e, t) {
        if (!(this instanceof C.Event)) return new C.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Te : Oe, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && C.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[C.expando] = !0;
      }, C.Event.prototype = {
        constructor: C.Event,
        isDefaultPrevented: Oe,
        isPropagationStopped: Oe,
        isImmediatePropagationStopped: Oe,
        isSimulated: !1,
        preventDefault: function preventDefault() {
          var e = this.originalEvent;
          this.isDefaultPrevented = Te, e && !this.isSimulated && e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
          var e = this.originalEvent;
          this.isPropagationStopped = Te, e && !this.isSimulated && e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
          var e = this.originalEvent;
          this.isImmediatePropagationStopped = Te, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
        }
      }, C.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        "char": !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function which(e) {
          var t = e.button;
          return null == e.which && De.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Ee.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which;
        }
      }, C.event.addProp), C.each({
        focus: "focusin",
        blur: "focusout"
      }, function (e, t) {
        C.event.special[e] = {
          setup: function setup() {
            return Me(this, e, Pe), !1;
          },
          trigger: function trigger() {
            return Me(this, e), !0;
          },
          delegateType: t
        };
      }), C.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
      }, function (e, t) {
        C.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function handle(e) {
            var n,
                i = this,
                r = e.relatedTarget,
                o = e.handleObj;
            return r && (r === i || C.contains(i, r)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
          }
        };
      }), C.fn.extend({
        on: function on(e, t, n, i) {
          return Ae(this, e, t, n, i);
        },
        one: function one(e, t, n, i) {
          return Ae(this, e, t, n, i, 1);
        },
        off: function off(e, t, n) {
          var i, r;
          if (e && e.preventDefault && e.handleObj) return i = e.handleObj, C(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;

          if ("object" == _typeof(e)) {
            for (r in e) {
              this.off(r, t, e[r]);
            }

            return this;
          }

          return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Oe), this.each(function () {
            C.event.remove(this, e, n, t);
          });
        }
      });
      var Ne = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
          Ie = /<script|<style|<link/i,
          Fe = /checked\s*(?:[^=]|=\s*.checked.)/i,
          je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

      function Le(e, t) {
        return P(e, "table") && P(11 !== t.nodeType ? t : t.firstChild, "tr") && C(e).children("tbody")[0] || e;
      }

      function Re(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
      }

      function He(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
      }

      function Be(e, t) {
        var n, i, r, o, a, s, l, c;

        if (1 === t.nodeType) {
          if (G.hasData(e) && (o = G.access(e), a = G.set(t, o), c = o.events)) for (r in delete a.handle, a.events = {}, c) {
            for (n = 0, i = c[r].length; n < i; n++) {
              C.event.add(t, r, c[r][n]);
            }
          }
          J.hasData(e) && (s = J.access(e), l = C.extend({}, s), J.set(t, l));
        }
      }

      function qe(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && me.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
      }

      function $e(e, t, n, i) {
        t = c.apply([], t);
        var r,
            o,
            a,
            s,
            l,
            u,
            d = 0,
            p = e.length,
            h = p - 1,
            f = t[0],
            m = b(f);
        if (m || p > 1 && "string" == typeof f && !v.checkClone && Fe.test(f)) return e.each(function (r) {
          var o = e.eq(r);
          m && (t[0] = f.call(this, r, o.html())), $e(o, t, n, i);
        });

        if (p && (o = (r = Se(t, e[0].ownerDocument, !1, e, i)).firstChild, 1 === r.childNodes.length && (r = o), o || i)) {
          for (s = (a = C.map(ye(r, "script"), Re)).length; d < p; d++) {
            l = r, d !== h && (l = C.clone(l, !0, !0), s && C.merge(a, ye(l, "script"))), n.call(e[d], l, d);
          }

          if (s) for (u = a[a.length - 1].ownerDocument, C.map(a, He), d = 0; d < s; d++) {
            l = a[d], ve.test(l.type || "") && !G.access(l, "globalEval") && C.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? C._evalUrl && !l.noModule && C._evalUrl(l.src, {
              nonce: l.nonce || l.getAttribute("nonce")
            }) : w(l.textContent.replace(je, ""), l, u));
          }
        }

        return e;
      }

      function We(e, t, n) {
        for (var i, r = t ? C.filter(t, e) : e, o = 0; null != (i = r[o]); o++) {
          n || 1 !== i.nodeType || C.cleanData(ye(i)), i.parentNode && (n && se(i) && _e(ye(i, "script")), i.parentNode.removeChild(i));
        }

        return e;
      }

      C.extend({
        htmlPrefilter: function htmlPrefilter(e) {
          return e.replace(Ne, "<$1></$2>");
        },
        clone: function clone(e, t, n) {
          var i,
              r,
              o,
              a,
              s = e.cloneNode(!0),
              l = se(e);
          if (!(v.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || C.isXMLDoc(e))) for (a = ye(s), i = 0, r = (o = ye(e)).length; i < r; i++) {
            qe(o[i], a[i]);
          }
          if (t) if (n) for (o = o || ye(e), a = a || ye(s), i = 0, r = o.length; i < r; i++) {
            Be(o[i], a[i]);
          } else Be(e, s);
          return (a = ye(s, "script")).length > 0 && _e(a, !l && ye(e, "script")), s;
        },
        cleanData: function cleanData(e) {
          for (var t, n, i, r = C.event.special, o = 0; void 0 !== (n = e[o]); o++) {
            if (Q(n)) {
              if (t = n[G.expando]) {
                if (t.events) for (i in t.events) {
                  r[i] ? C.event.remove(n, i) : C.removeEvent(n, i, t.handle);
                }
                n[G.expando] = void 0;
              }

              n[J.expando] && (n[J.expando] = void 0);
            }
          }
        }
      }), C.fn.extend({
        detach: function detach(e) {
          return We(this, e, !0);
        },
        remove: function remove(e) {
          return We(this, e);
        },
        text: function text(e) {
          return Y(this, function (e) {
            return void 0 === e ? C.text(this) : this.empty().each(function () {
              1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
            });
          }, null, e, arguments.length);
        },
        append: function append() {
          return $e(this, arguments, function (e) {
            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Le(this, e).appendChild(e);
          });
        },
        prepend: function prepend() {
          return $e(this, arguments, function (e) {
            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
              var t = Le(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function before() {
          return $e(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function after() {
          return $e(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function empty() {
          for (var e, t = 0; null != (e = this[t]); t++) {
            1 === e.nodeType && (C.cleanData(ye(e, !1)), e.textContent = "");
          }

          return this;
        },
        clone: function clone(e, t) {
          return e = null != e && e, t = null == t ? e : t, this.map(function () {
            return C.clone(this, e, t);
          });
        },
        html: function html(e) {
          return Y(this, function (e) {
            var t = this[0] || {},
                n = 0,
                i = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;

            if ("string" == typeof e && !Ie.test(e) && !be[(ge.exec(e) || ["", ""])[1].toLowerCase()]) {
              e = C.htmlPrefilter(e);

              try {
                for (; n < i; n++) {
                  1 === (t = this[n] || {}).nodeType && (C.cleanData(ye(t, !1)), t.innerHTML = e);
                }

                t = 0;
              } catch (e) {}
            }

            t && this.empty().append(e);
          }, null, e, arguments.length);
        },
        replaceWith: function replaceWith() {
          var e = [];
          return $e(this, arguments, function (t) {
            var n = this.parentNode;
            C.inArray(this, e) < 0 && (C.cleanData(ye(this)), n && n.replaceChild(t, this));
          }, e);
        }
      }), C.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
      }, function (e, t) {
        C.fn[e] = function (e) {
          for (var n, i = [], r = C(e), o = r.length - 1, a = 0; a <= o; a++) {
            n = a === o ? this : this.clone(!0), C(r[a])[t](n), u.apply(i, n.get());
          }

          return this.pushStack(i);
        };
      });

      var Ue = new RegExp("^(" + ie + ")(?!px)[a-z%]+$", "i"),
          Ye = function Ye(e) {
        var t = e.ownerDocument.defaultView;
        return t && t.opener || (t = n), t.getComputedStyle(e);
      },
          Xe = new RegExp(oe.join("|"), "i");

      function ze(e, t, n) {
        var i,
            r,
            o,
            a,
            s = e.style;
        return (n = n || Ye(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || se(e) || (a = C.style(e, t)), !v.pixelBoxStyles() && Ue.test(a) && Xe.test(t) && (i = s.width, r = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = i, s.minWidth = r, s.maxWidth = o)), void 0 !== a ? a + "" : a;
      }

      function Ve(e, t) {
        return {
          get: function get() {
            if (!e()) return (this.get = t).apply(this, arguments);
            delete this.get;
          }
        };
      }

      !function () {
        function e() {
          if (u) {
            c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", ae.appendChild(c).appendChild(u);
            var e = n.getComputedStyle(u);
            i = "1%" !== e.top, l = 12 === t(e.marginLeft), u.style.right = "60%", s = 36 === t(e.right), r = 36 === t(e.width), u.style.position = "absolute", o = 12 === t(u.offsetWidth / 3), ae.removeChild(c), u = null;
          }
        }

        function t(e) {
          return Math.round(parseFloat(e));
        }

        var i,
            r,
            o,
            s,
            l,
            c = a.createElement("div"),
            u = a.createElement("div");
        u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", v.clearCloneStyle = "content-box" === u.style.backgroundClip, C.extend(v, {
          boxSizingReliable: function boxSizingReliable() {
            return e(), r;
          },
          pixelBoxStyles: function pixelBoxStyles() {
            return e(), s;
          },
          pixelPosition: function pixelPosition() {
            return e(), i;
          },
          reliableMarginLeft: function reliableMarginLeft() {
            return e(), l;
          },
          scrollboxSize: function scrollboxSize() {
            return e(), o;
          }
        }));
      }();
      var Ke = ["Webkit", "Moz", "ms"],
          Qe = a.createElement("div").style,
          Ze = {};

      function Ge(e) {
        var t = C.cssProps[e] || Ze[e];
        return t || (e in Qe ? e : Ze[e] = function (e) {
          for (var t = e[0].toUpperCase() + e.slice(1), n = Ke.length; n--;) {
            if ((e = Ke[n] + t) in Qe) return e;
          }
        }(e) || e);
      }

      var Je = /^(none|table(?!-c[ea]).+)/,
          et = /^--/,
          tt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
          nt = {
        letterSpacing: "0",
        fontWeight: "400"
      };

      function it(e, t, n) {
        var i = re.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
      }

      function rt(e, t, n, i, r, o) {
        var a = "width" === t ? 1 : 0,
            s = 0,
            l = 0;
        if (n === (i ? "border" : "content")) return 0;

        for (; a < 4; a += 2) {
          "margin" === n && (l += C.css(e, n + oe[a], !0, r)), i ? ("content" === n && (l -= C.css(e, "padding" + oe[a], !0, r)), "margin" !== n && (l -= C.css(e, "border" + oe[a] + "Width", !0, r))) : (l += C.css(e, "padding" + oe[a], !0, r), "padding" !== n ? l += C.css(e, "border" + oe[a] + "Width", !0, r) : s += C.css(e, "border" + oe[a] + "Width", !0, r));
        }

        return !i && o >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - l - s - .5)) || 0), l;
      }

      function ot(e, t, n) {
        var i = Ye(e),
            r = (!v.boxSizingReliable() || n) && "border-box" === C.css(e, "boxSizing", !1, i),
            o = r,
            a = ze(e, t, i),
            s = "offset" + t[0].toUpperCase() + t.slice(1);

        if (Ue.test(a)) {
          if (!n) return a;
          a = "auto";
        }

        return (!v.boxSizingReliable() && r || "auto" === a || !parseFloat(a) && "inline" === C.css(e, "display", !1, i)) && e.getClientRects().length && (r = "border-box" === C.css(e, "boxSizing", !1, i), (o = s in e) && (a = e[s])), (a = parseFloat(a) || 0) + rt(e, t, n || (r ? "border" : "content"), o, i, a) + "px";
      }

      function at(e, t, n, i, r) {
        return new at.prototype.init(e, t, n, i, r);
      }

      C.extend({
        cssHooks: {
          opacity: {
            get: function get(e, t) {
              if (t) {
                var n = ze(e, "opacity");
                return "" === n ? "1" : n;
              }
            }
          }
        },
        cssNumber: {
          animationIterationCount: !0,
          columnCount: !0,
          fillOpacity: !0,
          flexGrow: !0,
          flexShrink: !0,
          fontWeight: !0,
          gridArea: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnStart: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowStart: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0
        },
        cssProps: {},
        style: function style(e, t, n, i) {
          if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
            var r,
                o,
                a,
                s = K(t),
                l = et.test(t),
                c = e.style;
            if (l || (t = Ge(s)), a = C.cssHooks[t] || C.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (r = a.get(e, !1, i)) ? r : c[t];
            "string" === (o = _typeof(n)) && (r = re.exec(n)) && r[1] && (n = de(e, t, r), o = "number"), null != n && n == n && ("number" !== o || l || (n += r && r[3] || (C.cssNumber[s] ? "" : "px")), v.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, i)) || (l ? c.setProperty(t, n) : c[t] = n));
          }
        },
        css: function css(e, t, n, i) {
          var r,
              o,
              a,
              s = K(t);
          return et.test(t) || (t = Ge(s)), (a = C.cssHooks[t] || C.cssHooks[s]) && "get" in a && (r = a.get(e, !0, n)), void 0 === r && (r = ze(e, t, i)), "normal" === r && t in nt && (r = nt[t]), "" === n || n ? (o = parseFloat(r), !0 === n || isFinite(o) ? o || 0 : r) : r;
        }
      }), C.each(["height", "width"], function (e, t) {
        C.cssHooks[t] = {
          get: function get(e, n, i) {
            if (n) return !Je.test(C.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ot(e, t, i) : ue(e, tt, function () {
              return ot(e, t, i);
            });
          },
          set: function set(e, n, i) {
            var r,
                o = Ye(e),
                a = !v.scrollboxSize() && "absolute" === o.position,
                s = (a || i) && "border-box" === C.css(e, "boxSizing", !1, o),
                l = i ? rt(e, t, i, s, o) : 0;
            return s && a && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - rt(e, t, "border", !1, o) - .5)), l && (r = re.exec(n)) && "px" !== (r[3] || "px") && (e.style[t] = n, n = C.css(e, t)), it(0, n, l);
          }
        };
      }), C.cssHooks.marginLeft = Ve(v.reliableMarginLeft, function (e, t) {
        if (t) return (parseFloat(ze(e, "marginLeft")) || e.getBoundingClientRect().left - ue(e, {
          marginLeft: 0
        }, function () {
          return e.getBoundingClientRect().left;
        })) + "px";
      }), C.each({
        margin: "",
        padding: "",
        border: "Width"
      }, function (e, t) {
        C.cssHooks[e + t] = {
          expand: function expand(n) {
            for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) {
              r[e + oe[i] + t] = o[i] || o[i - 2] || o[0];
            }

            return r;
          }
        }, "margin" !== e && (C.cssHooks[e + t].set = it);
      }), C.fn.extend({
        css: function css(e, t) {
          return Y(this, function (e, t, n) {
            var i,
                r,
                o = {},
                a = 0;

            if (Array.isArray(t)) {
              for (i = Ye(e), r = t.length; a < r; a++) {
                o[t[a]] = C.css(e, t[a], !1, i);
              }

              return o;
            }

            return void 0 !== n ? C.style(e, t, n) : C.css(e, t);
          }, e, t, arguments.length > 1);
        }
      }), C.Tween = at, at.prototype = {
        constructor: at,
        init: function init(e, t, n, i, r, o) {
          this.elem = e, this.prop = n, this.easing = r || C.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = o || (C.cssNumber[n] ? "" : "px");
        },
        cur: function cur() {
          var e = at.propHooks[this.prop];
          return e && e.get ? e.get(this) : at.propHooks._default.get(this);
        },
        run: function run(e) {
          var t,
              n = at.propHooks[this.prop];
          return this.options.duration ? this.pos = t = C.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : at.propHooks._default.set(this), this;
        }
      }, at.prototype.init.prototype = at.prototype, at.propHooks = {
        _default: {
          get: function get(e) {
            var t;
            return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = C.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
          },
          set: function set(e) {
            C.fx.step[e.prop] ? C.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !C.cssHooks[e.prop] && null == e.elem.style[Ge(e.prop)] ? e.elem[e.prop] = e.now : C.style(e.elem, e.prop, e.now + e.unit);
          }
        }
      }, at.propHooks.scrollTop = at.propHooks.scrollLeft = {
        set: function set(e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        }
      }, C.easing = {
        linear: function linear(e) {
          return e;
        },
        swing: function swing(e) {
          return .5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing"
      }, C.fx = at.prototype.init, C.fx.step = {};
      var st,
          lt,
          ct = /^(?:toggle|show|hide)$/,
          ut = /queueHooks$/;

      function dt() {
        lt && (!1 === a.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(dt) : n.setTimeout(dt, C.fx.interval), C.fx.tick());
      }

      function pt() {
        return n.setTimeout(function () {
          st = void 0;
        }), st = Date.now();
      }

      function ht(e, t) {
        var n,
            i = 0,
            r = {
          height: e
        };

        for (t = t ? 1 : 0; i < 4; i += 2 - t) {
          r["margin" + (n = oe[i])] = r["padding" + n] = e;
        }

        return t && (r.opacity = r.width = e), r;
      }

      function ft(e, t, n) {
        for (var i, r = (mt.tweeners[t] || []).concat(mt.tweeners["*"]), o = 0, a = r.length; o < a; o++) {
          if (i = r[o].call(n, t, e)) return i;
        }
      }

      function mt(e, t, n) {
        var i,
            r,
            o = 0,
            a = mt.prefilters.length,
            s = C.Deferred().always(function () {
          delete l.elem;
        }),
            l = function l() {
          if (r) return !1;

          for (var t = st || pt(), n = Math.max(0, c.startTime + c.duration - t), i = 1 - (n / c.duration || 0), o = 0, a = c.tweens.length; o < a; o++) {
            c.tweens[o].run(i);
          }

          return s.notifyWith(e, [c, i, n]), i < 1 && a ? n : (a || s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c]), !1);
        },
            c = s.promise({
          elem: e,
          props: C.extend({}, t),
          opts: C.extend(!0, {
            specialEasing: {},
            easing: C.easing._default
          }, n),
          originalProperties: t,
          originalOptions: n,
          startTime: st || pt(),
          duration: n.duration,
          tweens: [],
          createTween: function createTween(t, n) {
            var i = C.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
            return c.tweens.push(i), i;
          },
          stop: function stop(t) {
            var n = 0,
                i = t ? c.tweens.length : 0;
            if (r) return this;

            for (r = !0; n < i; n++) {
              c.tweens[n].run(1);
            }

            return t ? (s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c, t])) : s.rejectWith(e, [c, t]), this;
          }
        }),
            u = c.props;

        for (!function (e, t) {
          var n, i, r, o, a;

          for (n in e) {
            if (r = t[i = K(n)], o = e[n], Array.isArray(o) && (r = o[1], o = e[n] = o[0]), n !== i && (e[i] = o, delete e[n]), (a = C.cssHooks[i]) && ("expand" in a)) for (n in o = a.expand(o), delete e[i], o) {
              (n in e) || (e[n] = o[n], t[n] = r);
            } else t[i] = r;
          }
        }(u, c.opts.specialEasing); o < a; o++) {
          if (i = mt.prefilters[o].call(c, e, u, c.opts)) return b(i.stop) && (C._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
        }

        return C.map(u, ft, c), b(c.opts.start) && c.opts.start.call(e, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), C.fx.timer(C.extend(l, {
          elem: e,
          anim: c,
          queue: c.opts.queue
        })), c;
      }

      C.Animation = C.extend(mt, {
        tweeners: {
          "*": [function (e, t) {
            var n = this.createTween(e, t);
            return de(n.elem, e, re.exec(t), n), n;
          }]
        },
        tweener: function tweener(e, t) {
          b(e) ? (t = e, e = ["*"]) : e = e.match(R);

          for (var n, i = 0, r = e.length; i < r; i++) {
            n = e[i], mt.tweeners[n] = mt.tweeners[n] || [], mt.tweeners[n].unshift(t);
          }
        },
        prefilters: [function (e, t, n) {
          var i,
              r,
              o,
              a,
              s,
              l,
              c,
              u,
              d = "width" in t || "height" in t,
              p = this,
              h = {},
              f = e.style,
              m = e.nodeType && ce(e),
              g = G.get(e, "fxshow");

          for (i in n.queue || (null == (a = C._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
            a.unqueued || s();
          }), a.unqueued++, p.always(function () {
            p.always(function () {
              a.unqueued--, C.queue(e, "fx").length || a.empty.fire();
            });
          })), t) {
            if (r = t[i], ct.test(r)) {
              if (delete t[i], o = o || "toggle" === r, r === (m ? "hide" : "show")) {
                if ("show" !== r || !g || void 0 === g[i]) continue;
                m = !0;
              }

              h[i] = g && g[i] || C.style(e, i);
            }
          }

          if ((l = !C.isEmptyObject(t)) || !C.isEmptyObject(h)) for (i in d && 1 === e.nodeType && (n.overflow = [f.overflow, f.overflowX, f.overflowY], null == (c = g && g.display) && (c = G.get(e, "display")), "none" === (u = C.css(e, "display")) && (c ? u = c : (fe([e], !0), c = e.style.display || c, u = C.css(e, "display"), fe([e]))), ("inline" === u || "inline-block" === u && null != c) && "none" === C.css(e, "float") && (l || (p.done(function () {
            f.display = c;
          }), null == c && (u = f.display, c = "none" === u ? "" : u)), f.display = "inline-block")), n.overflow && (f.overflow = "hidden", p.always(function () {
            f.overflow = n.overflow[0], f.overflowX = n.overflow[1], f.overflowY = n.overflow[2];
          })), l = !1, h) {
            l || (g ? "hidden" in g && (m = g.hidden) : g = G.access(e, "fxshow", {
              display: c
            }), o && (g.hidden = !m), m && fe([e], !0), p.done(function () {
              for (i in m || fe([e]), G.remove(e, "fxshow"), h) {
                C.style(e, i, h[i]);
              }
            })), l = ft(m ? g[i] : 0, i, p), i in g || (g[i] = l.start, m && (l.end = l.start, l.start = 0));
          }
        }],
        prefilter: function prefilter(e, t) {
          t ? mt.prefilters.unshift(e) : mt.prefilters.push(e);
        }
      }), C.speed = function (e, t, n) {
        var i = e && "object" == _typeof(e) ? C.extend({}, e) : {
          complete: n || !n && t || b(e) && e,
          duration: e,
          easing: n && t || t && !b(t) && t
        };
        return C.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in C.fx.speeds ? i.duration = C.fx.speeds[i.duration] : i.duration = C.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function () {
          b(i.old) && i.old.call(this), i.queue && C.dequeue(this, i.queue);
        }, i;
      }, C.fn.extend({
        fadeTo: function fadeTo(e, t, n, i) {
          return this.filter(ce).css("opacity", 0).show().end().animate({
            opacity: t
          }, e, n, i);
        },
        animate: function animate(e, t, n, i) {
          var r = C.isEmptyObject(e),
              o = C.speed(t, n, i),
              a = function a() {
            var t = mt(this, C.extend({}, e), o);
            (r || G.get(this, "finish")) && t.stop(!0);
          };

          return a.finish = a, r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
        },
        stop: function stop(e, t, n) {
          var i = function i(e) {
            var t = e.stop;
            delete e.stop, t(n);
          };

          return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
            var t = !0,
                r = null != e && e + "queueHooks",
                o = C.timers,
                a = G.get(this);
            if (r) a[r] && a[r].stop && i(a[r]);else for (r in a) {
              a[r] && a[r].stop && ut.test(r) && i(a[r]);
            }

            for (r = o.length; r--;) {
              o[r].elem !== this || null != e && o[r].queue !== e || (o[r].anim.stop(n), t = !1, o.splice(r, 1));
            }

            !t && n || C.dequeue(this, e);
          });
        },
        finish: function finish(e) {
          return !1 !== e && (e = e || "fx"), this.each(function () {
            var t,
                n = G.get(this),
                i = n[e + "queue"],
                r = n[e + "queueHooks"],
                o = C.timers,
                a = i ? i.length : 0;

            for (n.finish = !0, C.queue(this, e, []), r && r.stop && r.stop.call(this, !0), t = o.length; t--;) {
              o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
            }

            for (t = 0; t < a; t++) {
              i[t] && i[t].finish && i[t].finish.call(this);
            }

            delete n.finish;
          });
        }
      }), C.each(["toggle", "show", "hide"], function (e, t) {
        var n = C.fn[t];

        C.fn[t] = function (e, i, r) {
          return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ht(t, !0), e, i, r);
        };
      }), C.each({
        slideDown: ht("show"),
        slideUp: ht("hide"),
        slideToggle: ht("toggle"),
        fadeIn: {
          opacity: "show"
        },
        fadeOut: {
          opacity: "hide"
        },
        fadeToggle: {
          opacity: "toggle"
        }
      }, function (e, t) {
        C.fn[e] = function (e, n, i) {
          return this.animate(t, e, n, i);
        };
      }), C.timers = [], C.fx.tick = function () {
        var e,
            t = 0,
            n = C.timers;

        for (st = Date.now(); t < n.length; t++) {
          (e = n[t])() || n[t] !== e || n.splice(t--, 1);
        }

        n.length || C.fx.stop(), st = void 0;
      }, C.fx.timer = function (e) {
        C.timers.push(e), C.fx.start();
      }, C.fx.interval = 13, C.fx.start = function () {
        lt || (lt = !0, dt());
      }, C.fx.stop = function () {
        lt = null;
      }, C.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
      }, C.fn.delay = function (e, t) {
        return e = C.fx && C.fx.speeds[e] || e, t = t || "fx", this.queue(t, function (t, i) {
          var r = n.setTimeout(t, e);

          i.stop = function () {
            n.clearTimeout(r);
          };
        });
      }, function () {
        var e = a.createElement("input"),
            t = a.createElement("select").appendChild(a.createElement("option"));
        e.type = "checkbox", v.checkOn = "" !== e.value, v.optSelected = t.selected, (e = a.createElement("input")).value = "t", e.type = "radio", v.radioValue = "t" === e.value;
      }();
      var gt,
          vt = C.expr.attrHandle;
      C.fn.extend({
        attr: function attr(e, t) {
          return Y(this, C.attr, e, t, arguments.length > 1);
        },
        removeAttr: function removeAttr(e) {
          return this.each(function () {
            C.removeAttr(this, e);
          });
        }
      }), C.extend({
        attr: function attr(e, t, n) {
          var i,
              r,
              o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? C.prop(e, t, n) : (1 === o && C.isXMLDoc(e) || (r = C.attrHooks[t.toLowerCase()] || (C.expr.match.bool.test(t) ? gt : void 0)), void 0 !== n ? null === n ? void C.removeAttr(e, t) : r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : r && "get" in r && null !== (i = r.get(e, t)) ? i : null == (i = C.find.attr(e, t)) ? void 0 : i);
        },
        attrHooks: {
          type: {
            set: function set(e, t) {
              if (!v.radioValue && "radio" === t && P(e, "input")) {
                var n = e.value;
                return e.setAttribute("type", t), n && (e.value = n), t;
              }
            }
          }
        },
        removeAttr: function removeAttr(e, t) {
          var n,
              i = 0,
              r = t && t.match(R);
          if (r && 1 === e.nodeType) for (; n = r[i++];) {
            e.removeAttribute(n);
          }
        }
      }), gt = {
        set: function set(e, t, n) {
          return !1 === t ? C.removeAttr(e, n) : e.setAttribute(n, n), n;
        }
      }, C.each(C.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var n = vt[t] || C.find.attr;

        vt[t] = function (e, t, i) {
          var r,
              o,
              a = t.toLowerCase();
          return i || (o = vt[a], vt[a] = r, r = null != n(e, t, i) ? a : null, vt[a] = o), r;
        };
      });
      var bt = /^(?:input|select|textarea|button)$/i,
          yt = /^(?:a|area)$/i;

      function _t(e) {
        return (e.match(R) || []).join(" ");
      }

      function wt(e) {
        return e.getAttribute && e.getAttribute("class") || "";
      }

      function xt(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(R) || [];
      }

      C.fn.extend({
        prop: function prop(e, t) {
          return Y(this, C.prop, e, t, arguments.length > 1);
        },
        removeProp: function removeProp(e) {
          return this.each(function () {
            delete this[C.propFix[e] || e];
          });
        }
      }), C.extend({
        prop: function prop(e, t, n) {
          var i,
              r,
              o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o) return 1 === o && C.isXMLDoc(e) || (t = C.propFix[t] || t, r = C.propHooks[t]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get" in r && null !== (i = r.get(e, t)) ? i : e[t];
        },
        propHooks: {
          tabIndex: {
            get: function get(e) {
              var t = C.find.attr(e, "tabindex");
              return t ? parseInt(t, 10) : bt.test(e.nodeName) || yt.test(e.nodeName) && e.href ? 0 : -1;
            }
          }
        },
        propFix: {
          "for": "htmlFor",
          "class": "className"
        }
      }), v.optSelected || (C.propHooks.selected = {
        get: function get(e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function set(e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        }
      }), C.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        C.propFix[this.toLowerCase()] = this;
      }), C.fn.extend({
        addClass: function addClass(e) {
          var t,
              n,
              i,
              r,
              o,
              a,
              s,
              l = 0;
          if (b(e)) return this.each(function (t) {
            C(this).addClass(e.call(this, t, wt(this)));
          });
          if ((t = xt(e)).length) for (; n = this[l++];) {
            if (r = wt(n), i = 1 === n.nodeType && " " + _t(r) + " ") {
              for (a = 0; o = t[a++];) {
                i.indexOf(" " + o + " ") < 0 && (i += o + " ");
              }

              r !== (s = _t(i)) && n.setAttribute("class", s);
            }
          }
          return this;
        },
        removeClass: function removeClass(e) {
          var t,
              n,
              i,
              r,
              o,
              a,
              s,
              l = 0;
          if (b(e)) return this.each(function (t) {
            C(this).removeClass(e.call(this, t, wt(this)));
          });
          if (!arguments.length) return this.attr("class", "");
          if ((t = xt(e)).length) for (; n = this[l++];) {
            if (r = wt(n), i = 1 === n.nodeType && " " + _t(r) + " ") {
              for (a = 0; o = t[a++];) {
                for (; i.indexOf(" " + o + " ") > -1;) {
                  i = i.replace(" " + o + " ", " ");
                }
              }

              r !== (s = _t(i)) && n.setAttribute("class", s);
            }
          }
          return this;
        },
        toggleClass: function toggleClass(e, t) {
          var n = _typeof(e),
              i = "string" === n || Array.isArray(e);

          return "boolean" == typeof t && i ? t ? this.addClass(e) : this.removeClass(e) : b(e) ? this.each(function (n) {
            C(this).toggleClass(e.call(this, n, wt(this), t), t);
          }) : this.each(function () {
            var t, r, o, a;
            if (i) for (r = 0, o = C(this), a = xt(e); t = a[r++];) {
              o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
            } else void 0 !== e && "boolean" !== n || ((t = wt(this)) && G.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : G.get(this, "__className__") || ""));
          });
        },
        hasClass: function hasClass(e) {
          var t,
              n,
              i = 0;

          for (t = " " + e + " "; n = this[i++];) {
            if (1 === n.nodeType && (" " + _t(wt(n)) + " ").indexOf(t) > -1) return !0;
          }

          return !1;
        }
      });
      var Ct = /\r/g;
      C.fn.extend({
        val: function val(e) {
          var t,
              n,
              i,
              r = this[0];
          return arguments.length ? (i = b(e), this.each(function (n) {
            var r;
            1 === this.nodeType && (null == (r = i ? e.call(this, n, C(this).val()) : e) ? r = "" : "number" == typeof r ? r += "" : Array.isArray(r) && (r = C.map(r, function (e) {
              return null == e ? "" : e + "";
            })), (t = C.valHooks[this.type] || C.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, r, "value") || (this.value = r));
          })) : r ? (t = C.valHooks[r.type] || C.valHooks[r.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(r, "value")) ? n : "string" == typeof (n = r.value) ? n.replace(Ct, "") : null == n ? "" : n : void 0;
        }
      }), C.extend({
        valHooks: {
          option: {
            get: function get(e) {
              var t = C.find.attr(e, "value");
              return null != t ? t : _t(C.text(e));
            }
          },
          select: {
            get: function get(e) {
              var t,
                  n,
                  i,
                  r = e.options,
                  o = e.selectedIndex,
                  a = "select-one" === e.type,
                  s = a ? null : [],
                  l = a ? o + 1 : r.length;

              for (i = o < 0 ? l : a ? o : 0; i < l; i++) {
                if (((n = r[i]).selected || i === o) && !n.disabled && (!n.parentNode.disabled || !P(n.parentNode, "optgroup"))) {
                  if (t = C(n).val(), a) return t;
                  s.push(t);
                }
              }

              return s;
            },
            set: function set(e, t) {
              for (var n, i, r = e.options, o = C.makeArray(t), a = r.length; a--;) {
                ((i = r[a]).selected = C.inArray(C.valHooks.option.get(i), o) > -1) && (n = !0);
              }

              return n || (e.selectedIndex = -1), o;
            }
          }
        }
      }), C.each(["radio", "checkbox"], function () {
        C.valHooks[this] = {
          set: function set(e, t) {
            if (Array.isArray(t)) return e.checked = C.inArray(C(e).val(), t) > -1;
          }
        }, v.checkOn || (C.valHooks[this].get = function (e) {
          return null === e.getAttribute("value") ? "on" : e.value;
        });
      }), v.focusin = "onfocusin" in n;

      var St = /^(?:focusinfocus|focusoutblur)$/,
          Dt = function Dt(e) {
        e.stopPropagation();
      };

      C.extend(C.event, {
        trigger: function trigger(e, t, i, r) {
          var o,
              s,
              l,
              c,
              u,
              d,
              p,
              h,
              m = [i || a],
              g = f.call(e, "type") ? e.type : e,
              v = f.call(e, "namespace") ? e.namespace.split(".") : [];

          if (s = h = l = i = i || a, 3 !== i.nodeType && 8 !== i.nodeType && !St.test(g + C.event.triggered) && (g.indexOf(".") > -1 && (v = g.split("."), g = v.shift(), v.sort()), u = g.indexOf(":") < 0 && "on" + g, (e = e[C.expando] ? e : new C.Event(g, "object" == _typeof(e) && e)).isTrigger = r ? 2 : 3, e.namespace = v.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = i), t = null == t ? [e] : C.makeArray(t, [e]), p = C.event.special[g] || {}, r || !p.trigger || !1 !== p.trigger.apply(i, t))) {
            if (!r && !p.noBubble && !y(i)) {
              for (c = p.delegateType || g, St.test(c + g) || (s = s.parentNode); s; s = s.parentNode) {
                m.push(s), l = s;
              }

              l === (i.ownerDocument || a) && m.push(l.defaultView || l.parentWindow || n);
            }

            for (o = 0; (s = m[o++]) && !e.isPropagationStopped();) {
              h = s, e.type = o > 1 ? c : p.bindType || g, (d = (G.get(s, "events") || {})[e.type] && G.get(s, "handle")) && d.apply(s, t), (d = u && s[u]) && d.apply && Q(s) && (e.result = d.apply(s, t), !1 === e.result && e.preventDefault());
            }

            return e.type = g, r || e.isDefaultPrevented() || p._default && !1 !== p._default.apply(m.pop(), t) || !Q(i) || u && b(i[g]) && !y(i) && ((l = i[u]) && (i[u] = null), C.event.triggered = g, e.isPropagationStopped() && h.addEventListener(g, Dt), i[g](), e.isPropagationStopped() && h.removeEventListener(g, Dt), C.event.triggered = void 0, l && (i[u] = l)), e.result;
          }
        },
        simulate: function simulate(e, t, n) {
          var i = C.extend(new C.Event(), n, {
            type: e,
            isSimulated: !0
          });
          C.event.trigger(i, null, t);
        }
      }), C.fn.extend({
        trigger: function trigger(e, t) {
          return this.each(function () {
            C.event.trigger(e, t, this);
          });
        },
        triggerHandler: function triggerHandler(e, t) {
          var n = this[0];
          if (n) return C.event.trigger(e, t, n, !0);
        }
      }), v.focusin || C.each({
        focus: "focusin",
        blur: "focusout"
      }, function (e, t) {
        var n = function n(e) {
          C.event.simulate(t, e.target, C.event.fix(e));
        };

        C.event.special[t] = {
          setup: function setup() {
            var i = this.ownerDocument || this,
                r = G.access(i, t);
            r || i.addEventListener(e, n, !0), G.access(i, t, (r || 0) + 1);
          },
          teardown: function teardown() {
            var i = this.ownerDocument || this,
                r = G.access(i, t) - 1;
            r ? G.access(i, t, r) : (i.removeEventListener(e, n, !0), G.remove(i, t));
          }
        };
      });
      var Et = n.location,
          kt = Date.now(),
          Tt = /\?/;

      C.parseXML = function (e) {
        var t;
        if (!e || "string" != typeof e) return null;

        try {
          t = new n.DOMParser().parseFromString(e, "text/xml");
        } catch (e) {
          t = void 0;
        }

        return t && !t.getElementsByTagName("parsererror").length || C.error("Invalid XML: " + e), t;
      };

      var Ot = /\[\]$/,
          Pt = /\r?\n/g,
          At = /^(?:submit|button|image|reset|file)$/i,
          Mt = /^(?:input|select|textarea|keygen)/i;

      function Nt(e, t, n, i) {
        var r;
        if (Array.isArray(t)) C.each(t, function (t, r) {
          n || Ot.test(e) ? i(e, r) : Nt(e + "[" + ("object" == _typeof(r) && null != r ? t : "") + "]", r, n, i);
        });else if (n || "object" !== x(t)) i(e, t);else for (r in t) {
          Nt(e + "[" + r + "]", t[r], n, i);
        }
      }

      C.param = function (e, t) {
        var n,
            i = [],
            r = function r(e, t) {
          var n = b(t) ? t() : t;
          i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
        };

        if (null == e) return "";
        if (Array.isArray(e) || e.jquery && !C.isPlainObject(e)) C.each(e, function () {
          r(this.name, this.value);
        });else for (n in e) {
          Nt(n, e[n], t, r);
        }
        return i.join("&");
      }, C.fn.extend({
        serialize: function serialize() {
          return C.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
          return this.map(function () {
            var e = C.prop(this, "elements");
            return e ? C.makeArray(e) : this;
          }).filter(function () {
            var e = this.type;
            return this.name && !C(this).is(":disabled") && Mt.test(this.nodeName) && !At.test(e) && (this.checked || !me.test(e));
          }).map(function (e, t) {
            var n = C(this).val();
            return null == n ? null : Array.isArray(n) ? C.map(n, function (e) {
              return {
                name: t.name,
                value: e.replace(Pt, "\r\n")
              };
            }) : {
              name: t.name,
              value: n.replace(Pt, "\r\n")
            };
          }).get();
        }
      });
      var It = /%20/g,
          Ft = /#.*$/,
          jt = /([?&])_=[^&]*/,
          Lt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
          Rt = /^(?:GET|HEAD)$/,
          Ht = /^\/\//,
          Bt = {},
          qt = {},
          $t = "*/".concat("*"),
          Wt = a.createElement("a");

      function Ut(e) {
        return function (t, n) {
          "string" != typeof t && (n = t, t = "*");
          var i,
              r = 0,
              o = t.toLowerCase().match(R) || [];
          if (b(n)) for (; i = o[r++];) {
            "+" === i[0] ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
          }
        };
      }

      function Yt(e, t, n, i) {
        var r = {},
            o = e === qt;

        function a(s) {
          var l;
          return r[s] = !0, C.each(e[s] || [], function (e, s) {
            var c = s(t, n, i);
            return "string" != typeof c || o || r[c] ? o ? !(l = c) : void 0 : (t.dataTypes.unshift(c), a(c), !1);
          }), l;
        }

        return a(t.dataTypes[0]) || !r["*"] && a("*");
      }

      function Xt(e, t) {
        var n,
            i,
            r = C.ajaxSettings.flatOptions || {};

        for (n in t) {
          void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
        }

        return i && C.extend(!0, e, i), e;
      }

      Wt.href = Et.href, C.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: Et.href,
          type: "GET",
          isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": $t,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript"
          },
          contents: {
            xml: /\bxml\b/,
            html: /\bhtml/,
            json: /\bjson\b/
          },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON"
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": JSON.parse,
            "text xml": C.parseXML
          },
          flatOptions: {
            url: !0,
            context: !0
          }
        },
        ajaxSetup: function ajaxSetup(e, t) {
          return t ? Xt(Xt(e, C.ajaxSettings), t) : Xt(C.ajaxSettings, e);
        },
        ajaxPrefilter: Ut(Bt),
        ajaxTransport: Ut(qt),
        ajax: function ajax(e, t) {
          "object" == _typeof(e) && (t = e, e = void 0), t = t || {};
          var i,
              r,
              o,
              s,
              l,
              c,
              u,
              d,
              p,
              h,
              f = C.ajaxSetup({}, t),
              m = f.context || f,
              g = f.context && (m.nodeType || m.jquery) ? C(m) : C.event,
              v = C.Deferred(),
              b = C.Callbacks("once memory"),
              y = f.statusCode || {},
              _ = {},
              w = {},
              x = "canceled",
              S = {
            readyState: 0,
            getResponseHeader: function getResponseHeader(e) {
              var t;

              if (u) {
                if (!s) for (s = {}; t = Lt.exec(o);) {
                  s[t[1].toLowerCase() + " "] = (s[t[1].toLowerCase() + " "] || []).concat(t[2]);
                }
                t = s[e.toLowerCase() + " "];
              }

              return null == t ? null : t.join(", ");
            },
            getAllResponseHeaders: function getAllResponseHeaders() {
              return u ? o : null;
            },
            setRequestHeader: function setRequestHeader(e, t) {
              return null == u && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e, _[e] = t), this;
            },
            overrideMimeType: function overrideMimeType(e) {
              return null == u && (f.mimeType = e), this;
            },
            statusCode: function statusCode(e) {
              var t;
              if (e) if (u) S.always(e[S.status]);else for (t in e) {
                y[t] = [y[t], e[t]];
              }
              return this;
            },
            abort: function abort(e) {
              var t = e || x;
              return i && i.abort(t), D(0, t), this;
            }
          };

          if (v.promise(S), f.url = ((e || f.url || Et.href) + "").replace(Ht, Et.protocol + "//"), f.type = t.method || t.type || f.method || f.type, f.dataTypes = (f.dataType || "*").toLowerCase().match(R) || [""], null == f.crossDomain) {
            c = a.createElement("a");

            try {
              c.href = f.url, c.href = c.href, f.crossDomain = Wt.protocol + "//" + Wt.host != c.protocol + "//" + c.host;
            } catch (e) {
              f.crossDomain = !0;
            }
          }

          if (f.data && f.processData && "string" != typeof f.data && (f.data = C.param(f.data, f.traditional)), Yt(Bt, f, t, S), u) return S;

          for (p in (d = C.event && f.global) && 0 == C.active++ && C.event.trigger("ajaxStart"), f.type = f.type.toUpperCase(), f.hasContent = !Rt.test(f.type), r = f.url.replace(Ft, ""), f.hasContent ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(It, "+")) : (h = f.url.slice(r.length), f.data && (f.processData || "string" == typeof f.data) && (r += (Tt.test(r) ? "&" : "?") + f.data, delete f.data), !1 === f.cache && (r = r.replace(jt, "$1"), h = (Tt.test(r) ? "&" : "?") + "_=" + kt++ + h), f.url = r + h), f.ifModified && (C.lastModified[r] && S.setRequestHeader("If-Modified-Since", C.lastModified[r]), C.etag[r] && S.setRequestHeader("If-None-Match", C.etag[r])), (f.data && f.hasContent && !1 !== f.contentType || t.contentType) && S.setRequestHeader("Content-Type", f.contentType), S.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + $t + "; q=0.01" : "") : f.accepts["*"]), f.headers) {
            S.setRequestHeader(p, f.headers[p]);
          }

          if (f.beforeSend && (!1 === f.beforeSend.call(m, S, f) || u)) return S.abort();

          if (x = "abort", b.add(f.complete), S.done(f.success), S.fail(f.error), i = Yt(qt, f, t, S)) {
            if (S.readyState = 1, d && g.trigger("ajaxSend", [S, f]), u) return S;
            f.async && f.timeout > 0 && (l = n.setTimeout(function () {
              S.abort("timeout");
            }, f.timeout));

            try {
              u = !1, i.send(_, D);
            } catch (e) {
              if (u) throw e;
              D(-1, e);
            }
          } else D(-1, "No Transport");

          function D(e, t, a, s) {
            var c,
                p,
                h,
                _,
                w,
                x = t;

            u || (u = !0, l && n.clearTimeout(l), i = void 0, o = s || "", S.readyState = e > 0 ? 4 : 0, c = e >= 200 && e < 300 || 304 === e, a && (_ = function (e, t, n) {
              for (var i, r, o, a, s = e.contents, l = e.dataTypes; "*" === l[0];) {
                l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
              }

              if (i) for (r in s) {
                if (s[r] && s[r].test(i)) {
                  l.unshift(r);
                  break;
                }
              }
              if (l[0] in n) o = l[0];else {
                for (r in n) {
                  if (!l[0] || e.converters[r + " " + l[0]]) {
                    o = r;
                    break;
                  }

                  a || (a = r);
                }

                o = o || a;
              }
              if (o) return o !== l[0] && l.unshift(o), n[o];
            }(f, S, a)), _ = function (e, t, n, i) {
              var r,
                  o,
                  a,
                  s,
                  l,
                  c = {},
                  u = e.dataTypes.slice();
              if (u[1]) for (a in e.converters) {
                c[a.toLowerCase()] = e.converters[a];
              }

              for (o = u.shift(); o;) {
                if (e.responseFields[o] && (n[e.responseFields[o]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = o, o = u.shift()) if ("*" === o) o = l;else if ("*" !== l && l !== o) {
                  if (!(a = c[l + " " + o] || c["* " + o])) for (r in c) {
                    if ((s = r.split(" "))[1] === o && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
                      !0 === a ? a = c[r] : !0 !== c[r] && (o = s[0], u.unshift(s[1]));
                      break;
                    }
                  }
                  if (!0 !== a) if (a && e["throws"]) t = a(t);else try {
                    t = a(t);
                  } catch (e) {
                    return {
                      state: "parsererror",
                      error: a ? e : "No conversion from " + l + " to " + o
                    };
                  }
                }
              }

              return {
                state: "success",
                data: t
              };
            }(f, _, S, c), c ? (f.ifModified && ((w = S.getResponseHeader("Last-Modified")) && (C.lastModified[r] = w), (w = S.getResponseHeader("etag")) && (C.etag[r] = w)), 204 === e || "HEAD" === f.type ? x = "nocontent" : 304 === e ? x = "notmodified" : (x = _.state, p = _.data, c = !(h = _.error))) : (h = x, !e && x || (x = "error", e < 0 && (e = 0))), S.status = e, S.statusText = (t || x) + "", c ? v.resolveWith(m, [p, x, S]) : v.rejectWith(m, [S, x, h]), S.statusCode(y), y = void 0, d && g.trigger(c ? "ajaxSuccess" : "ajaxError", [S, f, c ? p : h]), b.fireWith(m, [S, x]), d && (g.trigger("ajaxComplete", [S, f]), --C.active || C.event.trigger("ajaxStop")));
          }

          return S;
        },
        getJSON: function getJSON(e, t, n) {
          return C.get(e, t, n, "json");
        },
        getScript: function getScript(e, t) {
          return C.get(e, void 0, t, "script");
        }
      }), C.each(["get", "post"], function (e, t) {
        C[t] = function (e, n, i, r) {
          return b(n) && (r = r || i, i = n, n = void 0), C.ajax(C.extend({
            url: e,
            type: t,
            dataType: r,
            data: n,
            success: i
          }, C.isPlainObject(e) && e));
        };
      }), C._evalUrl = function (e, t) {
        return C.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          converters: {
            "text script": function textScript() {}
          },
          dataFilter: function dataFilter(e) {
            C.globalEval(e, t);
          }
        });
      }, C.fn.extend({
        wrapAll: function wrapAll(e) {
          var t;
          return this[0] && (b(e) && (e = e.call(this[0])), t = C(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
            for (var e = this; e.firstElementChild;) {
              e = e.firstElementChild;
            }

            return e;
          }).append(this)), this;
        },
        wrapInner: function wrapInner(e) {
          return b(e) ? this.each(function (t) {
            C(this).wrapInner(e.call(this, t));
          }) : this.each(function () {
            var t = C(this),
                n = t.contents();
            n.length ? n.wrapAll(e) : t.append(e);
          });
        },
        wrap: function wrap(e) {
          var t = b(e);
          return this.each(function (n) {
            C(this).wrapAll(t ? e.call(this, n) : e);
          });
        },
        unwrap: function unwrap(e) {
          return this.parent(e).not("body").each(function () {
            C(this).replaceWith(this.childNodes);
          }), this;
        }
      }), C.expr.pseudos.hidden = function (e) {
        return !C.expr.pseudos.visible(e);
      }, C.expr.pseudos.visible = function (e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
      }, C.ajaxSettings.xhr = function () {
        try {
          return new n.XMLHttpRequest();
        } catch (e) {}
      };
      var zt = {
        0: 200,
        1223: 204
      },
          Vt = C.ajaxSettings.xhr();
      v.cors = !!Vt && "withCredentials" in Vt, v.ajax = Vt = !!Vt, C.ajaxTransport(function (e) {
        var _t3, i;

        if (v.cors || Vt && !e.crossDomain) return {
          send: function send(r, o) {
            var a,
                s = e.xhr();
            if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (a in e.xhrFields) {
              s[a] = e.xhrFields[a];
            }

            for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"), r) {
              s.setRequestHeader(a, r[a]);
            }

            _t3 = function t(e) {
              return function () {
                _t3 && (_t3 = i = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(zt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                  binary: s.response
                } : {
                  text: s.responseText
                }, s.getAllResponseHeaders()));
              };
            }, s.onload = _t3(), i = s.onerror = s.ontimeout = _t3("error"), void 0 !== s.onabort ? s.onabort = i : s.onreadystatechange = function () {
              4 === s.readyState && n.setTimeout(function () {
                _t3 && i();
              });
            }, _t3 = _t3("abort");

            try {
              s.send(e.hasContent && e.data || null);
            } catch (e) {
              if (_t3) throw e;
            }
          },
          abort: function abort() {
            _t3 && _t3();
          }
        };
      }), C.ajaxPrefilter(function (e) {
        e.crossDomain && (e.contents.script = !1);
      }), C.ajaxSetup({
        accepts: {
          script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
          script: /\b(?:java|ecma)script\b/
        },
        converters: {
          "text script": function textScript(e) {
            return C.globalEval(e), e;
          }
        }
      }), C.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }), C.ajaxTransport("script", function (e) {
        var t, _n;

        if (e.crossDomain || e.scriptAttrs) return {
          send: function send(i, r) {
            t = C("<script>").attr(e.scriptAttrs || {}).prop({
              charset: e.scriptCharset,
              src: e.url
            }).on("load error", _n = function n(e) {
              t.remove(), _n = null, e && r("error" === e.type ? 404 : 200, e.type);
            }), a.head.appendChild(t[0]);
          },
          abort: function abort() {
            _n && _n();
          }
        };
      });
      var Kt,
          Qt = [],
          Zt = /(=)\?(?=&|$)|\?\?/;
      C.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
          var e = Qt.pop() || C.expando + "_" + kt++;
          return this[e] = !0, e;
        }
      }), C.ajaxPrefilter("json jsonp", function (e, t, i) {
        var r,
            o,
            a,
            s = !1 !== e.jsonp && (Zt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Zt.test(e.data) && "data");
        if (s || "jsonp" === e.dataTypes[0]) return r = e.jsonpCallback = b(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(Zt, "$1" + r) : !1 !== e.jsonp && (e.url += (Tt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function () {
          return a || C.error(r + " was not called"), a[0];
        }, e.dataTypes[0] = "json", o = n[r], n[r] = function () {
          a = arguments;
        }, i.always(function () {
          void 0 === o ? C(n).removeProp(r) : n[r] = o, e[r] && (e.jsonpCallback = t.jsonpCallback, Qt.push(r)), a && b(o) && o(a[0]), a = o = void 0;
        }), "script";
      }), v.createHTMLDocument = ((Kt = a.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Kt.childNodes.length), C.parseHTML = function (e, t, n) {
        return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (v.createHTMLDocument ? ((i = (t = a.implementation.createHTMLDocument("")).createElement("base")).href = a.location.href, t.head.appendChild(i)) : t = a), o = !n && [], (r = A.exec(e)) ? [t.createElement(r[1])] : (r = Se([e], t, o), o && o.length && C(o).remove(), C.merge([], r.childNodes)));
        var i, r, o;
      }, C.fn.load = function (e, t, n) {
        var i,
            r,
            o,
            a = this,
            s = e.indexOf(" ");
        return s > -1 && (i = _t(e.slice(s)), e = e.slice(0, s)), b(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (r = "POST"), a.length > 0 && C.ajax({
          url: e,
          type: r || "GET",
          dataType: "html",
          data: t
        }).done(function (e) {
          o = arguments, a.html(i ? C("<div>").append(C.parseHTML(e)).find(i) : e);
        }).always(n && function (e, t) {
          a.each(function () {
            n.apply(this, o || [e.responseText, t, e]);
          });
        }), this;
      }, C.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
        C.fn[t] = function (e) {
          return this.on(t, e);
        };
      }), C.expr.pseudos.animated = function (e) {
        return C.grep(C.timers, function (t) {
          return e === t.elem;
        }).length;
      }, C.offset = {
        setOffset: function setOffset(e, t, n) {
          var i,
              r,
              o,
              a,
              s,
              l,
              c = C.css(e, "position"),
              u = C(e),
              d = {};
          "static" === c && (e.style.position = "relative"), s = u.offset(), o = C.css(e, "top"), l = C.css(e, "left"), ("absolute" === c || "fixed" === c) && (o + l).indexOf("auto") > -1 ? (a = (i = u.position()).top, r = i.left) : (a = parseFloat(o) || 0, r = parseFloat(l) || 0), b(t) && (t = t.call(e, n, C.extend({}, s))), null != t.top && (d.top = t.top - s.top + a), null != t.left && (d.left = t.left - s.left + r), "using" in t ? t.using.call(e, d) : u.css(d);
        }
      }, C.fn.extend({
        offset: function offset(e) {
          if (arguments.length) return void 0 === e ? this : this.each(function (t) {
            C.offset.setOffset(this, e, t);
          });
          var t,
              n,
              i = this[0];
          return i ? i.getClientRects().length ? (t = i.getBoundingClientRect(), n = i.ownerDocument.defaultView, {
            top: t.top + n.pageYOffset,
            left: t.left + n.pageXOffset
          }) : {
            top: 0,
            left: 0
          } : void 0;
        },
        position: function position() {
          if (this[0]) {
            var e,
                t,
                n,
                i = this[0],
                r = {
              top: 0,
              left: 0
            };
            if ("fixed" === C.css(i, "position")) t = i.getBoundingClientRect();else {
              for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === C.css(e, "position");) {
                e = e.parentNode;
              }

              e && e !== i && 1 === e.nodeType && ((r = C(e).offset()).top += C.css(e, "borderTopWidth", !0), r.left += C.css(e, "borderLeftWidth", !0));
            }
            return {
              top: t.top - r.top - C.css(i, "marginTop", !0),
              left: t.left - r.left - C.css(i, "marginLeft", !0)
            };
          }
        },
        offsetParent: function offsetParent() {
          return this.map(function () {
            for (var e = this.offsetParent; e && "static" === C.css(e, "position");) {
              e = e.offsetParent;
            }

            return e || ae;
          });
        }
      }), C.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
      }, function (e, t) {
        var n = "pageYOffset" === t;

        C.fn[e] = function (i) {
          return Y(this, function (e, i, r) {
            var o;
            if (y(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === r) return o ? o[t] : e[i];
            o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : e[i] = r;
          }, e, i, arguments.length);
        };
      }), C.each(["top", "left"], function (e, t) {
        C.cssHooks[t] = Ve(v.pixelPosition, function (e, n) {
          if (n) return n = ze(e, t), Ue.test(n) ? C(e).position()[t] + "px" : n;
        });
      }), C.each({
        Height: "height",
        Width: "width"
      }, function (e, t) {
        C.each({
          padding: "inner" + e,
          content: t,
          "": "outer" + e
        }, function (n, i) {
          C.fn[i] = function (r, o) {
            var a = arguments.length && (n || "boolean" != typeof r),
                s = n || (!0 === r || !0 === o ? "margin" : "border");
            return Y(this, function (t, n, r) {
              var o;
              return y(t) ? 0 === i.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === r ? C.css(t, n, s) : C.style(t, n, r, s);
            }, t, a ? r : void 0, a);
          };
        });
      }), C.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
        C.fn[t] = function (e, n) {
          return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
        };
      }), C.fn.extend({
        hover: function hover(e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        }
      }), C.fn.extend({
        bind: function bind(e, t, n) {
          return this.on(e, null, t, n);
        },
        unbind: function unbind(e, t) {
          return this.off(e, null, t);
        },
        delegate: function delegate(e, t, n, i) {
          return this.on(t, e, n, i);
        },
        undelegate: function undelegate(e, t, n) {
          return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
        }
      }), C.proxy = function (e, t) {
        var n, i, r;
        if ("string" == typeof t && (n = e[t], t = e, e = n), b(e)) return i = l.call(arguments, 2), (r = function r() {
          return e.apply(t || this, i.concat(l.call(arguments)));
        }).guid = e.guid = e.guid || C.guid++, r;
      }, C.holdReady = function (e) {
        e ? C.readyWait++ : C.ready(!0);
      }, C.isArray = Array.isArray, C.parseJSON = JSON.parse, C.nodeName = P, C.isFunction = b, C.isWindow = y, C.camelCase = K, C.type = x, C.now = Date.now, C.isNumeric = function (e) {
        var t = C.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
      }, void 0 === (i = function () {
        return C;
      }.apply(t, [])) || (e.exports = i);
      var Gt = n.jQuery,
          Jt = n.$;
      return C.noConflict = function (e) {
        return n.$ === C && (n.$ = Jt), e && n.jQuery === C && (n.jQuery = Gt), C;
      }, r || (n.jQuery = n.$ = C), C;
    });
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    (function (e, t) {
      n(14);
      !function (e, t, n) {
        var i, r;
        "ui_timeago", r = {
          debug: !1
        }, i =
        /*#__PURE__*/
        function () {
          function i(t, n) {
            _classCallCheck(this, i);

            this.element = t, this.settings = e.extend({}, r, n), this._defaults = r, this._name = "ui_timeago", this.$element = e(this.element), this.init();
          }

          _createClass(i, [{
            key: "init",
            value: function init() {
              return this.$element.timeago();
            }
          }]);

          return i;
        }(), e.fn.ui_timeago = function (t) {
          return this.each(function () {
            if (!e.data(this, "plugin_ui_timeago")) return e.data(this, "plugin_ui_timeago", new i(this, t));
          });
        };
      }(e, window, document), t(function () {
        return ".apparatus.ui.timeago", t(".apparatus.ui.timeago").ui_timeago(), new MutationObserver(function (e) {
          return e.forEach(function (e) {
            return t(".apparatus.ui.timeago").ui_timeago();
          });
        }).observe(document.documentElement, {
          childList: !0,
          subtree: !0
        });
      });
    }).call(this, n(0), n(0));
  }, function (e, t, n) {
    var i, r, o;
    /**
     * Timeago is a jQuery plugin that makes it easy to support automatically
     * updating fuzzy timestamps (e.g. "4 minutes ago" or "about 1 day ago").
     *
     * @name timeago
     * @version 1.6.7
     * @requires jQuery >=1.5.0 <4.0
     * @author Ryan McGeary
     * @license MIT License - http://www.opensource.org/licenses/mit-license.php
     *
     * For usage and examples, visit:
     * http://timeago.yarp.com/
     *
     * Copyright (c) 2008-2019, Ryan McGeary (ryan -[at]- mcgeary [*dot*] org)
     */

    r = [n(0)], void 0 === (o = "function" == typeof (i = function i(e) {
      e.timeago = function (t) {
        return t instanceof Date ? r(t) : r("string" == typeof t ? e.timeago.parse(t) : "number" == typeof t ? new Date(t) : e.timeago.datetime(t));
      };

      var t = e.timeago;
      e.extend(e.timeago, {
        settings: {
          refreshMillis: 6e4,
          allowPast: !0,
          allowFuture: !1,
          localeTitle: !1,
          cutoff: 0,
          autoDispose: !0,
          strings: {
            prefixAgo: null,
            prefixFromNow: null,
            suffixAgo: "ago",
            suffixFromNow: "from now",
            inPast: "any moment now",
            seconds: "less than a minute",
            minute: "about a minute",
            minutes: "%d minutes",
            hour: "about an hour",
            hours: "about %d hours",
            day: "a day",
            days: "%d days",
            month: "about a month",
            months: "%d months",
            year: "about a year",
            years: "%d years",
            wordSeparator: " ",
            numbers: []
          }
        },
        inWords: function inWords(t) {
          if (!this.settings.allowPast && !this.settings.allowFuture) throw "timeago allowPast and allowFuture settings can not both be set to false.";
          var n = this.settings.strings,
              i = n.prefixAgo,
              r = n.suffixAgo;
          if (this.settings.allowFuture && t < 0 && (i = n.prefixFromNow, r = n.suffixFromNow), !this.settings.allowPast && t >= 0) return this.settings.strings.inPast;
          var o = Math.abs(t) / 1e3,
              a = o / 60,
              s = a / 60,
              l = s / 24,
              c = l / 365;

          function u(i, r) {
            var o = e.isFunction(i) ? i(r, t) : i,
                a = n.numbers && n.numbers[r] || r;
            return o.replace(/%d/i, a);
          }

          var d = o < 45 && u(n.seconds, Math.round(o)) || o < 90 && u(n.minute, 1) || a < 45 && u(n.minutes, Math.round(a)) || a < 90 && u(n.hour, 1) || s < 24 && u(n.hours, Math.round(s)) || s < 42 && u(n.day, 1) || l < 30 && u(n.days, Math.round(l)) || l < 45 && u(n.month, 1) || l < 365 && u(n.months, Math.round(l / 30)) || c < 1.5 && u(n.year, 1) || u(n.years, Math.round(c)),
              p = n.wordSeparator || "";
          return void 0 === n.wordSeparator && (p = " "), e.trim([i, d, r].join(p));
        },
        parse: function parse(t) {
          var n = e.trim(t);
          return n = (n = (n = (n = (n = n.replace(/\.\d+/, "")).replace(/-/, "/").replace(/-/, "/")).replace(/T/, " ").replace(/Z/, " UTC")).replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2")).replace(/([\+\-]\d\d)$/, " $100"), new Date(n);
        },
        datetime: function datetime(n) {
          var i = t.isTime(n) ? e(n).attr("datetime") : e(n).attr("title");
          return t.parse(i);
        },
        isTime: function isTime(t) {
          return "time" === e(t).get(0).tagName.toLowerCase();
        }
      });
      var n = {
        init: function init() {
          n.dispose.call(this);
          var r = e.proxy(i, this);
          r();
          var o = t.settings;
          o.refreshMillis > 0 && (this._timeagoInterval = setInterval(r, o.refreshMillis));
        },
        update: function update(n) {
          var r = n instanceof Date ? n : t.parse(n);
          e(this).data("timeago", {
            datetime: r
          }), t.settings.localeTitle && e(this).attr("title", r.toLocaleString()), i.apply(this);
        },
        updateFromDOM: function updateFromDOM() {
          e(this).data("timeago", {
            datetime: t.parse(t.isTime(this) ? e(this).attr("datetime") : e(this).attr("title"))
          }), i.apply(this);
        },
        dispose: function dispose() {
          this._timeagoInterval && (window.clearInterval(this._timeagoInterval), this._timeagoInterval = null);
        }
      };

      function i() {
        var n = t.settings;
        if (n.autoDispose && !e.contains(document.documentElement, this)) return e(this).timeago("dispose"), this;

        var i = function (n) {
          if (!(n = e(n)).data("timeago")) {
            n.data("timeago", {
              datetime: t.datetime(n)
            });
            var i = e.trim(n.text());
            t.settings.localeTitle ? n.attr("title", n.data("timeago").datetime.toLocaleString()) : !(i.length > 0) || t.isTime(n) && n.attr("title") || n.attr("title", i);
          }

          return n.data("timeago");
        }(this);

        return isNaN(i.datetime) || (0 === n.cutoff || Math.abs(o(i.datetime)) < n.cutoff ? e(this).text(r(i.datetime)) : e(this).attr("title").length > 0 && e(this).text(e(this).attr("title"))), this;
      }

      function r(e) {
        return t.inWords(o(e));
      }

      function o(e) {
        return new Date().getTime() - e.getTime();
      }

      e.fn.timeago = function (e, t) {
        var i = e ? n[e] : n.init;
        if (!i) throw new Error("Unknown function name '" + e + "' for timeago");
        return this.each(function () {
          i.call(this, t);
        }), this;
      }, document.createElement("abbr"), document.createElement("time");
    }) ? i.apply(t, r) : i) || (e.exports = o);
  }, function (e, t, n) {}, function (e, t, n) {
    (function (e) {
      n(17);
      e(function () {
        e(".simple_form_attachments").SimpleFormAttachments(), new MutationObserver(function (t) {
          t.forEach(function (t) {
            return e(".simple_form_attachments").SimpleFormAttachments();
          });
        }).observe(document.documentElement, {
          childList: !0,
          subtree: !0
        });
      });
    }).call(this, n(0));
  }, function (e, t, n) {
    "use strict";

    n.r(t), function (e) {
      var t,
          i = n(5),
          r = n.n(i);
      t = e, window, t.fn.SimpleFormAttachments = function (e) {
        this.each(function () {
          if (!t.data(this, "plugin_SimpleFormAttachments")) {
            var _e4 = new r.a(this);

            t.data(this, "plugin_SimpleFormAttachments", _e4);
          }
        });
      };
    }.call(this, n(0));
  }, function (e, t, n) {
    /**!
    
     @license
     handlebars v4.1.2
    
    Copyright (C) 2011-2017 by Yehuda Katz
    
    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:
    
    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.
    
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.
    
    */
    e.exports = function (e) {
      function t(i) {
        if (n[i]) return n[i].exports;
        var r = n[i] = {
          exports: {},
          id: i,
          loaded: !1
        };
        return e[i].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
      }

      var n = {};
      return t.m = e, t.c = n, t.p = "", t(0);
    }([function (e, t, n) {
      "use strict";

      function i() {
        var e = v();
        return e.compile = function (t, n) {
          return u.compile(t, n, e);
        }, e.precompile = function (t, n) {
          return u.precompile(t, n, e);
        }, e.AST = l["default"], e.Compiler = u.Compiler, e.JavaScriptCompiler = p["default"], e.Parser = c.parser, e.parse = c.parse, e;
      }

      var r = n(1)["default"];
      t.__esModule = !0;
      var o = n(2),
          a = r(o),
          s = n(35),
          l = r(s),
          c = n(36),
          u = n(41),
          d = n(42),
          p = r(d),
          h = n(39),
          f = r(h),
          m = n(34),
          g = r(m),
          v = a["default"].create,
          b = i();
      b.create = i, g["default"](b), b.Visitor = f["default"], b["default"] = b, t["default"] = b, e.exports = t["default"];
    }, function (e, t) {
      "use strict";

      t["default"] = function (e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }, t.__esModule = !0;
    }, function (e, t, n) {
      "use strict";

      function i() {
        var e = new s.HandlebarsEnvironment();
        return h.extend(e, s), e.SafeString = c["default"], e.Exception = d["default"], e.Utils = h, e.escapeExpression = h.escapeExpression, e.VM = m, e.template = function (t) {
          return m.template(t, e);
        }, e;
      }

      var r = n(3)["default"],
          o = n(1)["default"];
      t.__esModule = !0;
      var a = n(4),
          s = r(a),
          l = n(21),
          c = o(l),
          u = n(6),
          d = o(u),
          p = n(5),
          h = r(p),
          f = n(22),
          m = r(f),
          g = n(34),
          v = o(g),
          b = i();
      b.create = i, v["default"](b), b["default"] = b, t["default"] = b, e.exports = t["default"];
    }, function (e, t) {
      "use strict";

      t["default"] = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t["default"] = e, t;
      }, t.__esModule = !0;
    }, function (e, t, n) {
      "use strict";

      function i(e, t, n) {
        this.helpers = e || {}, this.partials = t || {}, this.decorators = n || {}, l.registerDefaultHelpers(this), c.registerDefaultDecorators(this);
      }

      var r = n(1)["default"];
      t.__esModule = !0, t.HandlebarsEnvironment = i;
      var o = n(5),
          a = n(6),
          s = r(a),
          l = n(10),
          c = n(18),
          u = n(20),
          d = r(u);
      t.VERSION = "4.1.2", t.COMPILER_REVISION = 7, t.REVISION_CHANGES = {
        1: "<= 1.0.rc.2",
        2: "== 1.0.0-rc.3",
        3: "== 1.0.0-rc.4",
        4: "== 1.x.x",
        5: "== 2.0.0-alpha.x",
        6: ">= 2.0.0-beta.1",
        7: ">= 4.0.0"
      };
      var p = "[object Object]";
      i.prototype = {
        constructor: i,
        logger: d["default"],
        log: d["default"].log,
        registerHelper: function registerHelper(e, t) {
          if (o.toString.call(e) === p) {
            if (t) throw new s["default"]("Arg not supported with multiple helpers");
            o.extend(this.helpers, e);
          } else this.helpers[e] = t;
        },
        unregisterHelper: function unregisterHelper(e) {
          delete this.helpers[e];
        },
        registerPartial: function registerPartial(e, t) {
          if (o.toString.call(e) === p) o.extend(this.partials, e);else {
            if (void 0 === t) throw new s["default"]('Attempting to register a partial called "' + e + '" as undefined');
            this.partials[e] = t;
          }
        },
        unregisterPartial: function unregisterPartial(e) {
          delete this.partials[e];
        },
        registerDecorator: function registerDecorator(e, t) {
          if (o.toString.call(e) === p) {
            if (t) throw new s["default"]("Arg not supported with multiple decorators");
            o.extend(this.decorators, e);
          } else this.decorators[e] = t;
        },
        unregisterDecorator: function unregisterDecorator(e) {
          delete this.decorators[e];
        }
      };
      var h = d["default"].log;
      t.log = h, t.createFrame = o.createFrame, t.logger = d["default"];
    }, function (e, t) {
      "use strict";

      function n(e) {
        return r[e];
      }

      function i(e) {
        for (var t = 1; t < arguments.length; t++) {
          for (var n in arguments[t]) {
            Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
          }
        }

        return e;
      }

      t.__esModule = !0, t.extend = i, t.indexOf = function (e, t) {
        for (var n = 0, i = e.length; n < i; n++) {
          if (e[n] === t) return n;
        }

        return -1;
      }, t.escapeExpression = function (e) {
        if ("string" != typeof e) {
          if (e && e.toHTML) return e.toHTML();
          if (null == e) return "";
          if (!e) return e + "";
          e = "" + e;
        }

        return a.test(e) ? e.replace(o, n) : e;
      }, t.isEmpty = function (e) {
        return !e && 0 !== e || !(!c(e) || 0 !== e.length);
      }, t.createFrame = function (e) {
        var t = i({}, e);
        return t._parent = e, t;
      }, t.blockParams = function (e, t) {
        return e.path = t, e;
      }, t.appendContextPath = function (e, t) {
        return (e ? e + "." : "") + t;
      };
      var r = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;",
        "=": "&#x3D;"
      },
          o = /[&<>"'`=]/g,
          a = /[&<>"'`=]/,
          s = Object.prototype.toString;
      t.toString = s;

      var l = function l(e) {
        return "function" == typeof e;
      };

      l(/x/) && (t.isFunction = l = function l(e) {
        return "function" == typeof e && "[object Function]" === s.call(e);
      }), t.isFunction = l;

      var c = Array.isArray || function (e) {
        return !(!e || "object" != _typeof(e)) && "[object Array]" === s.call(e);
      };

      t.isArray = c;
    }, function (e, t, n) {
      "use strict";

      function i(e, t) {
        var n = t && t.loc,
            a = void 0,
            s = void 0;
        n && (a = n.start.line, s = n.start.column, e += " - " + a + ":" + s);

        for (var l = Error.prototype.constructor.call(this, e), c = 0; c < o.length; c++) {
          this[o[c]] = l[o[c]];
        }

        Error.captureStackTrace && Error.captureStackTrace(this, i);

        try {
          n && (this.lineNumber = a, r ? Object.defineProperty(this, "column", {
            value: s,
            enumerable: !0
          }) : this.column = s);
        } catch (e) {}
      }

      var r = n(7)["default"];
      t.__esModule = !0;
      var o = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
      i.prototype = new Error(), t["default"] = i, e.exports = t["default"];
    }, function (e, t, n) {
      e.exports = {
        "default": n(8),
        __esModule: !0
      };
    }, function (e, t, n) {
      var i = n(9);

      e.exports = function (e, t, n) {
        return i.setDesc(e, t, n);
      };
    }, function (e, t) {
      var n = Object;
      e.exports = {
        create: n.create,
        getProto: n.getPrototypeOf,
        isEnum: {}.propertyIsEnumerable,
        getDesc: n.getOwnPropertyDescriptor,
        setDesc: n.defineProperty,
        setDescs: n.defineProperties,
        getKeys: n.keys,
        getNames: n.getOwnPropertyNames,
        getSymbols: n.getOwnPropertySymbols,
        each: [].forEach
      };
    }, function (e, t, n) {
      "use strict";

      var i = n(1)["default"];
      t.__esModule = !0, t.registerDefaultHelpers = function (e) {
        o["default"](e), s["default"](e), c["default"](e), d["default"](e), h["default"](e), m["default"](e), v["default"](e);
      };
      var r = n(11),
          o = i(r),
          a = n(12),
          s = i(a),
          l = n(13),
          c = i(l),
          u = n(14),
          d = i(u),
          p = n(15),
          h = i(p),
          f = n(16),
          m = i(f),
          g = n(17),
          v = i(g);
    }, function (e, t, n) {
      "use strict";

      t.__esModule = !0;
      var i = n(5);
      t["default"] = function (e) {
        e.registerHelper("blockHelperMissing", function (t, n) {
          var r = n.inverse,
              o = n.fn;
          if (!0 === t) return o(this);
          if (!1 === t || null == t) return r(this);
          if (i.isArray(t)) return t.length > 0 ? (n.ids && (n.ids = [n.name]), e.helpers.each(t, n)) : r(this);

          if (n.data && n.ids) {
            var a = i.createFrame(n.data);
            a.contextPath = i.appendContextPath(n.data.contextPath, n.name), n = {
              data: a
            };
          }

          return o(t, n);
        });
      }, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      var i = n(1)["default"];
      t.__esModule = !0;
      var r = n(5),
          o = n(6),
          a = i(o);
      t["default"] = function (e) {
        e.registerHelper("each", function (e, t) {
          function n(t, n, o) {
            c && (c.key = t, c.index = n, c.first = 0 === n, c.last = !!o, u && (c.contextPath = u + t)), l += i(e[t], {
              data: c,
              blockParams: r.blockParams([e[t], t], [u + t, null])
            });
          }

          if (!t) throw new a["default"]("Must pass iterator to #each");
          var i = t.fn,
              o = t.inverse,
              s = 0,
              l = "",
              c = void 0,
              u = void 0;
          if (t.data && t.ids && (u = r.appendContextPath(t.data.contextPath, t.ids[0]) + "."), r.isFunction(e) && (e = e.call(this)), t.data && (c = r.createFrame(t.data)), e && "object" == _typeof(e)) if (r.isArray(e)) for (var d = e.length; s < d; s++) {
            s in e && n(s, s, s === e.length - 1);
          } else {
            var p = void 0;

            for (var h in e) {
              e.hasOwnProperty(h) && (void 0 !== p && n(p, s - 1), p = h, s++);
            }

            void 0 !== p && n(p, s - 1, !0);
          }
          return 0 === s && (l = o(this)), l;
        });
      }, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      var i = n(1)["default"];
      t.__esModule = !0;
      var r = n(6),
          o = i(r);
      t["default"] = function (e) {
        e.registerHelper("helperMissing", function () {
          if (1 !== arguments.length) throw new o["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
        });
      }, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      t.__esModule = !0;
      var i = n(5);
      t["default"] = function (e) {
        e.registerHelper("if", function (e, t) {
          return i.isFunction(e) && (e = e.call(this)), !t.hash.includeZero && !e || i.isEmpty(e) ? t.inverse(this) : t.fn(this);
        }), e.registerHelper("unless", function (t, n) {
          return e.helpers["if"].call(this, t, {
            fn: n.inverse,
            inverse: n.fn,
            hash: n.hash
          });
        });
      }, e.exports = t["default"];
    }, function (e, t) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        e.registerHelper("log", function () {
          for (var t = [void 0], n = arguments[arguments.length - 1], i = 0; i < arguments.length - 1; i++) {
            t.push(arguments[i]);
          }

          var r = 1;
          null != n.hash.level ? r = n.hash.level : n.data && null != n.data.level && (r = n.data.level), t[0] = r, e.log.apply(e, t);
        });
      }, e.exports = t["default"];
    }, function (e, t) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        e.registerHelper("lookup", function (e, t) {
          return e ? "constructor" !== t || e.propertyIsEnumerable(t) ? e[t] : void 0 : e;
        });
      }, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      t.__esModule = !0;
      var i = n(5);
      t["default"] = function (e) {
        e.registerHelper("with", function (e, t) {
          i.isFunction(e) && (e = e.call(this));
          var n = t.fn;
          if (i.isEmpty(e)) return t.inverse(this);
          var r = t.data;
          return t.data && t.ids && ((r = i.createFrame(t.data)).contextPath = i.appendContextPath(t.data.contextPath, t.ids[0])), n(e, {
            data: r,
            blockParams: i.blockParams([e], [r && r.contextPath])
          });
        });
      }, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      var i = n(1)["default"];
      t.__esModule = !0, t.registerDefaultDecorators = function (e) {
        o["default"](e);
      };
      var r = n(19),
          o = i(r);
    }, function (e, t, n) {
      "use strict";

      t.__esModule = !0;
      var i = n(5);
      t["default"] = function (e) {
        e.registerDecorator("inline", function (e, t, n, r) {
          var o = e;
          return t.partials || (t.partials = {}, o = function o(r, _o2) {
            var a = n.partials;
            n.partials = i.extend({}, a, t.partials);
            var s = e(r, _o2);
            return n.partials = a, s;
          }), t.partials[r.args[0]] = r.fn, o;
        });
      }, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      t.__esModule = !0;
      var i = n(5),
          r = {
        methodMap: ["debug", "info", "warn", "error"],
        level: "info",
        lookupLevel: function lookupLevel(e) {
          if ("string" == typeof e) {
            var t = i.indexOf(r.methodMap, e.toLowerCase());
            e = t >= 0 ? t : parseInt(e, 10);
          }

          return e;
        },
        log: function log(e) {
          if (e = r.lookupLevel(e), "undefined" != typeof console && r.lookupLevel(r.level) <= e) {
            var t = r.methodMap[e];
            console[t] || (t = "log");

            for (var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
              i[o - 1] = arguments[o];
            }

            console[t].apply(console, i);
          }
        }
      };
      t["default"] = r, e.exports = t["default"];
    }, function (e, t) {
      "use strict";

      function n(e) {
        this.string = e;
      }

      t.__esModule = !0, n.prototype.toString = n.prototype.toHTML = function () {
        return "" + this.string;
      }, t["default"] = n, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      function i(e, t, n, i, r, a, s) {
        function l(t) {
          var r = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
              o = s;
          return !s || t == s[0] || t === e.nullContext && null === s[0] || (o = [t].concat(s)), n(e, t, e.helpers, e.partials, r.data || i, a && [r.blockParams].concat(a), o);
        }

        return (l = o(n, l, e, s, i, a)).program = t, l.depth = s ? s.length : 0, l.blockParams = r || 0, l;
      }

      function r() {
        return "";
      }

      function o(e, t, n, i, r, o) {
        if (e.decorator) {
          var a = {};
          t = e.decorator(t, a, n, i && i[0], r, o, i), u.extend(t, a);
        }

        return t;
      }

      var a = n(23)["default"],
          s = n(3)["default"],
          l = n(1)["default"];
      t.__esModule = !0, t.checkRevision = function (e) {
        var t = e && e[0] || 1,
            n = h.COMPILER_REVISION;

        if (t !== n) {
          if (t < n) {
            var i = h.REVISION_CHANGES[n],
                r = h.REVISION_CHANGES[t];
            throw new p["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + i + ") or downgrade your runtime to an older version (" + r + ").");
          }

          throw new p["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + e[1] + ").");
        }
      }, t.template = function (e, t) {
        function n(t) {
          function i(t) {
            return "" + e.main(r, t, r.helpers, r.partials, s, c, l);
          }

          var a = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
              s = a.data;
          n._setup(a), !a.partial && e.useData && (s = function (e, t) {
            return t && "root" in t || ((t = t ? h.createFrame(t) : {}).root = e), t;
          }(t, s));
          var l = void 0,
              c = e.useBlockParams ? [] : void 0;
          return e.useDepths && (l = a.depths ? t != a.depths[0] ? [t].concat(a.depths) : a.depths : [t]), (i = o(e.main, i, r, a.depths || [], s, c))(t, a);
        }

        if (!t) throw new p["default"]("No environment passed to template");
        if (!e || !e.main) throw new p["default"]("Unknown template object: " + _typeof(e));
        e.main.decorator = e.main_d, t.VM.checkRevision(e.compiler);
        var r = {
          strict: function strict(e, t) {
            if (!(t in e)) throw new p["default"]('"' + t + '" not defined in ' + e);
            return e[t];
          },
          lookup: function lookup(e, t) {
            for (var n = e.length, i = 0; i < n; i++) {
              if (e[i] && null != e[i][t]) return e[i][t];
            }
          },
          lambda: function lambda(e, t) {
            return "function" == typeof e ? e.call(t) : e;
          },
          escapeExpression: u.escapeExpression,
          invokePartial: function invokePartial(n, i, r) {
            r.hash && (i = u.extend({}, i, r.hash), r.ids && (r.ids[0] = !0)), n = t.VM.resolvePartial.call(this, n, i, r);
            var o = t.VM.invokePartial.call(this, n, i, r);

            if (null == o && t.compile && (r.partials[r.name] = t.compile(n, e.compilerOptions, t), o = r.partials[r.name](i, r)), null != o) {
              if (r.indent) {
                for (var a = o.split("\n"), s = 0, l = a.length; s < l && (a[s] || s + 1 !== l); s++) {
                  a[s] = r.indent + a[s];
                }

                o = a.join("\n");
              }

              return o;
            }

            throw new p["default"]("The partial " + r.name + " could not be compiled when running in runtime-only mode");
          },
          fn: function fn(t) {
            var n = e[t];
            return n.decorator = e[t + "_d"], n;
          },
          programs: [],
          program: function program(e, t, n, r, o) {
            var a = this.programs[e],
                s = this.fn(e);
            return t || o || r || n ? a = i(this, e, s, t, n, r, o) : a || (a = this.programs[e] = i(this, e, s)), a;
          },
          data: function data(e, t) {
            for (; e && t--;) {
              e = e._parent;
            }

            return e;
          },
          merge: function merge(e, t) {
            var n = e || t;
            return e && t && e !== t && (n = u.extend({}, t, e)), n;
          },
          nullContext: a({}),
          noop: t.VM.noop,
          compilerInfo: e.compiler
        };
        return n.isTop = !0, n._setup = function (n) {
          n.partial ? (r.helpers = n.helpers, r.partials = n.partials, r.decorators = n.decorators) : (r.helpers = r.merge(n.helpers, t.helpers), e.usePartial && (r.partials = r.merge(n.partials, t.partials)), (e.usePartial || e.useDecorators) && (r.decorators = r.merge(n.decorators, t.decorators)));
        }, n._child = function (t, n, o, a) {
          if (e.useBlockParams && !o) throw new p["default"]("must pass block params");
          if (e.useDepths && !a) throw new p["default"]("must pass parent depths");
          return i(r, t, e[t], n, 0, o, a);
        }, n;
      }, t.wrapProgram = i, t.resolvePartial = function (e, t, n) {
        return e ? e.call || n.name || (n.name = e, e = n.partials[e]) : e = "@partial-block" === n.name ? n.data["partial-block"] : n.partials[n.name], e;
      }, t.invokePartial = function (e, t, n) {
        var i = n.data && n.data["partial-block"];
        n.partial = !0, n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);
        var o = void 0;
        if (n.fn && n.fn !== r && function () {
          n.data = h.createFrame(n.data);
          var e = n.fn;
          o = n.data["partial-block"] = function (t) {
            var n = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
            return n.data = h.createFrame(n.data), n.data["partial-block"] = i, e(t, n);
          }, e.partials && (n.partials = u.extend({}, n.partials, e.partials));
        }(), void 0 === e && o && (e = o), void 0 === e) throw new p["default"]("The partial " + n.name + " could not be found");
        if (e instanceof Function) return e(t, n);
      }, t.noop = r;
      var c = n(5),
          u = s(c),
          d = n(6),
          p = l(d),
          h = n(4);
    }, function (e, t, n) {
      e.exports = {
        "default": n(24),
        __esModule: !0
      };
    }, function (e, t, n) {
      n(25), e.exports = n(30).Object.seal;
    }, function (e, t, n) {
      var i = n(26);
      n(27)("seal", function (e) {
        return function (t) {
          return e && i(t) ? e(t) : t;
        };
      });
    }, function (e, t) {
      e.exports = function (e) {
        return "object" == _typeof(e) ? null !== e : "function" == typeof e;
      };
    }, function (e, t, n) {
      var i = n(28),
          r = n(30),
          o = n(33);

      e.exports = function (e, t) {
        var n = (r.Object || {})[e] || Object[e],
            a = {};
        a[e] = t(n), i(i.S + i.F * o(function () {
          n(1);
        }), "Object", a);
      };
    }, function (e, t, n) {
      var i = n(29),
          r = n(30),
          o = n(31),
          a = "prototype",
          s = function s(e, t, n) {
        var l,
            c,
            u,
            d = e & s.F,
            p = e & s.G,
            h = e & s.S,
            f = e & s.P,
            m = e & s.B,
            g = e & s.W,
            v = p ? r : r[t] || (r[t] = {}),
            b = p ? i : h ? i[t] : (i[t] || {})[a];

        for (l in p && (n = t), n) {
          (c = !d && b && l in b) && l in v || (u = c ? b[l] : n[l], v[l] = p && "function" != typeof b[l] ? n[l] : m && c ? o(u, i) : g && b[l] == u ? function (e) {
            var t = function t(_t4) {
              return this instanceof e ? new e(_t4) : e(_t4);
            };

            return t[a] = e[a], t;
          }(u) : f && "function" == typeof u ? o(Function.call, u) : u, f && ((v[a] || (v[a] = {}))[l] = u));
        }
      };

      s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, e.exports = s;
    }, function (e, t) {
      var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    }, function (e, t) {
      var n = e.exports = {
        version: "1.2.6"
      };
      "number" == typeof __e && (__e = n);
    }, function (e, t, n) {
      var i = n(32);

      e.exports = function (e, t, n) {
        if (i(e), void 0 === t) return e;

        switch (n) {
          case 1:
            return function (n) {
              return e.call(t, n);
            };

          case 2:
            return function (n, i) {
              return e.call(t, n, i);
            };

          case 3:
            return function (n, i, r) {
              return e.call(t, n, i, r);
            };
        }

        return function () {
          return e.apply(t, arguments);
        };
      };
    }, function (e, t) {
      e.exports = function (e) {
        if ("function" != typeof e) throw TypeError(e + " is not a function!");
        return e;
      };
    }, function (e, t) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (e) {
          return !0;
        }
      };
    }, function (e, t) {
      (function (n) {
        "use strict";

        t.__esModule = !0, t["default"] = function (e) {
          var t = void 0 !== n ? n : window,
              i = t.Handlebars;

          e.noConflict = function () {
            return t.Handlebars === e && (t.Handlebars = i), e;
          };
        }, e.exports = t["default"];
      }).call(t, function () {
        return this;
      }());
    }, function (e, t) {
      "use strict";

      t.__esModule = !0;
      var n = {
        helpers: {
          helperExpression: function helperExpression(e) {
            return "SubExpression" === e.type || ("MustacheStatement" === e.type || "BlockStatement" === e.type) && !!(e.params && e.params.length || e.hash);
          },
          scopedId: function scopedId(e) {
            return /^\.|this\b/.test(e.original);
          },
          simpleId: function simpleId(e) {
            return 1 === e.parts.length && !n.helpers.scopedId(e) && !e.depth;
          }
        }
      };
      t["default"] = n, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      var i = n(1)["default"],
          r = n(3)["default"];
      t.__esModule = !0, t.parse = function (e, t) {
        return "Program" === e.type ? e : (a["default"].yy = p, p.locInfo = function (e) {
          return new p.SourceLocation(t && t.srcName, e);
        }, new l["default"](t).accept(a["default"].parse(e)));
      };
      var o = n(37),
          a = i(o),
          s = n(38),
          l = i(s),
          c = n(40),
          u = r(c),
          d = n(5);
      t.parser = a["default"];
      var p = {};
      d.extend(p, u);
    }, function (e, t) {
      "use strict";

      t.__esModule = !0;

      var n = function () {
        function e() {
          this.yy = {};
        }

        var t = {
          trace: function trace() {},
          yy: {},
          symbols_: {
            error: 2,
            root: 3,
            program: 4,
            EOF: 5,
            program_repetition0: 6,
            statement: 7,
            mustache: 8,
            block: 9,
            rawBlock: 10,
            partial: 11,
            partialBlock: 12,
            content: 13,
            COMMENT: 14,
            CONTENT: 15,
            openRawBlock: 16,
            rawBlock_repetition_plus0: 17,
            END_RAW_BLOCK: 18,
            OPEN_RAW_BLOCK: 19,
            helperName: 20,
            openRawBlock_repetition0: 21,
            openRawBlock_option0: 22,
            CLOSE_RAW_BLOCK: 23,
            openBlock: 24,
            block_option0: 25,
            closeBlock: 26,
            openInverse: 27,
            block_option1: 28,
            OPEN_BLOCK: 29,
            openBlock_repetition0: 30,
            openBlock_option0: 31,
            openBlock_option1: 32,
            CLOSE: 33,
            OPEN_INVERSE: 34,
            openInverse_repetition0: 35,
            openInverse_option0: 36,
            openInverse_option1: 37,
            openInverseChain: 38,
            OPEN_INVERSE_CHAIN: 39,
            openInverseChain_repetition0: 40,
            openInverseChain_option0: 41,
            openInverseChain_option1: 42,
            inverseAndProgram: 43,
            INVERSE: 44,
            inverseChain: 45,
            inverseChain_option0: 46,
            OPEN_ENDBLOCK: 47,
            OPEN: 48,
            mustache_repetition0: 49,
            mustache_option0: 50,
            OPEN_UNESCAPED: 51,
            mustache_repetition1: 52,
            mustache_option1: 53,
            CLOSE_UNESCAPED: 54,
            OPEN_PARTIAL: 55,
            partialName: 56,
            partial_repetition0: 57,
            partial_option0: 58,
            openPartialBlock: 59,
            OPEN_PARTIAL_BLOCK: 60,
            openPartialBlock_repetition0: 61,
            openPartialBlock_option0: 62,
            param: 63,
            sexpr: 64,
            OPEN_SEXPR: 65,
            sexpr_repetition0: 66,
            sexpr_option0: 67,
            CLOSE_SEXPR: 68,
            hash: 69,
            hash_repetition_plus0: 70,
            hashSegment: 71,
            ID: 72,
            EQUALS: 73,
            blockParams: 74,
            OPEN_BLOCK_PARAMS: 75,
            blockParams_repetition_plus0: 76,
            CLOSE_BLOCK_PARAMS: 77,
            path: 78,
            dataName: 79,
            STRING: 80,
            NUMBER: 81,
            BOOLEAN: 82,
            UNDEFINED: 83,
            NULL: 84,
            DATA: 85,
            pathSegments: 86,
            SEP: 87,
            $accept: 0,
            $end: 1
          },
          terminals_: {
            2: "error",
            5: "EOF",
            14: "COMMENT",
            15: "CONTENT",
            18: "END_RAW_BLOCK",
            19: "OPEN_RAW_BLOCK",
            23: "CLOSE_RAW_BLOCK",
            29: "OPEN_BLOCK",
            33: "CLOSE",
            34: "OPEN_INVERSE",
            39: "OPEN_INVERSE_CHAIN",
            44: "INVERSE",
            47: "OPEN_ENDBLOCK",
            48: "OPEN",
            51: "OPEN_UNESCAPED",
            54: "CLOSE_UNESCAPED",
            55: "OPEN_PARTIAL",
            60: "OPEN_PARTIAL_BLOCK",
            65: "OPEN_SEXPR",
            68: "CLOSE_SEXPR",
            72: "ID",
            73: "EQUALS",
            75: "OPEN_BLOCK_PARAMS",
            77: "CLOSE_BLOCK_PARAMS",
            80: "STRING",
            81: "NUMBER",
            82: "BOOLEAN",
            83: "UNDEFINED",
            84: "NULL",
            85: "DATA",
            87: "SEP"
          },
          productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 1], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
          performAction: function performAction(e, t, n, i, r, o, a) {
            var s = o.length - 1;

            switch (r) {
              case 1:
                return o[s - 1];

              case 2:
                this.$ = i.prepareProgram(o[s]);
                break;

              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
              case 8:
                this.$ = o[s];
                break;

              case 9:
                this.$ = {
                  type: "CommentStatement",
                  value: i.stripComment(o[s]),
                  strip: i.stripFlags(o[s], o[s]),
                  loc: i.locInfo(this._$)
                };
                break;

              case 10:
                this.$ = {
                  type: "ContentStatement",
                  original: o[s],
                  value: o[s],
                  loc: i.locInfo(this._$)
                };
                break;

              case 11:
                this.$ = i.prepareRawBlock(o[s - 2], o[s - 1], o[s], this._$);
                break;

              case 12:
                this.$ = {
                  path: o[s - 3],
                  params: o[s - 2],
                  hash: o[s - 1]
                };
                break;

              case 13:
                this.$ = i.prepareBlock(o[s - 3], o[s - 2], o[s - 1], o[s], !1, this._$);
                break;

              case 14:
                this.$ = i.prepareBlock(o[s - 3], o[s - 2], o[s - 1], o[s], !0, this._$);
                break;

              case 15:
                this.$ = {
                  open: o[s - 5],
                  path: o[s - 4],
                  params: o[s - 3],
                  hash: o[s - 2],
                  blockParams: o[s - 1],
                  strip: i.stripFlags(o[s - 5], o[s])
                };
                break;

              case 16:
              case 17:
                this.$ = {
                  path: o[s - 4],
                  params: o[s - 3],
                  hash: o[s - 2],
                  blockParams: o[s - 1],
                  strip: i.stripFlags(o[s - 5], o[s])
                };
                break;

              case 18:
                this.$ = {
                  strip: i.stripFlags(o[s - 1], o[s - 1]),
                  program: o[s]
                };
                break;

              case 19:
                var l = i.prepareBlock(o[s - 2], o[s - 1], o[s], o[s], !1, this._$),
                    c = i.prepareProgram([l], o[s - 1].loc);
                c.chained = !0, this.$ = {
                  strip: o[s - 2].strip,
                  program: c,
                  chain: !0
                };
                break;

              case 20:
                this.$ = o[s];
                break;

              case 21:
                this.$ = {
                  path: o[s - 1],
                  strip: i.stripFlags(o[s - 2], o[s])
                };
                break;

              case 22:
              case 23:
                this.$ = i.prepareMustache(o[s - 3], o[s - 2], o[s - 1], o[s - 4], i.stripFlags(o[s - 4], o[s]), this._$);
                break;

              case 24:
                this.$ = {
                  type: "PartialStatement",
                  name: o[s - 3],
                  params: o[s - 2],
                  hash: o[s - 1],
                  indent: "",
                  strip: i.stripFlags(o[s - 4], o[s]),
                  loc: i.locInfo(this._$)
                };
                break;

              case 25:
                this.$ = i.preparePartialBlock(o[s - 2], o[s - 1], o[s], this._$);
                break;

              case 26:
                this.$ = {
                  path: o[s - 3],
                  params: o[s - 2],
                  hash: o[s - 1],
                  strip: i.stripFlags(o[s - 4], o[s])
                };
                break;

              case 27:
              case 28:
                this.$ = o[s];
                break;

              case 29:
                this.$ = {
                  type: "SubExpression",
                  path: o[s - 3],
                  params: o[s - 2],
                  hash: o[s - 1],
                  loc: i.locInfo(this._$)
                };
                break;

              case 30:
                this.$ = {
                  type: "Hash",
                  pairs: o[s],
                  loc: i.locInfo(this._$)
                };
                break;

              case 31:
                this.$ = {
                  type: "HashPair",
                  key: i.id(o[s - 2]),
                  value: o[s],
                  loc: i.locInfo(this._$)
                };
                break;

              case 32:
                this.$ = i.id(o[s - 1]);
                break;

              case 33:
              case 34:
                this.$ = o[s];
                break;

              case 35:
                this.$ = {
                  type: "StringLiteral",
                  value: o[s],
                  original: o[s],
                  loc: i.locInfo(this._$)
                };
                break;

              case 36:
                this.$ = {
                  type: "NumberLiteral",
                  value: Number(o[s]),
                  original: Number(o[s]),
                  loc: i.locInfo(this._$)
                };
                break;

              case 37:
                this.$ = {
                  type: "BooleanLiteral",
                  value: "true" === o[s],
                  original: "true" === o[s],
                  loc: i.locInfo(this._$)
                };
                break;

              case 38:
                this.$ = {
                  type: "UndefinedLiteral",
                  original: void 0,
                  value: void 0,
                  loc: i.locInfo(this._$)
                };
                break;

              case 39:
                this.$ = {
                  type: "NullLiteral",
                  original: null,
                  value: null,
                  loc: i.locInfo(this._$)
                };
                break;

              case 40:
              case 41:
                this.$ = o[s];
                break;

              case 42:
                this.$ = i.preparePath(!0, o[s], this._$);
                break;

              case 43:
                this.$ = i.preparePath(!1, o[s], this._$);
                break;

              case 44:
                o[s - 2].push({
                  part: i.id(o[s]),
                  original: o[s],
                  separator: o[s - 1]
                }), this.$ = o[s - 2];
                break;

              case 45:
                this.$ = [{
                  part: i.id(o[s]),
                  original: o[s]
                }];
                break;

              case 46:
                this.$ = [];
                break;

              case 47:
                o[s - 1].push(o[s]);
                break;

              case 48:
                this.$ = [o[s]];
                break;

              case 49:
                o[s - 1].push(o[s]);
                break;

              case 50:
                this.$ = [];
                break;

              case 51:
                o[s - 1].push(o[s]);
                break;

              case 58:
                this.$ = [];
                break;

              case 59:
                o[s - 1].push(o[s]);
                break;

              case 64:
                this.$ = [];
                break;

              case 65:
                o[s - 1].push(o[s]);
                break;

              case 70:
                this.$ = [];
                break;

              case 71:
                o[s - 1].push(o[s]);
                break;

              case 78:
                this.$ = [];
                break;

              case 79:
                o[s - 1].push(o[s]);
                break;

              case 82:
                this.$ = [];
                break;

              case 83:
                o[s - 1].push(o[s]);
                break;

              case 86:
                this.$ = [];
                break;

              case 87:
                o[s - 1].push(o[s]);
                break;

              case 90:
                this.$ = [];
                break;

              case 91:
                o[s - 1].push(o[s]);
                break;

              case 94:
                this.$ = [];
                break;

              case 95:
                o[s - 1].push(o[s]);
                break;

              case 98:
                this.$ = [o[s]];
                break;

              case 99:
                o[s - 1].push(o[s]);
                break;

              case 100:
                this.$ = [o[s]];
                break;

              case 101:
                o[s - 1].push(o[s]);
            }
          },
          table: [{
            3: 1,
            4: 2,
            5: [2, 46],
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            1: [3]
          }, {
            5: [1, 4]
          }, {
            5: [2, 2],
            7: 5,
            8: 6,
            9: 7,
            10: 8,
            11: 9,
            12: 10,
            13: 11,
            14: [1, 12],
            15: [1, 20],
            16: 17,
            19: [1, 23],
            24: 15,
            27: 16,
            29: [1, 21],
            34: [1, 22],
            39: [2, 2],
            44: [2, 2],
            47: [2, 2],
            48: [1, 13],
            51: [1, 14],
            55: [1, 18],
            59: 19,
            60: [1, 24]
          }, {
            1: [2, 1]
          }, {
            5: [2, 47],
            14: [2, 47],
            15: [2, 47],
            19: [2, 47],
            29: [2, 47],
            34: [2, 47],
            39: [2, 47],
            44: [2, 47],
            47: [2, 47],
            48: [2, 47],
            51: [2, 47],
            55: [2, 47],
            60: [2, 47]
          }, {
            5: [2, 3],
            14: [2, 3],
            15: [2, 3],
            19: [2, 3],
            29: [2, 3],
            34: [2, 3],
            39: [2, 3],
            44: [2, 3],
            47: [2, 3],
            48: [2, 3],
            51: [2, 3],
            55: [2, 3],
            60: [2, 3]
          }, {
            5: [2, 4],
            14: [2, 4],
            15: [2, 4],
            19: [2, 4],
            29: [2, 4],
            34: [2, 4],
            39: [2, 4],
            44: [2, 4],
            47: [2, 4],
            48: [2, 4],
            51: [2, 4],
            55: [2, 4],
            60: [2, 4]
          }, {
            5: [2, 5],
            14: [2, 5],
            15: [2, 5],
            19: [2, 5],
            29: [2, 5],
            34: [2, 5],
            39: [2, 5],
            44: [2, 5],
            47: [2, 5],
            48: [2, 5],
            51: [2, 5],
            55: [2, 5],
            60: [2, 5]
          }, {
            5: [2, 6],
            14: [2, 6],
            15: [2, 6],
            19: [2, 6],
            29: [2, 6],
            34: [2, 6],
            39: [2, 6],
            44: [2, 6],
            47: [2, 6],
            48: [2, 6],
            51: [2, 6],
            55: [2, 6],
            60: [2, 6]
          }, {
            5: [2, 7],
            14: [2, 7],
            15: [2, 7],
            19: [2, 7],
            29: [2, 7],
            34: [2, 7],
            39: [2, 7],
            44: [2, 7],
            47: [2, 7],
            48: [2, 7],
            51: [2, 7],
            55: [2, 7],
            60: [2, 7]
          }, {
            5: [2, 8],
            14: [2, 8],
            15: [2, 8],
            19: [2, 8],
            29: [2, 8],
            34: [2, 8],
            39: [2, 8],
            44: [2, 8],
            47: [2, 8],
            48: [2, 8],
            51: [2, 8],
            55: [2, 8],
            60: [2, 8]
          }, {
            5: [2, 9],
            14: [2, 9],
            15: [2, 9],
            19: [2, 9],
            29: [2, 9],
            34: [2, 9],
            39: [2, 9],
            44: [2, 9],
            47: [2, 9],
            48: [2, 9],
            51: [2, 9],
            55: [2, 9],
            60: [2, 9]
          }, {
            20: 25,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 36,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            4: 37,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            39: [2, 46],
            44: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            4: 38,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            44: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            13: 40,
            15: [1, 20],
            17: 39
          }, {
            20: 42,
            56: 41,
            64: 43,
            65: [1, 44],
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            4: 45,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            5: [2, 10],
            14: [2, 10],
            15: [2, 10],
            18: [2, 10],
            19: [2, 10],
            29: [2, 10],
            34: [2, 10],
            39: [2, 10],
            44: [2, 10],
            47: [2, 10],
            48: [2, 10],
            51: [2, 10],
            55: [2, 10],
            60: [2, 10]
          }, {
            20: 46,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 47,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 48,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 42,
            56: 49,
            64: 43,
            65: [1, 44],
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            33: [2, 78],
            49: 50,
            65: [2, 78],
            72: [2, 78],
            80: [2, 78],
            81: [2, 78],
            82: [2, 78],
            83: [2, 78],
            84: [2, 78],
            85: [2, 78]
          }, {
            23: [2, 33],
            33: [2, 33],
            54: [2, 33],
            65: [2, 33],
            68: [2, 33],
            72: [2, 33],
            75: [2, 33],
            80: [2, 33],
            81: [2, 33],
            82: [2, 33],
            83: [2, 33],
            84: [2, 33],
            85: [2, 33]
          }, {
            23: [2, 34],
            33: [2, 34],
            54: [2, 34],
            65: [2, 34],
            68: [2, 34],
            72: [2, 34],
            75: [2, 34],
            80: [2, 34],
            81: [2, 34],
            82: [2, 34],
            83: [2, 34],
            84: [2, 34],
            85: [2, 34]
          }, {
            23: [2, 35],
            33: [2, 35],
            54: [2, 35],
            65: [2, 35],
            68: [2, 35],
            72: [2, 35],
            75: [2, 35],
            80: [2, 35],
            81: [2, 35],
            82: [2, 35],
            83: [2, 35],
            84: [2, 35],
            85: [2, 35]
          }, {
            23: [2, 36],
            33: [2, 36],
            54: [2, 36],
            65: [2, 36],
            68: [2, 36],
            72: [2, 36],
            75: [2, 36],
            80: [2, 36],
            81: [2, 36],
            82: [2, 36],
            83: [2, 36],
            84: [2, 36],
            85: [2, 36]
          }, {
            23: [2, 37],
            33: [2, 37],
            54: [2, 37],
            65: [2, 37],
            68: [2, 37],
            72: [2, 37],
            75: [2, 37],
            80: [2, 37],
            81: [2, 37],
            82: [2, 37],
            83: [2, 37],
            84: [2, 37],
            85: [2, 37]
          }, {
            23: [2, 38],
            33: [2, 38],
            54: [2, 38],
            65: [2, 38],
            68: [2, 38],
            72: [2, 38],
            75: [2, 38],
            80: [2, 38],
            81: [2, 38],
            82: [2, 38],
            83: [2, 38],
            84: [2, 38],
            85: [2, 38]
          }, {
            23: [2, 39],
            33: [2, 39],
            54: [2, 39],
            65: [2, 39],
            68: [2, 39],
            72: [2, 39],
            75: [2, 39],
            80: [2, 39],
            81: [2, 39],
            82: [2, 39],
            83: [2, 39],
            84: [2, 39],
            85: [2, 39]
          }, {
            23: [2, 43],
            33: [2, 43],
            54: [2, 43],
            65: [2, 43],
            68: [2, 43],
            72: [2, 43],
            75: [2, 43],
            80: [2, 43],
            81: [2, 43],
            82: [2, 43],
            83: [2, 43],
            84: [2, 43],
            85: [2, 43],
            87: [1, 51]
          }, {
            72: [1, 35],
            86: 52
          }, {
            23: [2, 45],
            33: [2, 45],
            54: [2, 45],
            65: [2, 45],
            68: [2, 45],
            72: [2, 45],
            75: [2, 45],
            80: [2, 45],
            81: [2, 45],
            82: [2, 45],
            83: [2, 45],
            84: [2, 45],
            85: [2, 45],
            87: [2, 45]
          }, {
            52: 53,
            54: [2, 82],
            65: [2, 82],
            72: [2, 82],
            80: [2, 82],
            81: [2, 82],
            82: [2, 82],
            83: [2, 82],
            84: [2, 82],
            85: [2, 82]
          }, {
            25: 54,
            38: 56,
            39: [1, 58],
            43: 57,
            44: [1, 59],
            45: 55,
            47: [2, 54]
          }, {
            28: 60,
            43: 61,
            44: [1, 59],
            47: [2, 56]
          }, {
            13: 63,
            15: [1, 20],
            18: [1, 62]
          }, {
            15: [2, 48],
            18: [2, 48]
          }, {
            33: [2, 86],
            57: 64,
            65: [2, 86],
            72: [2, 86],
            80: [2, 86],
            81: [2, 86],
            82: [2, 86],
            83: [2, 86],
            84: [2, 86],
            85: [2, 86]
          }, {
            33: [2, 40],
            65: [2, 40],
            72: [2, 40],
            80: [2, 40],
            81: [2, 40],
            82: [2, 40],
            83: [2, 40],
            84: [2, 40],
            85: [2, 40]
          }, {
            33: [2, 41],
            65: [2, 41],
            72: [2, 41],
            80: [2, 41],
            81: [2, 41],
            82: [2, 41],
            83: [2, 41],
            84: [2, 41],
            85: [2, 41]
          }, {
            20: 65,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            26: 66,
            47: [1, 67]
          }, {
            30: 68,
            33: [2, 58],
            65: [2, 58],
            72: [2, 58],
            75: [2, 58],
            80: [2, 58],
            81: [2, 58],
            82: [2, 58],
            83: [2, 58],
            84: [2, 58],
            85: [2, 58]
          }, {
            33: [2, 64],
            35: 69,
            65: [2, 64],
            72: [2, 64],
            75: [2, 64],
            80: [2, 64],
            81: [2, 64],
            82: [2, 64],
            83: [2, 64],
            84: [2, 64],
            85: [2, 64]
          }, {
            21: 70,
            23: [2, 50],
            65: [2, 50],
            72: [2, 50],
            80: [2, 50],
            81: [2, 50],
            82: [2, 50],
            83: [2, 50],
            84: [2, 50],
            85: [2, 50]
          }, {
            33: [2, 90],
            61: 71,
            65: [2, 90],
            72: [2, 90],
            80: [2, 90],
            81: [2, 90],
            82: [2, 90],
            83: [2, 90],
            84: [2, 90],
            85: [2, 90]
          }, {
            20: 75,
            33: [2, 80],
            50: 72,
            63: 73,
            64: 76,
            65: [1, 44],
            69: 74,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            72: [1, 80]
          }, {
            23: [2, 42],
            33: [2, 42],
            54: [2, 42],
            65: [2, 42],
            68: [2, 42],
            72: [2, 42],
            75: [2, 42],
            80: [2, 42],
            81: [2, 42],
            82: [2, 42],
            83: [2, 42],
            84: [2, 42],
            85: [2, 42],
            87: [1, 51]
          }, {
            20: 75,
            53: 81,
            54: [2, 84],
            63: 82,
            64: 76,
            65: [1, 44],
            69: 83,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            26: 84,
            47: [1, 67]
          }, {
            47: [2, 55]
          }, {
            4: 85,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            39: [2, 46],
            44: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            47: [2, 20]
          }, {
            20: 86,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            4: 87,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            26: 88,
            47: [1, 67]
          }, {
            47: [2, 57]
          }, {
            5: [2, 11],
            14: [2, 11],
            15: [2, 11],
            19: [2, 11],
            29: [2, 11],
            34: [2, 11],
            39: [2, 11],
            44: [2, 11],
            47: [2, 11],
            48: [2, 11],
            51: [2, 11],
            55: [2, 11],
            60: [2, 11]
          }, {
            15: [2, 49],
            18: [2, 49]
          }, {
            20: 75,
            33: [2, 88],
            58: 89,
            63: 90,
            64: 76,
            65: [1, 44],
            69: 91,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            65: [2, 94],
            66: 92,
            68: [2, 94],
            72: [2, 94],
            80: [2, 94],
            81: [2, 94],
            82: [2, 94],
            83: [2, 94],
            84: [2, 94],
            85: [2, 94]
          }, {
            5: [2, 25],
            14: [2, 25],
            15: [2, 25],
            19: [2, 25],
            29: [2, 25],
            34: [2, 25],
            39: [2, 25],
            44: [2, 25],
            47: [2, 25],
            48: [2, 25],
            51: [2, 25],
            55: [2, 25],
            60: [2, 25]
          }, {
            20: 93,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            31: 94,
            33: [2, 60],
            63: 95,
            64: 76,
            65: [1, 44],
            69: 96,
            70: 77,
            71: 78,
            72: [1, 79],
            75: [2, 60],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            33: [2, 66],
            36: 97,
            63: 98,
            64: 76,
            65: [1, 44],
            69: 99,
            70: 77,
            71: 78,
            72: [1, 79],
            75: [2, 66],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            22: 100,
            23: [2, 52],
            63: 101,
            64: 76,
            65: [1, 44],
            69: 102,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            33: [2, 92],
            62: 103,
            63: 104,
            64: 76,
            65: [1, 44],
            69: 105,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            33: [1, 106]
          }, {
            33: [2, 79],
            65: [2, 79],
            72: [2, 79],
            80: [2, 79],
            81: [2, 79],
            82: [2, 79],
            83: [2, 79],
            84: [2, 79],
            85: [2, 79]
          }, {
            33: [2, 81]
          }, {
            23: [2, 27],
            33: [2, 27],
            54: [2, 27],
            65: [2, 27],
            68: [2, 27],
            72: [2, 27],
            75: [2, 27],
            80: [2, 27],
            81: [2, 27],
            82: [2, 27],
            83: [2, 27],
            84: [2, 27],
            85: [2, 27]
          }, {
            23: [2, 28],
            33: [2, 28],
            54: [2, 28],
            65: [2, 28],
            68: [2, 28],
            72: [2, 28],
            75: [2, 28],
            80: [2, 28],
            81: [2, 28],
            82: [2, 28],
            83: [2, 28],
            84: [2, 28],
            85: [2, 28]
          }, {
            23: [2, 30],
            33: [2, 30],
            54: [2, 30],
            68: [2, 30],
            71: 107,
            72: [1, 108],
            75: [2, 30]
          }, {
            23: [2, 98],
            33: [2, 98],
            54: [2, 98],
            68: [2, 98],
            72: [2, 98],
            75: [2, 98]
          }, {
            23: [2, 45],
            33: [2, 45],
            54: [2, 45],
            65: [2, 45],
            68: [2, 45],
            72: [2, 45],
            73: [1, 109],
            75: [2, 45],
            80: [2, 45],
            81: [2, 45],
            82: [2, 45],
            83: [2, 45],
            84: [2, 45],
            85: [2, 45],
            87: [2, 45]
          }, {
            23: [2, 44],
            33: [2, 44],
            54: [2, 44],
            65: [2, 44],
            68: [2, 44],
            72: [2, 44],
            75: [2, 44],
            80: [2, 44],
            81: [2, 44],
            82: [2, 44],
            83: [2, 44],
            84: [2, 44],
            85: [2, 44],
            87: [2, 44]
          }, {
            54: [1, 110]
          }, {
            54: [2, 83],
            65: [2, 83],
            72: [2, 83],
            80: [2, 83],
            81: [2, 83],
            82: [2, 83],
            83: [2, 83],
            84: [2, 83],
            85: [2, 83]
          }, {
            54: [2, 85]
          }, {
            5: [2, 13],
            14: [2, 13],
            15: [2, 13],
            19: [2, 13],
            29: [2, 13],
            34: [2, 13],
            39: [2, 13],
            44: [2, 13],
            47: [2, 13],
            48: [2, 13],
            51: [2, 13],
            55: [2, 13],
            60: [2, 13]
          }, {
            38: 56,
            39: [1, 58],
            43: 57,
            44: [1, 59],
            45: 112,
            46: 111,
            47: [2, 76]
          }, {
            33: [2, 70],
            40: 113,
            65: [2, 70],
            72: [2, 70],
            75: [2, 70],
            80: [2, 70],
            81: [2, 70],
            82: [2, 70],
            83: [2, 70],
            84: [2, 70],
            85: [2, 70]
          }, {
            47: [2, 18]
          }, {
            5: [2, 14],
            14: [2, 14],
            15: [2, 14],
            19: [2, 14],
            29: [2, 14],
            34: [2, 14],
            39: [2, 14],
            44: [2, 14],
            47: [2, 14],
            48: [2, 14],
            51: [2, 14],
            55: [2, 14],
            60: [2, 14]
          }, {
            33: [1, 114]
          }, {
            33: [2, 87],
            65: [2, 87],
            72: [2, 87],
            80: [2, 87],
            81: [2, 87],
            82: [2, 87],
            83: [2, 87],
            84: [2, 87],
            85: [2, 87]
          }, {
            33: [2, 89]
          }, {
            20: 75,
            63: 116,
            64: 76,
            65: [1, 44],
            67: 115,
            68: [2, 96],
            69: 117,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            33: [1, 118]
          }, {
            32: 119,
            33: [2, 62],
            74: 120,
            75: [1, 121]
          }, {
            33: [2, 59],
            65: [2, 59],
            72: [2, 59],
            75: [2, 59],
            80: [2, 59],
            81: [2, 59],
            82: [2, 59],
            83: [2, 59],
            84: [2, 59],
            85: [2, 59]
          }, {
            33: [2, 61],
            75: [2, 61]
          }, {
            33: [2, 68],
            37: 122,
            74: 123,
            75: [1, 121]
          }, {
            33: [2, 65],
            65: [2, 65],
            72: [2, 65],
            75: [2, 65],
            80: [2, 65],
            81: [2, 65],
            82: [2, 65],
            83: [2, 65],
            84: [2, 65],
            85: [2, 65]
          }, {
            33: [2, 67],
            75: [2, 67]
          }, {
            23: [1, 124]
          }, {
            23: [2, 51],
            65: [2, 51],
            72: [2, 51],
            80: [2, 51],
            81: [2, 51],
            82: [2, 51],
            83: [2, 51],
            84: [2, 51],
            85: [2, 51]
          }, {
            23: [2, 53]
          }, {
            33: [1, 125]
          }, {
            33: [2, 91],
            65: [2, 91],
            72: [2, 91],
            80: [2, 91],
            81: [2, 91],
            82: [2, 91],
            83: [2, 91],
            84: [2, 91],
            85: [2, 91]
          }, {
            33: [2, 93]
          }, {
            5: [2, 22],
            14: [2, 22],
            15: [2, 22],
            19: [2, 22],
            29: [2, 22],
            34: [2, 22],
            39: [2, 22],
            44: [2, 22],
            47: [2, 22],
            48: [2, 22],
            51: [2, 22],
            55: [2, 22],
            60: [2, 22]
          }, {
            23: [2, 99],
            33: [2, 99],
            54: [2, 99],
            68: [2, 99],
            72: [2, 99],
            75: [2, 99]
          }, {
            73: [1, 109]
          }, {
            20: 75,
            63: 126,
            64: 76,
            65: [1, 44],
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            5: [2, 23],
            14: [2, 23],
            15: [2, 23],
            19: [2, 23],
            29: [2, 23],
            34: [2, 23],
            39: [2, 23],
            44: [2, 23],
            47: [2, 23],
            48: [2, 23],
            51: [2, 23],
            55: [2, 23],
            60: [2, 23]
          }, {
            47: [2, 19]
          }, {
            47: [2, 77]
          }, {
            20: 75,
            33: [2, 72],
            41: 127,
            63: 128,
            64: 76,
            65: [1, 44],
            69: 129,
            70: 77,
            71: 78,
            72: [1, 79],
            75: [2, 72],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            5: [2, 24],
            14: [2, 24],
            15: [2, 24],
            19: [2, 24],
            29: [2, 24],
            34: [2, 24],
            39: [2, 24],
            44: [2, 24],
            47: [2, 24],
            48: [2, 24],
            51: [2, 24],
            55: [2, 24],
            60: [2, 24]
          }, {
            68: [1, 130]
          }, {
            65: [2, 95],
            68: [2, 95],
            72: [2, 95],
            80: [2, 95],
            81: [2, 95],
            82: [2, 95],
            83: [2, 95],
            84: [2, 95],
            85: [2, 95]
          }, {
            68: [2, 97]
          }, {
            5: [2, 21],
            14: [2, 21],
            15: [2, 21],
            19: [2, 21],
            29: [2, 21],
            34: [2, 21],
            39: [2, 21],
            44: [2, 21],
            47: [2, 21],
            48: [2, 21],
            51: [2, 21],
            55: [2, 21],
            60: [2, 21]
          }, {
            33: [1, 131]
          }, {
            33: [2, 63]
          }, {
            72: [1, 133],
            76: 132
          }, {
            33: [1, 134]
          }, {
            33: [2, 69]
          }, {
            15: [2, 12]
          }, {
            14: [2, 26],
            15: [2, 26],
            19: [2, 26],
            29: [2, 26],
            34: [2, 26],
            47: [2, 26],
            48: [2, 26],
            51: [2, 26],
            55: [2, 26],
            60: [2, 26]
          }, {
            23: [2, 31],
            33: [2, 31],
            54: [2, 31],
            68: [2, 31],
            72: [2, 31],
            75: [2, 31]
          }, {
            33: [2, 74],
            42: 135,
            74: 136,
            75: [1, 121]
          }, {
            33: [2, 71],
            65: [2, 71],
            72: [2, 71],
            75: [2, 71],
            80: [2, 71],
            81: [2, 71],
            82: [2, 71],
            83: [2, 71],
            84: [2, 71],
            85: [2, 71]
          }, {
            33: [2, 73],
            75: [2, 73]
          }, {
            23: [2, 29],
            33: [2, 29],
            54: [2, 29],
            65: [2, 29],
            68: [2, 29],
            72: [2, 29],
            75: [2, 29],
            80: [2, 29],
            81: [2, 29],
            82: [2, 29],
            83: [2, 29],
            84: [2, 29],
            85: [2, 29]
          }, {
            14: [2, 15],
            15: [2, 15],
            19: [2, 15],
            29: [2, 15],
            34: [2, 15],
            39: [2, 15],
            44: [2, 15],
            47: [2, 15],
            48: [2, 15],
            51: [2, 15],
            55: [2, 15],
            60: [2, 15]
          }, {
            72: [1, 138],
            77: [1, 137]
          }, {
            72: [2, 100],
            77: [2, 100]
          }, {
            14: [2, 16],
            15: [2, 16],
            19: [2, 16],
            29: [2, 16],
            34: [2, 16],
            44: [2, 16],
            47: [2, 16],
            48: [2, 16],
            51: [2, 16],
            55: [2, 16],
            60: [2, 16]
          }, {
            33: [1, 139]
          }, {
            33: [2, 75]
          }, {
            33: [2, 32]
          }, {
            72: [2, 101],
            77: [2, 101]
          }, {
            14: [2, 17],
            15: [2, 17],
            19: [2, 17],
            29: [2, 17],
            34: [2, 17],
            39: [2, 17],
            44: [2, 17],
            47: [2, 17],
            48: [2, 17],
            51: [2, 17],
            55: [2, 17],
            60: [2, 17]
          }],
          defaultActions: {
            4: [2, 1],
            55: [2, 55],
            57: [2, 20],
            61: [2, 57],
            74: [2, 81],
            83: [2, 85],
            87: [2, 18],
            91: [2, 89],
            102: [2, 53],
            105: [2, 93],
            111: [2, 19],
            112: [2, 77],
            117: [2, 97],
            120: [2, 63],
            123: [2, 69],
            124: [2, 12],
            136: [2, 75],
            137: [2, 32]
          },
          parseError: function parseError(e, t) {
            throw new Error(e);
          },
          parse: function parse(e) {
            function t() {
              var e;
              return "number" != typeof (e = n.lexer.lex() || 1) && (e = n.symbols_[e] || e), e;
            }

            var n = this,
                i = [0],
                r = [null],
                o = [],
                a = this.table,
                s = "",
                l = 0,
                c = 0,
                u = 0;
            this.lexer.setInput(e), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {});
            var d = this.lexer.yylloc;
            o.push(d);
            var p = this.lexer.options && this.lexer.options.ranges;
            "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);

            for (var h, f, m, g, v, b, y, _, w, x = {};;) {
              if (m = i[i.length - 1], this.defaultActions[m] ? g = this.defaultActions[m] : (null != h || (h = t()), g = a[m] && a[m][h]), void 0 === g || !g.length || !g[0]) {
                var C = "";

                if (!u) {
                  for (b in w = [], a[m]) {
                    this.terminals_[b] && b > 2 && w.push("'" + this.terminals_[b] + "'");
                  }

                  C = this.lexer.showPosition ? "Parse error on line " + (l + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + w.join(", ") + ", got '" + (this.terminals_[h] || h) + "'" : "Parse error on line " + (l + 1) + ": Unexpected " + (1 == h ? "end of input" : "'" + (this.terminals_[h] || h) + "'"), this.parseError(C, {
                    text: this.lexer.match,
                    token: this.terminals_[h] || h,
                    line: this.lexer.yylineno,
                    loc: d,
                    expected: w
                  });
                }
              }

              if (g[0] instanceof Array && g.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + m + ", token: " + h);

              switch (g[0]) {
                case 1:
                  i.push(h), r.push(this.lexer.yytext), o.push(this.lexer.yylloc), i.push(g[1]), h = null, f ? (h = f, f = null) : (c = this.lexer.yyleng, s = this.lexer.yytext, l = this.lexer.yylineno, d = this.lexer.yylloc, u > 0 && u--);
                  break;

                case 2:
                  if (y = this.productions_[g[1]][1], x.$ = r[r.length - y], x._$ = {
                    first_line: o[o.length - (y || 1)].first_line,
                    last_line: o[o.length - 1].last_line,
                    first_column: o[o.length - (y || 1)].first_column,
                    last_column: o[o.length - 1].last_column
                  }, p && (x._$.range = [o[o.length - (y || 1)].range[0], o[o.length - 1].range[1]]), void 0 !== (v = this.performAction.call(x, s, c, l, this.yy, g[1], r, o))) return v;
                  y && (i = i.slice(0, -1 * y * 2), r = r.slice(0, -1 * y), o = o.slice(0, -1 * y)), i.push(this.productions_[g[1]][0]), r.push(x.$), o.push(x._$), _ = a[i[i.length - 2]][i[i.length - 1]], i.push(_);
                  break;

                case 3:
                  return !0;
              }
            }

            return !0;
          }
        },
            n = function () {
          var e = {
            EOF: 1,
            parseError: function parseError(e, t) {
              if (!this.yy.parser) throw new Error(e);
              this.yy.parser.parseError(e, t);
            },
            setInput: function setInput(e) {
              return this._input = e, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var e = this._input[0];
              this.yytext += e, this.yyleng++, this.offset++, this.match += e, this.matched += e;
              var t = e.match(/(?:\r\n?|\n).*/g);
              return t ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), e;
            },
            unput: function unput(e) {
              var t = e.length,
                  n = e.split(/(?:\r\n?|\n)/g);
              this._input = e + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - t - 1), this.offset -= t;
              var i = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var r = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === i.length ? this.yylloc.first_column : 0) + i[i.length - n.length].length - n[0].length : this.yylloc.first_column - t
              }, this.options.ranges && (this.yylloc.range = [r[0], r[0] + this.yyleng - t]), this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            less: function less(e) {
              this.unput(this.match.slice(e));
            },
            pastInput: function pastInput() {
              var e = this.matched.substr(0, this.matched.length - this.match.length);
              return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var e = this.match;
              return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var e = this.pastInput(),
                  t = new Array(e.length + 1).join("-");
              return e + this.upcomingInput() + "\n" + t + "^";
            },
            next: function next() {
              if (this.done) return this.EOF;
              var e, t, n, i, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var o = this._currentRules(), a = 0; a < o.length && (!(n = this._input.match(this.rules[o[a]])) || t && !(n[0].length > t[0].length) || (t = n, i = a, this.options.flex)); a++) {
                ;
              }

              return t ? ((r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], e = this.performAction.call(this, this.yy, this, o[i], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), e || void 0) : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              var e = this.next();
              return void 0 !== e ? e : this.lex();
            },
            begin: function begin(e) {
              this.conditionStack.push(e);
            },
            popState: function popState() {
              return this.conditionStack.pop();
            },
            _currentRules: function _currentRules() {
              return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function topState() {
              return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function pushState(e) {
              this.begin(e);
            },
            options: {},
            performAction: function performAction(e, t, n, i) {
              function r(e, n) {
                return t.yytext = t.yytext.substring(e, t.yyleng - n + e);
              }

              switch (n) {
                case 0:
                  if ("\\\\" === t.yytext.slice(-2) ? (r(0, 1), this.begin("mu")) : "\\" === t.yytext.slice(-1) ? (r(0, 1), this.begin("emu")) : this.begin("mu"), t.yytext) return 15;
                  break;

                case 1:
                  return 15;

                case 2:
                  return this.popState(), 15;

                case 3:
                  return this.begin("raw"), 15;

                case 4:
                  return this.popState(), "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : (r(5, 9), "END_RAW_BLOCK");

                case 5:
                  return 15;

                case 6:
                  return this.popState(), 14;

                case 7:
                  return 65;

                case 8:
                  return 68;

                case 9:
                  return 19;

                case 10:
                  return this.popState(), this.begin("raw"), 23;

                case 11:
                  return 55;

                case 12:
                  return 60;

                case 13:
                  return 29;

                case 14:
                  return 47;

                case 15:
                case 16:
                  return this.popState(), 44;

                case 17:
                  return 34;

                case 18:
                  return 39;

                case 19:
                  return 51;

                case 20:
                  return 48;

                case 21:
                  this.unput(t.yytext), this.popState(), this.begin("com");
                  break;

                case 22:
                  return this.popState(), 14;

                case 23:
                  return 48;

                case 24:
                  return 73;

                case 25:
                case 26:
                  return 72;

                case 27:
                  return 87;

                case 28:
                  break;

                case 29:
                  return this.popState(), 54;

                case 30:
                  return this.popState(), 33;

                case 31:
                  return t.yytext = r(1, 2).replace(/\\"/g, '"'), 80;

                case 32:
                  return t.yytext = r(1, 2).replace(/\\'/g, "'"), 80;

                case 33:
                  return 85;

                case 34:
                case 35:
                  return 82;

                case 36:
                  return 83;

                case 37:
                  return 84;

                case 38:
                  return 81;

                case 39:
                  return 75;

                case 40:
                  return 77;

                case 41:
                  return 72;

                case 42:
                  return t.yytext = t.yytext.replace(/\\([\\\]])/g, "$1"), 72;

                case 43:
                  return "INVALID";

                case 44:
                  return 5;
              }
            },
            rules: [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]*?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/],
            conditions: {
              mu: {
                rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
                inclusive: !1
              },
              emu: {
                rules: [2],
                inclusive: !1
              },
              com: {
                rules: [6],
                inclusive: !1
              },
              raw: {
                rules: [3, 4, 5],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 1, 44],
                inclusive: !0
              }
            }
          };
          return e;
        }();

        return t.lexer = n, e.prototype = t, t.Parser = e, new e();
      }();

      t["default"] = n, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      function i() {
        var e = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
        this.options = e;
      }

      function r(e, t, n) {
        void 0 === t && (t = e.length);
        var i = e[t - 1],
            r = e[t - 2];
        return i ? "ContentStatement" === i.type ? (r || !n ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(i.original) : void 0 : n;
      }

      function o(e, t, n) {
        void 0 === t && (t = -1);
        var i = e[t + 1],
            r = e[t + 2];
        return i ? "ContentStatement" === i.type ? (r || !n ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(i.original) : void 0 : n;
      }

      function a(e, t, n) {
        var i = e[null == t ? 0 : t + 1];

        if (i && "ContentStatement" === i.type && (n || !i.rightStripped)) {
          var r = i.value;
          i.value = i.value.replace(n ? /^\s+/ : /^[ \t]*\r?\n?/, ""), i.rightStripped = i.value !== r;
        }
      }

      function s(e, t, n) {
        var i = e[null == t ? e.length - 1 : t - 1];

        if (i && "ContentStatement" === i.type && (n || !i.leftStripped)) {
          var r = i.value;
          return i.value = i.value.replace(n ? /\s+$/ : /[ \t]+$/, ""), i.leftStripped = i.value !== r, i.leftStripped;
        }
      }

      var l = n(1)["default"];
      t.__esModule = !0;
      var c = n(39),
          u = l(c);
      i.prototype = new u["default"](), i.prototype.Program = function (e) {
        var t = !this.options.ignoreStandalone,
            n = !this.isRootSeen;
        this.isRootSeen = !0;

        for (var i = e.body, l = 0, c = i.length; l < c; l++) {
          var u = i[l],
              d = this.accept(u);

          if (d) {
            var p = r(i, l, n),
                h = o(i, l, n),
                f = d.openStandalone && p,
                m = d.closeStandalone && h,
                g = d.inlineStandalone && p && h;
            d.close && a(i, l, !0), d.open && s(i, l, !0), t && g && (a(i, l), s(i, l) && "PartialStatement" === u.type && (u.indent = /([ \t]+$)/.exec(i[l - 1].original)[1])), t && f && (a((u.program || u.inverse).body), s(i, l)), t && m && (a(i, l), s((u.inverse || u.program).body));
          }
        }

        return e;
      }, i.prototype.BlockStatement = i.prototype.DecoratorBlock = i.prototype.PartialBlockStatement = function (e) {
        this.accept(e.program), this.accept(e.inverse);
        var t = e.program || e.inverse,
            n = e.program && e.inverse,
            i = n,
            l = n;
        if (n && n.chained) for (i = n.body[0].program; l.chained;) {
          l = l.body[l.body.length - 1].program;
        }
        var c = {
          open: e.openStrip.open,
          close: e.closeStrip.close,
          openStandalone: o(t.body),
          closeStandalone: r((i || t).body)
        };

        if (e.openStrip.close && a(t.body, null, !0), n) {
          var u = e.inverseStrip;
          u.open && s(t.body, null, !0), u.close && a(i.body, null, !0), e.closeStrip.open && s(l.body, null, !0), !this.options.ignoreStandalone && r(t.body) && o(i.body) && (s(t.body), a(i.body));
        } else e.closeStrip.open && s(t.body, null, !0);

        return c;
      }, i.prototype.Decorator = i.prototype.MustacheStatement = function (e) {
        return e.strip;
      }, i.prototype.PartialStatement = i.prototype.CommentStatement = function (e) {
        var t = e.strip || {};
        return {
          inlineStandalone: !0,
          open: t.open,
          close: t.close
        };
      }, t["default"] = i, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      function i() {
        this.parents = [];
      }

      function r(e) {
        this.acceptRequired(e, "path"), this.acceptArray(e.params), this.acceptKey(e, "hash");
      }

      function o(e) {
        r.call(this, e), this.acceptKey(e, "program"), this.acceptKey(e, "inverse");
      }

      function a(e) {
        this.acceptRequired(e, "name"), this.acceptArray(e.params), this.acceptKey(e, "hash");
      }

      var s = n(1)["default"];
      t.__esModule = !0;
      var l = n(6),
          c = s(l);
      i.prototype = {
        constructor: i,
        mutating: !1,
        acceptKey: function acceptKey(e, t) {
          var n = this.accept(e[t]);

          if (this.mutating) {
            if (n && !i.prototype[n.type]) throw new c["default"]('Unexpected node type "' + n.type + '" found when accepting ' + t + " on " + e.type);
            e[t] = n;
          }
        },
        acceptRequired: function acceptRequired(e, t) {
          if (this.acceptKey(e, t), !e[t]) throw new c["default"](e.type + " requires " + t);
        },
        acceptArray: function acceptArray(e) {
          for (var t = 0, n = e.length; t < n; t++) {
            this.acceptKey(e, t), e[t] || (e.splice(t, 1), t--, n--);
          }
        },
        accept: function accept(e) {
          if (e) {
            if (!this[e.type]) throw new c["default"]("Unknown type: " + e.type, e);
            this.current && this.parents.unshift(this.current), this.current = e;
            var t = this[e.type](e);
            return this.current = this.parents.shift(), !this.mutating || t ? t : !1 !== t ? e : void 0;
          }
        },
        Program: function Program(e) {
          this.acceptArray(e.body);
        },
        MustacheStatement: r,
        Decorator: r,
        BlockStatement: o,
        DecoratorBlock: o,
        PartialStatement: a,
        PartialBlockStatement: function PartialBlockStatement(e) {
          a.call(this, e), this.acceptKey(e, "program");
        },
        ContentStatement: function ContentStatement() {},
        CommentStatement: function CommentStatement() {},
        SubExpression: r,
        PathExpression: function PathExpression() {},
        StringLiteral: function StringLiteral() {},
        NumberLiteral: function NumberLiteral() {},
        BooleanLiteral: function BooleanLiteral() {},
        UndefinedLiteral: function UndefinedLiteral() {},
        NullLiteral: function NullLiteral() {},
        Hash: function Hash(e) {
          this.acceptArray(e.pairs);
        },
        HashPair: function HashPair(e) {
          this.acceptRequired(e, "value");
        }
      }, t["default"] = i, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      function i(e, t) {
        if (t = t.path ? t.path.original : t, e.path.original !== t) {
          var n = {
            loc: e.path.loc
          };
          throw new a["default"](e.path.original + " doesn't match " + t, n);
        }
      }

      var r = n(1)["default"];
      t.__esModule = !0, t.SourceLocation = function (e, t) {
        this.source = e, this.start = {
          line: t.first_line,
          column: t.first_column
        }, this.end = {
          line: t.last_line,
          column: t.last_column
        };
      }, t.id = function (e) {
        return /^\[.*\]$/.test(e) ? e.substring(1, e.length - 1) : e;
      }, t.stripFlags = function (e, t) {
        return {
          open: "~" === e.charAt(2),
          close: "~" === t.charAt(t.length - 3)
        };
      }, t.stripComment = function (e) {
        return e.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
      }, t.preparePath = function (e, t, n) {
        n = this.locInfo(n);

        for (var i = e ? "@" : "", r = [], o = 0, s = 0, l = t.length; s < l; s++) {
          var c = t[s].part,
              u = t[s].original !== c;
          if (i += (t[s].separator || "") + c, u || ".." !== c && "." !== c && "this" !== c) r.push(c);else {
            if (r.length > 0) throw new a["default"]("Invalid path: " + i, {
              loc: n
            });
            ".." === c && o++;
          }
        }

        return {
          type: "PathExpression",
          data: e,
          depth: o,
          parts: r,
          original: i,
          loc: n
        };
      }, t.prepareMustache = function (e, t, n, i, r, o) {
        var a = i.charAt(3) || i.charAt(2),
            s = "{" !== a && "&" !== a;
        return {
          type: /\*/.test(i) ? "Decorator" : "MustacheStatement",
          path: e,
          params: t,
          hash: n,
          escaped: s,
          strip: r,
          loc: this.locInfo(o)
        };
      }, t.prepareRawBlock = function (e, t, n, r) {
        i(e, n), r = this.locInfo(r);
        var o = {
          type: "Program",
          body: t,
          strip: {},
          loc: r
        };
        return {
          type: "BlockStatement",
          path: e.path,
          params: e.params,
          hash: e.hash,
          program: o,
          openStrip: {},
          inverseStrip: {},
          closeStrip: {},
          loc: r
        };
      }, t.prepareBlock = function (e, t, n, r, o, s) {
        r && r.path && i(e, r);
        var l = /\*/.test(e.open);
        t.blockParams = e.blockParams;
        var c = void 0,
            u = void 0;

        if (n) {
          if (l) throw new a["default"]("Unexpected inverse block on decorator", n);
          n.chain && (n.program.body[0].closeStrip = r.strip), u = n.strip, c = n.program;
        }

        return o && (o = c, c = t, t = o), {
          type: l ? "DecoratorBlock" : "BlockStatement",
          path: e.path,
          params: e.params,
          hash: e.hash,
          program: t,
          inverse: c,
          openStrip: e.strip,
          inverseStrip: u,
          closeStrip: r && r.strip,
          loc: this.locInfo(s)
        };
      }, t.prepareProgram = function (e, t) {
        if (!t && e.length) {
          var n = e[0].loc,
              i = e[e.length - 1].loc;
          n && i && (t = {
            source: n.source,
            start: {
              line: n.start.line,
              column: n.start.column
            },
            end: {
              line: i.end.line,
              column: i.end.column
            }
          });
        }

        return {
          type: "Program",
          body: e,
          strip: {},
          loc: t
        };
      }, t.preparePartialBlock = function (e, t, n, r) {
        return i(e, n), {
          type: "PartialBlockStatement",
          name: e.path,
          params: e.params,
          hash: e.hash,
          program: t,
          openStrip: e.strip,
          closeStrip: n && n.strip,
          loc: this.locInfo(r)
        };
      };
      var o = n(6),
          a = r(o);
    }, function (e, t, n) {
      "use strict";

      function i() {}

      function r(e, t) {
        if (e === t) return !0;

        if (c.isArray(e) && c.isArray(t) && e.length === t.length) {
          for (var n = 0; n < e.length; n++) {
            if (!r(e[n], t[n])) return !1;
          }

          return !0;
        }
      }

      function o(e) {
        if (!e.path.parts) {
          var t = e.path;
          e.path = {
            type: "PathExpression",
            data: !1,
            depth: 0,
            parts: [t.original + ""],
            original: t.original + "",
            loc: t.loc
          };
        }
      }

      var a = n(1)["default"];
      t.__esModule = !0, t.Compiler = i, t.precompile = function (e, t, n) {
        if (null == e || "string" != typeof e && "Program" !== e.type) throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + e);
        "data" in (t = t || {}) || (t.data = !0), t.compat && (t.useDepths = !0);
        var i = n.parse(e, t),
            r = new n.Compiler().compile(i, t);
        return new n.JavaScriptCompiler().compile(r, t);
      }, t.compile = function (e, t, n) {
        function i() {
          var i = n.parse(e, t),
              r = new n.Compiler().compile(i, t),
              o = new n.JavaScriptCompiler().compile(r, t, void 0, !0);
          return n.template(o);
        }

        function r(e, t) {
          return o || (o = i()), o.call(this, e, t);
        }

        if (void 0 === t && (t = {}), null == e || "string" != typeof e && "Program" !== e.type) throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + e);
        "data" in (t = c.extend({}, t)) || (t.data = !0), t.compat && (t.useDepths = !0);
        var o = void 0;
        return r._setup = function (e) {
          return o || (o = i()), o._setup(e);
        }, r._child = function (e, t, n, r) {
          return o || (o = i()), o._child(e, t, n, r);
        }, r;
      };
      var s = n(6),
          l = a(s),
          c = n(5),
          u = n(35),
          d = a(u),
          p = [].slice;
      i.prototype = {
        compiler: i,
        equals: function equals(e) {
          var t = this.opcodes.length;
          if (e.opcodes.length !== t) return !1;

          for (var n = 0; n < t; n++) {
            var i = this.opcodes[n],
                o = e.opcodes[n];
            if (i.opcode !== o.opcode || !r(i.args, o.args)) return !1;
          }

          t = this.children.length;

          for (var n = 0; n < t; n++) {
            if (!this.children[n].equals(e.children[n])) return !1;
          }

          return !0;
        },
        guid: 0,
        compile: function compile(e, t) {
          this.sourceNode = [], this.opcodes = [], this.children = [], this.options = t, this.stringParams = t.stringParams, this.trackIds = t.trackIds, t.blockParams = t.blockParams || [];
          var n = t.knownHelpers;
          if (t.knownHelpers = {
            helperMissing: !0,
            blockHelperMissing: !0,
            each: !0,
            "if": !0,
            unless: !0,
            "with": !0,
            log: !0,
            lookup: !0
          }, n) for (var i in n) {
            this.options.knownHelpers[i] = n[i];
          }
          return this.accept(e);
        },
        compileProgram: function compileProgram(e) {
          var t = new this.compiler(),
              n = t.compile(e, this.options),
              i = this.guid++;
          return this.usePartial = this.usePartial || n.usePartial, this.children[i] = n, this.useDepths = this.useDepths || n.useDepths, i;
        },
        accept: function accept(e) {
          if (!this[e.type]) throw new l["default"]("Unknown type: " + e.type, e);
          this.sourceNode.unshift(e);
          var t = this[e.type](e);
          return this.sourceNode.shift(), t;
        },
        Program: function Program(e) {
          this.options.blockParams.unshift(e.blockParams);

          for (var t = e.body, n = t.length, i = 0; i < n; i++) {
            this.accept(t[i]);
          }

          return this.options.blockParams.shift(), this.isSimple = 1 === n, this.blockParams = e.blockParams ? e.blockParams.length : 0, this;
        },
        BlockStatement: function BlockStatement(e) {
          o(e);
          var t = e.program,
              n = e.inverse;
          t = t && this.compileProgram(t), n = n && this.compileProgram(n);
          var i = this.classifySexpr(e);
          "helper" === i ? this.helperSexpr(e, t, n) : "simple" === i ? (this.simpleSexpr(e), this.opcode("pushProgram", t), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("blockValue", e.path.original)) : (this.ambiguousSexpr(e, t, n), this.opcode("pushProgram", t), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append");
        },
        DecoratorBlock: function DecoratorBlock(e) {
          var t = e.program && this.compileProgram(e.program),
              n = this.setupFullMustacheParams(e, t, void 0),
              i = e.path;
          this.useDecorators = !0, this.opcode("registerDecorator", n.length, i.original);
        },
        PartialStatement: function PartialStatement(e) {
          this.usePartial = !0;
          var t = e.program;
          t && (t = this.compileProgram(e.program));
          var n = e.params;
          if (n.length > 1) throw new l["default"]("Unsupported number of partial arguments: " + n.length, e);
          n.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : n.push({
            type: "PathExpression",
            parts: [],
            depth: 0
          }));
          var i = e.name.original,
              r = "SubExpression" === e.name.type;
          r && this.accept(e.name), this.setupFullMustacheParams(e, t, void 0, !0);
          var o = e.indent || "";
          this.options.preventIndent && o && (this.opcode("appendContent", o), o = ""), this.opcode("invokePartial", r, i, o), this.opcode("append");
        },
        PartialBlockStatement: function PartialBlockStatement(e) {
          this.PartialStatement(e);
        },
        MustacheStatement: function MustacheStatement(e) {
          this.SubExpression(e), e.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
        },
        Decorator: function Decorator(e) {
          this.DecoratorBlock(e);
        },
        ContentStatement: function ContentStatement(e) {
          e.value && this.opcode("appendContent", e.value);
        },
        CommentStatement: function CommentStatement() {},
        SubExpression: function SubExpression(e) {
          o(e);
          var t = this.classifySexpr(e);
          "simple" === t ? this.simpleSexpr(e) : "helper" === t ? this.helperSexpr(e) : this.ambiguousSexpr(e);
        },
        ambiguousSexpr: function ambiguousSexpr(e, t, n) {
          var i = e.path,
              r = i.parts[0],
              o = null != t || null != n;
          this.opcode("getContext", i.depth), this.opcode("pushProgram", t), this.opcode("pushProgram", n), i.strict = !0, this.accept(i), this.opcode("invokeAmbiguous", r, o);
        },
        simpleSexpr: function simpleSexpr(e) {
          var t = e.path;
          t.strict = !0, this.accept(t), this.opcode("resolvePossibleLambda");
        },
        helperSexpr: function helperSexpr(e, t, n) {
          var i = this.setupFullMustacheParams(e, t, n),
              r = e.path,
              o = r.parts[0];
          if (this.options.knownHelpers[o]) this.opcode("invokeKnownHelper", i.length, o);else {
            if (this.options.knownHelpersOnly) throw new l["default"]("You specified knownHelpersOnly, but used the unknown helper " + o, e);
            r.strict = !0, r.falsy = !0, this.accept(r), this.opcode("invokeHelper", i.length, r.original, d["default"].helpers.simpleId(r));
          }
        },
        PathExpression: function PathExpression(e) {
          this.addDepth(e.depth), this.opcode("getContext", e.depth);
          var t = e.parts[0],
              n = d["default"].helpers.scopedId(e),
              i = !e.depth && !n && this.blockParamIndex(t);
          i ? this.opcode("lookupBlockParam", i, e.parts) : t ? e.data ? (this.options.data = !0, this.opcode("lookupData", e.depth, e.parts, e.strict)) : this.opcode("lookupOnContext", e.parts, e.falsy, e.strict, n) : this.opcode("pushContext");
        },
        StringLiteral: function StringLiteral(e) {
          this.opcode("pushString", e.value);
        },
        NumberLiteral: function NumberLiteral(e) {
          this.opcode("pushLiteral", e.value);
        },
        BooleanLiteral: function BooleanLiteral(e) {
          this.opcode("pushLiteral", e.value);
        },
        UndefinedLiteral: function UndefinedLiteral() {
          this.opcode("pushLiteral", "undefined");
        },
        NullLiteral: function NullLiteral() {
          this.opcode("pushLiteral", "null");
        },
        Hash: function Hash(e) {
          var t = e.pairs,
              n = 0,
              i = t.length;

          for (this.opcode("pushHash"); n < i; n++) {
            this.pushParam(t[n].value);
          }

          for (; n--;) {
            this.opcode("assignToHash", t[n].key);
          }

          this.opcode("popHash");
        },
        opcode: function opcode(e) {
          this.opcodes.push({
            opcode: e,
            args: p.call(arguments, 1),
            loc: this.sourceNode[0].loc
          });
        },
        addDepth: function addDepth(e) {
          e && (this.useDepths = !0);
        },
        classifySexpr: function classifySexpr(e) {
          var t = d["default"].helpers.simpleId(e.path),
              n = t && !!this.blockParamIndex(e.path.parts[0]),
              i = !n && d["default"].helpers.helperExpression(e),
              r = !n && (i || t);

          if (r && !i) {
            var o = e.path.parts[0],
                a = this.options;
            a.knownHelpers[o] ? i = !0 : a.knownHelpersOnly && (r = !1);
          }

          return i ? "helper" : r ? "ambiguous" : "simple";
        },
        pushParams: function pushParams(e) {
          for (var t = 0, n = e.length; t < n; t++) {
            this.pushParam(e[t]);
          }
        },
        pushParam: function pushParam(e) {
          var t = null != e.value ? e.value : e.original || "";
          if (this.stringParams) t.replace && (t = t.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")), e.depth && this.addDepth(e.depth), this.opcode("getContext", e.depth || 0), this.opcode("pushStringParam", t, e.type), "SubExpression" === e.type && this.accept(e);else {
            if (this.trackIds) {
              var n = void 0;

              if (!e.parts || d["default"].helpers.scopedId(e) || e.depth || (n = this.blockParamIndex(e.parts[0])), n) {
                var i = e.parts.slice(1).join(".");
                this.opcode("pushId", "BlockParam", n, i);
              } else (t = e.original || t).replace && (t = t.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "")), this.opcode("pushId", e.type, t);
            }

            this.accept(e);
          }
        },
        setupFullMustacheParams: function setupFullMustacheParams(e, t, n, i) {
          var r = e.params;
          return this.pushParams(r), this.opcode("pushProgram", t), this.opcode("pushProgram", n), e.hash ? this.accept(e.hash) : this.opcode("emptyHash", i), r;
        },
        blockParamIndex: function blockParamIndex(e) {
          for (var t = 0, n = this.options.blockParams.length; t < n; t++) {
            var i = this.options.blockParams[t],
                r = i && c.indexOf(i, e);
            if (i && r >= 0) return [t, r];
          }
        }
      };
    }, function (e, t, n) {
      "use strict";

      function i(e) {
        this.value = e;
      }

      function r() {}

      var o = n(1)["default"];
      t.__esModule = !0;
      var a = n(4),
          s = n(6),
          l = o(s),
          c = n(5),
          u = n(43),
          d = o(u);
      r.prototype = {
        nameLookup: function nameLookup(e, t) {
          return "constructor" === t ? ["(", e, ".propertyIsEnumerable('constructor') ? ", e, ".constructor : undefined", ")"] : r.isValidJavaScriptVariableName(t) ? [e, ".", t] : [e, "[", JSON.stringify(t), "]"];
        },
        depthedLookup: function depthedLookup(e) {
          return [this.aliasable("container.lookup"), '(depths, "', e, '")'];
        },
        compilerInfo: function compilerInfo() {
          var e = a.COMPILER_REVISION,
              t = a.REVISION_CHANGES[e];
          return [e, t];
        },
        appendToBuffer: function appendToBuffer(e, t, n) {
          return c.isArray(e) || (e = [e]), e = this.source.wrap(e, t), this.environment.isSimple ? ["return ", e, ";"] : n ? ["buffer += ", e, ";"] : (e.appendToBuffer = !0, e);
        },
        initializeBuffer: function initializeBuffer() {
          return this.quotedString("");
        },
        compile: function compile(e, t, n, i) {
          this.environment = e, this.options = t, this.stringParams = this.options.stringParams, this.trackIds = this.options.trackIds, this.precompile = !i, this.name = this.environment.name, this.isChild = !!n, this.context = n || {
            decorators: [],
            programs: [],
            environments: []
          }, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.aliases = {}, this.registers = {
            list: []
          }, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.blockParams = [], this.compileChildren(e, t), this.useDepths = this.useDepths || e.useDepths || e.useDecorators || this.options.compat, this.useBlockParams = this.useBlockParams || e.useBlockParams;
          var r = e.opcodes,
              o = void 0,
              a = void 0,
              s = void 0,
              c = void 0;

          for (s = 0, c = r.length; s < c; s++) {
            o = r[s], this.source.currentLocation = o.loc, a = a || o.loc, this[o.opcode].apply(this, o.args);
          }

          if (this.source.currentLocation = a, this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new l["default"]("Compile completed with content left on stack");
          this.decorators.isEmpty() ? this.decorators = void 0 : (this.useDecorators = !0, this.decorators.prepend("var decorators = container.decorators;\n"), this.decorators.push("return fn;"), i ? this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]) : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"), this.decorators.push("}\n"), this.decorators = this.decorators.merge()));
          var u = this.createFunctionContext(i);
          if (this.isChild) return u;
          var d = {
            compiler: this.compilerInfo(),
            main: u
          };
          this.decorators && (d.main_d = this.decorators, d.useDecorators = !0);
          var p = this.context,
              h = p.programs,
              f = p.decorators;

          for (s = 0, c = h.length; s < c; s++) {
            h[s] && (d[s] = h[s], f[s] && (d[s + "_d"] = f[s], d.useDecorators = !0));
          }

          return this.environment.usePartial && (d.usePartial = !0), this.options.data && (d.useData = !0), this.useDepths && (d.useDepths = !0), this.useBlockParams && (d.useBlockParams = !0), this.options.compat && (d.compat = !0), i ? d.compilerOptions = this.options : (d.compiler = JSON.stringify(d.compiler), this.source.currentLocation = {
            start: {
              line: 1,
              column: 0
            }
          }, d = this.objectLiteral(d), t.srcName ? (d = d.toStringWithSourceMap({
            file: t.destName
          })).map = d.map && d.map.toString() : d = d.toString()), d;
        },
        preamble: function preamble() {
          this.lastContext = 0, this.source = new d["default"](this.options.srcName), this.decorators = new d["default"](this.options.srcName);
        },
        createFunctionContext: function createFunctionContext(e) {
          var t = "",
              n = this.stackVars.concat(this.registers.list);
          n.length > 0 && (t += ", " + n.join(", "));
          var i = 0;

          for (var r in this.aliases) {
            var o = this.aliases[r];
            this.aliases.hasOwnProperty(r) && o.children && o.referenceCount > 1 && (t += ", alias" + ++i + "=" + r, o.children[0] = "alias" + i);
          }

          var a = ["container", "depth0", "helpers", "partials", "data"];
          (this.useBlockParams || this.useDepths) && a.push("blockParams"), this.useDepths && a.push("depths");
          var s = this.mergeSource(t);
          return e ? (a.push(s), Function.apply(this, a)) : this.source.wrap(["function(", a.join(","), ") {\n  ", s, "}"]);
        },
        mergeSource: function mergeSource(e) {
          var t = this.environment.isSimple,
              n = !this.forceBuffer,
              i = void 0,
              r = void 0,
              o = void 0,
              a = void 0;
          return this.source.each(function (e) {
            e.appendToBuffer ? (o ? e.prepend("  + ") : o = e, a = e) : (o && (r ? o.prepend("buffer += ") : i = !0, a.add(";"), o = a = void 0), r = !0, t || (n = !1));
          }), n ? o ? (o.prepend("return "), a.add(";")) : r || this.source.push('return "";') : (e += ", buffer = " + (i ? "" : this.initializeBuffer()), o ? (o.prepend("return buffer + "), a.add(";")) : this.source.push("return buffer;")), e && this.source.prepend("var " + e.substring(2) + (i ? "" : ";\n")), this.source.merge();
        },
        blockValue: function blockValue(e) {
          var t = this.aliasable("helpers.blockHelperMissing"),
              n = [this.contextName(0)];
          this.setupHelperArgs(e, 0, n);
          var i = this.popStack();
          n.splice(1, 0, i), this.push(this.source.functionCall(t, "call", n));
        },
        ambiguousBlockValue: function ambiguousBlockValue() {
          var e = this.aliasable("helpers.blockHelperMissing"),
              t = [this.contextName(0)];
          this.setupHelperArgs("", 0, t, !0), this.flushInline();
          var n = this.topStack();
          t.splice(1, 0, n), this.pushSource(["if (!", this.lastHelper, ") { ", n, " = ", this.source.functionCall(e, "call", t), "}"]);
        },
        appendContent: function appendContent(e) {
          this.pendingContent ? e = this.pendingContent + e : this.pendingLocation = this.source.currentLocation, this.pendingContent = e;
        },
        append: function append() {
          if (this.isInline()) this.replaceStack(function (e) {
            return [" != null ? ", e, ' : ""'];
          }), this.pushSource(this.appendToBuffer(this.popStack()));else {
            var e = this.popStack();
            this.pushSource(["if (", e, " != null) { ", this.appendToBuffer(e, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
          }
        },
        appendEscaped: function appendEscaped() {
          this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
        },
        getContext: function getContext(e) {
          this.lastContext = e;
        },
        pushContext: function pushContext() {
          this.pushStackLiteral(this.contextName(this.lastContext));
        },
        lookupOnContext: function lookupOnContext(e, t, n, i) {
          var r = 0;
          i || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(e[r++])), this.resolvePath("context", e, r, t, n);
        },
        lookupBlockParam: function lookupBlockParam(e, t) {
          this.useBlockParams = !0, this.push(["blockParams[", e[0], "][", e[1], "]"]), this.resolvePath("context", t, 1);
        },
        lookupData: function lookupData(e, t, n) {
          e ? this.pushStackLiteral("container.data(data, " + e + ")") : this.pushStackLiteral("data"), this.resolvePath("data", t, 0, !0, n);
        },
        resolvePath: function resolvePath(e, t, n, i, r) {
          var o = this;
          if (this.options.strict || this.options.assumeObjects) this.push(function (e, t, n, i) {
            var r = t.popStack(),
                o = 0,
                a = n.length;

            for (e && a--; o < a; o++) {
              r = t.nameLookup(r, n[o], i);
            }

            return e ? [t.aliasable("container.strict"), "(", r, ", ", t.quotedString(n[o]), ")"] : r;
          }(this.options.strict && r, this, t, e));else for (var a = t.length; n < a; n++) {
            this.replaceStack(function (r) {
              var a = o.nameLookup(r, t[n], e);
              return i ? [" && ", a] : [" != null ? ", a, " : ", r];
            });
          }
        },
        resolvePossibleLambda: function resolvePossibleLambda() {
          this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
        },
        pushStringParam: function pushStringParam(e, t) {
          this.pushContext(), this.pushString(t), "SubExpression" !== t && ("string" == typeof e ? this.pushString(e) : this.pushStackLiteral(e));
        },
        emptyHash: function emptyHash(e) {
          this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(e ? "undefined" : "{}");
        },
        pushHash: function pushHash() {
          this.hash && this.hashes.push(this.hash), this.hash = {
            values: [],
            types: [],
            contexts: [],
            ids: []
          };
        },
        popHash: function popHash() {
          var e = this.hash;
          this.hash = this.hashes.pop(), this.trackIds && this.push(this.objectLiteral(e.ids)), this.stringParams && (this.push(this.objectLiteral(e.contexts)), this.push(this.objectLiteral(e.types))), this.push(this.objectLiteral(e.values));
        },
        pushString: function pushString(e) {
          this.pushStackLiteral(this.quotedString(e));
        },
        pushLiteral: function pushLiteral(e) {
          this.pushStackLiteral(e);
        },
        pushProgram: function pushProgram(e) {
          null != e ? this.pushStackLiteral(this.programExpression(e)) : this.pushStackLiteral(null);
        },
        registerDecorator: function registerDecorator(e, t) {
          var n = this.nameLookup("decorators", t, "decorator"),
              i = this.setupHelperArgs(t, e);
          this.decorators.push(["fn = ", this.decorators.functionCall(n, "", ["fn", "props", "container", i]), " || fn;"]);
        },
        invokeHelper: function invokeHelper(e, t, n) {
          var i = this.popStack(),
              r = this.setupHelper(e, t),
              o = n ? [r.name, " || "] : "",
              a = ["("].concat(o, i);
          this.options.strict || a.push(" || ", this.aliasable("helpers.helperMissing")), a.push(")"), this.push(this.source.functionCall(a, "call", r.callParams));
        },
        invokeKnownHelper: function invokeKnownHelper(e, t) {
          var n = this.setupHelper(e, t);
          this.push(this.source.functionCall(n.name, "call", n.callParams));
        },
        invokeAmbiguous: function invokeAmbiguous(e, t) {
          this.useRegister("helper");
          var n = this.popStack();
          this.emptyHash();
          var i = this.setupHelper(0, e, t),
              r = this.lastHelper = this.nameLookup("helpers", e, "helper"),
              o = ["(", "(helper = ", r, " || ", n, ")"];
          this.options.strict || (o[0] = "(helper = ", o.push(" != null ? helper : ", this.aliasable("helpers.helperMissing"))), this.push(["(", o, i.paramsInit ? ["),(", i.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", i.callParams), " : helper))"]);
        },
        invokePartial: function invokePartial(e, t, n) {
          var i = [],
              r = this.setupParams(t, 1, i);
          e && (t = this.popStack(), delete r.name), n && (r.indent = JSON.stringify(n)), r.helpers = "helpers", r.partials = "partials", r.decorators = "container.decorators", e ? i.unshift(t) : i.unshift(this.nameLookup("partials", t, "partial")), this.options.compat && (r.depths = "depths"), r = this.objectLiteral(r), i.push(r), this.push(this.source.functionCall("container.invokePartial", "", i));
        },
        assignToHash: function assignToHash(e) {
          var t = this.popStack(),
              n = void 0,
              i = void 0,
              r = void 0;
          this.trackIds && (r = this.popStack()), this.stringParams && (i = this.popStack(), n = this.popStack());
          var o = this.hash;
          n && (o.contexts[e] = n), i && (o.types[e] = i), r && (o.ids[e] = r), o.values[e] = t;
        },
        pushId: function pushId(e, t, n) {
          "BlockParam" === e ? this.pushStackLiteral("blockParams[" + t[0] + "].path[" + t[1] + "]" + (n ? " + " + JSON.stringify("." + n) : "")) : "PathExpression" === e ? this.pushString(t) : "SubExpression" === e ? this.pushStackLiteral("true") : this.pushStackLiteral("null");
        },
        compiler: r,
        compileChildren: function compileChildren(e, t) {
          for (var n = e.children, i = void 0, r = void 0, o = 0, a = n.length; o < a; o++) {
            i = n[o], r = new this.compiler();
            var s = this.matchExistingProgram(i);

            if (null == s) {
              this.context.programs.push("");
              var l = this.context.programs.length;
              i.index = l, i.name = "program" + l, this.context.programs[l] = r.compile(i, t, this.context, !this.precompile), this.context.decorators[l] = r.decorators, this.context.environments[l] = i, this.useDepths = this.useDepths || r.useDepths, this.useBlockParams = this.useBlockParams || r.useBlockParams, i.useDepths = this.useDepths, i.useBlockParams = this.useBlockParams;
            } else i.index = s.index, i.name = "program" + s.index, this.useDepths = this.useDepths || s.useDepths, this.useBlockParams = this.useBlockParams || s.useBlockParams;
          }
        },
        matchExistingProgram: function matchExistingProgram(e) {
          for (var t = 0, n = this.context.environments.length; t < n; t++) {
            var i = this.context.environments[t];
            if (i && i.equals(e)) return i;
          }
        },
        programExpression: function programExpression(e) {
          var t = this.environment.children[e],
              n = [t.index, "data", t.blockParams];
          return (this.useBlockParams || this.useDepths) && n.push("blockParams"), this.useDepths && n.push("depths"), "container.program(" + n.join(", ") + ")";
        },
        useRegister: function useRegister(e) {
          this.registers[e] || (this.registers[e] = !0, this.registers.list.push(e));
        },
        push: function push(e) {
          return e instanceof i || (e = this.source.wrap(e)), this.inlineStack.push(e), e;
        },
        pushStackLiteral: function pushStackLiteral(e) {
          this.push(new i(e));
        },
        pushSource: function pushSource(e) {
          this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), this.pendingContent = void 0), e && this.source.push(e);
        },
        replaceStack: function replaceStack(e) {
          var t = ["("],
              n = void 0,
              r = void 0,
              o = void 0;
          if (!this.isInline()) throw new l["default"]("replaceStack on non-inline");
          var a = this.popStack(!0);
          if (a instanceof i) n = [a.value], t = ["(", n], o = !0;else {
            r = !0;
            var s = this.incrStack();
            t = ["((", this.push(s), " = ", a, ")"], n = this.topStack();
          }
          var c = e.call(this, n);
          o || this.popStack(), r && this.stackSlot--, this.push(t.concat(c, ")"));
        },
        incrStack: function incrStack() {
          return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
        },
        topStackName: function topStackName() {
          return "stack" + this.stackSlot;
        },
        flushInline: function flushInline() {
          var e = this.inlineStack;
          this.inlineStack = [];

          for (var t = 0, n = e.length; t < n; t++) {
            var r = e[t];
            if (r instanceof i) this.compileStack.push(r);else {
              var o = this.incrStack();
              this.pushSource([o, " = ", r, ";"]), this.compileStack.push(o);
            }
          }
        },
        isInline: function isInline() {
          return this.inlineStack.length;
        },
        popStack: function popStack(e) {
          var t = this.isInline(),
              n = (t ? this.inlineStack : this.compileStack).pop();
          if (!e && n instanceof i) return n.value;

          if (!t) {
            if (!this.stackSlot) throw new l["default"]("Invalid stack pop");
            this.stackSlot--;
          }

          return n;
        },
        topStack: function topStack() {
          var e = this.isInline() ? this.inlineStack : this.compileStack,
              t = e[e.length - 1];
          return t instanceof i ? t.value : t;
        },
        contextName: function contextName(e) {
          return this.useDepths && e ? "depths[" + e + "]" : "depth" + e;
        },
        quotedString: function quotedString(e) {
          return this.source.quotedString(e);
        },
        objectLiteral: function objectLiteral(e) {
          return this.source.objectLiteral(e);
        },
        aliasable: function aliasable(e) {
          var t = this.aliases[e];
          return t ? (t.referenceCount++, t) : ((t = this.aliases[e] = this.source.wrap(e)).aliasable = !0, t.referenceCount = 1, t);
        },
        setupHelper: function setupHelper(e, t, n) {
          var i = [],
              r = this.setupHelperArgs(t, e, i, n),
              o = this.nameLookup("helpers", t, "helper"),
              a = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
          return {
            params: i,
            paramsInit: r,
            name: o,
            callParams: [a].concat(i)
          };
        },
        setupParams: function setupParams(e, t, n) {
          var i = {},
              r = [],
              o = [],
              a = [],
              s = !n,
              l = void 0;
          s && (n = []), i.name = this.quotedString(e), i.hash = this.popStack(), this.trackIds && (i.hashIds = this.popStack()), this.stringParams && (i.hashTypes = this.popStack(), i.hashContexts = this.popStack());
          var c = this.popStack(),
              u = this.popStack();
          (u || c) && (i.fn = u || "container.noop", i.inverse = c || "container.noop");

          for (var d = t; d--;) {
            l = this.popStack(), n[d] = l, this.trackIds && (a[d] = this.popStack()), this.stringParams && (o[d] = this.popStack(), r[d] = this.popStack());
          }

          return s && (i.args = this.source.generateArray(n)), this.trackIds && (i.ids = this.source.generateArray(a)), this.stringParams && (i.types = this.source.generateArray(o), i.contexts = this.source.generateArray(r)), this.options.data && (i.data = "data"), this.useBlockParams && (i.blockParams = "blockParams"), i;
        },
        setupHelperArgs: function setupHelperArgs(e, t, n, i) {
          var r = this.setupParams(e, t, n);
          return r = this.objectLiteral(r), i ? (this.useRegister("options"), n.push("options"), ["options=", r]) : n ? (n.push(r), "") : r;
        }
      }, function () {
        for (var e = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "), t = r.RESERVED_WORDS = {}, n = 0, i = e.length; n < i; n++) {
          t[e[n]] = !0;
        }
      }(), r.isValidJavaScriptVariableName = function (e) {
        return !r.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e);
      }, t["default"] = r, e.exports = t["default"];
    }, function (e, t, n) {
      "use strict";

      function i(e, t, n) {
        if (o.isArray(e)) {
          for (var i = [], r = 0, a = e.length; r < a; r++) {
            i.push(t.wrap(e[r], n));
          }

          return i;
        }

        return "boolean" == typeof e || "number" == typeof e ? e + "" : e;
      }

      function r(e) {
        this.srcFile = e, this.source = [];
      }

      t.__esModule = !0;
      var o = n(5),
          a = void 0;
      a || ((a = function a(e, t, n, i) {
        this.src = "", i && this.add(i);
      }).prototype = {
        add: function add(e) {
          o.isArray(e) && (e = e.join("")), this.src += e;
        },
        prepend: function prepend(e) {
          o.isArray(e) && (e = e.join("")), this.src = e + this.src;
        },
        toStringWithSourceMap: function toStringWithSourceMap() {
          return {
            code: this.toString()
          };
        },
        toString: function toString() {
          return this.src;
        }
      }), r.prototype = {
        isEmpty: function isEmpty() {
          return !this.source.length;
        },
        prepend: function prepend(e, t) {
          this.source.unshift(this.wrap(e, t));
        },
        push: function push(e, t) {
          this.source.push(this.wrap(e, t));
        },
        merge: function merge() {
          var e = this.empty();
          return this.each(function (t) {
            e.add(["  ", t, "\n"]);
          }), e;
        },
        each: function each(e) {
          for (var t = 0, n = this.source.length; t < n; t++) {
            e(this.source[t]);
          }
        },
        empty: function empty() {
          var e = this.currentLocation || {
            start: {}
          };
          return new a(e.start.line, e.start.column, this.srcFile);
        },
        wrap: function wrap(e) {
          var t = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || {
            start: {}
          } : arguments[1];
          return e instanceof a ? e : (e = i(e, this, t), new a(t.start.line, t.start.column, this.srcFile, e));
        },
        functionCall: function functionCall(e, t, n) {
          return n = this.generateList(n), this.wrap([e, t ? "." + t + "(" : "(", n, ")"]);
        },
        quotedString: function quotedString(e) {
          return '"' + (e + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"';
        },
        objectLiteral: function objectLiteral(e) {
          var t = [];

          for (var n in e) {
            if (e.hasOwnProperty(n)) {
              var r = i(e[n], this);
              "undefined" !== r && t.push([this.quotedString(n), ":", r]);
            }
          }

          var o = this.generateList(t);
          return o.prepend("{"), o.add("}"), o;
        },
        generateList: function generateList(e) {
          for (var t = this.empty(), n = 0, r = e.length; n < r; n++) {
            n && t.add(","), t.add(i(e[n], this));
          }

          return t;
        },
        generateArray: function generateArray(e) {
          var t = this.generateList(e);
          return t.prepend("["), t.add("]"), t;
        }
      }, t["default"] = r, e.exports = t["default"];
    }]);
  }, function (e, t, n) {
    var i;
    /*!
     * numeral.js
     * version : 1.5.6
     * author : Adam Draper
     * license : MIT
     * http://adamwdraper.github.com/Numeral-js/
     */

    /*!
     * numeral.js
     * version : 1.5.6
     * author : Adam Draper
     * license : MIT
     * http://adamwdraper.github.com/Numeral-js/
     */

    (function () {
      var _n2,
          r = {},
          o = "en",
          a = null,
          s = "0,0",
          l = e.exports;

      function c(e) {
        this._value = e;
      }

      function u(e, t, n, i) {
        var r,
            o,
            a = Math.pow(10, t);
        return o = (n(e * a) / a).toFixed(t), i && (r = new RegExp("0{1," + i + "}$"), o = o.replace(r, "")), o;
      }

      function d(e, t, n) {
        return t.indexOf("$") > -1 ? function (e, t, n) {
          var i,
              a,
              s = t.indexOf("$"),
              l = t.indexOf("("),
              c = t.indexOf("-"),
              u = "";
          t.indexOf(" $") > -1 ? (u = " ", t = t.replace(" $", "")) : t.indexOf("$ ") > -1 ? (u = " ", t = t.replace("$ ", "")) : t = t.replace("$", "");
          a = h(e._value, t, n), s <= 1 ? a.indexOf("(") > -1 || a.indexOf("-") > -1 ? (a = a.split(""), i = 1, (s < l || s < c) && (i = 0), a.splice(i, 0, r[o].currency.symbol + u), a = a.join("")) : a = r[o].currency.symbol + u + a : a.indexOf(")") > -1 ? ((a = a.split("")).splice(-1, 0, u + r[o].currency.symbol), a = a.join("")) : a = a + u + r[o].currency.symbol;
          return a;
        }(e, t, n) : t.indexOf("%") > -1 ? function (e, t, n) {
          var i,
              r = "",
              o = 100 * e._value;
          t.indexOf(" %") > -1 ? (r = " ", t = t.replace(" %", "")) : t = t.replace("%", "");
          (i = h(o, t, n)).indexOf(")") > -1 ? ((i = i.split("")).splice(-1, 0, r + "%"), i = i.join("")) : i = i + r + "%";
          return i;
        }(e, t, n) : t.indexOf(":") > -1 ? function (e) {
          var t = Math.floor(e._value / 60 / 60),
              n = Math.floor((e._value - 60 * t * 60) / 60),
              i = Math.round(e._value - 60 * t * 60 - 60 * n);
          return t + ":" + (n < 10 ? "0" + n : n) + ":" + (i < 10 ? "0" + i : i);
        }(e) : h(e._value, t, n);
      }

      function p(e, t) {
        var n,
            i,
            s,
            l,
            c,
            u = t,
            d = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
            p = !1;
        if (t.indexOf(":") > -1) e._value = function (e) {
          var t = e.split(":"),
              n = 0;
          3 === t.length ? (n += 60 * Number(t[0]) * 60, n += 60 * Number(t[1]), n += Number(t[2])) : 2 === t.length && (n += 60 * Number(t[0]), n += Number(t[1]));
          return Number(n);
        }(t);else if (t === a) e._value = 0;else {
          for ("." !== r[o].delimiters.decimal && (t = t.replace(/\./g, "").replace(r[o].delimiters.decimal, ".")), n = new RegExp("[^a-zA-Z]" + r[o].abbreviations.thousand + "(?:\\)|(\\" + r[o].currency.symbol + ")?(?:\\))?)?$"), i = new RegExp("[^a-zA-Z]" + r[o].abbreviations.million + "(?:\\)|(\\" + r[o].currency.symbol + ")?(?:\\))?)?$"), s = new RegExp("[^a-zA-Z]" + r[o].abbreviations.billion + "(?:\\)|(\\" + r[o].currency.symbol + ")?(?:\\))?)?$"), l = new RegExp("[^a-zA-Z]" + r[o].abbreviations.trillion + "(?:\\)|(\\" + r[o].currency.symbol + ")?(?:\\))?)?$"), c = 0; c <= d.length && !(p = t.indexOf(d[c]) > -1 && Math.pow(1024, c + 1)); c++) {
            ;
          }

          e._value = (p || 1) * (u.match(n) ? Math.pow(10, 3) : 1) * (u.match(i) ? Math.pow(10, 6) : 1) * (u.match(s) ? Math.pow(10, 9) : 1) * (u.match(l) ? Math.pow(10, 12) : 1) * (t.indexOf("%") > -1 ? .01 : 1) * ((t.split("-").length + Math.min(t.split("(").length - 1, t.split(")").length - 1)) % 2 ? 1 : -1) * Number(t.replace(/[^0-9\.]+/g, "")), e._value = p ? Math.ceil(e._value) : e._value;
        }
        return e._value;
      }

      function h(e, t, n) {
        var i,
            s,
            l,
            c,
            d,
            p,
            h = !1,
            f = !1,
            m = !1,
            g = "",
            v = !1,
            b = !1,
            y = !1,
            _ = !1,
            w = !1,
            x = "",
            C = "",
            S = Math.abs(e),
            D = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
            E = "",
            k = !1;

        if (0 === e && null !== a) return a;
        if (t.indexOf("(") > -1 ? (h = !0, t = t.slice(1, -1)) : t.indexOf("+") > -1 && (f = !0, t = t.replace(/\+/g, "")), t.indexOf("a") > -1 && (v = t.indexOf("aK") >= 0, b = t.indexOf("aM") >= 0, y = t.indexOf("aB") >= 0, _ = t.indexOf("aT") >= 0, w = v || b || y || _, t.indexOf(" a") > -1 ? (g = " ", t = t.replace(" a", "")) : t = t.replace("a", ""), S >= Math.pow(10, 12) && !w || _ ? (g += r[o].abbreviations.trillion, e /= Math.pow(10, 12)) : S < Math.pow(10, 12) && S >= Math.pow(10, 9) && !w || y ? (g += r[o].abbreviations.billion, e /= Math.pow(10, 9)) : S < Math.pow(10, 9) && S >= Math.pow(10, 6) && !w || b ? (g += r[o].abbreviations.million, e /= Math.pow(10, 6)) : (S < Math.pow(10, 6) && S >= Math.pow(10, 3) && !w || v) && (g += r[o].abbreviations.thousand, e /= Math.pow(10, 3))), t.indexOf("b") > -1) for (t.indexOf(" b") > -1 ? (x = " ", t = t.replace(" b", "")) : t = t.replace("b", ""), l = 0; l <= D.length; l++) {
          if (i = Math.pow(1024, l), s = Math.pow(1024, l + 1), e >= i && e < s) {
            x += D[l], i > 0 && (e /= i);
            break;
          }
        }
        return t.indexOf("o") > -1 && (t.indexOf(" o") > -1 ? (C = " ", t = t.replace(" o", "")) : t = t.replace("o", ""), C += r[o].ordinal(e)), t.indexOf("[.]") > -1 && (m = !0, t = t.replace("[.]", ".")), c = e.toString().split(".")[0], d = t.split(".")[1], p = t.indexOf(","), d ? (c = (E = d.indexOf("[") > -1 ? u(e, (d = (d = d.replace("]", "")).split("["))[0].length + d[1].length, n, d[1].length) : u(e, d.length, n)).split(".")[0], E = E.split(".")[1].length ? r[o].delimiters.decimal + E.split(".")[1] : "", m && 0 === Number(E.slice(1)) && (E = "")) : c = u(e, null, n), c.indexOf("-") > -1 && (c = c.slice(1), k = !0), p > -1 && (c = c.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + r[o].delimiters.thousands)), 0 === t.indexOf(".") && (c = ""), (h && k ? "(" : "") + (!h && k ? "-" : "") + (!k && f ? "+" : "") + c + E + (C || "") + (g || "") + (x || "") + (h && k ? ")" : "");
      }

      function f(e) {
        var t = e.toString().split(".");
        return t.length < 2 ? 1 : Math.pow(10, t[1].length);
      }

      function m() {
        return Array.prototype.slice.call(arguments).reduce(function (e, t) {
          var n = f(e),
              i = f(t);
          return n > i ? n : i;
        }, -1 / 0);
      }

      (_n2 = function n(e) {
        return _n2.isNumeral(e) ? e = e.value() : 0 === e || void 0 === e ? e = 0 : Number(e) || (e = _n2.fn.unformat(e)), new c(Number(e));
      }).version = "1.5.6", _n2.isNumeral = function (e) {
        return e instanceof c;
      }, _n2.language = function (e, t) {
        if (!e) return o;

        if (e && !t) {
          if (!r[e]) throw new Error("Unknown language : " + e);
          o = e;
        }

        return !t && r[e] || function (e, t) {
          r[e] = t;
        }(e, t), _n2;
      }, _n2.languageData = function (e) {
        if (!e) return r[o];
        if (!r[e]) throw new Error("Unknown language : " + e);
        return r[e];
      }, _n2.language("en", {
        delimiters: {
          thousands: ",",
          decimal: "."
        },
        abbreviations: {
          thousand: "k",
          million: "m",
          billion: "b",
          trillion: "t"
        },
        ordinal: function ordinal(e) {
          var t = e % 10;
          return 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
        },
        currency: {
          symbol: "$"
        }
      }), _n2.zeroFormat = function (e) {
        a = "string" == typeof e ? e : null;
      }, _n2.defaultFormat = function (e) {
        s = "string" == typeof e ? e : "0.0";
      }, "function" != typeof Array.prototype.reduce && (Array.prototype.reduce = function (e, t) {
        "use strict";

        if (null == this) throw new TypeError("Array.prototype.reduce called on null or undefined");
        if ("function" != typeof e) throw new TypeError(e + " is not a function");
        var n,
            i,
            r = this.length >>> 0,
            o = !1;

        for (1 < arguments.length && (i = t, o = !0), n = 0; r > n; ++n) {
          this.hasOwnProperty(n) && (o ? i = e(i, this[n], n, this) : (i = this[n], o = !0));
        }

        if (!o) throw new TypeError("Reduce of empty array with no initial value");
        return i;
      }), _n2.fn = c.prototype = {
        clone: function clone() {
          return _n2(this);
        },
        format: function format(e, t) {
          return d(this, e || s, void 0 !== t ? t : Math.round);
        },
        unformat: function unformat(e) {
          return "[object Number]" === Object.prototype.toString.call(e) ? e : p(this, e || s);
        },
        value: function value() {
          return this._value;
        },
        valueOf: function valueOf() {
          return this._value;
        },
        set: function set(e) {
          return this._value = Number(e), this;
        },
        add: function add(e) {
          var t = m.call(null, this._value, e);
          return this._value = [this._value, e].reduce(function (e, n, i, r) {
            return e + t * n;
          }, 0) / t, this;
        },
        subtract: function subtract(e) {
          var t = m.call(null, this._value, e);
          return this._value = [e].reduce(function (e, n, i, r) {
            return e - t * n;
          }, this._value * t) / t, this;
        },
        multiply: function multiply(e) {
          return this._value = [this._value, e].reduce(function (e, t, n, i) {
            var r = m(e, t);
            return e * r * (t * r) / (r * r);
          }, 1), this;
        },
        divide: function divide(e) {
          return this._value = [this._value, e].reduce(function (e, t, n, i) {
            var r = m(e, t);
            return e * r / (t * r);
          }), this;
        },
        difference: function difference(e) {
          return Math.abs(_n2(this._value).subtract(e).value());
        }
      }, l && (e.exports = _n2), "undefined" == typeof ender && (this.numeral = _n2), void 0 === (i = function () {
        return _n2;
      }.apply(t, [])) || (e.exports = i);
    }).call(this);
  }, function (e, t, n) {
    var i, r;
    /**!
     * Sortable
     * @author	RubaXa   <trash@rubaxa.org>
     * @author	owenm    <owen23355@gmail.com>
     * @license MIT
     */

    /**!
     * Sortable
     * @author	RubaXa   <trash@rubaxa.org>
     * @author	owenm    <owen23355@gmail.com>
     * @license MIT
     */

    !function (o) {
      "use strict";

      void 0 === (r = "function" == typeof (i = o) ? i.call(t, n, t, e) : i) || (e.exports = r);
    }(function () {
      "use strict";

      if ("undefined" == typeof window || !window.document) return function () {
        throw new Error("Sortable.js requires a window with a document");
      };

      var e,
          t,
          n,
          i,
          r,
          o,
          a,
          s,
          l,
          c,
          u,
          d,
          p,
          h,
          f,
          m,
          g,
          v,
          b,
          y,
          _,
          w,
          x,
          C,
          S,
          D,
          E,
          k,
          T = [],
          O = !1,
          P = !1,
          A = !1,
          M = [],
          N = !1,
          I = !1,
          F = [],
          j = /\s+/g,
          L = "Sortable" + new Date().getTime(),
          R = window,
          H = R.document,
          B = R.parseInt,
          q = R.setTimeout,
          $ = R.jQuery || R.Zepto,
          W = R.Polymer,
          U = {
        capture: !1,
        passive: !1
      },
          Y = !!navigator.userAgent.match(/(?:Trident.*rv[ :]?11\.|msie|iemobile)/i),
          X = !!navigator.userAgent.match(/Edge/i),
          z = !!navigator.userAgent.match(/firefox/i),
          V = !(!navigator.userAgent.match(/safari/i) || navigator.userAgent.match(/chrome/i) || navigator.userAgent.match(/android/i)),
          K = !!navigator.userAgent.match(/iP(ad|od|hone)/i),
          Q = X || Y ? "cssFloat" : "float",
          Z = "draggable" in H.createElement("div"),
          G = function () {
        if (Y) return !1;
        var e = H.createElement("x");
        return e.style.cssText = "pointer-events:auto", "auto" === e.style.pointerEvents;
      }(),
          J = !1,
          ee = !1,
          te = Math.abs,
          ne = Math.min,
          ie = Math.max,
          re = [],
          oe = function oe(e, t) {
        var n = Se(e),
            i = B(n.width) - B(n.paddingLeft) - B(n.paddingRight) - B(n.borderLeftWidth) - B(n.borderRightWidth),
            r = Ae(e, 0, t),
            o = Ae(e, 1, t),
            a = r && Se(r),
            s = o && Se(o),
            l = a && B(a.marginLeft) + B(a.marginRight) + $e(r).width,
            c = s && B(s.marginLeft) + B(s.marginRight) + $e(o).width;
        if ("flex" === n.display) return "column" === n.flexDirection || "column-reverse" === n.flexDirection ? "vertical" : "horizontal";
        if ("grid" === n.display) return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";

        if (r && "none" !== a["float"]) {
          var u = "left" === a["float"] ? "left" : "right";
          return !o || "both" !== s.clear && s.clear !== u ? "horizontal" : "vertical";
        }

        return r && ("block" === a.display || "flex" === a.display || "table" === a.display || "grid" === a.display || l >= i && "none" === n[Q] || o && "none" === n[Q] && l + c > i) ? "vertical" : "horizontal";
      },
          ae = function ae(e, t, n, i, r) {
        var o = $e(n),
            a = "vertical" === i ? o.left : o.top,
            s = "vertical" === i ? o.right : o.bottom,
            l = "vertical" === i ? e : t;
        return a < l && l < s;
      },
          se = function se(e, t) {
        if (!e || !e.getBoundingClientRect) return le();
        var n = e,
            i = !1;

        do {
          if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
            var r = Se(n);

            if (n.clientWidth < n.scrollWidth && ("auto" == r.overflowX || "scroll" == r.overflowX) || n.clientHeight < n.scrollHeight && ("auto" == r.overflowY || "scroll" == r.overflowY)) {
              if (!n || !n.getBoundingClientRect || n === H.body) return le();
              if (i || t) return n;
              i = !0;
            }
          }
        } while (n = n.parentNode);

        return le();
      },
          le = function le() {
        return Y ? H.documentElement : H.scrollingElement;
      },
          ce = function ce(e, t, n) {
        e.scrollLeft += t, e.scrollTop += n;
      },
          ue = Le(function (e, t, n, i) {
        if (t.scroll) {
          var r = n ? n[L] : window,
              o = t.scrollSensitivity,
              a = t.scrollSpeed,
              u = e.clientX,
              d = e.clientY,
              p = le(),
              h = !1;
          l !== n && (de(), s = t.scroll, c = t.scrollFn, !0 === s && (s = se(n, !0), l = s));
          var f = 0,
              m = s;

          do {
            var g,
                v,
                b,
                y,
                w,
                x,
                C,
                S,
                D,
                E = m,
                k = $e(E),
                P = k.top,
                A = k.bottom,
                M = k.left,
                N = k.right,
                I = k.width,
                F = k.height;
            if (g = E.scrollWidth, v = E.scrollHeight, b = Se(E), S = E.scrollLeft, D = E.scrollTop, E === p ? (x = I < g && ("auto" === b.overflowX || "scroll" === b.overflowX || "visible" === b.overflowX), C = F < v && ("auto" === b.overflowY || "scroll" === b.overflowY || "visible" === b.overflowY)) : (x = I < g && ("auto" === b.overflowX || "scroll" === b.overflowX), C = F < v && ("auto" === b.overflowY || "scroll" === b.overflowY)), y = x && (te(N - u) <= o && S + I < g) - (te(M - u) <= o && !!S), w = C && (te(A - d) <= o && D + F < v) - (te(P - d) <= o && !!D), !T[f]) for (var j = 0; j <= f; j++) {
              T[j] || (T[j] = {});
            }
            T[f].vx == y && T[f].vy == w && T[f].el === E || (T[f].el = E, T[f].vx = y, T[f].vy = w, clearInterval(T[f].pid), !E || 0 == y && 0 == w || (h = !0, T[f].pid = setInterval(function () {
              i && 0 === this.layer && (be.active._emulateDragOver(!0), be.active._onTouchMove(_, !0));
              var t = T[this.layer].vy ? T[this.layer].vy * a : 0,
                  n = T[this.layer].vx ? T[this.layer].vx * a : 0;
              "function" == typeof c && "continue" !== c.call(r, n, t, e, _, T[this.layer].el) || ce(T[this.layer].el, n, t);
            }.bind({
              layer: f
            }), 24))), f++;
          } while (t.bubbleScroll && m !== p && (m = se(m, !1)));

          O = h;
        }
      }, 30),
          de = function de() {
        T.forEach(function (e) {
          clearInterval(e.pid);
        }), T = [];
      },
          pe = function pe(e) {
        function t(e, n) {
          return function (i, r, o, a) {
            var s = i.options.group.name && r.options.group.name && i.options.group.name === r.options.group.name;
            if (null == e && (n || s)) return !0;
            if (null == e || !1 === e) return !1;
            if (n && "clone" === e) return e;
            if ("function" == typeof e) return t(e(i, r, o, a), n)(i, r, o, a);
            var l = (n ? i : r).options.group.name;
            return !0 === e || "string" == typeof e && e === l || e.join && e.indexOf(l) > -1;
          };
        }

        var n = {},
            i = e.group;
        i && "object" == _typeof(i) || (i = {
          name: i
        }), n.name = i.name, n.checkPull = t(i.pull, !0), n.checkPut = t(i.put), n.revertClone = i.revertClone, e.group = n;
      },
          he = function he(t) {
        e && e.parentNode && e.parentNode[L] && e.parentNode[L]._computeIsAligned(t);
      },
          fe = function fe() {
        !G && n && Se(n, "display", "none");
      },
          me = function me() {
        !G && n && Se(n, "display", "");
      };

      H.addEventListener("click", function (e) {
        if (A) return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), A = !1, !1;
      }, !0);

      var ge,
          ve = function ve(t) {
        if (e) {
          var n = function (e, t) {
            for (var n = 0; n < M.length; n++) {
              if (!Me(M[n])) {
                var i = $e(M[n]),
                    r = M[n][L].options.emptyInsertThreshold,
                    o = e >= i.left - r && e <= i.right + r,
                    a = t >= i.top - r && t <= i.bottom + r;
                if (r && o && a) return M[n];
              }
            }
          }((t = t.touches ? t.touches[0] : t).clientX, t.clientY);

          if (n) {
            var i = {};

            for (var r in t) {
              i[r] = t[r];
            }

            i.target = i.rootEl = n, i.preventDefault = void 0, i.stopPropagation = void 0, n[L]._onDragOver(i);
          }
        }
      };

      function be(e, t) {
        if (!e || !e.nodeType || 1 !== e.nodeType) throw "Sortable: `el` must be HTMLElement, not " + {}.toString.call(e);
        this.el = e, this.options = t = Re({}, t), e[L] = this;
        var n = {
          group: null,
          sort: !0,
          disabled: !1,
          store: null,
          handle: null,
          scroll: !0,
          scrollSensitivity: 30,
          scrollSpeed: 10,
          bubbleScroll: !0,
          draggable: /[uo]l/i.test(e.nodeName) ? ">li" : ">*",
          swapThreshold: 1,
          invertSwap: !1,
          invertedSwapThreshold: null,
          removeCloneOnHide: !0,
          direction: function direction() {
            return oe(e, this.options);
          },
          ghostClass: "sortable-ghost",
          chosenClass: "sortable-chosen",
          dragClass: "sortable-drag",
          ignore: "a, img",
          filter: null,
          preventOnFilter: !0,
          animation: 0,
          easing: null,
          setData: function setData(e, t) {
            e.setData("Text", t.textContent);
          },
          dropBubble: !1,
          dragoverBubble: !1,
          dataIdAttr: "data-id",
          delay: 0,
          delayOnTouchOnly: !1,
          touchStartThreshold: B(window.devicePixelRatio, 10) || 1,
          forceFallback: !1,
          fallbackClass: "sortable-fallback",
          fallbackOnBody: !1,
          fallbackTolerance: 0,
          fallbackOffset: {
            x: 0,
            y: 0
          },
          supportPointer: !1 !== be.supportPointer && "PointerEvent" in window,
          emptyInsertThreshold: 5
        };

        for (var i in n) {
          !(i in t) && (t[i] = n[i]);
        }

        for (var r in pe(t), this) {
          "_" === r.charAt(0) && "function" == typeof this[r] && (this[r] = this[r].bind(this));
        }

        this.nativeDraggable = !t.forceFallback && Z, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? we(e, "pointerdown", this._onTapStart) : (we(e, "mousedown", this._onTapStart), we(e, "touchstart", this._onTapStart)), this.nativeDraggable && (we(e, "dragover", this), we(e, "dragenter", this)), M.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []);
      }

      function ye(e, t, n, i) {
        if (e) {
          n = n || H;

          do {
            if (null != t && (">" === t[0] ? e.parentNode === n && je(e, t) : je(e, t)) || i && e === n) return e;
            if (e === n) break;
          } while (e = _e(e));
        }

        return null;
      }

      function _e(e) {
        return e.host && e !== H && e.host.nodeType ? e.host : e.parentNode;
      }

      function we(e, t, n) {
        e.addEventListener(t, n, !Y && U);
      }

      function xe(e, t, n) {
        e.removeEventListener(t, n, !Y && U);
      }

      function Ce(e, t, n) {
        if (e && t) if (e.classList) e.classList[n ? "add" : "remove"](t);else {
          var i = (" " + e.className + " ").replace(j, " ").replace(" " + t + " ", " ");
          e.className = (i + (n ? " " + t : "")).replace(j, " ");
        }
      }

      function Se(e, t, n) {
        var i = e && e.style;

        if (i) {
          if (void 0 === n) return H.defaultView && H.defaultView.getComputedStyle ? n = H.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), void 0 === t ? n : n[t];
          t in i || -1 !== t.indexOf("webkit") || (t = "-webkit-" + t), i[t] = n + ("string" == typeof n ? "" : "px");
        }
      }

      function De(e) {
        var t = "";

        do {
          var n = Se(e, "transform");
          n && "none" !== n && (t = n + " " + t);
        } while (e = e.parentNode);

        return window.DOMMatrix ? new DOMMatrix(t) : window.WebKitCSSMatrix ? new WebKitCSSMatrix(t) : window.CSSMatrix ? new CSSMatrix(t) : void 0;
      }

      function Ee(e, t, n) {
        if (e) {
          var i = e.getElementsByTagName(t),
              r = 0,
              o = i.length;
          if (n) for (; r < o; r++) {
            n(i[r], r);
          }
          return i;
        }

        return [];
      }

      function ke(e, t, n, r, o, a, s, l, c, u, d) {
        var p,
            h = (e = e || t[L]).options,
            f = "on" + n.charAt(0).toUpperCase() + n.substr(1);
        !window.CustomEvent || Y || X ? (p = H.createEvent("Event")).initEvent(n, !0, !0) : p = new CustomEvent(n, {
          bubbles: !0,
          cancelable: !0
        }), p.to = o || t, p.from = a || t, p.item = r || t, p.clone = i, p.oldIndex = s, p.newIndex = l, p.oldDraggableIndex = c, p.newDraggableIndex = u, p.originalEvent = d, p.pullMode = m ? m.lastPutMode : void 0, t && t.dispatchEvent(p), h[f] && h[f].call(e, p);
      }

      function Te(e, t, n, i, r, o, a, s) {
        var l,
            c,
            u = e[L],
            d = u.options.onMove;
        return !window.CustomEvent || Y || X ? (l = H.createEvent("Event")).initEvent("move", !0, !0) : l = new CustomEvent("move", {
          bubbles: !0,
          cancelable: !0
        }), l.to = t, l.from = e, l.dragged = n, l.draggedRect = i, l.related = r || t, l.relatedRect = o || $e(t), l.willInsertAfter = s, l.originalEvent = a, e.dispatchEvent(l), d && (c = d.call(u, l, a)), c;
      }

      function Oe(e) {
        e.draggable = !1;
      }

      function Pe() {
        J = !1;
      }

      function Ae(t, i, r) {
        for (var o = 0, a = 0, s = t.children; a < s.length;) {
          if ("none" !== s[a].style.display && s[a] !== n && s[a] !== e && ye(s[a], r.draggable, t, !1)) {
            if (o === i) return s[a];
            o++;
          }

          a++;
        }

        return null;
      }

      function Me(e) {
        for (var t = e.lastElementChild; t && (t === n || "none" === Se(t, "display"));) {
          t = t.previousElementSibling;
        }

        return t || null;
      }

      function Ne(t) {
        return Fe(e) < Fe(t) ? 1 : -1;
      }

      function Ie(e) {
        for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, i = 0; n--;) {
          i += t.charCodeAt(n);
        }

        return i.toString(36);
      }

      function Fe(e, t) {
        var n = 0;
        if (!e || !e.parentNode) return -1;

        for (; e && (e = e.previousElementSibling);) {
          "TEMPLATE" === e.nodeName.toUpperCase() || e === i || t && !je(e, t) || n++;
        }

        return n;
      }

      function je(e, t) {
        if (t) {
          if (">" === t[0] && (t = t.substring(1)), e) try {
            if (e.matches) return e.matches(t);
            if (e.msMatchesSelector) return e.msMatchesSelector(t);
            if (e.webkitMatchesSelector) return e.webkitMatchesSelector(t);
          } catch (e) {
            return !1;
          }
          return !1;
        }
      }

      function Le(e, t) {
        return function () {
          if (!ge) {
            var n = arguments,
                i = this;
            ge = q(function () {
              1 === n.length ? e.call(i, n[0]) : e.apply(i, n), ge = void 0;
            }, t);
          }
        };
      }

      function Re(e, t) {
        if (e && t) for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
        return e;
      }

      function He(e) {
        return W && W.dom ? W.dom(e).cloneNode(!0) : $ ? $(e).clone(!0)[0] : e.cloneNode(!0);
      }

      function Be(e) {
        return q(e, 0);
      }

      function qe(e) {
        return clearTimeout(e);
      }

      function $e(e, t, n, i) {
        if (e.getBoundingClientRect || e === R) {
          var r, o, a, s, l, c, u;
          if (e !== R && e !== le() ? (o = (r = e.getBoundingClientRect()).top, a = r.left, s = r.bottom, l = r.right, c = r.height, u = r.width) : (o = 0, a = 0, s = window.innerHeight, l = window.innerWidth, c = window.innerHeight, u = window.innerWidth), i && e !== R && (n = n || e.parentNode, !Y)) do {
            if (n && n.getBoundingClientRect && "none" !== Se(n, "transform")) {
              var d = n.getBoundingClientRect();
              o -= d.top + B(Se(n, "border-top-width")), a -= d.left + B(Se(n, "border-left-width")), s = o + r.height, l = a + r.width;
              break;
            }
          } while (n = n.parentNode);

          if (t && e !== R) {
            var p = De(n || e),
                h = p && p.a,
                f = p && p.d;
            p && (s = (o /= f) + (c /= f), l = (a /= h) + (u /= h));
          }

          return {
            top: o,
            left: a,
            bottom: s,
            right: l,
            width: u,
            height: c
          };
        }
      }

      function We(e, t) {
        for (var n = se(e, !0), i = $e(e)[t]; n;) {
          var r = $e(n)[t];
          if (!("top" === t || "left" === t ? i >= r : i <= r)) return n;
          if (n === le()) break;
          n = se(n, !1);
        }

        return !1;
      }

      function Ue(e) {
        var t = 0,
            n = 0,
            i = le();
        if (e) do {
          var r = De(e),
              o = r.a,
              a = r.d;
          t += e.scrollLeft * o, n += e.scrollTop * a;
        } while (e !== i && (e = e.parentNode));
        return [t, n];
      }

      return be.prototype = {
        constructor: be,
        _computeIsAligned: function _computeIsAligned(t) {
          var i;

          if (n && !G ? (fe(), i = H.elementFromPoint(t.clientX, t.clientY), me()) : i = t.target, i = ye(i, this.options.draggable, this.el, !1), !ee && e && e.parentNode === this.el) {
            for (var r = this.el.children, o = 0; o < r.length; o++) {
              ye(r[o], this.options.draggable, this.el, !1) && r[o] !== i && (r[o].sortableMouseAligned = ae(t.clientX, t.clientY, r[o], this._getDirection(t, null), this.options));
            }

            ye(i, this.options.draggable, this.el, !0) || (x = null), ee = !0, q(function () {
              ee = !1;
            }, 30);
          }
        },
        _getDirection: function _getDirection(t, n) {
          return "function" == typeof this.options.direction ? this.options.direction.call(this, t, n, e) : this.options.direction;
        },
        _onTapStart: function _onTapStart(t) {
          if (t.cancelable) {
            var n,
                i,
                r = this,
                o = this.el,
                s = this.options,
                l = s.preventOnFilter,
                c = t.type,
                u = t.touches && t.touches[0],
                d = (u || t).target,
                p = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || d,
                h = s.filter;

            if (function (e) {
              re.length = 0;
              var t = e.getElementsByTagName("input"),
                  n = t.length;

              for (; n--;) {
                var i = t[n];
                i.checked && re.push(i);
              }
            }(o), !e && !(/mousedown|pointerdown/.test(c) && 0 !== t.button || s.disabled || p.isContentEditable || (d = ye(d, s.draggable, o, !1), a === d))) {
              if (n = Fe(d), i = Fe(d, s.draggable), "function" == typeof h) {
                if (h.call(this, t, d, this)) return ke(r, p, "filter", d, o, o, n, void 0, i), void (l && t.cancelable && t.preventDefault());
              } else if (h && (h = h.split(",").some(function (e) {
                if (e = ye(p, e.trim(), o, !1)) return ke(r, e, "filter", d, o, o, n, void 0, i), !0;
              }))) return void (l && t.cancelable && t.preventDefault());

              s.handle && !ye(p, s.handle, o, !1) || this._prepareDragStart(t, u, d, n, i);
            }
          }
        },
        _handleAutoScroll: function _handleAutoScroll(t, n) {
          if (e && this.options.scroll) {
            var i = t.clientX,
                r = t.clientY,
                o = H.elementFromPoint(i, r),
                a = this;

            if (n || X || Y || V) {
              ue(t, a.options, o, n);
              var s = se(o, !0);
              !O || g && i === v && r === b || (g && clearInterval(g), g = setInterval(function () {
                if (e) {
                  var o = se(H.elementFromPoint(i, r), !0);
                  o !== s && (s = o, de(), ue(t, a.options, s, n));
                }
              }, 10), v = i, b = r);
            } else {
              if (!a.options.bubbleScroll || se(o, !0) === le()) return void de();
              ue(t, a.options, se(o, !1), !1);
            }
          }
        },
        _prepareDragStart: function _prepareDragStart(n, i, s, l, c) {
          var d,
              h = this,
              m = h.el,
              g = h.options,
              v = m.ownerDocument;
          s && !e && s.parentNode === m && (r = m, t = (e = s).parentNode, o = e.nextSibling, a = s, f = g.group, u = l, p = c, y = {
            target: e,
            clientX: (i || n).clientX,
            clientY: (i || n).clientY
          }, this._lastX = (i || n).clientX, this._lastY = (i || n).clientY, e.style["will-change"] = "all", e.style.transition = "", e.style.transform = "", d = function d() {
            h._disableDelayedDragEvents(), !z && h.nativeDraggable && (e.draggable = !0), h._triggerDragStart(n, i), ke(h, r, "choose", e, r, r, u, void 0, p), Ce(e, g.chosenClass, !0);
          }, g.ignore.split(",").forEach(function (t) {
            Ee(e, t.trim(), Oe);
          }), we(v, "dragover", ve), we(v, "mousemove", ve), we(v, "touchmove", ve), we(v, "mouseup", h._onDrop), we(v, "touchend", h._onDrop), we(v, "touchcancel", h._onDrop), z && this.nativeDraggable && (this.options.touchStartThreshold = 4, e.draggable = !0), !g.delay || g.delayOnTouchOnly && !i || this.nativeDraggable && (X || Y) ? d() : (we(v, "mouseup", h._disableDelayedDrag), we(v, "touchend", h._disableDelayedDrag), we(v, "touchcancel", h._disableDelayedDrag), we(v, "mousemove", h._delayedDragTouchMoveHandler), we(v, "touchmove", h._delayedDragTouchMoveHandler), g.supportPointer && we(v, "pointermove", h._delayedDragTouchMoveHandler), h._dragStartTimer = q(d, g.delay)));
        },
        _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
          var t = e.touches ? e.touches[0] : e;
          ie(te(t.clientX - this._lastX), te(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
        },
        _disableDelayedDrag: function _disableDelayedDrag() {
          e && Oe(e), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
        },
        _disableDelayedDragEvents: function _disableDelayedDragEvents() {
          var e = this.el.ownerDocument;
          xe(e, "mouseup", this._disableDelayedDrag), xe(e, "touchend", this._disableDelayedDrag), xe(e, "touchcancel", this._disableDelayedDrag), xe(e, "mousemove", this._delayedDragTouchMoveHandler), xe(e, "touchmove", this._delayedDragTouchMoveHandler), xe(e, "pointermove", this._delayedDragTouchMoveHandler);
        },
        _triggerDragStart: function _triggerDragStart(t, n) {
          n = n || ("touch" == t.pointerType ? t : null), !this.nativeDraggable || n ? this.options.supportPointer ? we(H, "pointermove", this._onTouchMove) : we(H, n ? "touchmove" : "mousemove", this._onTouchMove) : (we(e, "dragend", this), we(r, "dragstart", this._onDragStart));

          try {
            H.selection ? Be(function () {
              H.selection.empty();
            }) : window.getSelection().removeAllRanges();
          } catch (e) {}
        },
        _dragStarted: function _dragStarted(t, n) {
          if (P = !1, r && e) {
            this.nativeDraggable && (we(H, "dragover", this._handleAutoScroll), we(H, "dragover", he));
            var i = this.options;
            !t && Ce(e, i.dragClass, !1), Ce(e, i.ghostClass, !0), Se(e, "transform", ""), be.active = this, t && this._appendGhost(), ke(this, r, "start", e, r, r, u, void 0, p, void 0, n);
          } else this._nulling();
        },
        _emulateDragOver: function _emulateDragOver(t) {
          if (_) {
            if (this._lastX === _.clientX && this._lastY === _.clientY && !t) return;
            this._lastX = _.clientX, this._lastY = _.clientY, fe();

            for (var n = H.elementFromPoint(_.clientX, _.clientY), i = n; n && n.shadowRoot && (n = n.shadowRoot.elementFromPoint(_.clientX, _.clientY)) !== i;) {
              i = n;
            }

            if (i) do {
              if (i[L]) if (i[L]._onDragOver({
                clientX: _.clientX,
                clientY: _.clientY,
                target: n,
                rootEl: i
              }) && !this.options.dragoverBubble) break;
              n = i;
            } while (i = i.parentNode);
            e.parentNode[L]._computeIsAligned(_), me();
          }
        },
        _onTouchMove: function _onTouchMove(e, t) {
          if (y) {
            var i = this.options,
                r = i.fallbackTolerance,
                o = i.fallbackOffset,
                a = e.touches ? e.touches[0] : e,
                s = n && De(n),
                l = n && s && s.a,
                c = n && s && s.d,
                u = K && E && Ue(E),
                d = (a.clientX - y.clientX + o.x) / (l || 1) + (u ? u[0] - F[0] : 0) / (l || 1),
                p = (a.clientY - y.clientY + o.y) / (c || 1) + (u ? u[1] - F[1] : 0) / (c || 1),
                h = e.touches ? "translate3d(" + d + "px," + p + "px,0)" : "translate(" + d + "px," + p + "px)";

            if (!be.active && !P) {
              if (r && ne(te(a.clientX - this._lastX), te(a.clientY - this._lastY)) < r) return;

              this._onDragStart(e, !0);
            }

            !t && this._handleAutoScroll(a, !0), w = !0, _ = a, Se(n, "webkitTransform", h), Se(n, "mozTransform", h), Se(n, "msTransform", h), Se(n, "transform", h), e.cancelable && e.preventDefault();
          }
        },
        _appendGhost: function _appendGhost() {
          if (!n) {
            var t = this.options.fallbackOnBody ? H.body : r,
                i = $e(e, !0, t, !K),
                o = (Se(e), this.options);

            if (K) {
              for (E = t; "static" === Se(E, "position") && "none" === Se(E, "transform") && E !== H;) {
                E = E.parentNode;
              }

              if (E !== H) {
                var a = $e(E, !0);
                i.top -= a.top, i.left -= a.left;
              }

              E !== H.body && E !== H.documentElement ? (E === H && (E = le()), i.top += E.scrollTop, i.left += E.scrollLeft) : E = le(), F = Ue(E);
            }

            Ce(n = e.cloneNode(!0), o.ghostClass, !1), Ce(n, o.fallbackClass, !0), Ce(n, o.dragClass, !0), Se(n, "box-sizing", "border-box"), Se(n, "margin", 0), Se(n, "top", i.top), Se(n, "left", i.left), Se(n, "width", i.width), Se(n, "height", i.height), Se(n, "opacity", "0.8"), Se(n, "position", K ? "absolute" : "fixed"), Se(n, "zIndex", "100000"), Se(n, "pointerEvents", "none"), t.appendChild(n);
          }
        },
        _onDragStart: function _onDragStart(t, n) {
          var o = this,
              a = t.dataTransfer,
              s = o.options;
          (i = He(e)).draggable = !1, i.style["will-change"] = "", this._hideClone(), Ce(i, o.options.chosenClass, !1), o._cloneId = Be(function () {
            o.options.removeCloneOnHide || r.insertBefore(i, e), ke(o, r, "clone", e);
          }), !n && Ce(e, s.dragClass, !0), n ? (A = !0, o._loopId = setInterval(o._emulateDragOver, 50)) : (xe(H, "mouseup", o._onDrop), xe(H, "touchend", o._onDrop), xe(H, "touchcancel", o._onDrop), a && (a.effectAllowed = "move", s.setData && s.setData.call(o, a, e)), we(H, "drop", o), Se(e, "transform", "translateZ(0)")), P = !0, o._dragStartId = Be(o._dragStarted.bind(o, n, t)), we(H, "selectstart", o), V && Se(H.body, "user-select", "none");
        },
        _onDragOver: function _onDragOver(n) {
          var i,
              a,
              s,
              l = this.el,
              c = n.target,
              d = this.options,
              h = d.group,
              g = be.active,
              v = f === h,
              b = d.sort,
              y = this;

          if (!J) {
            if (void 0 !== n.preventDefault && n.cancelable && n.preventDefault(), w = !0, c = ye(c, d.draggable, l, !0), e.contains(n.target) || c.animated) return U(!1);

            if (c !== e && (A = !1), g && !d.disabled && (v ? b || (s = !r.contains(e)) : m === this || (this.lastPutMode = f.checkPull(this, g, e, n)) && h.checkPut(this, g, e, n))) {
              var _ = this._getDirection(n, c);

              if (i = $e(e), s) return this._hideClone(), t = r, o ? r.insertBefore(e, o) : r.appendChild(e), U(!0);
              var E = Me(l);

              if (!E || function (e, t, n) {
                var i = $e(Me(n)),
                    r = "vertical" === t ? e.clientY : e.clientX,
                    o = "vertical" === t ? e.clientX : e.clientY,
                    a = "vertical" === t ? i.bottom : i.right,
                    s = "vertical" === t ? i.left : i.top,
                    l = "vertical" === t ? i.right : i.bottom;
                return "vertical" === t ? o > l + 10 || o <= l && r > a && o >= s : r > a && o > s || r <= a && o > l + 10;
              }(n, _, l) && !E.animated) {
                if (E && l === n.target && (c = E), c && (a = $e(c)), v ? g._hideClone() : g._showClone(this), !1 !== Te(r, l, e, i, c, a, n, !!c)) return l.appendChild(e), t = l, k = null, Y(), U(!0);
              } else if (c && c !== e && c.parentNode === l) {
                var T,
                    O = 0,
                    P = c.sortableMouseAligned,
                    M = e.parentNode !== l,
                    F = "vertical" === _ ? "top" : "left",
                    j = We(c, "top") || We(e, "top"),
                    R = j ? j.scrollTop : void 0;
                if (x !== c && (S = null, T = $e(c)[F], N = !1), function (t, n, i) {
                  var r = t === e && k || $e(t),
                      o = n === e && k || $e(n),
                      a = "vertical" === i ? r.left : r.top,
                      s = "vertical" === i ? r.right : r.bottom,
                      l = "vertical" === i ? r.width : r.height,
                      c = "vertical" === i ? o.left : o.top,
                      u = "vertical" === i ? o.right : o.bottom,
                      d = "vertical" === i ? o.width : o.height;
                  return a === c || s === u || a + l / 2 === c + d / 2;
                }(e, c, _) && P || M || j || d.invertSwap || "insert" === S || "swap" === S ? ("swap" !== S && (I = d.invertSwap || M), O = function (t, n, i, r, o, a, s) {
                  var l = $e(n),
                      c = "vertical" === i ? t.clientY : t.clientX,
                      u = "vertical" === i ? l.height : l.width,
                      d = "vertical" === i ? l.top : l.left,
                      p = "vertical" === i ? l.bottom : l.right,
                      h = $e(e),
                      f = !1;
                  if (!a) if (s && D < u * r) {
                    if (!N && (1 === C ? c > d + u * o / 2 : c < p - u * o / 2) && (N = !0), N) f = !0;else {
                      "vertical" === i ? h.top : h.left, "vertical" === i ? h.bottom : h.right;
                      if (1 === C ? c < d + D : c > p - D) return -1 * C;
                    }
                  } else if (c > d + u * (1 - r) / 2 && c < p - u * (1 - r) / 2) return Ne(n);
                  if ((f = f || a) && (c < d + u * o / 2 || c > p - u * o / 2)) return c > d + u / 2 ? 1 : -1;
                  return 0;
                }(n, c, _, d.swapThreshold, null == d.invertedSwapThreshold ? d.swapThreshold : d.invertedSwapThreshold, I, x === c), S = "swap") : (O = Ne(c), S = "insert"), 0 === O) return U(!1);
                k = null, x = c, C = O, a = $e(c);
                var B = c.nextElementSibling,
                    $ = !1,
                    W = Te(r, l, e, i, c, a, n, $ = 1 === O);
                if (!1 !== W) return 1 !== W && -1 !== W || ($ = 1 === W), J = !0, q(Pe, 30), v ? g._hideClone() : g._showClone(this), $ && !B ? l.appendChild(e) : c.parentNode.insertBefore(e, $ ? B : c), j && ce(j, 0, R - j.scrollTop), t = e.parentNode, void 0 === T || I || (D = te(T - $e(c)[F])), Y(), U(!0);
              }

              if (l.contains(e)) return U(!1);
            }

            return !1;
          }

          function U(t) {
            return t && (v ? g._hideClone() : g._showClone(y), g && (Ce(e, m ? m.options.ghostClass : g.options.ghostClass, !1), Ce(e, d.ghostClass, !0)), m !== y && y !== be.active ? m = y : y === be.active && (m = null), i && y._animate(i, e), c && a && y._animate(a, c)), (c === e && !e.animated || c === l && !c.animated) && (x = null), d.dragoverBubble || n.rootEl || c === H || (y._handleAutoScroll(n), e.parentNode[L]._computeIsAligned(n), !t && ve(n)), !d.dragoverBubble && n.stopPropagation && n.stopPropagation(), !0;
          }

          function Y() {
            ke(y, r, "change", c, l, r, u, Fe(e), p, Fe(e, d.draggable), n);
          }
        },
        _animate: function _animate(t, n) {
          var i = this.options.animation;

          if (i) {
            var r = $e(n);

            if (n === e && (k = r), 1 === t.nodeType && (t = $e(t)), t.left + t.width / 2 !== r.left + r.width / 2 || t.top + t.height / 2 !== r.top + r.height / 2) {
              var o = De(this.el),
                  a = o && o.a,
                  s = o && o.d;
              Se(n, "transition", "none"), Se(n, "transform", "translate3d(" + (t.left - r.left) / (a || 1) + "px," + (t.top - r.top) / (s || 1) + "px,0)"), this._repaint(n), Se(n, "transition", "transform " + i + "ms" + (this.options.easing ? " " + this.options.easing : "")), Se(n, "transform", "translate3d(0,0,0)");
            }

            "number" == typeof n.animated && clearTimeout(n.animated), n.animated = q(function () {
              Se(n, "transition", ""), Se(n, "transform", ""), n.animated = !1;
            }, i);
          }
        },
        _repaint: function _repaint(e) {
          return e.offsetWidth;
        },
        _offMoveEvents: function _offMoveEvents() {
          xe(H, "touchmove", this._onTouchMove), xe(H, "pointermove", this._onTouchMove), xe(H, "dragover", ve), xe(H, "mousemove", ve), xe(H, "touchmove", ve);
        },
        _offUpEvents: function _offUpEvents() {
          var e = this.el.ownerDocument;
          xe(e, "mouseup", this._onDrop), xe(e, "touchend", this._onDrop), xe(e, "pointerup", this._onDrop), xe(e, "touchcancel", this._onDrop), xe(H, "selectstart", this);
        },
        _onDrop: function _onDrop(a) {
          var s = this.el,
              l = this.options;
          P = !1, O = !1, I = !1, N = !1, clearInterval(this._loopId), clearInterval(g), de(), clearTimeout(ge), ge = void 0, clearTimeout(this._dragStartTimer), qe(this._cloneId), qe(this._dragStartId), xe(H, "mousemove", this._onTouchMove), this.nativeDraggable && (xe(H, "drop", this), xe(s, "dragstart", this._onDragStart), xe(H, "dragover", this._handleAutoScroll), xe(H, "dragover", he)), V && Se(H.body, "user-select", ""), this._offMoveEvents(), this._offUpEvents(), a && (w && (a.cancelable && a.preventDefault(), !l.dropBubble && a.stopPropagation()), n && n.parentNode && n.parentNode.removeChild(n), (r === t || m && "clone" !== m.lastPutMode) && i && i.parentNode && i.parentNode.removeChild(i), e && (this.nativeDraggable && xe(e, "dragend", this), Oe(e), e.style["will-change"] = "", Ce(e, m ? m.options.ghostClass : this.options.ghostClass, !1), Ce(e, this.options.chosenClass, !1), ke(this, r, "unchoose", e, t, r, u, null, p, null, a), r !== t ? (d = Fe(e), h = Fe(e, l.draggable), d >= 0 && (ke(null, t, "add", e, t, r, u, d, p, h, a), ke(this, r, "remove", e, t, r, u, d, p, h, a), ke(null, t, "sort", e, t, r, u, d, p, h, a), ke(this, r, "sort", e, t, r, u, d, p, h, a)), m && m.save()) : e.nextSibling !== o && (d = Fe(e), h = Fe(e, l.draggable), d >= 0 && (ke(this, r, "update", e, t, r, u, d, p, h, a), ke(this, r, "sort", e, t, r, u, d, p, h, a))), be.active && (null != d && -1 !== d || (d = u, h = p), ke(this, r, "end", e, t, r, u, d, p, h, a), this.save()))), this._nulling();
        },
        _nulling: function _nulling() {
          r = e = t = n = o = i = a = s = l = T.length = g = v = b = y = _ = w = d = u = x = C = k = m = f = be.active = null, re.forEach(function (e) {
            e.checked = !0;
          }), re.length = 0;
        },
        handleEvent: function handleEvent(t) {
          switch (t.type) {
            case "drop":
            case "dragend":
              this._onDrop(t);

              break;

            case "dragenter":
            case "dragover":
              e && (this._onDragOver(t), function (e) {
                e.dataTransfer && (e.dataTransfer.dropEffect = "move");
                e.cancelable && e.preventDefault();
              }(t));
              break;

            case "selectstart":
              t.preventDefault();
          }
        },
        toArray: function toArray() {
          for (var e, t = [], n = this.el.children, i = 0, r = n.length, o = this.options; i < r; i++) {
            ye(e = n[i], o.draggable, this.el, !1) && t.push(e.getAttribute(o.dataIdAttr) || Ie(e));
          }

          return t;
        },
        sort: function sort(e) {
          var t = {},
              n = this.el;
          this.toArray().forEach(function (e, i) {
            var r = n.children[i];
            ye(r, this.options.draggable, n, !1) && (t[e] = r);
          }, this), e.forEach(function (e) {
            t[e] && (n.removeChild(t[e]), n.appendChild(t[e]));
          });
        },
        save: function save() {
          var e = this.options.store;
          e && e.set && e.set(this);
        },
        closest: function closest(e, t) {
          return ye(e, t || this.options.draggable, this.el, !1);
        },
        option: function option(e, t) {
          var n = this.options;
          if (void 0 === t) return n[e];
          n[e] = t, "group" === e && pe(n);
        },
        destroy: function destroy() {
          var e = this.el;
          e[L] = null, xe(e, "mousedown", this._onTapStart), xe(e, "touchstart", this._onTapStart), xe(e, "pointerdown", this._onTapStart), this.nativeDraggable && (xe(e, "dragover", this), xe(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function (e) {
            e.removeAttribute("draggable");
          }), this._onDrop(), M.splice(M.indexOf(this.el), 1), this.el = e = null;
        },
        _hideClone: function _hideClone() {
          i.cloneHidden || (Se(i, "display", "none"), i.cloneHidden = !0, i.parentNode && this.options.removeCloneOnHide && i.parentNode.removeChild(i));
        },
        _showClone: function _showClone(t) {
          "clone" === t.lastPutMode ? i.cloneHidden && (r.contains(e) && !this.options.group.revertClone ? r.insertBefore(i, e) : o ? r.insertBefore(i, o) : r.appendChild(i), this.options.group.revertClone && this._animate(e, i), Se(i, "display", ""), i.cloneHidden = !1) : this._hideClone();
        }
      }, we(H, "touchmove", function (e) {
        (be.active || P) && e.cancelable && e.preventDefault();
      }), be.utils = {
        on: we,
        off: xe,
        css: Se,
        find: Ee,
        is: function is(e, t) {
          return !!ye(e, t, e, !1);
        },
        extend: Re,
        throttle: Le,
        closest: ye,
        toggleClass: Ce,
        clone: He,
        index: Fe,
        nextTick: Be,
        cancelNextTick: qe,
        detectDirection: oe,
        getChild: Ae
      }, be.create = function (e, t) {
        return new be(e, t);
      }, be.version = "1.9.0", be;
    });
  }, function (e, t, n) {
    (function (e) {
      (function (e) {
        e.ui = e.ui || {}, e.ui.version = "1.12.1";
        var t,
            n = 0,
            i = Array.prototype.slice;
        /*!
           * jQuery UI Widget 1.12.1
           * http://jqueryui.com
           *
           * Copyright jQuery Foundation and other contributors
           * Released under the MIT license.
           * http://jquery.org/license
           */

        e.cleanData = (t = e.cleanData, function (n) {
          var i, r, o;

          for (o = 0; null != (r = n[o]); o++) {
            try {
              (i = e._data(r, "events")) && i.remove && e(r).triggerHandler("remove");
            } catch (e) {}
          }

          t(n);
        }), e.widget = function (t, n, i) {
          var r,
              o,
              a,
              s = {},
              l = t.split(".")[0],
              c = l + "-" + (t = t.split(".")[1]);
          return i || (i = n, n = e.Widget), e.isArray(i) && (i = e.extend.apply(null, [{}].concat(i))), e.expr[":"][c.toLowerCase()] = function (t) {
            return !!e.data(t, c);
          }, e[l] = e[l] || {}, r = e[l][t], o = e[l][t] = function (e, t) {
            if (!this._createWidget) return new o(e, t);
            arguments.length && this._createWidget(e, t);
          }, e.extend(o, r, {
            version: i.version,
            _proto: e.extend({}, i),
            _childConstructors: []
          }), (a = new n()).options = e.widget.extend({}, a.options), e.each(i, function (t, i) {
            e.isFunction(i) ? s[t] = function () {
              function e() {
                return n.prototype[t].apply(this, arguments);
              }

              function r(e) {
                return n.prototype[t].apply(this, e);
              }

              return function () {
                var t,
                    n = this._super,
                    o = this._superApply;
                return this._super = e, this._superApply = r, t = i.apply(this, arguments), this._super = n, this._superApply = o, t;
              };
            }() : s[t] = i;
          }), o.prototype = e.widget.extend(a, {
            widgetEventPrefix: r && a.widgetEventPrefix || t
          }, s, {
            constructor: o,
            namespace: l,
            widgetName: t,
            widgetFullName: c
          }), r ? (e.each(r._childConstructors, function (t, n) {
            var i = n.prototype;
            e.widget(i.namespace + "." + i.widgetName, o, n._proto);
          }), delete r._childConstructors) : n._childConstructors.push(o), e.widget.bridge(t, o), o;
        }, e.widget.extend = function (t) {
          for (var n, r, o = i.call(arguments, 1), a = 0, s = o.length; a < s; a++) {
            for (n in o[a]) {
              r = o[a][n], o[a].hasOwnProperty(n) && void 0 !== r && (e.isPlainObject(r) ? t[n] = e.isPlainObject(t[n]) ? e.widget.extend({}, t[n], r) : e.widget.extend({}, r) : t[n] = r);
            }
          }

          return t;
        }, e.widget.bridge = function (t, n) {
          var r = n.prototype.widgetFullName || t;

          e.fn[t] = function (o) {
            var a = "string" == typeof o,
                s = i.call(arguments, 1),
                l = this;
            return a ? this.length || "instance" !== o ? this.each(function () {
              var n,
                  i = e.data(this, r);
              return "instance" === o ? (l = i, !1) : i ? e.isFunction(i[o]) && "_" !== o.charAt(0) ? (n = i[o].apply(i, s)) !== i && void 0 !== n ? (l = n && n.jquery ? l.pushStack(n.get()) : n, !1) : void 0 : e.error("no such method '" + o + "' for " + t + " widget instance") : e.error("cannot call methods on " + t + " prior to initialization; attempted to call method '" + o + "'");
            }) : l = void 0 : (s.length && (o = e.widget.extend.apply(null, [o].concat(s))), this.each(function () {
              var t = e.data(this, r);
              t ? (t.option(o || {}), t._init && t._init()) : e.data(this, r, new n(o, this));
            })), l;
          };
        }, e.Widget = function () {}, e.Widget._childConstructors = [], e.Widget.prototype = {
          widgetName: "widget",
          widgetEventPrefix: "",
          defaultElement: "<div>",
          options: {
            classes: {},
            disabled: !1,
            create: null
          },
          _createWidget: function _createWidget(t, i) {
            i = e(i || this.defaultElement || this)[0], this.element = e(i), this.uuid = n++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = e(), this.hoverable = e(), this.focusable = e(), this.classesElementLookup = {}, i !== this && (e.data(i, this.widgetFullName, this), this._on(!0, this.element, {
              remove: function remove(e) {
                e.target === i && this.destroy();
              }
            }), this.document = e(i.style ? i.ownerDocument : i.document || i), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init();
          },
          _getCreateOptions: function _getCreateOptions() {
            return {};
          },
          _getCreateEventData: e.noop,
          _create: e.noop,
          _init: e.noop,
          destroy: function destroy() {
            var t = this;
            this._destroy(), e.each(this.classesElementLookup, function (e, n) {
              t._removeClass(n, e);
            }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace);
          },
          _destroy: e.noop,
          widget: function widget() {
            return this.element;
          },
          option: function option(t, n) {
            var i,
                r,
                o,
                a = t;
            if (0 === arguments.length) return e.widget.extend({}, this.options);
            if ("string" == typeof t) if (a = {}, i = t.split("."), t = i.shift(), i.length) {
              for (r = a[t] = e.widget.extend({}, this.options[t]), o = 0; o < i.length - 1; o++) {
                r[i[o]] = r[i[o]] || {}, r = r[i[o]];
              }

              if (t = i.pop(), 1 === arguments.length) return void 0 === r[t] ? null : r[t];
              r[t] = n;
            } else {
              if (1 === arguments.length) return void 0 === this.options[t] ? null : this.options[t];
              a[t] = n;
            }
            return this._setOptions(a), this;
          },
          _setOptions: function _setOptions(e) {
            var t;

            for (t in e) {
              this._setOption(t, e[t]);
            }

            return this;
          },
          _setOption: function _setOption(e, t) {
            return "classes" === e && this._setOptionClasses(t), this.options[e] = t, "disabled" === e && this._setOptionDisabled(t), this;
          },
          _setOptionClasses: function _setOptionClasses(t) {
            var n, i, r;

            for (n in t) {
              r = this.classesElementLookup[n], t[n] !== this.options.classes[n] && r && r.length && (i = e(r.get()), this._removeClass(r, n), i.addClass(this._classes({
                element: i,
                keys: n,
                classes: t,
                add: !0
              })));
            }
          },
          _setOptionDisabled: function _setOptionDisabled(e) {
            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!e), e && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"));
          },
          enable: function enable() {
            return this._setOptions({
              disabled: !1
            });
          },
          disable: function disable() {
            return this._setOptions({
              disabled: !0
            });
          },
          _classes: function _classes(t) {
            var n = [],
                i = this;

            function r(r, o) {
              var a, s;

              for (s = 0; s < r.length; s++) {
                a = i.classesElementLookup[r[s]] || e(), a = t.add ? e(e.unique(a.get().concat(t.element.get()))) : e(a.not(t.element).get()), i.classesElementLookup[r[s]] = a, n.push(r[s]), o && t.classes[r[s]] && n.push(t.classes[r[s]]);
              }
            }

            return t = e.extend({
              element: this.element,
              classes: this.options.classes || {}
            }, t), this._on(t.element, {
              remove: "_untrackClassesElement"
            }), t.keys && r(t.keys.match(/\S+/g) || [], !0), t.extra && r(t.extra.match(/\S+/g) || []), n.join(" ");
          },
          _untrackClassesElement: function _untrackClassesElement(t) {
            var n = this;
            e.each(n.classesElementLookup, function (i, r) {
              -1 !== e.inArray(t.target, r) && (n.classesElementLookup[i] = e(r.not(t.target).get()));
            });
          },
          _removeClass: function _removeClass(e, t, n) {
            return this._toggleClass(e, t, n, !1);
          },
          _addClass: function _addClass(e, t, n) {
            return this._toggleClass(e, t, n, !0);
          },
          _toggleClass: function _toggleClass(e, t, n, i) {
            i = "boolean" == typeof i ? i : n;
            var r = "string" == typeof e || null === e,
                o = {
              extra: r ? t : n,
              keys: r ? e : t,
              element: r ? this.element : e,
              add: i
            };
            return o.element.toggleClass(this._classes(o), i), this;
          },
          _on: function _on(t, n, i) {
            var r,
                o = this;
            "boolean" != typeof t && (i = n, n = t, t = !1), i ? (n = r = e(n), this.bindings = this.bindings.add(n)) : (i = n, n = this.element, r = this.widget()), e.each(i, function (i, a) {
              function s() {
                if (t || !0 !== o.options.disabled && !e(this).hasClass("ui-state-disabled")) return ("string" == typeof a ? o[a] : a).apply(o, arguments);
              }

              "string" != typeof a && (s.guid = a.guid = a.guid || s.guid || e.guid++);
              var l = i.match(/^([\w:-]*)\s*(.*)$/),
                  c = l[1] + o.eventNamespace,
                  u = l[2];
              u ? r.on(c, u, s) : n.on(c, s);
            });
          },
          _off: function _off(t, n) {
            n = (n || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, t.off(n).off(n), this.bindings = e(this.bindings.not(t).get()), this.focusable = e(this.focusable.not(t).get()), this.hoverable = e(this.hoverable.not(t).get());
          },
          _delay: function _delay(e, t) {
            var n = this;
            return setTimeout(function () {
              return ("string" == typeof e ? n[e] : e).apply(n, arguments);
            }, t || 0);
          },
          _hoverable: function _hoverable(t) {
            this.hoverable = this.hoverable.add(t), this._on(t, {
              mouseenter: function mouseenter(t) {
                this._addClass(e(t.currentTarget), null, "ui-state-hover");
              },
              mouseleave: function mouseleave(t) {
                this._removeClass(e(t.currentTarget), null, "ui-state-hover");
              }
            });
          },
          _focusable: function _focusable(t) {
            this.focusable = this.focusable.add(t), this._on(t, {
              focusin: function focusin(t) {
                this._addClass(e(t.currentTarget), null, "ui-state-focus");
              },
              focusout: function focusout(t) {
                this._removeClass(e(t.currentTarget), null, "ui-state-focus");
              }
            });
          },
          _trigger: function _trigger(t, n, i) {
            var r,
                o,
                a = this.options[t];
            if (i = i || {}, (n = e.Event(n)).type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), n.target = this.element[0], o = n.originalEvent) for (r in o) {
              r in n || (n[r] = o[r]);
            }
            return this.element.trigger(n, i), !(e.isFunction(a) && !1 === a.apply(this.element[0], [n].concat(i)) || n.isDefaultPrevented());
          }
        }, e.each({
          show: "fadeIn",
          hide: "fadeOut"
        }, function (t, n) {
          e.Widget.prototype["_" + t] = function (i, r, o) {
            var a;
            "string" == typeof r && (r = {
              effect: r
            });
            var s = r ? !0 === r || "number" == typeof r ? n : r.effect || n : t;
            "number" == typeof (r = r || {}) && (r = {
              duration: r
            }), a = !e.isEmptyObject(r), r.complete = o, r.delay && i.delay(r.delay), a && e.effects && e.effects.effect[s] ? i[t](r) : s !== t && i[s] ? i[s](r.duration, r.easing, o) : i.queue(function (n) {
              e(this)[t](), o && o.call(i[0]), n();
            });
          };
        }), e.widget;
      })(e);
    }).call(this, n(0));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e(window.jQuery);
    }(function (e) {
      "use strict";

      var t = 0,
          n = e,
          i = "parseJSON";
      "JSON" in window && "parse" in JSON && (n = JSON, i = "parse"), e.ajaxTransport("iframe", function (n) {
        if (n.async) {
          var i,
              r,
              o,
              a = n.initialIframeSrc || "javascript:false;";
          return {
            send: function send(s, l) {
              (i = e('<form style="display:none;"></form>')).attr("accept-charset", n.formAcceptCharset), o = /\?/.test(n.url) ? "&" : "?", "DELETE" === n.type ? (n.url = n.url + o + "_method=DELETE", n.type = "POST") : "PUT" === n.type ? (n.url = n.url + o + "_method=PUT", n.type = "POST") : "PATCH" === n.type && (n.url = n.url + o + "_method=PATCH", n.type = "POST"), r = e('<iframe src="' + a + '" name="iframe-transport-' + (t += 1) + '"></iframe>').bind("load", function () {
                var t,
                    o = e.isArray(n.paramName) ? n.paramName : [n.paramName];
                r.unbind("load").bind("load", function () {
                  var t;

                  try {
                    if (!(t = r.contents()).length || !t[0].firstChild) throw new Error();
                  } catch (e) {
                    t = void 0;
                  }

                  l(200, "success", {
                    iframe: t
                  }), e('<iframe src="' + a + '"></iframe>').appendTo(i), window.setTimeout(function () {
                    i.remove();
                  }, 0);
                }), i.prop("target", r.prop("name")).prop("action", n.url).prop("method", n.type), n.formData && e.each(n.formData, function (t, n) {
                  e('<input type="hidden"/>').prop("name", n.name).val(n.value).appendTo(i);
                }), n.fileInput && n.fileInput.length && "POST" === n.type && (t = n.fileInput.clone(), n.fileInput.after(function (e) {
                  return t[e];
                }), n.paramName && n.fileInput.each(function (t) {
                  e(this).prop("name", o[t] || n.paramName);
                }), i.append(n.fileInput).prop("enctype", "multipart/form-data").prop("encoding", "multipart/form-data"), n.fileInput.removeAttr("form")), i.submit(), t && t.length && n.fileInput.each(function (n, i) {
                  var r = e(t[n]);
                  e(i).prop("name", r.prop("name")).attr("form", r.attr("form")), r.replaceWith(i);
                });
              }), i.append(r).appendTo(document.body);
            },
            abort: function abort() {
              r && r.unbind("load").prop("src", a), i && i.remove();
            }
          };
        }
      }), e.ajaxSetup({
        converters: {
          "iframe text": function iframeText(t) {
            return t && e(t[0].body).text();
          },
          "iframe json": function iframeJson(t) {
            return t && n[i](e(t[0].body).text());
          },
          "iframe html": function iframeHtml(t) {
            return t && e(t[0].body).html();
          },
          "iframe xml": function iframeXml(t) {
            var n = t && t[0];
            return n && e.isXMLDoc(n) ? n : e.parseXML(n.XMLDocument && n.XMLDocument.xml || e(n.body).html());
          },
          "iframe script": function iframeScript(t) {
            return t && e.globalEval(e(t[0].body).text());
          }
        }
      });
    });
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e(window.jQuery);
    }(function (e) {
      "use strict";

      function t(t) {
        var n = "dragover" === t;
        return function (i) {
          i.dataTransfer = i.originalEvent && i.originalEvent.dataTransfer;
          var r = i.dataTransfer;
          r && -1 !== e.inArray("Files", r.types) && !1 !== this._trigger(t, e.Event(t, {
            delegatedEvent: i
          })) && (i.preventDefault(), n && (r.dropEffect = "copy"));
        };
      }

      e.support.fileInput = !(new RegExp("(Android (1\\.[0156]|2\\.[01]))|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)|(w(eb)?OSBrowser)|(webOS)|(Kindle/(1\\.0|2\\.[05]|3\\.0))").test(window.navigator.userAgent) || e('<input type="file"/>').prop("disabled")), e.support.xhrFileUpload = !(!window.ProgressEvent || !window.FileReader), e.support.xhrFormDataFileUpload = !!window.FormData, e.support.blobSlice = window.Blob && (Blob.prototype.slice || Blob.prototype.webkitSlice || Blob.prototype.mozSlice), e.widget("blueimp.fileupload", {
        options: {
          dropZone: e(document),
          pasteZone: void 0,
          fileInput: void 0,
          replaceFileInput: !0,
          paramName: void 0,
          singleFileUploads: !0,
          limitMultiFileUploads: void 0,
          limitMultiFileUploadSize: void 0,
          limitMultiFileUploadSizeOverhead: 512,
          sequentialUploads: !1,
          limitConcurrentUploads: void 0,
          forceIframeTransport: !1,
          redirect: void 0,
          redirectParamName: void 0,
          postMessage: void 0,
          multipart: !0,
          maxChunkSize: void 0,
          uploadedBytes: void 0,
          recalculateProgress: !0,
          progressInterval: 100,
          bitrateInterval: 500,
          autoUpload: !0,
          uniqueFilenames: void 0,
          messages: {
            uploadedBytes: "Uploaded bytes exceed file size"
          },
          i18n: function i18n(t, n) {
            return t = this.messages[t] || t.toString(), n && e.each(n, function (e, n) {
              t = t.replace("{" + e + "}", n);
            }), t;
          },
          formData: function formData(e) {
            return e.serializeArray();
          },
          add: function add(t, n) {
            if (t.isDefaultPrevented()) return !1;
            (n.autoUpload || !1 !== n.autoUpload && e(this).fileupload("option", "autoUpload")) && n.process().done(function () {
              n.submit();
            });
          },
          processData: !1,
          contentType: !1,
          cache: !1,
          timeout: 0
        },
        _specialOptions: ["fileInput", "dropZone", "pasteZone", "multipart", "forceIframeTransport"],
        _blobSlice: e.support.blobSlice && function () {
          var e = this.slice || this.webkitSlice || this.mozSlice;
          return e.apply(this, arguments);
        },
        _BitrateTimer: function _BitrateTimer() {
          this.timestamp = Date.now ? Date.now() : new Date().getTime(), this.loaded = 0, this.bitrate = 0, this.getBitrate = function (e, t, n) {
            var i = e - this.timestamp;
            return (!this.bitrate || !n || i > n) && (this.bitrate = (t - this.loaded) * (1e3 / i) * 8, this.loaded = t, this.timestamp = e), this.bitrate;
          };
        },
        _isXHRUpload: function _isXHRUpload(t) {
          return !t.forceIframeTransport && (!t.multipart && e.support.xhrFileUpload || e.support.xhrFormDataFileUpload);
        },
        _getFormData: function _getFormData(t) {
          var n;
          return "function" === e.type(t.formData) ? t.formData(t.form) : e.isArray(t.formData) ? t.formData : "object" === e.type(t.formData) ? (n = [], e.each(t.formData, function (e, t) {
            n.push({
              name: e,
              value: t
            });
          }), n) : [];
        },
        _getTotal: function _getTotal(t) {
          var n = 0;
          return e.each(t, function (e, t) {
            n += t.size || 1;
          }), n;
        },
        _initProgressObject: function _initProgressObject(t) {
          var n = {
            loaded: 0,
            total: 0,
            bitrate: 0
          };
          t._progress ? e.extend(t._progress, n) : t._progress = n;
        },
        _initResponseObject: function _initResponseObject(e) {
          var t;
          if (e._response) for (t in e._response) {
            e._response.hasOwnProperty(t) && delete e._response[t];
          } else e._response = {};
        },
        _onProgress: function _onProgress(t, n) {
          if (t.lengthComputable) {
            var i,
                r = Date.now ? Date.now() : new Date().getTime();
            if (n._time && n.progressInterval && r - n._time < n.progressInterval && t.loaded !== t.total) return;
            n._time = r, i = Math.floor(t.loaded / t.total * (n.chunkSize || n._progress.total)) + (n.uploadedBytes || 0), this._progress.loaded += i - n._progress.loaded, this._progress.bitrate = this._bitrateTimer.getBitrate(r, this._progress.loaded, n.bitrateInterval), n._progress.loaded = n.loaded = i, n._progress.bitrate = n.bitrate = n._bitrateTimer.getBitrate(r, i, n.bitrateInterval), this._trigger("progress", e.Event("progress", {
              delegatedEvent: t
            }), n), this._trigger("progressall", e.Event("progressall", {
              delegatedEvent: t
            }), this._progress);
          }
        },
        _initProgressListener: function _initProgressListener(t) {
          var n = this,
              i = t.xhr ? t.xhr() : e.ajaxSettings.xhr();
          i.upload && (e(i.upload).bind("progress", function (e) {
            var i = e.originalEvent;
            e.lengthComputable = i.lengthComputable, e.loaded = i.loaded, e.total = i.total, n._onProgress(e, t);
          }), t.xhr = function () {
            return i;
          });
        },
        _deinitProgressListener: function _deinitProgressListener(t) {
          var n = t.xhr ? t.xhr() : e.ajaxSettings.xhr();
          n.upload && e(n.upload).unbind("progress");
        },
        _isInstanceOf: function _isInstanceOf(e, t) {
          return Object.prototype.toString.call(t) === "[object " + e + "]";
        },
        _getUniqueFilename: function _getUniqueFilename(e, t) {
          return t[e = String(e)] ? (e = e.replace(/(?: \(([\d]+)\))?(\.[^.]+)?$/, function (e, t, n) {
            return " (" + (t ? Number(t) + 1 : 1) + ")" + (n || "");
          }), this._getUniqueFilename(e, t)) : (t[e] = !0, e);
        },
        _initXHRData: function _initXHRData(t) {
          var n,
              i = this,
              r = t.files[0],
              o = t.multipart || !e.support.xhrFileUpload,
              a = "array" === e.type(t.paramName) ? t.paramName[0] : t.paramName;
          t.headers = e.extend({}, t.headers), t.contentRange && (t.headers["Content-Range"] = t.contentRange), o && !t.blob && this._isInstanceOf("File", r) || (t.headers["Content-Disposition"] = 'attachment; filename="' + encodeURI(r.uploadName || r.name) + '"'), o ? e.support.xhrFormDataFileUpload && (t.postMessage ? (n = this._getFormData(t), t.blob ? n.push({
            name: a,
            value: t.blob
          }) : e.each(t.files, function (i, r) {
            n.push({
              name: "array" === e.type(t.paramName) && t.paramName[i] || a,
              value: r
            });
          })) : (i._isInstanceOf("FormData", t.formData) ? n = t.formData : (n = new FormData(), e.each(this._getFormData(t), function (e, t) {
            n.append(t.name, t.value);
          })), t.blob ? n.append(a, t.blob, r.uploadName || r.name) : e.each(t.files, function (r, o) {
            if (i._isInstanceOf("File", o) || i._isInstanceOf("Blob", o)) {
              var s = o.uploadName || o.name;
              t.uniqueFilenames && (s = i._getUniqueFilename(s, t.uniqueFilenames)), n.append("array" === e.type(t.paramName) && t.paramName[r] || a, o, s);
            }
          })), t.data = n) : (t.contentType = r.type || "application/octet-stream", t.data = t.blob || r), t.blob = null;
        },
        _initIframeSettings: function _initIframeSettings(t) {
          var n = e("<a></a>").prop("href", t.url).prop("host");
          t.dataType = "iframe " + (t.dataType || ""), t.formData = this._getFormData(t), t.redirect && n && n !== location.host && t.formData.push({
            name: t.redirectParamName || "redirect",
            value: t.redirect
          });
        },
        _initDataSettings: function _initDataSettings(e) {
          this._isXHRUpload(e) ? (this._chunkedUpload(e, !0) || (e.data || this._initXHRData(e), this._initProgressListener(e)), e.postMessage && (e.dataType = "postmessage " + (e.dataType || ""))) : this._initIframeSettings(e);
        },
        _getParamName: function _getParamName(t) {
          var n = e(t.fileInput),
              i = t.paramName;
          return i ? e.isArray(i) || (i = [i]) : (i = [], n.each(function () {
            for (var t = e(this), n = t.prop("name") || "files[]", r = (t.prop("files") || [1]).length; r;) {
              i.push(n), r -= 1;
            }
          }), i.length || (i = [n.prop("name") || "files[]"])), i;
        },
        _initFormSettings: function _initFormSettings(t) {
          t.form && t.form.length || (t.form = e(t.fileInput.prop("form")), t.form.length || (t.form = e(this.options.fileInput.prop("form")))), t.paramName = this._getParamName(t), t.url || (t.url = t.form.prop("action") || location.href), t.type = (t.type || "string" === e.type(t.form.prop("method")) && t.form.prop("method") || "").toUpperCase(), "POST" !== t.type && "PUT" !== t.type && "PATCH" !== t.type && (t.type = "POST"), t.formAcceptCharset || (t.formAcceptCharset = t.form.attr("accept-charset"));
        },
        _getAJAXSettings: function _getAJAXSettings(t) {
          var n = e.extend({}, this.options, t);
          return this._initFormSettings(n), this._initDataSettings(n), n;
        },
        _getDeferredState: function _getDeferredState(e) {
          return e.state ? e.state() : e.isResolved() ? "resolved" : e.isRejected() ? "rejected" : "pending";
        },
        _enhancePromise: function _enhancePromise(e) {
          return e.success = e.done, e.error = e.fail, e.complete = e.always, e;
        },
        _getXHRPromise: function _getXHRPromise(t, n, i) {
          var r = e.Deferred(),
              o = r.promise();
          return n = n || this.options.context || o, !0 === t ? r.resolveWith(n, i) : !1 === t && r.rejectWith(n, i), o.abort = r.promise, this._enhancePromise(o);
        },
        _addConvenienceMethods: function _addConvenienceMethods(t, n) {
          var i = this,
              r = function r(t) {
            return e.Deferred().resolveWith(i, t).promise();
          };

          n.process = function (t, o) {
            return (t || o) && (n._processQueue = this._processQueue = (this._processQueue || r([this])).then(function () {
              return n.errorThrown ? e.Deferred().rejectWith(i, [n]).promise() : r(arguments);
            }).then(t, o)), this._processQueue || r([this]);
          }, n.submit = function () {
            return "pending" !== this.state() && (n.jqXHR = this.jqXHR = !1 !== i._trigger("submit", e.Event("submit", {
              delegatedEvent: t
            }), this) && i._onSend(t, this)), this.jqXHR || i._getXHRPromise();
          }, n.abort = function () {
            return this.jqXHR ? this.jqXHR.abort() : (this.errorThrown = "abort", i._trigger("fail", null, this), i._getXHRPromise(!1));
          }, n.state = function () {
            return this.jqXHR ? i._getDeferredState(this.jqXHR) : this._processQueue ? i._getDeferredState(this._processQueue) : void 0;
          }, n.processing = function () {
            return !this.jqXHR && this._processQueue && "pending" === i._getDeferredState(this._processQueue);
          }, n.progress = function () {
            return this._progress;
          }, n.response = function () {
            return this._response;
          };
        },
        _getUploadedBytes: function _getUploadedBytes(e) {
          var t = e.getResponseHeader("Range"),
              n = t && t.split("-"),
              i = n && n.length > 1 && parseInt(n[1], 10);
          return i && i + 1;
        },
        _chunkedUpload: function _chunkedUpload(t, n) {
          t.uploadedBytes = t.uploadedBytes || 0;

          var i,
              _r2,
              o = this,
              a = t.files[0],
              s = a.size,
              l = t.uploadedBytes,
              c = t.maxChunkSize || s,
              u = this._blobSlice,
              d = e.Deferred(),
              p = d.promise();

          return !(!(this._isXHRUpload(t) && u && (l || ("function" === e.type(c) ? c(t) : c) < s)) || t.data) && (!!n || (l >= s ? (a.error = t.i18n("uploadedBytes"), this._getXHRPromise(!1, t.context, [null, "error", a.error])) : (_r2 = function r() {
            var n = e.extend({}, t),
                p = n._progress.loaded;
            n.blob = u.call(a, l, l + ("function" === e.type(c) ? c(n) : c), a.type), n.chunkSize = n.blob.size, n.contentRange = "bytes " + l + "-" + (l + n.chunkSize - 1) + "/" + s, o._trigger("chunkbeforesend", null, n), o._initXHRData(n), o._initProgressListener(n), i = (!1 !== o._trigger("chunksend", null, n) && e.ajax(n) || o._getXHRPromise(!1, n.context)).done(function (i, a, c) {
              l = o._getUploadedBytes(c) || l + n.chunkSize, p + n.chunkSize - n._progress.loaded && o._onProgress(e.Event("progress", {
                lengthComputable: !0,
                loaded: l - n.uploadedBytes,
                total: l - n.uploadedBytes
              }), n), t.uploadedBytes = n.uploadedBytes = l, n.result = i, n.textStatus = a, n.jqXHR = c, o._trigger("chunkdone", null, n), o._trigger("chunkalways", null, n), l < s ? _r2() : d.resolveWith(n.context, [i, a, c]);
            }).fail(function (e, t, i) {
              n.jqXHR = e, n.textStatus = t, n.errorThrown = i, o._trigger("chunkfail", null, n), o._trigger("chunkalways", null, n), d.rejectWith(n.context, [e, t, i]);
            }).always(function () {
              o._deinitProgressListener(n);
            });
          }, this._enhancePromise(p), p.abort = function () {
            return i.abort();
          }, _r2(), p)));
        },
        _beforeSend: function _beforeSend(e, t) {
          0 === this._active && (this._trigger("start"), this._bitrateTimer = new this._BitrateTimer(), this._progress.loaded = this._progress.total = 0, this._progress.bitrate = 0), this._initResponseObject(t), this._initProgressObject(t), t._progress.loaded = t.loaded = t.uploadedBytes || 0, t._progress.total = t.total = this._getTotal(t.files) || 1, t._progress.bitrate = t.bitrate = 0, this._active += 1, this._progress.loaded += t.loaded, this._progress.total += t.total;
        },
        _onDone: function _onDone(t, n, i, r) {
          var o = r._progress.total,
              a = r._response;
          r._progress.loaded < o && this._onProgress(e.Event("progress", {
            lengthComputable: !0,
            loaded: o,
            total: o
          }), r), a.result = r.result = t, a.textStatus = r.textStatus = n, a.jqXHR = r.jqXHR = i, this._trigger("done", null, r);
        },
        _onFail: function _onFail(e, t, n, i) {
          var r = i._response;
          i.recalculateProgress && (this._progress.loaded -= i._progress.loaded, this._progress.total -= i._progress.total), r.jqXHR = i.jqXHR = e, r.textStatus = i.textStatus = t, r.errorThrown = i.errorThrown = n, this._trigger("fail", null, i);
        },
        _onAlways: function _onAlways(e, t, n, i) {
          this._trigger("always", null, i);
        },
        _onSend: function _onSend(t, n) {
          n.submit || this._addConvenienceMethods(t, n);

          var i,
              r,
              o,
              a,
              s = this,
              l = s._getAJAXSettings(n),
              c = function c() {
            return s._sending += 1, l._bitrateTimer = new s._BitrateTimer(), i = i || ((r || !1 === s._trigger("send", e.Event("send", {
              delegatedEvent: t
            }), l)) && s._getXHRPromise(!1, l.context, r) || s._chunkedUpload(l) || e.ajax(l)).done(function (e, t, n) {
              s._onDone(e, t, n, l);
            }).fail(function (e, t, n) {
              s._onFail(e, t, n, l);
            }).always(function (e, t, n) {
              if (s._deinitProgressListener(l), s._onAlways(e, t, n, l), s._sending -= 1, s._active -= 1, l.limitConcurrentUploads && l.limitConcurrentUploads > s._sending) for (var i = s._slots.shift(); i;) {
                if ("pending" === s._getDeferredState(i)) {
                  i.resolve();
                  break;
                }

                i = s._slots.shift();
              }
              0 === s._active && s._trigger("stop");
            });
          };

          return this._beforeSend(t, l), this.options.sequentialUploads || this.options.limitConcurrentUploads && this.options.limitConcurrentUploads <= this._sending ? (this.options.limitConcurrentUploads > 1 ? (o = e.Deferred(), this._slots.push(o), a = o.then(c)) : (this._sequence = this._sequence.then(c, c), a = this._sequence), a.abort = function () {
            return r = [void 0, "abort", "abort"], i ? i.abort() : (o && o.rejectWith(l.context, r), c());
          }, this._enhancePromise(a)) : c();
        },
        _onAdd: function _onAdd(t, n) {
          var i,
              r,
              o,
              a,
              s = this,
              l = !0,
              c = e.extend({}, this.options, n),
              u = n.files,
              d = u.length,
              p = c.limitMultiFileUploads,
              h = c.limitMultiFileUploadSize,
              f = c.limitMultiFileUploadSizeOverhead,
              m = 0,
              g = this._getParamName(c),
              v = 0;

          if (!d) return !1;
          if (h && void 0 === u[0].size && (h = void 0), (c.singleFileUploads || p || h) && this._isXHRUpload(c)) {
            if (c.singleFileUploads || h || !p) {
              if (!c.singleFileUploads && h) for (o = [], i = [], a = 0; a < d; a += 1) {
                m += u[a].size + f, (a + 1 === d || m + u[a + 1].size + f > h || p && a + 1 - v >= p) && (o.push(u.slice(v, a + 1)), (r = g.slice(v, a + 1)).length || (r = g), i.push(r), v = a + 1, m = 0);
              } else i = g;
            } else for (o = [], i = [], a = 0; a < d; a += p) {
              o.push(u.slice(a, a + p)), (r = g.slice(a, a + p)).length || (r = g), i.push(r);
            }
          } else o = [u], i = [g];
          return n.originalFiles = u, e.each(o || u, function (r, a) {
            var c = e.extend({}, n);
            return c.files = o ? a : [a], c.paramName = i[r], s._initResponseObject(c), s._initProgressObject(c), s._addConvenienceMethods(t, c), l = s._trigger("add", e.Event("add", {
              delegatedEvent: t
            }), c);
          }), l;
        },
        _replaceFileInput: function _replaceFileInput(t) {
          var n = t.fileInput,
              i = n.clone(!0),
              r = n.is(document.activeElement);
          t.fileInputClone = i, e("<form></form>").append(i)[0].reset(), n.after(i).detach(), r && i.focus(), e.cleanData(n.unbind("remove")), this.options.fileInput = this.options.fileInput.map(function (e, t) {
            return t === n[0] ? i[0] : t;
          }), n[0] === this.element[0] && (this.element = i);
        },
        _handleFileTreeEntry: function _handleFileTreeEntry(t, n) {
          var i,
              r = this,
              o = e.Deferred(),
              a = [],
              s = function s(e) {
            e && !e.entry && (e.entry = t), o.resolve([e]);
          },
              l = function l() {
            i.readEntries(function (e) {
              e.length ? (a = a.concat(e), l()) : function (e) {
                r._handleFileTreeEntries(e, n + t.name + "/").done(function (e) {
                  o.resolve(e);
                }).fail(s);
              }(a);
            }, s);
          };

          return n = n || "", t.isFile ? t._file ? (t._file.relativePath = n, o.resolve(t._file)) : t.file(function (e) {
            e.relativePath = n, o.resolve(e);
          }, s) : t.isDirectory ? (i = t.createReader(), l()) : o.resolve([]), o.promise();
        },
        _handleFileTreeEntries: function _handleFileTreeEntries(t, n) {
          var i = this;
          return e.when.apply(e, e.map(t, function (e) {
            return i._handleFileTreeEntry(e, n);
          })).then(function () {
            return Array.prototype.concat.apply([], arguments);
          });
        },
        _getDroppedFiles: function _getDroppedFiles(t) {
          var n = (t = t || {}).items;
          return n && n.length && (n[0].webkitGetAsEntry || n[0].getAsEntry) ? this._handleFileTreeEntries(e.map(n, function (e) {
            var t;
            return e.webkitGetAsEntry ? ((t = e.webkitGetAsEntry()) && (t._file = e.getAsFile()), t) : e.getAsEntry();
          })) : e.Deferred().resolve(e.makeArray(t.files)).promise();
        },
        _getSingleFileInputFiles: function _getSingleFileInputFiles(t) {
          var n,
              i,
              r = (t = e(t)).prop("webkitEntries") || t.prop("entries");
          if (r && r.length) return this._handleFileTreeEntries(r);
          if ((n = e.makeArray(t.prop("files"))).length) void 0 === n[0].name && n[0].fileName && e.each(n, function (e, t) {
            t.name = t.fileName, t.size = t.fileSize;
          });else {
            if (!(i = t.prop("value"))) return e.Deferred().resolve([]).promise();
            n = [{
              name: i.replace(/^.*\\/, "")
            }];
          }
          return e.Deferred().resolve(n).promise();
        },
        _getFileInputFiles: function _getFileInputFiles(t) {
          return t instanceof e && 1 !== t.length ? e.when.apply(e, e.map(t, this._getSingleFileInputFiles)).then(function () {
            return Array.prototype.concat.apply([], arguments);
          }) : this._getSingleFileInputFiles(t);
        },
        _onChange: function _onChange(t) {
          var n = this,
              i = {
            fileInput: e(t.target),
            form: e(t.target.form)
          };

          this._getFileInputFiles(i.fileInput).always(function (r) {
            i.files = r, n.options.replaceFileInput && n._replaceFileInput(i), !1 !== n._trigger("change", e.Event("change", {
              delegatedEvent: t
            }), i) && n._onAdd(t, i);
          });
        },
        _onPaste: function _onPaste(t) {
          var n = t.originalEvent && t.originalEvent.clipboardData && t.originalEvent.clipboardData.items,
              i = {
            files: []
          };
          n && n.length && (e.each(n, function (e, t) {
            var n = t.getAsFile && t.getAsFile();
            n && i.files.push(n);
          }), !1 !== this._trigger("paste", e.Event("paste", {
            delegatedEvent: t
          }), i) && this._onAdd(t, i));
        },
        _onDrop: function _onDrop(t) {
          t.dataTransfer = t.originalEvent && t.originalEvent.dataTransfer;
          var n = this,
              i = t.dataTransfer,
              r = {};
          i && i.files && i.files.length && (t.preventDefault(), this._getDroppedFiles(i).always(function (i) {
            r.files = i, !1 !== n._trigger("drop", e.Event("drop", {
              delegatedEvent: t
            }), r) && n._onAdd(t, r);
          }));
        },
        _onDragOver: t("dragover"),
        _onDragEnter: t("dragenter"),
        _onDragLeave: t("dragleave"),
        _initEventHandlers: function _initEventHandlers() {
          this._isXHRUpload(this.options) && (this._on(this.options.dropZone, {
            dragover: this._onDragOver,
            drop: this._onDrop,
            dragenter: this._onDragEnter,
            dragleave: this._onDragLeave
          }), this._on(this.options.pasteZone, {
            paste: this._onPaste
          })), e.support.fileInput && this._on(this.options.fileInput, {
            change: this._onChange
          });
        },
        _destroyEventHandlers: function _destroyEventHandlers() {
          this._off(this.options.dropZone, "dragenter dragleave dragover drop"), this._off(this.options.pasteZone, "paste"), this._off(this.options.fileInput, "change");
        },
        _destroy: function _destroy() {
          this._destroyEventHandlers();
        },
        _setOption: function _setOption(t, n) {
          var i = -1 !== e.inArray(t, this._specialOptions);
          i && this._destroyEventHandlers(), this._super(t, n), i && (this._initSpecialOptions(), this._initEventHandlers());
        },
        _initSpecialOptions: function _initSpecialOptions() {
          var t = this.options;
          void 0 === t.fileInput ? t.fileInput = this.element.is('input[type="file"]') ? this.element : this.element.find('input[type="file"]') : t.fileInput instanceof e || (t.fileInput = e(t.fileInput)), t.dropZone instanceof e || (t.dropZone = e(t.dropZone)), t.pasteZone instanceof e || (t.pasteZone = e(t.pasteZone));
        },
        _getRegExp: function _getRegExp(e) {
          var t = e.split("/"),
              n = t.pop();
          return t.shift(), new RegExp(t.join("/"), n);
        },
        _isRegExpOption: function _isRegExpOption(t, n) {
          return "url" !== t && "string" === e.type(n) && /^\/.*\/[igm]{0,3}$/.test(n);
        },
        _initDataAttributes: function _initDataAttributes() {
          var t = this,
              n = this.options,
              i = this.element.data();
          e.each(this.element[0].attributes, function (e, r) {
            var o,
                a = r.name.toLowerCase();
            /^data-/.test(a) && (a = a.slice(5).replace(/-[a-z]/g, function (e) {
              return e.charAt(1).toUpperCase();
            }), o = i[a], t._isRegExpOption(a, o) && (o = t._getRegExp(o)), n[a] = o);
          });
        },
        _create: function _create() {
          this._initDataAttributes(), this._initSpecialOptions(), this._slots = [], this._sequence = this._getXHRPromise(!0), this._sending = this._active = 0, this._initProgressObject(this), this._initEventHandlers();
        },
        active: function active() {
          return this._active;
        },
        progress: function progress() {
          return this._progress;
        },
        add: function add(t) {
          var n = this;
          t && !this.options.disabled && (t.fileInput && !t.files ? this._getFileInputFiles(t.fileInput).always(function (e) {
            t.files = e, n._onAdd(null, t);
          }) : (t.files = e.makeArray(t.files), this._onAdd(null, t)));
        },
        send: function send(t) {
          if (t && !this.options.disabled) {
            if (t.fileInput && !t.files) {
              var n,
                  i,
                  r = this,
                  o = e.Deferred(),
                  a = o.promise();
              return a.abort = function () {
                return i = !0, n ? n.abort() : (o.reject(null, "abort", "abort"), a);
              }, this._getFileInputFiles(t.fileInput).always(function (e) {
                i || (e.length ? (t.files = e, (n = r._onSend(null, t)).then(function (e, t, n) {
                  o.resolve(e, t, n);
                }, function (e, t, n) {
                  o.reject(e, t, n);
                })) : o.reject());
              }), this._enhancePromise(a);
            }

            if (t.files = e.makeArray(t.files), t.files.length) return this._onSend(null, t);
          }

          return this._getXHRPromise(!1, t && t.context);
        }
      });
    });
  }, function (e, t, n) {
    var i, r, o;
    /*! jQuery UI - v1.12.1+CommonJS - 2018-02-10
     * http://jqueryui.com
     * Includes: widget.js
     * Copyright jQuery Foundation and other contributors; Licensed MIT */

    r = [n(0)], void 0 === (o = "function" == typeof (i = function i(e) {
      e.ui = e.ui || {}, e.ui.version = "1.12.1";
      var t,
          n = 0,
          i = Array.prototype.slice;
      /*!
         * jQuery UI Widget 1.12.1
         * http://jqueryui.com
         *
         * Copyright jQuery Foundation and other contributors
         * Released under the MIT license.
         * http://jquery.org/license
         */

      e.cleanData = (t = e.cleanData, function (n) {
        var i, r, o;

        for (o = 0; null != (r = n[o]); o++) {
          try {
            (i = e._data(r, "events")) && i.remove && e(r).triggerHandler("remove");
          } catch (e) {}
        }

        t(n);
      }), e.widget = function (t, n, i) {
        var r,
            o,
            a,
            s = {},
            l = t.split(".")[0];
        t = t.split(".")[1];
        var c = l + "-" + t;
        return i || (i = n, n = e.Widget), e.isArray(i) && (i = e.extend.apply(null, [{}].concat(i))), e.expr[":"][c.toLowerCase()] = function (t) {
          return !!e.data(t, c);
        }, e[l] = e[l] || {}, r = e[l][t], o = e[l][t] = function (e, t) {
          if (!this._createWidget) return new o(e, t);
          arguments.length && this._createWidget(e, t);
        }, e.extend(o, r, {
          version: i.version,
          _proto: e.extend({}, i),
          _childConstructors: []
        }), (a = new n()).options = e.widget.extend({}, a.options), e.each(i, function (t, i) {
          e.isFunction(i) ? s[t] = function () {
            function e() {
              return n.prototype[t].apply(this, arguments);
            }

            function r(e) {
              return n.prototype[t].apply(this, e);
            }

            return function () {
              var t,
                  n = this._super,
                  o = this._superApply;
              return this._super = e, this._superApply = r, t = i.apply(this, arguments), this._super = n, this._superApply = o, t;
            };
          }() : s[t] = i;
        }), o.prototype = e.widget.extend(a, {
          widgetEventPrefix: r && a.widgetEventPrefix || t
        }, s, {
          constructor: o,
          namespace: l,
          widgetName: t,
          widgetFullName: c
        }), r ? (e.each(r._childConstructors, function (t, n) {
          var i = n.prototype;
          e.widget(i.namespace + "." + i.widgetName, o, n._proto);
        }), delete r._childConstructors) : n._childConstructors.push(o), e.widget.bridge(t, o), o;
      }, e.widget.extend = function (t) {
        for (var n, r, o = i.call(arguments, 1), a = 0, s = o.length; a < s; a++) {
          for (n in o[a]) {
            r = o[a][n], o[a].hasOwnProperty(n) && void 0 !== r && (e.isPlainObject(r) ? t[n] = e.isPlainObject(t[n]) ? e.widget.extend({}, t[n], r) : e.widget.extend({}, r) : t[n] = r);
          }
        }

        return t;
      }, e.widget.bridge = function (t, n) {
        var r = n.prototype.widgetFullName || t;

        e.fn[t] = function (o) {
          var a = "string" == typeof o,
              s = i.call(arguments, 1),
              l = this;
          return a ? this.length || "instance" !== o ? this.each(function () {
            var n,
                i = e.data(this, r);
            return "instance" === o ? (l = i, !1) : i ? e.isFunction(i[o]) && "_" !== o.charAt(0) ? (n = i[o].apply(i, s)) !== i && void 0 !== n ? (l = n && n.jquery ? l.pushStack(n.get()) : n, !1) : void 0 : e.error("no such method '" + o + "' for " + t + " widget instance") : e.error("cannot call methods on " + t + " prior to initialization; attempted to call method '" + o + "'");
          }) : l = void 0 : (s.length && (o = e.widget.extend.apply(null, [o].concat(s))), this.each(function () {
            var t = e.data(this, r);
            t ? (t.option(o || {}), t._init && t._init()) : e.data(this, r, new n(o, this));
          })), l;
        };
      }, e.Widget = function () {}, e.Widget._childConstructors = [], e.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
          classes: {},
          disabled: !1,
          create: null
        },
        _createWidget: function _createWidget(t, i) {
          i = e(i || this.defaultElement || this)[0], this.element = e(i), this.uuid = n++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = e(), this.hoverable = e(), this.focusable = e(), this.classesElementLookup = {}, i !== this && (e.data(i, this.widgetFullName, this), this._on(!0, this.element, {
            remove: function remove(e) {
              e.target === i && this.destroy();
            }
          }), this.document = e(i.style ? i.ownerDocument : i.document || i), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init();
        },
        _getCreateOptions: function _getCreateOptions() {
          return {};
        },
        _getCreateEventData: e.noop,
        _create: e.noop,
        _init: e.noop,
        destroy: function destroy() {
          var t = this;
          this._destroy(), e.each(this.classesElementLookup, function (e, n) {
            t._removeClass(n, e);
          }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace);
        },
        _destroy: e.noop,
        widget: function widget() {
          return this.element;
        },
        option: function option(t, n) {
          var i,
              r,
              o,
              a = t;
          if (0 === arguments.length) return e.widget.extend({}, this.options);
          if ("string" == typeof t) if (a = {}, i = t.split("."), t = i.shift(), i.length) {
            for (r = a[t] = e.widget.extend({}, this.options[t]), o = 0; o < i.length - 1; o++) {
              r[i[o]] = r[i[o]] || {}, r = r[i[o]];
            }

            if (t = i.pop(), 1 === arguments.length) return void 0 === r[t] ? null : r[t];
            r[t] = n;
          } else {
            if (1 === arguments.length) return void 0 === this.options[t] ? null : this.options[t];
            a[t] = n;
          }
          return this._setOptions(a), this;
        },
        _setOptions: function _setOptions(e) {
          var t;

          for (t in e) {
            this._setOption(t, e[t]);
          }

          return this;
        },
        _setOption: function _setOption(e, t) {
          return "classes" === e && this._setOptionClasses(t), this.options[e] = t, "disabled" === e && this._setOptionDisabled(t), this;
        },
        _setOptionClasses: function _setOptionClasses(t) {
          var n, i, r;

          for (n in t) {
            r = this.classesElementLookup[n], t[n] !== this.options.classes[n] && r && r.length && (i = e(r.get()), this._removeClass(r, n), i.addClass(this._classes({
              element: i,
              keys: n,
              classes: t,
              add: !0
            })));
          }
        },
        _setOptionDisabled: function _setOptionDisabled(e) {
          this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!e), e && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"));
        },
        enable: function enable() {
          return this._setOptions({
            disabled: !1
          });
        },
        disable: function disable() {
          return this._setOptions({
            disabled: !0
          });
        },
        _classes: function _classes(t) {
          var n = [],
              i = this;

          function r(r, o) {
            var a, s;

            for (s = 0; s < r.length; s++) {
              a = i.classesElementLookup[r[s]] || e(), a = t.add ? e(e.unique(a.get().concat(t.element.get()))) : e(a.not(t.element).get()), i.classesElementLookup[r[s]] = a, n.push(r[s]), o && t.classes[r[s]] && n.push(t.classes[r[s]]);
            }
          }

          return t = e.extend({
            element: this.element,
            classes: this.options.classes || {}
          }, t), this._on(t.element, {
            remove: "_untrackClassesElement"
          }), t.keys && r(t.keys.match(/\S+/g) || [], !0), t.extra && r(t.extra.match(/\S+/g) || []), n.join(" ");
        },
        _untrackClassesElement: function _untrackClassesElement(t) {
          var n = this;
          e.each(n.classesElementLookup, function (i, r) {
            -1 !== e.inArray(t.target, r) && (n.classesElementLookup[i] = e(r.not(t.target).get()));
          });
        },
        _removeClass: function _removeClass(e, t, n) {
          return this._toggleClass(e, t, n, !1);
        },
        _addClass: function _addClass(e, t, n) {
          return this._toggleClass(e, t, n, !0);
        },
        _toggleClass: function _toggleClass(e, t, n, i) {
          i = "boolean" == typeof i ? i : n;
          var r = "string" == typeof e || null === e,
              o = {
            extra: r ? t : n,
            keys: r ? e : t,
            element: r ? this.element : e,
            add: i
          };
          return o.element.toggleClass(this._classes(o), i), this;
        },
        _on: function _on(t, n, i) {
          var r,
              o = this;
          "boolean" != typeof t && (i = n, n = t, t = !1), i ? (n = r = e(n), this.bindings = this.bindings.add(n)) : (i = n, n = this.element, r = this.widget()), e.each(i, function (i, a) {
            function s() {
              if (t || !0 !== o.options.disabled && !e(this).hasClass("ui-state-disabled")) return ("string" == typeof a ? o[a] : a).apply(o, arguments);
            }

            "string" != typeof a && (s.guid = a.guid = a.guid || s.guid || e.guid++);
            var l = i.match(/^([\w:-]*)\s*(.*)$/),
                c = l[1] + o.eventNamespace,
                u = l[2];
            u ? r.on(c, u, s) : n.on(c, s);
          });
        },
        _off: function _off(t, n) {
          n = (n || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, t.off(n).off(n), this.bindings = e(this.bindings.not(t).get()), this.focusable = e(this.focusable.not(t).get()), this.hoverable = e(this.hoverable.not(t).get());
        },
        _delay: function _delay(e, t) {
          var n = this;
          return setTimeout(function () {
            return ("string" == typeof e ? n[e] : e).apply(n, arguments);
          }, t || 0);
        },
        _hoverable: function _hoverable(t) {
          this.hoverable = this.hoverable.add(t), this._on(t, {
            mouseenter: function mouseenter(t) {
              this._addClass(e(t.currentTarget), null, "ui-state-hover");
            },
            mouseleave: function mouseleave(t) {
              this._removeClass(e(t.currentTarget), null, "ui-state-hover");
            }
          });
        },
        _focusable: function _focusable(t) {
          this.focusable = this.focusable.add(t), this._on(t, {
            focusin: function focusin(t) {
              this._addClass(e(t.currentTarget), null, "ui-state-focus");
            },
            focusout: function focusout(t) {
              this._removeClass(e(t.currentTarget), null, "ui-state-focus");
            }
          });
        },
        _trigger: function _trigger(t, n, i) {
          var r,
              o,
              a = this.options[t];
          if (i = i || {}, (n = e.Event(n)).type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), n.target = this.element[0], o = n.originalEvent) for (r in o) {
            r in n || (n[r] = o[r]);
          }
          return this.element.trigger(n, i), !(e.isFunction(a) && !1 === a.apply(this.element[0], [n].concat(i)) || n.isDefaultPrevented());
        }
      }, e.each({
        show: "fadeIn",
        hide: "fadeOut"
      }, function (t, n) {
        e.Widget.prototype["_" + t] = function (i, r, o) {
          var a;
          "string" == typeof r && (r = {
            effect: r
          });
          var s = r ? !0 === r || "number" == typeof r ? n : r.effect || n : t;
          "number" == typeof (r = r || {}) && (r = {
            duration: r
          }), a = !e.isEmptyObject(r), r.complete = o, r.delay && i.delay(r.delay), a && e.effects && e.effects.effect[s] ? i[t](r) : s !== t && i[s] ? i[s](r.duration, r.easing, o) : i.queue(function (n) {
            e(this)[t](), o && o.call(i[0]), n();
          });
        };
      }), e.widget;
    }) ? i.apply(t, r) : i) || (e.exports = o);
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e(window.jQuery);
    }(function (e) {
      "use strict";

      var t = e.blueimp.fileupload.prototype.options.add;
      e.widget("blueimp.fileupload", e.blueimp.fileupload, {
        options: {
          processQueue: [],
          add: function add(n, i) {
            var r = e(this);
            i.process(function () {
              return r.fileupload("process", i);
            }), t.call(this, n, i);
          }
        },
        processActions: {},
        _processFile: function _processFile(t, n) {
          var i = this,
              r = e.Deferred().resolveWith(i, [t]).promise();
          return this._trigger("process", null, t), e.each(t.processQueue, function (t, o) {
            var a = function a(t) {
              return n.errorThrown ? e.Deferred().rejectWith(i, [n]).promise() : i.processActions[o.action].call(i, t, o);
            };

            r = r.then(a, o.always && a);
          }), r.done(function () {
            i._trigger("processdone", null, t), i._trigger("processalways", null, t);
          }).fail(function () {
            i._trigger("processfail", null, t), i._trigger("processalways", null, t);
          }), r;
        },
        _transformProcessQueue: function _transformProcessQueue(t) {
          var n = [];
          e.each(t.processQueue, function () {
            var i = {},
                r = this.action,
                o = !0 === this.prefix ? r : this.prefix;
            e.each(this, function (n, r) {
              "string" === e.type(r) && "@" === r.charAt(0) ? i[n] = t[r.slice(1) || (o ? o + n.charAt(0).toUpperCase() + n.slice(1) : n)] : i[n] = r;
            }), n.push(i);
          }), t.processQueue = n;
        },
        processing: function processing() {
          return this._processing;
        },
        process: function process(t) {
          var n = this,
              i = e.extend({}, this.options, t);
          return i.processQueue && i.processQueue.length && (this._transformProcessQueue(i), 0 === this._processing && this._trigger("processstart"), e.each(t.files, function (r) {
            var o = r ? e.extend({}, i) : i,
                a = function a() {
              return t.errorThrown ? e.Deferred().rejectWith(n, [t]).promise() : n._processFile(o, t);
            };

            o.index = r, n._processing += 1, n._processingQueue = n._processingQueue.then(a, a).always(function () {
              n._processing -= 1, 0 === n._processing && n._trigger("processstop");
            });
          })), this._processingQueue;
        },
        _create: function _create() {
          this._super(), this._processing = 0, this._processingQueue = e.Deferred().resolveWith(this).promise();
        }
      });
    });
  }, function (e, t, n) {
    var i, r, o;
    /*!
     * jQuery UI Widget 1.12.1
     * http://jqueryui.com
     *
     * Copyright jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     */

    r = [n(0), n(27)], void 0 === (o = "function" == typeof (i = function i(e) {
      var t,
          n = 0,
          i = Array.prototype.slice;
      return e.cleanData = (t = e.cleanData, function (n) {
        var i, r, o;

        for (o = 0; null != (r = n[o]); o++) {
          try {
            (i = e._data(r, "events")) && i.remove && e(r).triggerHandler("remove");
          } catch (e) {}
        }

        t(n);
      }), e.widget = function (t, n, i) {
        var r,
            o,
            a,
            s = {},
            l = t.split(".")[0],
            c = l + "-" + (t = t.split(".")[1]);
        return i || (i = n, n = e.Widget), e.isArray(i) && (i = e.extend.apply(null, [{}].concat(i))), e.expr[":"][c.toLowerCase()] = function (t) {
          return !!e.data(t, c);
        }, e[l] = e[l] || {}, r = e[l][t], o = e[l][t] = function (e, t) {
          if (!this._createWidget) return new o(e, t);
          arguments.length && this._createWidget(e, t);
        }, e.extend(o, r, {
          version: i.version,
          _proto: e.extend({}, i),
          _childConstructors: []
        }), (a = new n()).options = e.widget.extend({}, a.options), e.each(i, function (t, i) {
          e.isFunction(i) ? s[t] = function () {
            function e() {
              return n.prototype[t].apply(this, arguments);
            }

            function r(e) {
              return n.prototype[t].apply(this, e);
            }

            return function () {
              var t,
                  n = this._super,
                  o = this._superApply;
              return this._super = e, this._superApply = r, t = i.apply(this, arguments), this._super = n, this._superApply = o, t;
            };
          }() : s[t] = i;
        }), o.prototype = e.widget.extend(a, {
          widgetEventPrefix: r && a.widgetEventPrefix || t
        }, s, {
          constructor: o,
          namespace: l,
          widgetName: t,
          widgetFullName: c
        }), r ? (e.each(r._childConstructors, function (t, n) {
          var i = n.prototype;
          e.widget(i.namespace + "." + i.widgetName, o, n._proto);
        }), delete r._childConstructors) : n._childConstructors.push(o), e.widget.bridge(t, o), o;
      }, e.widget.extend = function (t) {
        for (var n, r, o = i.call(arguments, 1), a = 0, s = o.length; a < s; a++) {
          for (n in o[a]) {
            r = o[a][n], o[a].hasOwnProperty(n) && void 0 !== r && (e.isPlainObject(r) ? t[n] = e.isPlainObject(t[n]) ? e.widget.extend({}, t[n], r) : e.widget.extend({}, r) : t[n] = r);
          }
        }

        return t;
      }, e.widget.bridge = function (t, n) {
        var r = n.prototype.widgetFullName || t;

        e.fn[t] = function (o) {
          var a = "string" == typeof o,
              s = i.call(arguments, 1),
              l = this;
          return a ? this.length || "instance" !== o ? this.each(function () {
            var n,
                i = e.data(this, r);
            return "instance" === o ? (l = i, !1) : i ? e.isFunction(i[o]) && "_" !== o.charAt(0) ? (n = i[o].apply(i, s)) !== i && void 0 !== n ? (l = n && n.jquery ? l.pushStack(n.get()) : n, !1) : void 0 : e.error("no such method '" + o + "' for " + t + " widget instance") : e.error("cannot call methods on " + t + " prior to initialization; attempted to call method '" + o + "'");
          }) : l = void 0 : (s.length && (o = e.widget.extend.apply(null, [o].concat(s))), this.each(function () {
            var t = e.data(this, r);
            t ? (t.option(o || {}), t._init && t._init()) : e.data(this, r, new n(o, this));
          })), l;
        };
      }, e.Widget = function () {}, e.Widget._childConstructors = [], e.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
          classes: {},
          disabled: !1,
          create: null
        },
        _createWidget: function _createWidget(t, i) {
          i = e(i || this.defaultElement || this)[0], this.element = e(i), this.uuid = n++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = e(), this.hoverable = e(), this.focusable = e(), this.classesElementLookup = {}, i !== this && (e.data(i, this.widgetFullName, this), this._on(!0, this.element, {
            remove: function remove(e) {
              e.target === i && this.destroy();
            }
          }), this.document = e(i.style ? i.ownerDocument : i.document || i), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init();
        },
        _getCreateOptions: function _getCreateOptions() {
          return {};
        },
        _getCreateEventData: e.noop,
        _create: e.noop,
        _init: e.noop,
        destroy: function destroy() {
          var t = this;
          this._destroy(), e.each(this.classesElementLookup, function (e, n) {
            t._removeClass(n, e);
          }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace);
        },
        _destroy: e.noop,
        widget: function widget() {
          return this.element;
        },
        option: function option(t, n) {
          var i,
              r,
              o,
              a = t;
          if (0 === arguments.length) return e.widget.extend({}, this.options);
          if ("string" == typeof t) if (a = {}, i = t.split("."), t = i.shift(), i.length) {
            for (r = a[t] = e.widget.extend({}, this.options[t]), o = 0; o < i.length - 1; o++) {
              r[i[o]] = r[i[o]] || {}, r = r[i[o]];
            }

            if (t = i.pop(), 1 === arguments.length) return void 0 === r[t] ? null : r[t];
            r[t] = n;
          } else {
            if (1 === arguments.length) return void 0 === this.options[t] ? null : this.options[t];
            a[t] = n;
          }
          return this._setOptions(a), this;
        },
        _setOptions: function _setOptions(e) {
          var t;

          for (t in e) {
            this._setOption(t, e[t]);
          }

          return this;
        },
        _setOption: function _setOption(e, t) {
          return "classes" === e && this._setOptionClasses(t), this.options[e] = t, "disabled" === e && this._setOptionDisabled(t), this;
        },
        _setOptionClasses: function _setOptionClasses(t) {
          var n, i, r;

          for (n in t) {
            r = this.classesElementLookup[n], t[n] !== this.options.classes[n] && r && r.length && (i = e(r.get()), this._removeClass(r, n), i.addClass(this._classes({
              element: i,
              keys: n,
              classes: t,
              add: !0
            })));
          }
        },
        _setOptionDisabled: function _setOptionDisabled(e) {
          this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!e), e && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"));
        },
        enable: function enable() {
          return this._setOptions({
            disabled: !1
          });
        },
        disable: function disable() {
          return this._setOptions({
            disabled: !0
          });
        },
        _classes: function _classes(t) {
          var n = [],
              i = this;

          function r(r, o) {
            var a, s;

            for (s = 0; s < r.length; s++) {
              a = i.classesElementLookup[r[s]] || e(), a = t.add ? e(e.unique(a.get().concat(t.element.get()))) : e(a.not(t.element).get()), i.classesElementLookup[r[s]] = a, n.push(r[s]), o && t.classes[r[s]] && n.push(t.classes[r[s]]);
            }
          }

          return t = e.extend({
            element: this.element,
            classes: this.options.classes || {}
          }, t), this._on(t.element, {
            remove: "_untrackClassesElement"
          }), t.keys && r(t.keys.match(/\S+/g) || [], !0), t.extra && r(t.extra.match(/\S+/g) || []), n.join(" ");
        },
        _untrackClassesElement: function _untrackClassesElement(t) {
          var n = this;
          e.each(n.classesElementLookup, function (i, r) {
            -1 !== e.inArray(t.target, r) && (n.classesElementLookup[i] = e(r.not(t.target).get()));
          });
        },
        _removeClass: function _removeClass(e, t, n) {
          return this._toggleClass(e, t, n, !1);
        },
        _addClass: function _addClass(e, t, n) {
          return this._toggleClass(e, t, n, !0);
        },
        _toggleClass: function _toggleClass(e, t, n, i) {
          i = "boolean" == typeof i ? i : n;
          var r = "string" == typeof e || null === e,
              o = {
            extra: r ? t : n,
            keys: r ? e : t,
            element: r ? this.element : e,
            add: i
          };
          return o.element.toggleClass(this._classes(o), i), this;
        },
        _on: function _on(t, n, i) {
          var r,
              o = this;
          "boolean" != typeof t && (i = n, n = t, t = !1), i ? (n = r = e(n), this.bindings = this.bindings.add(n)) : (i = n, n = this.element, r = this.widget()), e.each(i, function (i, a) {
            function s() {
              if (t || !0 !== o.options.disabled && !e(this).hasClass("ui-state-disabled")) return ("string" == typeof a ? o[a] : a).apply(o, arguments);
            }

            "string" != typeof a && (s.guid = a.guid = a.guid || s.guid || e.guid++);
            var l = i.match(/^([\w:-]*)\s*(.*)$/),
                c = l[1] + o.eventNamespace,
                u = l[2];
            u ? r.on(c, u, s) : n.on(c, s);
          });
        },
        _off: function _off(t, n) {
          n = (n || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, t.off(n).off(n), this.bindings = e(this.bindings.not(t).get()), this.focusable = e(this.focusable.not(t).get()), this.hoverable = e(this.hoverable.not(t).get());
        },
        _delay: function _delay(e, t) {
          var n = this;
          return setTimeout(function () {
            return ("string" == typeof e ? n[e] : e).apply(n, arguments);
          }, t || 0);
        },
        _hoverable: function _hoverable(t) {
          this.hoverable = this.hoverable.add(t), this._on(t, {
            mouseenter: function mouseenter(t) {
              this._addClass(e(t.currentTarget), null, "ui-state-hover");
            },
            mouseleave: function mouseleave(t) {
              this._removeClass(e(t.currentTarget), null, "ui-state-hover");
            }
          });
        },
        _focusable: function _focusable(t) {
          this.focusable = this.focusable.add(t), this._on(t, {
            focusin: function focusin(t) {
              this._addClass(e(t.currentTarget), null, "ui-state-focus");
            },
            focusout: function focusout(t) {
              this._removeClass(e(t.currentTarget), null, "ui-state-focus");
            }
          });
        },
        _trigger: function _trigger(t, n, i) {
          var r,
              o,
              a = this.options[t];
          if (i = i || {}, (n = e.Event(n)).type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), n.target = this.element[0], o = n.originalEvent) for (r in o) {
            r in n || (n[r] = o[r]);
          }
          return this.element.trigger(n, i), !(e.isFunction(a) && !1 === a.apply(this.element[0], [n].concat(i)) || n.isDefaultPrevented());
        }
      }, e.each({
        show: "fadeIn",
        hide: "fadeOut"
      }, function (t, n) {
        e.Widget.prototype["_" + t] = function (i, r, o) {
          var a;
          "string" == typeof r && (r = {
            effect: r
          });
          var s = r ? !0 === r || "number" == typeof r ? n : r.effect || n : t;
          "number" == typeof (r = r || {}) && (r = {
            duration: r
          }), a = !e.isEmptyObject(r), r.complete = o, r.delay && i.delay(r.delay), a && e.effects && e.effects.effect[s] ? i[t](r) : s !== t && i[s] ? i[s](r.duration, r.easing, o) : i.queue(function (n) {
            e(this)[t](), o && o.call(i[0]), n();
          });
        };
      }), e.widget;
    }) ? i.apply(t, r) : i) || (e.exports = o);
  }, function (e, t, n) {
    var i, r, o;
    r = [n(0)], void 0 === (o = "function" == typeof (i = function i(e) {
      return e.ui = e.ui || {}, e.ui.version = "1.12.1";
    }) ? i.apply(t, r) : i) || (e.exports = o);
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e(window.jQuery);
    }(function (e) {
      "use strict";

      e.blueimp.fileupload.prototype.options.processQueue.push({
        action: "validate",
        always: !0,
        acceptFileTypes: "@",
        maxFileSize: "@",
        minFileSize: "@",
        maxNumberOfFiles: "@",
        disabled: "@disableValidation"
      }), e.widget("blueimp.fileupload", e.blueimp.fileupload, {
        options: {
          getNumberOfFiles: e.noop,
          messages: {
            maxNumberOfFiles: "Maximum number of files exceeded",
            acceptFileTypes: "File type not allowed",
            maxFileSize: "File is too large",
            minFileSize: "File is too small"
          }
        },
        processActions: {
          validate: function validate(t, n) {
            if (n.disabled) return t;
            var i,
                r = e.Deferred(),
                o = this.options,
                a = t.files[t.index];
            return (n.minFileSize || n.maxFileSize) && (i = a.size), "number" === e.type(n.maxNumberOfFiles) && (o.getNumberOfFiles() || 0) + t.files.length > n.maxNumberOfFiles ? a.error = o.i18n("maxNumberOfFiles") : !n.acceptFileTypes || n.acceptFileTypes.test(a.type) || n.acceptFileTypes.test(a.name) ? i > n.maxFileSize ? a.error = o.i18n("maxFileSize") : "number" === e.type(i) && i < n.minFileSize ? a.error = o.i18n("minFileSize") : delete a.error : a.error = o.i18n("acceptFileTypes"), a.error || t.files.error ? (t.files.error = !0, r.rejectWith(this, [t])) : r.resolveWith(this, [t]), r.promise();
          }
        }
      });
    });
  }, function (e, t, n) {
    var i, r, o;
    !function (a) {
      "use strict";

      r = [n(0), n(4)], void 0 === (o = "function" == typeof (i = function i(e) {
        var t = e.blueimp.fileupload.prototype.options.add;
        e.widget("blueimp.fileupload", e.blueimp.fileupload, {
          options: {
            processQueue: [],
            add: function add(n, i) {
              var r = e(this);
              i.process(function () {
                return r.fileupload("process", i);
              }), t.call(this, n, i);
            }
          },
          processActions: {},
          _processFile: function _processFile(t, n) {
            var i = this,
                r = e.Deferred().resolveWith(i, [t]),
                o = r.promise();
            return this._trigger("process", null, t), e.each(t.processQueue, function (t, r) {
              var a = function a(t) {
                return n.errorThrown ? e.Deferred().rejectWith(i, [n]).promise() : i.processActions[r.action].call(i, t, r);
              };

              o = o.then(a, r.always && a);
            }), o.done(function () {
              i._trigger("processdone", null, t), i._trigger("processalways", null, t);
            }).fail(function () {
              i._trigger("processfail", null, t), i._trigger("processalways", null, t);
            }), o;
          },
          _transformProcessQueue: function _transformProcessQueue(t) {
            var n = [];
            e.each(t.processQueue, function () {
              var i = {},
                  r = this.action,
                  o = !0 === this.prefix ? r : this.prefix;
              e.each(this, function (n, r) {
                "string" === e.type(r) && "@" === r.charAt(0) ? i[n] = t[r.slice(1) || (o ? o + n.charAt(0).toUpperCase() + n.slice(1) : n)] : i[n] = r;
              }), n.push(i);
            }), t.processQueue = n;
          },
          processing: function processing() {
            return this._processing;
          },
          process: function process(t) {
            var n = this,
                i = e.extend({}, this.options, t);
            return i.processQueue && i.processQueue.length && (this._transformProcessQueue(i), 0 === this._processing && this._trigger("processstart"), e.each(t.files, function (r) {
              var o = r ? e.extend({}, i) : i,
                  a = function a() {
                return t.errorThrown ? e.Deferred().rejectWith(n, [t]).promise() : n._processFile(o, t);
              };

              o.index = r, n._processing += 1, n._processingQueue = n._processingQueue.then(a, a).always(function () {
                n._processing -= 1, 0 === n._processing && n._trigger("processstop");
              });
            })), this._processingQueue;
          },
          _create: function _create() {
            this._super(), this._processing = 0, this._processingQueue = e.Deferred().resolveWith(this).promise();
          }
        });
      }) ? i.apply(t, r) : i) || (e.exports = o);
    }();
  }, function (e, t, n) {}, function (e, t, n) {
    (function (e) {
      n(32);
      e(function () {
        var t = ".simple_form_nested_fields";
        e(t).SimpleFormNestedFields(), new MutationObserver(function (n) {
          n.forEach(function (n) {
            return e(t).SimpleFormNestedFields();
          });
        }).observe(document.documentElement, {
          childList: !0,
          subtree: !0
        });
      });
    }).call(this, n(0));
  }, function (e, t, n) {
    "use strict";

    n.r(t), function (e) {
      var t,
          i = n(6),
          r = n.n(i);
      t = e, window, t.fn.SimpleFormNestedFields = function (e) {
        this.each(function () {
          if (!t.data(this, "plugin_SimpleFormNestedFields")) {
            var _e5 = new r.a(this);

            t.data(this, "plugin_SimpleFormNestedFields", _e5);
          }
        });
      };
    }.call(this, n(0));
  }, function (e, t, n) {
    var i, r;
    /**!
     * Sortable
     * @author	RubaXa   <trash@rubaxa.org>
     * @author	owenm    <owen23355@gmail.com>
     * @license MIT
     */

    /**!
     * Sortable
     * @author	RubaXa   <trash@rubaxa.org>
     * @author	owenm    <owen23355@gmail.com>
     * @license MIT
     */

    !function (o) {
      "use strict";

      void 0 === (r = "function" == typeof (i = o) ? i.call(t, n, t, e) : i) || (e.exports = r);
    }(function () {
      "use strict";

      if ("undefined" == typeof window || !window.document) return function () {
        throw new Error("Sortable.js requires a window with a document");
      };

      var e,
          t,
          n,
          i,
          r,
          o,
          a,
          s,
          l,
          c,
          u,
          d,
          p,
          h,
          f,
          m,
          g,
          v,
          b,
          y,
          _,
          w,
          x,
          C,
          S,
          D,
          E,
          k,
          T = [],
          O = !1,
          P = !1,
          A = !1,
          M = [],
          N = !1,
          I = !1,
          F = [],
          j = /\s+/g,
          L = "Sortable" + new Date().getTime(),
          R = window,
          H = R.document,
          B = R.parseInt,
          q = R.setTimeout,
          $ = R.jQuery || R.Zepto,
          W = R.Polymer,
          U = {
        capture: !1,
        passive: !1
      },
          Y = !!navigator.userAgent.match(/(?:Trident.*rv[ :]?11\.|msie|iemobile)/i),
          X = !!navigator.userAgent.match(/Edge/i),
          z = !!navigator.userAgent.match(/firefox/i),
          V = !(!navigator.userAgent.match(/safari/i) || navigator.userAgent.match(/chrome/i) || navigator.userAgent.match(/android/i)),
          K = !!navigator.userAgent.match(/iP(ad|od|hone)/i),
          Q = X || Y ? "cssFloat" : "float",
          Z = "draggable" in H.createElement("div"),
          G = function () {
        if (Y) return !1;
        var e = H.createElement("x");
        return e.style.cssText = "pointer-events:auto", "auto" === e.style.pointerEvents;
      }(),
          J = !1,
          ee = !1,
          te = Math.abs,
          ne = Math.min,
          ie = Math.max,
          re = [],
          oe = function oe(e, t) {
        var n = Se(e),
            i = B(n.width) - B(n.paddingLeft) - B(n.paddingRight) - B(n.borderLeftWidth) - B(n.borderRightWidth),
            r = Ae(e, 0, t),
            o = Ae(e, 1, t),
            a = r && Se(r),
            s = o && Se(o),
            l = a && B(a.marginLeft) + B(a.marginRight) + $e(r).width,
            c = s && B(s.marginLeft) + B(s.marginRight) + $e(o).width;
        if ("flex" === n.display) return "column" === n.flexDirection || "column-reverse" === n.flexDirection ? "vertical" : "horizontal";
        if ("grid" === n.display) return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";

        if (r && "none" !== a["float"]) {
          var u = "left" === a["float"] ? "left" : "right";
          return !o || "both" !== s.clear && s.clear !== u ? "horizontal" : "vertical";
        }

        return r && ("block" === a.display || "flex" === a.display || "table" === a.display || "grid" === a.display || l >= i && "none" === n[Q] || o && "none" === n[Q] && l + c > i) ? "vertical" : "horizontal";
      },
          ae = function ae(e, t, n, i, r) {
        var o = $e(n),
            a = "vertical" === i ? o.left : o.top,
            s = "vertical" === i ? o.right : o.bottom,
            l = "vertical" === i ? e : t;
        return a < l && l < s;
      },
          se = function se(e, t) {
        if (!e || !e.getBoundingClientRect) return le();
        var n = e,
            i = !1;

        do {
          if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
            var r = Se(n);

            if (n.clientWidth < n.scrollWidth && ("auto" == r.overflowX || "scroll" == r.overflowX) || n.clientHeight < n.scrollHeight && ("auto" == r.overflowY || "scroll" == r.overflowY)) {
              if (!n || !n.getBoundingClientRect || n === H.body) return le();
              if (i || t) return n;
              i = !0;
            }
          }
        } while (n = n.parentNode);

        return le();
      },
          le = function le() {
        return Y ? H.documentElement : H.scrollingElement;
      },
          ce = function ce(e, t, n) {
        e.scrollLeft += t, e.scrollTop += n;
      },
          ue = Le(function (e, t, n, i) {
        if (t.scroll) {
          var r = n ? n[L] : window,
              o = t.scrollSensitivity,
              a = t.scrollSpeed,
              u = e.clientX,
              d = e.clientY,
              p = le(),
              h = !1;
          l !== n && (de(), s = t.scroll, c = t.scrollFn, !0 === s && (s = se(n, !0), l = s));
          var f = 0,
              m = s;

          do {
            var g,
                v,
                b,
                y,
                w,
                x,
                C,
                S,
                D,
                E = m,
                k = $e(E),
                P = k.top,
                A = k.bottom,
                M = k.left,
                N = k.right,
                I = k.width,
                F = k.height;
            if (g = E.scrollWidth, v = E.scrollHeight, b = Se(E), S = E.scrollLeft, D = E.scrollTop, E === p ? (x = I < g && ("auto" === b.overflowX || "scroll" === b.overflowX || "visible" === b.overflowX), C = F < v && ("auto" === b.overflowY || "scroll" === b.overflowY || "visible" === b.overflowY)) : (x = I < g && ("auto" === b.overflowX || "scroll" === b.overflowX), C = F < v && ("auto" === b.overflowY || "scroll" === b.overflowY)), y = x && (te(N - u) <= o && S + I < g) - (te(M - u) <= o && !!S), w = C && (te(A - d) <= o && D + F < v) - (te(P - d) <= o && !!D), !T[f]) for (var j = 0; j <= f; j++) {
              T[j] || (T[j] = {});
            }
            T[f].vx == y && T[f].vy == w && T[f].el === E || (T[f].el = E, T[f].vx = y, T[f].vy = w, clearInterval(T[f].pid), !E || 0 == y && 0 == w || (h = !0, T[f].pid = setInterval(function () {
              i && 0 === this.layer && (be.active._emulateDragOver(!0), be.active._onTouchMove(_, !0));
              var t = T[this.layer].vy ? T[this.layer].vy * a : 0,
                  n = T[this.layer].vx ? T[this.layer].vx * a : 0;
              "function" == typeof c && "continue" !== c.call(r, n, t, e, _, T[this.layer].el) || ce(T[this.layer].el, n, t);
            }.bind({
              layer: f
            }), 24))), f++;
          } while (t.bubbleScroll && m !== p && (m = se(m, !1)));

          O = h;
        }
      }, 30),
          de = function de() {
        T.forEach(function (e) {
          clearInterval(e.pid);
        }), T = [];
      },
          pe = function pe(e) {
        function t(e, n) {
          return function (i, r, o, a) {
            var s = i.options.group.name && r.options.group.name && i.options.group.name === r.options.group.name;
            if (null == e && (n || s)) return !0;
            if (null == e || !1 === e) return !1;
            if (n && "clone" === e) return e;
            if ("function" == typeof e) return t(e(i, r, o, a), n)(i, r, o, a);
            var l = (n ? i : r).options.group.name;
            return !0 === e || "string" == typeof e && e === l || e.join && e.indexOf(l) > -1;
          };
        }

        var n = {},
            i = e.group;
        i && "object" == _typeof(i) || (i = {
          name: i
        }), n.name = i.name, n.checkPull = t(i.pull, !0), n.checkPut = t(i.put), n.revertClone = i.revertClone, e.group = n;
      },
          he = function he(t) {
        e && e.parentNode && e.parentNode[L] && e.parentNode[L]._computeIsAligned(t);
      },
          fe = function fe() {
        !G && n && Se(n, "display", "none");
      },
          me = function me() {
        !G && n && Se(n, "display", "");
      };

      H.addEventListener("click", function (e) {
        if (A) return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), A = !1, !1;
      }, !0);

      var ge,
          ve = function ve(t) {
        if (e) {
          var n = function (e, t) {
            for (var n = 0; n < M.length; n++) {
              if (!Me(M[n])) {
                var i = $e(M[n]),
                    r = M[n][L].options.emptyInsertThreshold,
                    o = e >= i.left - r && e <= i.right + r,
                    a = t >= i.top - r && t <= i.bottom + r;
                if (r && o && a) return M[n];
              }
            }
          }((t = t.touches ? t.touches[0] : t).clientX, t.clientY);

          if (n) {
            var i = {};

            for (var r in t) {
              i[r] = t[r];
            }

            i.target = i.rootEl = n, i.preventDefault = void 0, i.stopPropagation = void 0, n[L]._onDragOver(i);
          }
        }
      };

      function be(e, t) {
        if (!e || !e.nodeType || 1 !== e.nodeType) throw "Sortable: `el` must be HTMLElement, not " + {}.toString.call(e);
        this.el = e, this.options = t = Re({}, t), e[L] = this;
        var n = {
          group: null,
          sort: !0,
          disabled: !1,
          store: null,
          handle: null,
          scroll: !0,
          scrollSensitivity: 30,
          scrollSpeed: 10,
          bubbleScroll: !0,
          draggable: /[uo]l/i.test(e.nodeName) ? ">li" : ">*",
          swapThreshold: 1,
          invertSwap: !1,
          invertedSwapThreshold: null,
          removeCloneOnHide: !0,
          direction: function direction() {
            return oe(e, this.options);
          },
          ghostClass: "sortable-ghost",
          chosenClass: "sortable-chosen",
          dragClass: "sortable-drag",
          ignore: "a, img",
          filter: null,
          preventOnFilter: !0,
          animation: 0,
          easing: null,
          setData: function setData(e, t) {
            e.setData("Text", t.textContent);
          },
          dropBubble: !1,
          dragoverBubble: !1,
          dataIdAttr: "data-id",
          delay: 0,
          delayOnTouchOnly: !1,
          touchStartThreshold: B(window.devicePixelRatio, 10) || 1,
          forceFallback: !1,
          fallbackClass: "sortable-fallback",
          fallbackOnBody: !1,
          fallbackTolerance: 0,
          fallbackOffset: {
            x: 0,
            y: 0
          },
          supportPointer: !1 !== be.supportPointer && "PointerEvent" in window,
          emptyInsertThreshold: 5
        };

        for (var i in n) {
          !(i in t) && (t[i] = n[i]);
        }

        for (var r in pe(t), this) {
          "_" === r.charAt(0) && "function" == typeof this[r] && (this[r] = this[r].bind(this));
        }

        this.nativeDraggable = !t.forceFallback && Z, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? we(e, "pointerdown", this._onTapStart) : (we(e, "mousedown", this._onTapStart), we(e, "touchstart", this._onTapStart)), this.nativeDraggable && (we(e, "dragover", this), we(e, "dragenter", this)), M.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []);
      }

      function ye(e, t, n, i) {
        if (e) {
          n = n || H;

          do {
            if (null != t && (">" === t[0] ? e.parentNode === n && je(e, t) : je(e, t)) || i && e === n) return e;
            if (e === n) break;
          } while (e = _e(e));
        }

        return null;
      }

      function _e(e) {
        return e.host && e !== H && e.host.nodeType ? e.host : e.parentNode;
      }

      function we(e, t, n) {
        e.addEventListener(t, n, !Y && U);
      }

      function xe(e, t, n) {
        e.removeEventListener(t, n, !Y && U);
      }

      function Ce(e, t, n) {
        if (e && t) if (e.classList) e.classList[n ? "add" : "remove"](t);else {
          var i = (" " + e.className + " ").replace(j, " ").replace(" " + t + " ", " ");
          e.className = (i + (n ? " " + t : "")).replace(j, " ");
        }
      }

      function Se(e, t, n) {
        var i = e && e.style;

        if (i) {
          if (void 0 === n) return H.defaultView && H.defaultView.getComputedStyle ? n = H.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), void 0 === t ? n : n[t];
          t in i || -1 !== t.indexOf("webkit") || (t = "-webkit-" + t), i[t] = n + ("string" == typeof n ? "" : "px");
        }
      }

      function De(e) {
        var t = "";

        do {
          var n = Se(e, "transform");
          n && "none" !== n && (t = n + " " + t);
        } while (e = e.parentNode);

        return window.DOMMatrix ? new DOMMatrix(t) : window.WebKitCSSMatrix ? new WebKitCSSMatrix(t) : window.CSSMatrix ? new CSSMatrix(t) : void 0;
      }

      function Ee(e, t, n) {
        if (e) {
          var i = e.getElementsByTagName(t),
              r = 0,
              o = i.length;
          if (n) for (; r < o; r++) {
            n(i[r], r);
          }
          return i;
        }

        return [];
      }

      function ke(e, t, n, r, o, a, s, l, c, u, d) {
        var p,
            h = (e = e || t[L]).options,
            f = "on" + n.charAt(0).toUpperCase() + n.substr(1);
        !window.CustomEvent || Y || X ? (p = H.createEvent("Event")).initEvent(n, !0, !0) : p = new CustomEvent(n, {
          bubbles: !0,
          cancelable: !0
        }), p.to = o || t, p.from = a || t, p.item = r || t, p.clone = i, p.oldIndex = s, p.newIndex = l, p.oldDraggableIndex = c, p.newDraggableIndex = u, p.originalEvent = d, p.pullMode = m ? m.lastPutMode : void 0, t && t.dispatchEvent(p), h[f] && h[f].call(e, p);
      }

      function Te(e, t, n, i, r, o, a, s) {
        var l,
            c,
            u = e[L],
            d = u.options.onMove;
        return !window.CustomEvent || Y || X ? (l = H.createEvent("Event")).initEvent("move", !0, !0) : l = new CustomEvent("move", {
          bubbles: !0,
          cancelable: !0
        }), l.to = t, l.from = e, l.dragged = n, l.draggedRect = i, l.related = r || t, l.relatedRect = o || $e(t), l.willInsertAfter = s, l.originalEvent = a, e.dispatchEvent(l), d && (c = d.call(u, l, a)), c;
      }

      function Oe(e) {
        e.draggable = !1;
      }

      function Pe() {
        J = !1;
      }

      function Ae(t, i, r) {
        for (var o = 0, a = 0, s = t.children; a < s.length;) {
          if ("none" !== s[a].style.display && s[a] !== n && s[a] !== e && ye(s[a], r.draggable, t, !1)) {
            if (o === i) return s[a];
            o++;
          }

          a++;
        }

        return null;
      }

      function Me(e) {
        for (var t = e.lastElementChild; t && (t === n || "none" === Se(t, "display"));) {
          t = t.previousElementSibling;
        }

        return t || null;
      }

      function Ne(t) {
        return Fe(e) < Fe(t) ? 1 : -1;
      }

      function Ie(e) {
        for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, i = 0; n--;) {
          i += t.charCodeAt(n);
        }

        return i.toString(36);
      }

      function Fe(e, t) {
        var n = 0;
        if (!e || !e.parentNode) return -1;

        for (; e && (e = e.previousElementSibling);) {
          "TEMPLATE" === e.nodeName.toUpperCase() || e === i || t && !je(e, t) || n++;
        }

        return n;
      }

      function je(e, t) {
        if (t) {
          if (">" === t[0] && (t = t.substring(1)), e) try {
            if (e.matches) return e.matches(t);
            if (e.msMatchesSelector) return e.msMatchesSelector(t);
            if (e.webkitMatchesSelector) return e.webkitMatchesSelector(t);
          } catch (e) {
            return !1;
          }
          return !1;
        }
      }

      function Le(e, t) {
        return function () {
          if (!ge) {
            var n = arguments,
                i = this;
            ge = q(function () {
              1 === n.length ? e.call(i, n[0]) : e.apply(i, n), ge = void 0;
            }, t);
          }
        };
      }

      function Re(e, t) {
        if (e && t) for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
        return e;
      }

      function He(e) {
        return W && W.dom ? W.dom(e).cloneNode(!0) : $ ? $(e).clone(!0)[0] : e.cloneNode(!0);
      }

      function Be(e) {
        return q(e, 0);
      }

      function qe(e) {
        return clearTimeout(e);
      }

      function $e(e, t, n, i) {
        if (e.getBoundingClientRect || e === R) {
          var r, o, a, s, l, c, u;
          if (e !== R && e !== le() ? (o = (r = e.getBoundingClientRect()).top, a = r.left, s = r.bottom, l = r.right, c = r.height, u = r.width) : (o = 0, a = 0, s = window.innerHeight, l = window.innerWidth, c = window.innerHeight, u = window.innerWidth), i && e !== R && (n = n || e.parentNode, !Y)) do {
            if (n && n.getBoundingClientRect && "none" !== Se(n, "transform")) {
              var d = n.getBoundingClientRect();
              o -= d.top + B(Se(n, "border-top-width")), a -= d.left + B(Se(n, "border-left-width")), s = o + r.height, l = a + r.width;
              break;
            }
          } while (n = n.parentNode);

          if (t && e !== R) {
            var p = De(n || e),
                h = p && p.a,
                f = p && p.d;
            p && (s = (o /= f) + (c /= f), l = (a /= h) + (u /= h));
          }

          return {
            top: o,
            left: a,
            bottom: s,
            right: l,
            width: u,
            height: c
          };
        }
      }

      function We(e, t) {
        for (var n = se(e, !0), i = $e(e)[t]; n;) {
          var r = $e(n)[t];
          if (!("top" === t || "left" === t ? i >= r : i <= r)) return n;
          if (n === le()) break;
          n = se(n, !1);
        }

        return !1;
      }

      function Ue(e) {
        var t = 0,
            n = 0,
            i = le();
        if (e) do {
          var r = De(e),
              o = r.a,
              a = r.d;
          t += e.scrollLeft * o, n += e.scrollTop * a;
        } while (e !== i && (e = e.parentNode));
        return [t, n];
      }

      return be.prototype = {
        constructor: be,
        _computeIsAligned: function _computeIsAligned(t) {
          var i;

          if (n && !G ? (fe(), i = H.elementFromPoint(t.clientX, t.clientY), me()) : i = t.target, i = ye(i, this.options.draggable, this.el, !1), !ee && e && e.parentNode === this.el) {
            for (var r = this.el.children, o = 0; o < r.length; o++) {
              ye(r[o], this.options.draggable, this.el, !1) && r[o] !== i && (r[o].sortableMouseAligned = ae(t.clientX, t.clientY, r[o], this._getDirection(t, null), this.options));
            }

            ye(i, this.options.draggable, this.el, !0) || (x = null), ee = !0, q(function () {
              ee = !1;
            }, 30);
          }
        },
        _getDirection: function _getDirection(t, n) {
          return "function" == typeof this.options.direction ? this.options.direction.call(this, t, n, e) : this.options.direction;
        },
        _onTapStart: function _onTapStart(t) {
          if (t.cancelable) {
            var n,
                i,
                r = this,
                o = this.el,
                s = this.options,
                l = s.preventOnFilter,
                c = t.type,
                u = t.touches && t.touches[0],
                d = (u || t).target,
                p = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || d,
                h = s.filter;

            if (function (e) {
              re.length = 0;
              var t = e.getElementsByTagName("input"),
                  n = t.length;

              for (; n--;) {
                var i = t[n];
                i.checked && re.push(i);
              }
            }(o), !e && !(/mousedown|pointerdown/.test(c) && 0 !== t.button || s.disabled || p.isContentEditable || (d = ye(d, s.draggable, o, !1), a === d))) {
              if (n = Fe(d), i = Fe(d, s.draggable), "function" == typeof h) {
                if (h.call(this, t, d, this)) return ke(r, p, "filter", d, o, o, n, void 0, i), void (l && t.cancelable && t.preventDefault());
              } else if (h && (h = h.split(",").some(function (e) {
                if (e = ye(p, e.trim(), o, !1)) return ke(r, e, "filter", d, o, o, n, void 0, i), !0;
              }))) return void (l && t.cancelable && t.preventDefault());

              s.handle && !ye(p, s.handle, o, !1) || this._prepareDragStart(t, u, d, n, i);
            }
          }
        },
        _handleAutoScroll: function _handleAutoScroll(t, n) {
          if (e && this.options.scroll) {
            var i = t.clientX,
                r = t.clientY,
                o = H.elementFromPoint(i, r),
                a = this;

            if (n || X || Y || V) {
              ue(t, a.options, o, n);
              var s = se(o, !0);
              !O || g && i === v && r === b || (g && clearInterval(g), g = setInterval(function () {
                if (e) {
                  var o = se(H.elementFromPoint(i, r), !0);
                  o !== s && (s = o, de(), ue(t, a.options, s, n));
                }
              }, 10), v = i, b = r);
            } else {
              if (!a.options.bubbleScroll || se(o, !0) === le()) return void de();
              ue(t, a.options, se(o, !1), !1);
            }
          }
        },
        _prepareDragStart: function _prepareDragStart(n, i, s, l, c) {
          var d,
              h = this,
              m = h.el,
              g = h.options,
              v = m.ownerDocument;
          s && !e && s.parentNode === m && (r = m, t = (e = s).parentNode, o = e.nextSibling, a = s, f = g.group, u = l, p = c, y = {
            target: e,
            clientX: (i || n).clientX,
            clientY: (i || n).clientY
          }, this._lastX = (i || n).clientX, this._lastY = (i || n).clientY, e.style["will-change"] = "all", e.style.transition = "", e.style.transform = "", d = function d() {
            h._disableDelayedDragEvents(), !z && h.nativeDraggable && (e.draggable = !0), h._triggerDragStart(n, i), ke(h, r, "choose", e, r, r, u, void 0, p), Ce(e, g.chosenClass, !0);
          }, g.ignore.split(",").forEach(function (t) {
            Ee(e, t.trim(), Oe);
          }), we(v, "dragover", ve), we(v, "mousemove", ve), we(v, "touchmove", ve), we(v, "mouseup", h._onDrop), we(v, "touchend", h._onDrop), we(v, "touchcancel", h._onDrop), z && this.nativeDraggable && (this.options.touchStartThreshold = 4, e.draggable = !0), !g.delay || g.delayOnTouchOnly && !i || this.nativeDraggable && (X || Y) ? d() : (we(v, "mouseup", h._disableDelayedDrag), we(v, "touchend", h._disableDelayedDrag), we(v, "touchcancel", h._disableDelayedDrag), we(v, "mousemove", h._delayedDragTouchMoveHandler), we(v, "touchmove", h._delayedDragTouchMoveHandler), g.supportPointer && we(v, "pointermove", h._delayedDragTouchMoveHandler), h._dragStartTimer = q(d, g.delay)));
        },
        _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
          var t = e.touches ? e.touches[0] : e;
          ie(te(t.clientX - this._lastX), te(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
        },
        _disableDelayedDrag: function _disableDelayedDrag() {
          e && Oe(e), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
        },
        _disableDelayedDragEvents: function _disableDelayedDragEvents() {
          var e = this.el.ownerDocument;
          xe(e, "mouseup", this._disableDelayedDrag), xe(e, "touchend", this._disableDelayedDrag), xe(e, "touchcancel", this._disableDelayedDrag), xe(e, "mousemove", this._delayedDragTouchMoveHandler), xe(e, "touchmove", this._delayedDragTouchMoveHandler), xe(e, "pointermove", this._delayedDragTouchMoveHandler);
        },
        _triggerDragStart: function _triggerDragStart(t, n) {
          n = n || ("touch" == t.pointerType ? t : null), !this.nativeDraggable || n ? this.options.supportPointer ? we(H, "pointermove", this._onTouchMove) : we(H, n ? "touchmove" : "mousemove", this._onTouchMove) : (we(e, "dragend", this), we(r, "dragstart", this._onDragStart));

          try {
            H.selection ? Be(function () {
              H.selection.empty();
            }) : window.getSelection().removeAllRanges();
          } catch (e) {}
        },
        _dragStarted: function _dragStarted(t, n) {
          if (P = !1, r && e) {
            this.nativeDraggable && (we(H, "dragover", this._handleAutoScroll), we(H, "dragover", he));
            var i = this.options;
            !t && Ce(e, i.dragClass, !1), Ce(e, i.ghostClass, !0), Se(e, "transform", ""), be.active = this, t && this._appendGhost(), ke(this, r, "start", e, r, r, u, void 0, p, void 0, n);
          } else this._nulling();
        },
        _emulateDragOver: function _emulateDragOver(t) {
          if (_) {
            if (this._lastX === _.clientX && this._lastY === _.clientY && !t) return;
            this._lastX = _.clientX, this._lastY = _.clientY, fe();

            for (var n = H.elementFromPoint(_.clientX, _.clientY), i = n; n && n.shadowRoot && (n = n.shadowRoot.elementFromPoint(_.clientX, _.clientY)) !== i;) {
              i = n;
            }

            if (i) do {
              if (i[L]) if (i[L]._onDragOver({
                clientX: _.clientX,
                clientY: _.clientY,
                target: n,
                rootEl: i
              }) && !this.options.dragoverBubble) break;
              n = i;
            } while (i = i.parentNode);
            e.parentNode[L]._computeIsAligned(_), me();
          }
        },
        _onTouchMove: function _onTouchMove(e, t) {
          if (y) {
            var i = this.options,
                r = i.fallbackTolerance,
                o = i.fallbackOffset,
                a = e.touches ? e.touches[0] : e,
                s = n && De(n),
                l = n && s && s.a,
                c = n && s && s.d,
                u = K && E && Ue(E),
                d = (a.clientX - y.clientX + o.x) / (l || 1) + (u ? u[0] - F[0] : 0) / (l || 1),
                p = (a.clientY - y.clientY + o.y) / (c || 1) + (u ? u[1] - F[1] : 0) / (c || 1),
                h = e.touches ? "translate3d(" + d + "px," + p + "px,0)" : "translate(" + d + "px," + p + "px)";

            if (!be.active && !P) {
              if (r && ne(te(a.clientX - this._lastX), te(a.clientY - this._lastY)) < r) return;

              this._onDragStart(e, !0);
            }

            !t && this._handleAutoScroll(a, !0), w = !0, _ = a, Se(n, "webkitTransform", h), Se(n, "mozTransform", h), Se(n, "msTransform", h), Se(n, "transform", h), e.cancelable && e.preventDefault();
          }
        },
        _appendGhost: function _appendGhost() {
          if (!n) {
            var t = this.options.fallbackOnBody ? H.body : r,
                i = $e(e, !0, t, !K),
                o = (Se(e), this.options);

            if (K) {
              for (E = t; "static" === Se(E, "position") && "none" === Se(E, "transform") && E !== H;) {
                E = E.parentNode;
              }

              if (E !== H) {
                var a = $e(E, !0);
                i.top -= a.top, i.left -= a.left;
              }

              E !== H.body && E !== H.documentElement ? (E === H && (E = le()), i.top += E.scrollTop, i.left += E.scrollLeft) : E = le(), F = Ue(E);
            }

            Ce(n = e.cloneNode(!0), o.ghostClass, !1), Ce(n, o.fallbackClass, !0), Ce(n, o.dragClass, !0), Se(n, "box-sizing", "border-box"), Se(n, "margin", 0), Se(n, "top", i.top), Se(n, "left", i.left), Se(n, "width", i.width), Se(n, "height", i.height), Se(n, "opacity", "0.8"), Se(n, "position", K ? "absolute" : "fixed"), Se(n, "zIndex", "100000"), Se(n, "pointerEvents", "none"), t.appendChild(n);
          }
        },
        _onDragStart: function _onDragStart(t, n) {
          var o = this,
              a = t.dataTransfer,
              s = o.options;
          (i = He(e)).draggable = !1, i.style["will-change"] = "", this._hideClone(), Ce(i, o.options.chosenClass, !1), o._cloneId = Be(function () {
            o.options.removeCloneOnHide || r.insertBefore(i, e), ke(o, r, "clone", e);
          }), !n && Ce(e, s.dragClass, !0), n ? (A = !0, o._loopId = setInterval(o._emulateDragOver, 50)) : (xe(H, "mouseup", o._onDrop), xe(H, "touchend", o._onDrop), xe(H, "touchcancel", o._onDrop), a && (a.effectAllowed = "move", s.setData && s.setData.call(o, a, e)), we(H, "drop", o), Se(e, "transform", "translateZ(0)")), P = !0, o._dragStartId = Be(o._dragStarted.bind(o, n, t)), we(H, "selectstart", o), V && Se(H.body, "user-select", "none");
        },
        _onDragOver: function _onDragOver(n) {
          var i,
              a,
              s,
              l = this.el,
              c = n.target,
              d = this.options,
              h = d.group,
              g = be.active,
              v = f === h,
              b = d.sort,
              y = this;

          if (!J) {
            if (void 0 !== n.preventDefault && n.cancelable && n.preventDefault(), w = !0, c = ye(c, d.draggable, l, !0), e.contains(n.target) || c.animated) return U(!1);

            if (c !== e && (A = !1), g && !d.disabled && (v ? b || (s = !r.contains(e)) : m === this || (this.lastPutMode = f.checkPull(this, g, e, n)) && h.checkPut(this, g, e, n))) {
              var _ = this._getDirection(n, c);

              if (i = $e(e), s) return this._hideClone(), t = r, o ? r.insertBefore(e, o) : r.appendChild(e), U(!0);
              var E = Me(l);

              if (!E || function (e, t, n) {
                var i = $e(Me(n)),
                    r = "vertical" === t ? e.clientY : e.clientX,
                    o = "vertical" === t ? e.clientX : e.clientY,
                    a = "vertical" === t ? i.bottom : i.right,
                    s = "vertical" === t ? i.left : i.top,
                    l = "vertical" === t ? i.right : i.bottom;
                return "vertical" === t ? o > l + 10 || o <= l && r > a && o >= s : r > a && o > s || r <= a && o > l + 10;
              }(n, _, l) && !E.animated) {
                if (E && l === n.target && (c = E), c && (a = $e(c)), v ? g._hideClone() : g._showClone(this), !1 !== Te(r, l, e, i, c, a, n, !!c)) return l.appendChild(e), t = l, k = null, Y(), U(!0);
              } else if (c && c !== e && c.parentNode === l) {
                var T,
                    O = 0,
                    P = c.sortableMouseAligned,
                    M = e.parentNode !== l,
                    F = "vertical" === _ ? "top" : "left",
                    j = We(c, "top") || We(e, "top"),
                    R = j ? j.scrollTop : void 0;
                if (x !== c && (S = null, T = $e(c)[F], N = !1), function (t, n, i) {
                  var r = t === e && k || $e(t),
                      o = n === e && k || $e(n),
                      a = "vertical" === i ? r.left : r.top,
                      s = "vertical" === i ? r.right : r.bottom,
                      l = "vertical" === i ? r.width : r.height,
                      c = "vertical" === i ? o.left : o.top,
                      u = "vertical" === i ? o.right : o.bottom,
                      d = "vertical" === i ? o.width : o.height;
                  return a === c || s === u || a + l / 2 === c + d / 2;
                }(e, c, _) && P || M || j || d.invertSwap || "insert" === S || "swap" === S ? ("swap" !== S && (I = d.invertSwap || M), O = function (t, n, i, r, o, a, s) {
                  var l = $e(n),
                      c = "vertical" === i ? t.clientY : t.clientX,
                      u = "vertical" === i ? l.height : l.width,
                      d = "vertical" === i ? l.top : l.left,
                      p = "vertical" === i ? l.bottom : l.right,
                      h = $e(e),
                      f = !1;
                  if (!a) if (s && D < u * r) {
                    if (!N && (1 === C ? c > d + u * o / 2 : c < p - u * o / 2) && (N = !0), N) f = !0;else {
                      "vertical" === i ? h.top : h.left, "vertical" === i ? h.bottom : h.right;
                      if (1 === C ? c < d + D : c > p - D) return -1 * C;
                    }
                  } else if (c > d + u * (1 - r) / 2 && c < p - u * (1 - r) / 2) return Ne(n);
                  if ((f = f || a) && (c < d + u * o / 2 || c > p - u * o / 2)) return c > d + u / 2 ? 1 : -1;
                  return 0;
                }(n, c, _, d.swapThreshold, null == d.invertedSwapThreshold ? d.swapThreshold : d.invertedSwapThreshold, I, x === c), S = "swap") : (O = Ne(c), S = "insert"), 0 === O) return U(!1);
                k = null, x = c, C = O, a = $e(c);
                var B = c.nextElementSibling,
                    $ = !1,
                    W = Te(r, l, e, i, c, a, n, $ = 1 === O);
                if (!1 !== W) return 1 !== W && -1 !== W || ($ = 1 === W), J = !0, q(Pe, 30), v ? g._hideClone() : g._showClone(this), $ && !B ? l.appendChild(e) : c.parentNode.insertBefore(e, $ ? B : c), j && ce(j, 0, R - j.scrollTop), t = e.parentNode, void 0 === T || I || (D = te(T - $e(c)[F])), Y(), U(!0);
              }

              if (l.contains(e)) return U(!1);
            }

            return !1;
          }

          function U(t) {
            return t && (v ? g._hideClone() : g._showClone(y), g && (Ce(e, m ? m.options.ghostClass : g.options.ghostClass, !1), Ce(e, d.ghostClass, !0)), m !== y && y !== be.active ? m = y : y === be.active && (m = null), i && y._animate(i, e), c && a && y._animate(a, c)), (c === e && !e.animated || c === l && !c.animated) && (x = null), d.dragoverBubble || n.rootEl || c === H || (y._handleAutoScroll(n), e.parentNode[L]._computeIsAligned(n), !t && ve(n)), !d.dragoverBubble && n.stopPropagation && n.stopPropagation(), !0;
          }

          function Y() {
            ke(y, r, "change", c, l, r, u, Fe(e), p, Fe(e, d.draggable), n);
          }
        },
        _animate: function _animate(t, n) {
          var i = this.options.animation;

          if (i) {
            var r = $e(n);

            if (n === e && (k = r), 1 === t.nodeType && (t = $e(t)), t.left + t.width / 2 !== r.left + r.width / 2 || t.top + t.height / 2 !== r.top + r.height / 2) {
              var o = De(this.el),
                  a = o && o.a,
                  s = o && o.d;
              Se(n, "transition", "none"), Se(n, "transform", "translate3d(" + (t.left - r.left) / (a || 1) + "px," + (t.top - r.top) / (s || 1) + "px,0)"), this._repaint(n), Se(n, "transition", "transform " + i + "ms" + (this.options.easing ? " " + this.options.easing : "")), Se(n, "transform", "translate3d(0,0,0)");
            }

            "number" == typeof n.animated && clearTimeout(n.animated), n.animated = q(function () {
              Se(n, "transition", ""), Se(n, "transform", ""), n.animated = !1;
            }, i);
          }
        },
        _repaint: function _repaint(e) {
          return e.offsetWidth;
        },
        _offMoveEvents: function _offMoveEvents() {
          xe(H, "touchmove", this._onTouchMove), xe(H, "pointermove", this._onTouchMove), xe(H, "dragover", ve), xe(H, "mousemove", ve), xe(H, "touchmove", ve);
        },
        _offUpEvents: function _offUpEvents() {
          var e = this.el.ownerDocument;
          xe(e, "mouseup", this._onDrop), xe(e, "touchend", this._onDrop), xe(e, "pointerup", this._onDrop), xe(e, "touchcancel", this._onDrop), xe(H, "selectstart", this);
        },
        _onDrop: function _onDrop(a) {
          var s = this.el,
              l = this.options;
          P = !1, O = !1, I = !1, N = !1, clearInterval(this._loopId), clearInterval(g), de(), clearTimeout(ge), ge = void 0, clearTimeout(this._dragStartTimer), qe(this._cloneId), qe(this._dragStartId), xe(H, "mousemove", this._onTouchMove), this.nativeDraggable && (xe(H, "drop", this), xe(s, "dragstart", this._onDragStart), xe(H, "dragover", this._handleAutoScroll), xe(H, "dragover", he)), V && Se(H.body, "user-select", ""), this._offMoveEvents(), this._offUpEvents(), a && (w && (a.cancelable && a.preventDefault(), !l.dropBubble && a.stopPropagation()), n && n.parentNode && n.parentNode.removeChild(n), (r === t || m && "clone" !== m.lastPutMode) && i && i.parentNode && i.parentNode.removeChild(i), e && (this.nativeDraggable && xe(e, "dragend", this), Oe(e), e.style["will-change"] = "", Ce(e, m ? m.options.ghostClass : this.options.ghostClass, !1), Ce(e, this.options.chosenClass, !1), ke(this, r, "unchoose", e, t, r, u, null, p, null, a), r !== t ? (d = Fe(e), h = Fe(e, l.draggable), d >= 0 && (ke(null, t, "add", e, t, r, u, d, p, h, a), ke(this, r, "remove", e, t, r, u, d, p, h, a), ke(null, t, "sort", e, t, r, u, d, p, h, a), ke(this, r, "sort", e, t, r, u, d, p, h, a)), m && m.save()) : e.nextSibling !== o && (d = Fe(e), h = Fe(e, l.draggable), d >= 0 && (ke(this, r, "update", e, t, r, u, d, p, h, a), ke(this, r, "sort", e, t, r, u, d, p, h, a))), be.active && (null != d && -1 !== d || (d = u, h = p), ke(this, r, "end", e, t, r, u, d, p, h, a), this.save()))), this._nulling();
        },
        _nulling: function _nulling() {
          r = e = t = n = o = i = a = s = l = T.length = g = v = b = y = _ = w = d = u = x = C = k = m = f = be.active = null, re.forEach(function (e) {
            e.checked = !0;
          }), re.length = 0;
        },
        handleEvent: function handleEvent(t) {
          switch (t.type) {
            case "drop":
            case "dragend":
              this._onDrop(t);

              break;

            case "dragenter":
            case "dragover":
              e && (this._onDragOver(t), function (e) {
                e.dataTransfer && (e.dataTransfer.dropEffect = "move");
                e.cancelable && e.preventDefault();
              }(t));
              break;

            case "selectstart":
              t.preventDefault();
          }
        },
        toArray: function toArray() {
          for (var e, t = [], n = this.el.children, i = 0, r = n.length, o = this.options; i < r; i++) {
            ye(e = n[i], o.draggable, this.el, !1) && t.push(e.getAttribute(o.dataIdAttr) || Ie(e));
          }

          return t;
        },
        sort: function sort(e) {
          var t = {},
              n = this.el;
          this.toArray().forEach(function (e, i) {
            var r = n.children[i];
            ye(r, this.options.draggable, n, !1) && (t[e] = r);
          }, this), e.forEach(function (e) {
            t[e] && (n.removeChild(t[e]), n.appendChild(t[e]));
          });
        },
        save: function save() {
          var e = this.options.store;
          e && e.set && e.set(this);
        },
        closest: function closest(e, t) {
          return ye(e, t || this.options.draggable, this.el, !1);
        },
        option: function option(e, t) {
          var n = this.options;
          if (void 0 === t) return n[e];
          n[e] = t, "group" === e && pe(n);
        },
        destroy: function destroy() {
          var e = this.el;
          e[L] = null, xe(e, "mousedown", this._onTapStart), xe(e, "touchstart", this._onTapStart), xe(e, "pointerdown", this._onTapStart), this.nativeDraggable && (xe(e, "dragover", this), xe(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function (e) {
            e.removeAttribute("draggable");
          }), this._onDrop(), M.splice(M.indexOf(this.el), 1), this.el = e = null;
        },
        _hideClone: function _hideClone() {
          i.cloneHidden || (Se(i, "display", "none"), i.cloneHidden = !0, i.parentNode && this.options.removeCloneOnHide && i.parentNode.removeChild(i));
        },
        _showClone: function _showClone(t) {
          "clone" === t.lastPutMode ? i.cloneHidden && (r.contains(e) && !this.options.group.revertClone ? r.insertBefore(i, e) : o ? r.insertBefore(i, o) : r.appendChild(i), this.options.group.revertClone && this._animate(e, i), Se(i, "display", ""), i.cloneHidden = !1) : this._hideClone();
        }
      }, we(H, "touchmove", function (e) {
        (be.active || P) && e.cancelable && e.preventDefault();
      }), be.utils = {
        on: we,
        off: xe,
        css: Se,
        find: Ee,
        is: function is(e, t) {
          return !!ye(e, t, e, !1);
        },
        extend: Re,
        throttle: Le,
        closest: ye,
        toggleClass: Ce,
        clone: He,
        index: Fe,
        nextTick: Be,
        cancelNextTick: qe,
        detectDirection: oe,
        getChild: Ae
      }, be.create = function (e, t) {
        return new be(e, t);
      }, be.version = "1.9.0", be;
    });
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    var i = {
      "./apparatus_ui/page_tree_component/node_component_controller.js": 37,
      "./dropdown_controller.js": 38,
      "./inputs/block_width_controller.js": 41,
      "./inputs/column_width_controller.js": 42,
      "./inputs/date_picker_controller.js": 43,
      "./inputs/date_time_picker_controller.js": 44,
      "./inputs/sortable_association_controller.js": 47,
      "./toggle_controller.js": 45
    };

    function r(e) {
      var t = o(e);
      return n(t);
    }

    function o(e) {
      if (!n.o(i, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return i[e];
    }

    r.keys = function () {
      return Object.keys(i);
    }, r.resolve = o, e.exports = r, r.id = 36;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return l;
    });
    var i = n(1);

    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var l = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, l, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, i["b"]), n = t, (l = [{
        key: "connect",
        value: function value() {
          console.log(this.data.get("treePath"));
        }
      }, {
        key: "toggle",
        value: function value() {
          console.log(this.expanded, this.loaded), this.expanded ? this.expanded = !1 : this.loaded ? this.expanded = !0 : this._loadTree();
        }
      }, {
        key: "_loadTree",
        value: function value(e) {
          var _this8 = this;

          Rails.ajax({
            type: "GET",
            dataType: "html",
            url: this.data.get("treePath"),
            success: function success(e) {
              var t = new DOMParser().parseFromString(e.body.innerHTML, "text/html").body.firstChild;
              _this8.element.appendChild(t), _this8.expanded = !0, _this8.loaded = !0;
            }
          });
        }
      }, {
        key: "expanded",
        set: function set(e) {
          e ? this.element.setAttribute("aria-expanded", "true") : this.element.setAttribute("aria-expanded", "false");
        },
        get: function get() {
          return "true" == this.element.getAttribute("aria-expanded");
        }
      }, {
        key: "loaded",
        set: function set(e) {
          e ? this.element.setAttribute("data-loaded", "true") : this.element.setAttribute("data-loaded", "false");
        },
        get: function get() {
          return "true" == this.element.getAttribute("data-loaded");
        }
      }]) && r(n.prototype, l), c && r(n, c), t;
    }();
  }, function (e, t, n) {
    "use strict";

    n.r(t), function (e) {
      n.d(t, "default", function () {
        return l;
      });
      var i = n(1);

      function r(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
        }
      }

      function o(e, t) {
        return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }

      function a(e) {
        return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function s(e, t) {
        return (s = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      n(39), n(40);

      var l = function (t) {
        function n() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, n), o(this, a(n).apply(this, arguments));
        }

        var l, c, u;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && s(e, t);
        }(n, i["b"]), l = n, (c = [{
          key: "connect",
          value: function value() {
            e(this.element).dropdown({
              duration: 0,
              transition: "drop",
              action: "hide"
            });
          }
        }, {
          key: "close",
          value: function value() {
            e(this.element).dropdown("hide");
          }
        }]) && r(l.prototype, c), u && r(l, u), n;
      }();
    }.call(this, n(0));
  }, function (e, t, n) {
    (function (e) {
      !function (e, t, n, i) {
        "use strict";

        t = void 0 !== t && t.Math == Math ? t : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), e.fn.transition = function () {
          var i,
              r = e(this),
              o = r.selector || "",
              a = new Date().getTime(),
              s = [],
              l = arguments,
              c = l[0],
              u = [].slice.call(arguments, 1),
              d = "string" == typeof c;
          t.requestAnimationFrame || t.mozRequestAnimationFrame || t.webkitRequestAnimationFrame || t.msRequestAnimationFrame;
          return r.each(function (t) {
            var p,
                h,
                f,
                m,
                g,
                v,
                b,
                y,
                _,
                w = e(this),
                x = this;

            (_ = {
              initialize: function initialize() {
                p = _.get.settings.apply(x, l), m = p.className, f = p.error, g = p.metadata, y = "." + p.namespace, b = "module-" + p.namespace, h = w.data(b) || _, v = _.get.animationEndEvent(), d && (d = _.invoke(c)), !1 === d && (_.verbose("Converted arguments into settings object", p), p.interval ? _.delay(p.animate) : _.animate(), _.instantiate());
              },
              instantiate: function instantiate() {
                _.verbose("Storing instance of module", _), h = _, w.data(b, h);
              },
              destroy: function destroy() {
                _.verbose("Destroying previous module for", x), w.removeData(b);
              },
              refresh: function refresh() {
                _.verbose("Refreshing display type on next animation"), delete _.displayType;
              },
              forceRepaint: function forceRepaint() {
                _.verbose("Forcing element repaint");

                var e = w.parent(),
                    t = w.next();
                0 === t.length ? w.detach().appendTo(e) : w.detach().insertBefore(t);
              },
              repaint: function repaint() {
                _.verbose("Repainting element");

                x.offsetWidth;
              },
              delay: function delay(e) {
                var n,
                    i = _.get.animationDirection();

                i || (i = _.can.transition() ? _.get.direction() : "static"), e = void 0 !== e ? e : p.interval, n = "auto" == p.reverse && i == m.outward || 1 == p.reverse ? (r.length - t) * p.interval : t * p.interval, _.debug("Delaying animation by", n), setTimeout(_.animate, n);
              },
              animate: function animate(e) {
                if (p = e || p, !_.is.supported()) return _.error(f.support), !1;

                if (_.debug("Preparing animation", p.animation), _.is.animating()) {
                  if (p.queue) return !p.allowRepeats && _.has.direction() && _.is.occurring() && !0 !== _.queuing ? _.debug("Animation is currently occurring, preventing queueing same animation", p.animation) : _.queue(p.animation), !1;
                  if (!p.allowRepeats && _.is.occurring()) return _.debug("Animation is already occurring, will not execute repeated animation", p.animation), !1;
                  _.debug("New animation started, completing previous early", p.animation), h.complete();
                }

                _.can.animate() ? _.set.animating(p.animation) : _.error(f.noAnimation, p.animation, x);
              },
              reset: function reset() {
                _.debug("Resetting animation to beginning conditions"), _.remove.animationCallbacks(), _.restore.conditions(), _.remove.animating();
              },
              queue: function queue(e) {
                _.debug("Queueing animation of", e), _.queuing = !0, w.one(v + ".queue" + y, function () {
                  _.queuing = !1, _.repaint(), _.animate.apply(this, p);
                });
              },
              complete: function complete(e) {
                _.debug("Animation complete", p.animation), _.remove.completeCallback(), _.remove.failSafe(), _.is.looping() || (_.is.outward() ? (_.verbose("Animation is outward, hiding element"), _.restore.conditions(), _.hide()) : _.is.inward() ? (_.verbose("Animation is outward, showing element"), _.restore.conditions(), _.show()) : (_.verbose("Static animation completed"), _.restore.conditions(), p.onComplete.call(x)));
              },
              force: {
                visible: function visible() {
                  var e = w.attr("style"),
                      t = _.get.userStyle(),
                      n = _.get.displayType(),
                      i = t + "display: " + n + " !important;",
                      r = void 0 === e || "" === e;

                  w.css("display") !== n ? (_.verbose("Overriding default display to show element", n), w.attr("style", i)) : r && w.removeAttr("style");
                },
                hidden: function hidden() {
                  var e = w.attr("style"),
                      t = void 0 === e || "" === e;
                  "none" === w.css("display") || _.is.hidden() ? t && w.removeAttr("style") : (_.verbose("Overriding default display to hide element"), w.css("display", "none"));
                }
              },
              has: {
                direction: function direction(t) {
                  var n = !1;
                  return "string" == typeof (t = t || p.animation) && (t = t.split(" "), e.each(t, function (e, t) {
                    t !== m.inward && t !== m.outward || (n = !0);
                  })), n;
                },
                inlineDisplay: function inlineDisplay() {
                  var t = w.attr("style") || "";
                  return e.isArray(t.match(/display.*?;/, ""));
                }
              },
              set: {
                animating: function animating(e) {
                  var t;
                  _.remove.completeCallback(), e = e || p.animation, t = _.get.animationClass(e), _.save.animation(t), _.force.visible(), _.remove.hidden(), _.remove.direction(), _.start.animation(t);
                },
                duration: function duration(e, t) {
                  ((t = "number" == typeof (t = t || p.duration) ? t + "ms" : t) || 0 === t) && (_.verbose("Setting animation duration", t), w.css({
                    "animation-duration": t
                  }));
                },
                direction: function direction(e) {
                  (e = e || _.get.direction()) == m.inward ? _.set.inward() : _.set.outward();
                },
                looping: function looping() {
                  _.debug("Transition set to loop"), w.addClass(m.looping);
                },
                hidden: function hidden() {
                  w.addClass(m.transition).addClass(m.hidden);
                },
                inward: function inward() {
                  _.debug("Setting direction to inward"), w.removeClass(m.outward).addClass(m.inward);
                },
                outward: function outward() {
                  _.debug("Setting direction to outward"), w.removeClass(m.inward).addClass(m.outward);
                },
                visible: function visible() {
                  w.addClass(m.transition).addClass(m.visible);
                }
              },
              start: {
                animation: function animation(e) {
                  e = e || _.get.animationClass(), _.debug("Starting tween", e), w.addClass(e).one(v + ".complete" + y, _.complete), p.useFailSafe && _.add.failSafe(), _.set.duration(p.duration), p.onStart.call(x);
                }
              },
              save: {
                animation: function animation(e) {
                  _.cache || (_.cache = {}), _.cache.animation = e;
                },
                displayType: function displayType(e) {
                  "none" !== e && w.data(g.displayType, e);
                },
                transitionExists: function transitionExists(t, n) {
                  e.fn.transition.exists[t] = n, _.verbose("Saving existence of transition", t, n);
                }
              },
              restore: {
                conditions: function conditions() {
                  var e = _.get.currentAnimation();

                  e && (w.removeClass(e), _.verbose("Removing animation class", _.cache)), _.remove.duration();
                }
              },
              add: {
                failSafe: function failSafe() {
                  var e = _.get.duration();

                  _.timer = setTimeout(function () {
                    w.triggerHandler(v);
                  }, e + p.failSafeDelay), _.verbose("Adding fail safe timer", _.timer);
                }
              },
              remove: {
                animating: function animating() {
                  w.removeClass(m.animating);
                },
                animationCallbacks: function animationCallbacks() {
                  _.remove.queueCallback(), _.remove.completeCallback();
                },
                queueCallback: function queueCallback() {
                  w.off(".queue" + y);
                },
                completeCallback: function completeCallback() {
                  w.off(".complete" + y);
                },
                display: function display() {
                  w.css("display", "");
                },
                direction: function direction() {
                  w.removeClass(m.inward).removeClass(m.outward);
                },
                duration: function duration() {
                  w.css("animation-duration", "");
                },
                failSafe: function failSafe() {
                  _.verbose("Removing fail safe timer", _.timer), _.timer && clearTimeout(_.timer);
                },
                hidden: function hidden() {
                  w.removeClass(m.hidden);
                },
                visible: function visible() {
                  w.removeClass(m.visible);
                },
                looping: function looping() {
                  _.debug("Transitions are no longer looping"), _.is.looping() && (_.reset(), w.removeClass(m.looping));
                },
                transition: function transition() {
                  w.removeClass(m.visible).removeClass(m.hidden);
                }
              },
              get: {
                settings: function settings(t, n, i) {
                  return "object" == _typeof(t) ? e.extend(!0, {}, e.fn.transition.settings, t) : "function" == typeof i ? e.extend({}, e.fn.transition.settings, {
                    animation: t,
                    onComplete: i,
                    duration: n
                  }) : "string" == typeof n || "number" == typeof n ? e.extend({}, e.fn.transition.settings, {
                    animation: t,
                    duration: n
                  }) : "object" == _typeof(n) ? e.extend({}, e.fn.transition.settings, n, {
                    animation: t
                  }) : "function" == typeof n ? e.extend({}, e.fn.transition.settings, {
                    animation: t,
                    onComplete: n
                  }) : e.extend({}, e.fn.transition.settings, {
                    animation: t
                  });
                },
                animationClass: function animationClass(e) {
                  var t = e || p.animation,
                      n = _.can.transition() && !_.has.direction() ? _.get.direction() + " " : "";
                  return m.animating + " " + m.transition + " " + n + t;
                },
                currentAnimation: function currentAnimation() {
                  return !(!_.cache || void 0 === _.cache.animation) && _.cache.animation;
                },
                currentDirection: function currentDirection() {
                  return _.is.inward() ? m.inward : m.outward;
                },
                direction: function direction() {
                  return _.is.hidden() || !_.is.visible() ? m.inward : m.outward;
                },
                animationDirection: function animationDirection(t) {
                  var n;
                  return "string" == typeof (t = t || p.animation) && (t = t.split(" "), e.each(t, function (e, t) {
                    t === m.inward ? n = m.inward : t === m.outward && (n = m.outward);
                  })), n || !1;
                },
                duration: function duration(e) {
                  return !1 === (e = e || p.duration) && (e = w.css("animation-duration") || 0), "string" == typeof e ? e.indexOf("ms") > -1 ? parseFloat(e) : 1e3 * parseFloat(e) : e;
                },
                displayType: function displayType(e) {
                  return e = void 0 === e || e, p.displayType ? p.displayType : (e && void 0 === w.data(g.displayType) && _.can.transition(!0), w.data(g.displayType));
                },
                userStyle: function userStyle(e) {
                  return (e = e || w.attr("style") || "").replace(/display.*?;/, "");
                },
                transitionExists: function transitionExists(t) {
                  return e.fn.transition.exists[t];
                },
                animationStartEvent: function animationStartEvent() {
                  var e,
                      t = n.createElement("div"),
                      i = {
                    animation: "animationstart",
                    OAnimation: "oAnimationStart",
                    MozAnimation: "mozAnimationStart",
                    WebkitAnimation: "webkitAnimationStart"
                  };

                  for (e in i) {
                    if (void 0 !== t.style[e]) return i[e];
                  }

                  return !1;
                },
                animationEndEvent: function animationEndEvent() {
                  var e,
                      t = n.createElement("div"),
                      i = {
                    animation: "animationend",
                    OAnimation: "oAnimationEnd",
                    MozAnimation: "mozAnimationEnd",
                    WebkitAnimation: "webkitAnimationEnd"
                  };

                  for (e in i) {
                    if (void 0 !== t.style[e]) return i[e];
                  }

                  return !1;
                }
              },
              can: {
                transition: function transition(t) {
                  var n,
                      i,
                      r,
                      o,
                      a,
                      s,
                      l = p.animation,
                      c = _.get.transitionExists(l),
                      u = _.get.displayType(!1);

                  if (void 0 === c || t) {
                    if (_.verbose("Determining whether animation exists"), n = w.attr("class"), i = w.prop("tagName"), o = (r = e("<" + i + " />").addClass(n).insertAfter(w)).addClass(l).removeClass(m.inward).removeClass(m.outward).addClass(m.animating).addClass(m.transition).css("animationName"), a = r.addClass(m.inward).css("animationName"), u || (u = r.attr("class", n).removeAttr("style").removeClass(m.hidden).removeClass(m.visible).show().css("display"), _.verbose("Determining final display state", u), _.save.displayType(u)), r.remove(), o != a) _.debug("Direction exists for animation", l), s = !0;else {
                      if ("none" == o || !o) return void _.debug("No animation defined in css", l);
                      _.debug("Static animation found", l, u), s = !1;
                    }

                    _.save.transitionExists(l, s);
                  }

                  return void 0 !== c ? c : s;
                },
                animate: function animate() {
                  return void 0 !== _.can.transition();
                }
              },
              is: {
                animating: function animating() {
                  return w.hasClass(m.animating);
                },
                inward: function inward() {
                  return w.hasClass(m.inward);
                },
                outward: function outward() {
                  return w.hasClass(m.outward);
                },
                looping: function looping() {
                  return w.hasClass(m.looping);
                },
                occurring: function occurring(e) {
                  return e = "." + (e = e || p.animation).replace(" ", "."), w.filter(e).length > 0;
                },
                visible: function visible() {
                  return w.is(":visible");
                },
                hidden: function hidden() {
                  return "hidden" === w.css("visibility");
                },
                supported: function supported() {
                  return !1 !== v;
                }
              },
              hide: function hide() {
                _.verbose("Hiding element"), _.is.animating() && _.reset(), x.blur(), _.remove.display(), _.remove.visible(), _.set.hidden(), _.force.hidden(), p.onHide.call(x), p.onComplete.call(x);
              },
              show: function show(e) {
                _.verbose("Showing element", e), _.remove.hidden(), _.set.visible(), _.force.visible(), p.onShow.call(x), p.onComplete.call(x);
              },
              toggle: function toggle() {
                _.is.visible() ? _.hide() : _.show();
              },
              stop: function stop() {
                _.debug("Stopping current animation"), w.triggerHandler(v);
              },
              stopAll: function stopAll() {
                _.debug("Stopping all animation"), _.remove.queueCallback(), w.triggerHandler(v);
              },
              clear: {
                queue: function queue() {
                  _.debug("Clearing animation queue"), _.remove.queueCallback();
                }
              },
              enable: function enable() {
                _.verbose("Starting animation"), w.removeClass(m.disabled);
              },
              disable: function disable() {
                _.debug("Stopping animation"), w.addClass(m.disabled);
              },
              setting: function setting(t, n) {
                if (_.debug("Changing setting", t, n), e.isPlainObject(t)) e.extend(!0, p, t);else {
                  if (void 0 === n) return p[t];
                  e.isPlainObject(p[t]) ? e.extend(!0, p[t], n) : p[t] = n;
                }
              },
              internal: function internal(t, n) {
                if (e.isPlainObject(t)) e.extend(!0, _, t);else {
                  if (void 0 === n) return _[t];
                  _[t] = n;
                }
              },
              debug: function debug() {
                !p.silent && p.debug && (p.performance ? _.performance.log(arguments) : (_.debug = Function.prototype.bind.call(console.info, console, p.name + ":"), _.debug.apply(console, arguments)));
              },
              verbose: function verbose() {
                !p.silent && p.verbose && p.debug && (p.performance ? _.performance.log(arguments) : (_.verbose = Function.prototype.bind.call(console.info, console, p.name + ":"), _.verbose.apply(console, arguments)));
              },
              error: function error() {
                p.silent || (_.error = Function.prototype.bind.call(console.error, console, p.name + ":"), _.error.apply(console, arguments));
              },
              performance: {
                log: function log(e) {
                  var t, n;
                  p.performance && (n = (t = new Date().getTime()) - (a || t), a = t, s.push({
                    Name: e[0],
                    Arguments: [].slice.call(e, 1) || "",
                    Element: x,
                    "Execution Time": n
                  })), clearTimeout(_.performance.timer), _.performance.timer = setTimeout(_.performance.display, 500);
                },
                display: function display() {
                  var t = p.name + ":",
                      n = 0;
                  a = !1, clearTimeout(_.performance.timer), e.each(s, function (e, t) {
                    n += t["Execution Time"];
                  }), t += " " + n + "ms", o && (t += " '" + o + "'"), r.length > 1 && (t += " (" + r.length + ")"), (void 0 !== console.group || void 0 !== console.table) && s.length > 0 && (console.groupCollapsed(t), console.table ? console.table(s) : e.each(s, function (e, t) {
                    console.log(t.Name + ": " + t["Execution Time"] + "ms");
                  }), console.groupEnd()), s = [];
                }
              },
              invoke: function invoke(t, n, r) {
                var o,
                    a,
                    s,
                    l = h;
                return n = n || u, r = x || r, "string" == typeof t && void 0 !== l && (t = t.split(/[\. ]/), o = t.length - 1, e.each(t, function (n, i) {
                  var r = n != o ? i + t[n + 1].charAt(0).toUpperCase() + t[n + 1].slice(1) : t;
                  if (e.isPlainObject(l[r]) && n != o) l = l[r];else {
                    if (void 0 !== l[r]) return a = l[r], !1;
                    if (!e.isPlainObject(l[i]) || n == o) return void 0 !== l[i] && (a = l[i], !1);
                    l = l[i];
                  }
                })), e.isFunction(a) ? s = a.apply(r, n) : void 0 !== a && (s = a), e.isArray(i) ? i.push(s) : void 0 !== i ? i = [i, s] : void 0 !== s && (i = s), void 0 !== a && a;
              }
            }).initialize();
          }), void 0 !== i ? i : this;
        }, e.fn.transition.exists = {}, e.fn.transition.settings = {
          name: "Transition",
          silent: !1,
          debug: !1,
          verbose: !1,
          performance: !0,
          namespace: "transition",
          interval: 0,
          reverse: "auto",
          onStart: function onStart() {},
          onComplete: function onComplete() {},
          onShow: function onShow() {},
          onHide: function onHide() {},
          useFailSafe: !0,
          failSafeDelay: 100,
          allowRepeats: !1,
          displayType: !1,
          animation: "fade",
          duration: !1,
          queue: !0,
          metadata: {
            displayType: "display"
          },
          className: {
            animating: "animating",
            disabled: "disabled",
            hidden: "hidden",
            inward: "in",
            loading: "loading",
            looping: "looping",
            outward: "out",
            transition: "transition",
            visible: "visible"
          },
          error: {
            noAnimation: "Element is no longer attached to DOM. Unable to animate.  Use silent setting to surpress this warning in production.",
            repeated: "That animation is already occurring, cancelling repeated animation",
            method: "The method you called is not defined",
            support: "This browser does not support CSS animations"
          }
        };
      }(e, window, document);
    }).call(this, n(0));
  }, function (e, t, n) {
    (function (e) {
      !function (e, t, n, i) {
        "use strict";

        t = void 0 !== t && t.Math == Math ? t : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), e.fn.dropdown = function (i) {
          var r,
              o = e(this),
              a = e(n),
              s = o.selector || "",
              l = "ontouchstart" in n.documentElement,
              c = new Date().getTime(),
              u = [],
              d = arguments[0],
              p = "string" == typeof d,
              h = [].slice.call(arguments, 1);
          return o.each(function (f) {
            var m,
                g,
                v,
                b,
                y,
                _,
                w,
                x,
                C = e.isPlainObject(i) ? e.extend(!0, {}, e.fn.dropdown.settings, i) : e.extend({}, e.fn.dropdown.settings),
                S = C.className,
                D = C.message,
                E = C.fields,
                k = C.keys,
                T = C.metadata,
                O = C.namespace,
                P = C.regExp,
                A = C.selector,
                M = C.error,
                N = C.templates,
                I = "." + O,
                F = "module-" + O,
                j = e(this),
                L = e(C.context),
                R = j.find(A.text),
                H = j.find(A.search),
                B = j.find(A.sizer),
                q = j.find(A.input),
                $ = j.find(A.icon),
                W = j.prev().find(A.text).length > 0 ? j.prev().find(A.text) : j.prev(),
                U = j.children(A.menu),
                Y = U.find(A.item),
                X = !1,
                z = !1,
                V = !1,
                K = this,
                Q = j.data(F);

            x = {
              initialize: function initialize() {
                x.debug("Initializing dropdown", C), x.is.alreadySetup() ? x.setup.reference() : (x.setup.layout(), C.values && x.change.values(C.values), x.refreshData(), x.save.defaults(), x.restore.selected(), x.create.id(), x.bind.events(), x.observeChanges(), x.instantiate());
              },
              instantiate: function instantiate() {
                x.verbose("Storing instance of dropdown", x), Q = x, j.data(F, x);
              },
              destroy: function destroy() {
                x.verbose("Destroying previous dropdown", j), x.remove.tabbable(), j.off(I).removeData(F), U.off(I), a.off(b), x.disconnect.menuObserver(), x.disconnect.selectObserver();
              },
              observeChanges: function observeChanges() {
                "MutationObserver" in t && (_ = new MutationObserver(x.event.select.mutation), w = new MutationObserver(x.event.menu.mutation), x.debug("Setting up mutation observer", _, w), x.observe.select(), x.observe.menu());
              },
              disconnect: {
                menuObserver: function menuObserver() {
                  w && w.disconnect();
                },
                selectObserver: function selectObserver() {
                  _ && _.disconnect();
                }
              },
              observe: {
                select: function select() {
                  x.has.input() && _.observe(j[0], {
                    childList: !0,
                    subtree: !0
                  });
                },
                menu: function menu() {
                  x.has.menu() && w.observe(U[0], {
                    childList: !0,
                    subtree: !0
                  });
                }
              },
              create: {
                id: function id() {
                  y = (Math.random().toString(16) + "000000000").substr(2, 8), b = "." + y, x.verbose("Creating unique id for element", y);
                },
                userChoice: function userChoice(t) {
                  var n, i, r;
                  return !!(t = t || x.get.userValues()) && (t = e.isArray(t) ? t : [t], e.each(t, function (t, o) {
                    !1 === x.get.item(o) && (r = C.templates.addition(x.add.variables(D.addResult, o)), i = e("<div />").html(r).attr("data-" + T.value, o).attr("data-" + T.text, o).addClass(S.addition).addClass(S.item), C.hideAdditions && i.addClass(S.hidden), n = void 0 === n ? i : n.add(i), x.verbose("Creating user choices for value", o, i));
                  }), n);
                },
                userLabels: function userLabels(t) {
                  var n = x.get.userValues();
                  n && (x.debug("Adding user labels", n), e.each(n, function (e, t) {
                    x.verbose("Adding custom user value"), x.add.label(t, t);
                  }));
                },
                menu: function menu() {
                  U = e("<div />").addClass(S.menu).appendTo(j);
                },
                sizer: function sizer() {
                  B = e("<span />").addClass(S.sizer).insertAfter(H);
                }
              },
              search: function search(e) {
                e = void 0 !== e ? e : x.get.query(), x.verbose("Searching for query", e), x.has.minCharacters(e) ? x.filter(e) : x.hide();
              },
              select: {
                firstUnfiltered: function firstUnfiltered() {
                  x.verbose("Selecting first non-filtered element"), x.remove.selectedItem(), Y.not(A.unselectable).not(A.addition + A.hidden).eq(0).addClass(S.selected);
                },
                nextAvailable: function nextAvailable(e) {
                  var t = (e = e.eq(0)).nextAll(A.item).not(A.unselectable).eq(0),
                      n = e.prevAll(A.item).not(A.unselectable).eq(0);
                  t.length > 0 ? (x.verbose("Moving selection to", t), t.addClass(S.selected)) : (x.verbose("Moving selection to", n), n.addClass(S.selected));
                }
              },
              setup: {
                api: function api() {
                  var e = {
                    debug: C.debug,
                    urlData: {
                      value: x.get.value(),
                      query: x.get.query()
                    },
                    on: !1
                  };
                  x.verbose("First request, initializing API"), j.api(e);
                },
                layout: function layout() {
                  j.is("select") && (x.setup.select(), x.setup.returnedObject()), x.has.menu() || x.create.menu(), x.is.search() && !x.has.search() && (x.verbose("Adding search input"), H = e("<input />").addClass(S.search).prop("autocomplete", "off").insertBefore(R)), x.is.multiple() && x.is.searchSelection() && !x.has.sizer() && x.create.sizer(), C.allowTab && x.set.tabbable();
                },
                select: function select() {
                  var t = x.get.selectValues();
                  x.debug("Dropdown initialized on a select", t), j.is("select") && (q = j), q.parent(A.dropdown).length > 0 ? (x.debug("UI dropdown already exists. Creating dropdown menu only"), j = q.closest(A.dropdown), x.has.menu() || x.create.menu(), U = j.children(A.menu), x.setup.menu(t)) : (x.debug("Creating entire dropdown from select"), j = e("<div />").attr("class", q.attr("class")).addClass(S.selection).addClass(S.dropdown).html(N.dropdown(t)).insertBefore(q), q.hasClass(S.multiple) && !1 === q.prop("multiple") && (x.error(M.missingMultiple), q.prop("multiple", !0)), q.is("[multiple]") && x.set.multiple(), q.prop("disabled") && (x.debug("Disabling dropdown"), j.addClass(S.disabled)), q.removeAttr("class").detach().prependTo(j)), x.refresh();
                },
                menu: function menu(e) {
                  U.html(N.menu(e, E)), Y = U.find(A.item);
                },
                reference: function reference() {
                  x.debug("Dropdown behavior was called on select, replacing with closest dropdown"), j = j.parent(A.dropdown), Q = j.data(F), K = j.get(0), x.refresh(), x.setup.returnedObject();
                },
                returnedObject: function returnedObject() {
                  var e = o.slice(0, f),
                      t = o.slice(f + 1);
                  o = e.add(j).add(t);
                }
              },
              refresh: function refresh() {
                x.refreshSelectors(), x.refreshData();
              },
              refreshItems: function refreshItems() {
                Y = U.find(A.item);
              },
              refreshSelectors: function refreshSelectors() {
                x.verbose("Refreshing selector cache"), R = j.find(A.text), H = j.find(A.search), q = j.find(A.input), $ = j.find(A.icon), W = j.prev().find(A.text).length > 0 ? j.prev().find(A.text) : j.prev(), U = j.children(A.menu), Y = U.find(A.item);
              },
              refreshData: function refreshData() {
                x.verbose("Refreshing cached metadata"), Y.removeData(T.text).removeData(T.value);
              },
              clearData: function clearData() {
                x.verbose("Clearing metadata"), Y.removeData(T.text).removeData(T.value), j.removeData(T.defaultText).removeData(T.defaultValue).removeData(T.placeholderText);
              },
              toggle: function toggle() {
                x.verbose("Toggling menu visibility"), x.is.active() ? x.hide() : x.show();
              },
              show: function show(t) {
                if (t = e.isFunction(t) ? t : function () {}, !x.can.show() && x.is.remote() && (x.debug("No API results retrieved, searching before show"), x.queryRemote(x.get.query(), x.show)), x.can.show() && !x.is.active()) {
                  if (x.debug("Showing dropdown"), !x.has.message() || x.has.maxSelections() || x.has.allResultsFiltered() || x.remove.message(), x.is.allFiltered()) return !0;
                  !1 !== C.onShow.call(K) && x.animate.show(function () {
                    x.can.click() && x.bind.intent(), x.has.menuSearch() && x.focusSearch(), x.set.visible(), t.call(K);
                  });
                }
              },
              hide: function hide(t) {
                t = e.isFunction(t) ? t : function () {}, x.is.active() && (x.debug("Hiding dropdown"), !1 !== C.onHide.call(K) && x.animate.hide(function () {
                  x.remove.visible(), t.call(K);
                }));
              },
              hideOthers: function hideOthers() {
                x.verbose("Finding other dropdowns to hide"), o.not(j).has(A.menu + "." + S.visible).dropdown("hide");
              },
              hideMenu: function hideMenu() {
                x.verbose("Hiding menu  instantaneously"), x.remove.active(), x.remove.visible(), U.transition("hide");
              },
              hideSubMenus: function hideSubMenus() {
                var e = U.children(A.item).find(A.menu);
                x.verbose("Hiding sub menus", e), e.transition("hide");
              },
              bind: {
                events: function events() {
                  l && x.bind.touchEvents(), x.bind.keyboardEvents(), x.bind.inputEvents(), x.bind.mouseEvents();
                },
                touchEvents: function touchEvents() {
                  x.debug("Touch device detected binding additional touch events"), x.is.searchSelection() || x.is.single() && j.on("touchstart" + I, x.event.test.toggle), U.on("touchstart" + I, A.item, x.event.item.mouseenter);
                },
                keyboardEvents: function keyboardEvents() {
                  x.verbose("Binding keyboard events"), j.on("keydown" + I, x.event.keydown), x.has.search() && j.on(x.get.inputEvent() + I, A.search, x.event.input), x.is.multiple() && a.on("keydown" + b, x.event.document.keydown);
                },
                inputEvents: function inputEvents() {
                  x.verbose("Binding input change events"), j.on("change" + I, A.input, x.event.change);
                },
                mouseEvents: function mouseEvents() {
                  x.verbose("Binding mouse events"), x.is.multiple() && j.on("click" + I, A.label, x.event.label.click).on("click" + I, A.remove, x.event.remove.click), x.is.searchSelection() ? (j.on("mousedown" + I, x.event.mousedown).on("mouseup" + I, x.event.mouseup).on("mousedown" + I, A.menu, x.event.menu.mousedown).on("mouseup" + I, A.menu, x.event.menu.mouseup).on("click" + I, A.icon, x.event.icon.click).on("focus" + I, A.search, x.event.search.focus).on("click" + I, A.search, x.event.search.focus).on("blur" + I, A.search, x.event.search.blur).on("click" + I, A.text, x.event.text.focus), x.is.multiple() && j.on("click" + I, x.event.click)) : ("click" == C.on ? j.on("click" + I, A.icon, x.event.icon.click).on("click" + I, x.event.test.toggle) : "hover" == C.on ? j.on("mouseenter" + I, x.delay.show).on("mouseleave" + I, x.delay.hide) : j.on(C.on + I, x.toggle), j.on("mousedown" + I, x.event.mousedown).on("mouseup" + I, x.event.mouseup).on("focus" + I, x.event.focus), x.has.menuSearch() ? j.on("blur" + I, A.search, x.event.search.blur) : j.on("blur" + I, x.event.blur)), U.on("mouseenter" + I, A.item, x.event.item.mouseenter).on("mouseleave" + I, A.item, x.event.item.mouseleave).on("click" + I, A.item, x.event.item.click);
                },
                intent: function intent() {
                  x.verbose("Binding hide intent event to document"), l && a.on("touchstart" + b, x.event.test.touch).on("touchmove" + b, x.event.test.touch), a.on("click" + b, x.event.test.hide);
                }
              },
              unbind: {
                intent: function intent() {
                  x.verbose("Removing hide intent event from document"), l && a.off("touchstart" + b).off("touchmove" + b), a.off("click" + b);
                }
              },
              filter: function filter(e) {
                var t = void 0 !== e ? e : x.get.query(),
                    n = function n() {
                  x.is.multiple() && x.filterActive(), (e || !e && 0 == x.get.activeItem().length) && x.select.firstUnfiltered(), x.has.allResultsFiltered() ? C.onNoResults.call(K, t) ? C.allowAdditions ? C.hideAdditions && (x.verbose("User addition with no menu, setting empty style"), x.set.empty(), x.hideMenu()) : (x.verbose("All items filtered, showing message", t), x.add.message(D.noResults)) : (x.verbose("All items filtered, hiding dropdown", t), x.hideMenu()) : (x.remove.empty(), x.remove.message()), C.allowAdditions && x.add.userSuggestion(e), x.is.searchSelection() && x.can.show() && x.is.focusedOnSearch() && x.show();
                };

                C.useLabels && x.has.maxSelections() || (C.apiSettings ? x.can.useAPI() ? x.queryRemote(t, function () {
                  C.filterRemoteData && x.filterItems(t), n();
                }) : x.error(M.noAPI) : (x.filterItems(t), n()));
              },
              queryRemote: function queryRemote(t, n) {
                var i = {
                  errorDuration: !1,
                  cache: "local",
                  throttle: C.throttle,
                  urlData: {
                    query: t
                  },
                  onError: function onError() {
                    x.add.message(D.serverError), n();
                  },
                  onFailure: function onFailure() {
                    x.add.message(D.serverError), n();
                  },
                  onSuccess: function onSuccess(e) {
                    x.remove.message(), x.setup.menu({
                      values: e[E.remoteValues]
                    }), n();
                  }
                };
                j.api("get request") || x.setup.api(), i = e.extend(!0, {}, i, C.apiSettings), j.api("setting", i).api("query");
              },
              filterItems: function filterItems(t) {
                var n = void 0 !== t ? t : x.get.query(),
                    i = null,
                    r = x.escape.string(n),
                    o = new RegExp("^" + r, "igm");
                x.has.query() && (i = [], x.verbose("Searching for matching values", n), Y.each(function () {
                  var t,
                      r,
                      a = e(this);

                  if ("both" == C.match || "text" == C.match) {
                    if (-1 !== (t = String(x.get.choiceText(a, !1))).search(o)) return i.push(this), !0;
                    if ("exact" === C.fullTextSearch && x.exactSearch(n, t)) return i.push(this), !0;
                    if (!0 === C.fullTextSearch && x.fuzzySearch(n, t)) return i.push(this), !0;
                  }

                  if ("both" == C.match || "value" == C.match) {
                    if (-1 !== (r = String(x.get.choiceValue(a, t))).search(o)) return i.push(this), !0;
                    if ("exact" === C.fullTextSearch && x.exactSearch(n, r)) return i.push(this), !0;
                    if (!0 === C.fullTextSearch && x.fuzzySearch(n, r)) return i.push(this), !0;
                  }
                })), x.debug("Showing only matched items", n), x.remove.filteredItem(), i && Y.not(i).addClass(S.filtered);
              },
              fuzzySearch: function fuzzySearch(e, t) {
                var n = t.length,
                    i = e.length;
                if (e = e.toLowerCase(), t = t.toLowerCase(), i > n) return !1;
                if (i === n) return e === t;

                e: for (var r = 0, o = 0; r < i; r++) {
                  for (var a = e.charCodeAt(r); o < n;) {
                    if (t.charCodeAt(o++) === a) continue e;
                  }

                  return !1;
                }

                return !0;
              },
              exactSearch: function exactSearch(e, t) {
                return e = e.toLowerCase(), (t = t.toLowerCase()).indexOf(e) > -1;
              },
              filterActive: function filterActive() {
                C.useLabels && Y.filter("." + S.active).addClass(S.filtered);
              },
              focusSearch: function focusSearch(e) {
                x.has.search() && !x.is.focusedOnSearch() && (e ? (j.off("focus" + I, A.search), H.focus(), j.on("focus" + I, A.search, x.event.search.focus)) : H.focus());
              },
              forceSelection: function forceSelection() {
                var e = Y.not(S.filtered).filter("." + S.selected).eq(0),
                    t = Y.not(S.filtered).filter("." + S.active).eq(0),
                    n = e.length > 0 ? e : t;
                if (n.length > 0 && !x.is.multiple()) return x.debug("Forcing partial selection to selected item", n), void x.event.item.click.call(n, {}, !0);
                C.allowAdditions ? (x.set.selected(x.get.query()), x.remove.searchTerm()) : x.remove.searchTerm();
              },
              change: {
                values: function values(t) {
                  C.allowAdditions || x.clear(), x.debug("Creating dropdown with specified values", t), x.setup.menu({
                    values: t
                  }), e.each(t, function (e, t) {
                    if (1 == t.selected) return x.debug("Setting initial selection to", t.value), x.set.selected(t.value), !0;
                  });
                }
              },
              event: {
                change: function change() {
                  V || (x.debug("Input changed, updating selection"), x.set.selected());
                },
                focus: function focus() {
                  C.showOnFocus && !X && x.is.hidden() && !g && x.show();
                },
                blur: function blur(e) {
                  g = n.activeElement === this, X || g || (x.remove.activeLabel(), x.hide());
                },
                mousedown: function mousedown() {
                  x.is.searchSelection() ? v = !0 : X = !0;
                },
                mouseup: function mouseup() {
                  x.is.searchSelection() ? v = !1 : X = !1;
                },
                click: function click(t) {
                  e(t.target).is(j) && (x.is.focusedOnSearch() ? x.show() : x.focusSearch());
                },
                search: {
                  focus: function focus() {
                    X = !0, x.is.multiple() && x.remove.activeLabel(), C.showOnFocus && x.search();
                  },
                  blur: function blur(e) {
                    g = n.activeElement === this, x.is.searchSelection() && !v && (z || g || (C.forceSelection && x.forceSelection(), x.hide())), v = !1;
                  }
                },
                icon: {
                  click: function click(e) {
                    x.toggle();
                  }
                },
                text: {
                  focus: function focus(e) {
                    X = !0, x.focusSearch();
                  }
                },
                input: function input(e) {
                  (x.is.multiple() || x.is.searchSelection()) && x.set.filtered(), clearTimeout(x.timer), x.timer = setTimeout(x.search, C.delay.search);
                },
                label: {
                  click: function click(t) {
                    var n = e(this),
                        i = j.find(A.label),
                        r = i.filter("." + S.active),
                        o = n.nextAll("." + S.active),
                        a = n.prevAll("." + S.active),
                        s = o.length > 0 ? n.nextUntil(o).add(r).add(n) : n.prevUntil(a).add(r).add(n);
                    t.shiftKey ? (r.removeClass(S.active), s.addClass(S.active)) : t.ctrlKey ? n.toggleClass(S.active) : (r.removeClass(S.active), n.addClass(S.active)), C.onLabelSelect.apply(this, i.filter("." + S.active));
                  }
                },
                remove: {
                  click: function click() {
                    var t = e(this).parent();
                    t.hasClass(S.active) ? x.remove.activeLabels() : x.remove.activeLabels(t);
                  }
                },
                test: {
                  toggle: function toggle(e) {
                    var t = x.is.multiple() ? x.show : x.toggle;
                    x.is.bubbledLabelClick(e) || x.is.bubbledIconClick(e) || x.determine.eventOnElement(e, t) && e.preventDefault();
                  },
                  touch: function touch(e) {
                    x.determine.eventOnElement(e, function () {
                      "touchstart" == e.type ? x.timer = setTimeout(function () {
                        x.hide();
                      }, C.delay.touch) : "touchmove" == e.type && clearTimeout(x.timer);
                    }), e.stopPropagation();
                  },
                  hide: function hide(e) {
                    x.determine.eventInModule(e, x.hide);
                  }
                },
                select: {
                  mutation: function mutation(t) {
                    x.debug("<select> modified, recreating menu");
                    var n = !1;
                    e.each(t, function (t, i) {
                      if (e(i.target).is("select") || e(i.addedNodes).is("select")) return n = !0, !0;
                    }), n && (x.disconnect.selectObserver(), x.refresh(), x.setup.select(), x.set.selected(), x.observe.select());
                  }
                },
                menu: {
                  mutation: function mutation(t) {
                    var n = t[0],
                        i = n.addedNodes ? e(n.addedNodes[0]) : e(!1),
                        r = n.removedNodes ? e(n.removedNodes[0]) : e(!1),
                        o = i.add(r),
                        a = o.is(A.addition) || o.closest(A.addition).length > 0,
                        s = o.is(A.message) || o.closest(A.message).length > 0;
                    a || s ? (x.debug("Updating item selector cache"), x.refreshItems()) : (x.debug("Menu modified, updating selector cache"), x.refresh());
                  },
                  mousedown: function mousedown() {
                    z = !0;
                  },
                  mouseup: function mouseup() {
                    z = !1;
                  }
                },
                item: {
                  mouseenter: function mouseenter(t) {
                    var n = e(t.target),
                        i = e(this),
                        r = i.children(A.menu),
                        o = i.siblings(A.item).children(A.menu),
                        a = r.length > 0;
                    !(r.find(n).length > 0) && a && (clearTimeout(x.itemTimer), x.itemTimer = setTimeout(function () {
                      x.verbose("Showing sub-menu", r), e.each(o, function () {
                        x.animate.hide(!1, e(this));
                      }), x.animate.show(!1, r);
                    }, C.delay.show), t.preventDefault());
                  },
                  mouseleave: function mouseleave(t) {
                    var n = e(this).children(A.menu);
                    n.length > 0 && (clearTimeout(x.itemTimer), x.itemTimer = setTimeout(function () {
                      x.verbose("Hiding sub-menu", n), x.animate.hide(!1, n);
                    }, C.delay.hide));
                  },
                  click: function click(t, i) {
                    var r = e(this),
                        o = e(t ? t.target : ""),
                        a = r.find(A.menu),
                        s = x.get.choiceText(r),
                        l = x.get.choiceValue(r, s),
                        c = a.length > 0,
                        u = a.find(o).length > 0;
                    x.has.menuSearch() && e(n.activeElement).blur(), u || c && !C.allowCategorySelection || (x.is.searchSelection() && (C.allowAdditions && x.remove.userAddition(), x.remove.searchTerm(), x.is.focusedOnSearch() || 1 == i || x.focusSearch(!0)), C.useLabels || (x.remove.filteredItem(), x.set.scrollPosition(r)), x.determine.selectAction.call(this, s, l));
                  }
                },
                document: {
                  keydown: function keydown(e) {
                    var t = e.which;

                    if (x.is.inObject(t, k)) {
                      var n = j.find(A.label),
                          i = n.filter("." + S.active),
                          r = (i.data(T.value), n.index(i)),
                          o = n.length,
                          a = i.length > 0,
                          s = i.length > 1,
                          l = 0 === r,
                          c = r + 1 == o,
                          u = x.is.searchSelection(),
                          d = x.is.focusedOnSearch(),
                          p = x.is.focused(),
                          h = d && 0 === x.get.caretPosition();
                      if (u && !a && !d) return;
                      t == k.leftArrow ? !p && !h || a ? a && (e.shiftKey ? x.verbose("Adding previous label to selection") : (x.verbose("Selecting previous label"), n.removeClass(S.active)), l && !s ? i.addClass(S.active) : i.prev(A.siblingLabel).addClass(S.active).end(), e.preventDefault()) : (x.verbose("Selecting previous label"), n.last().addClass(S.active)) : t == k.rightArrow ? (p && !a && n.first().addClass(S.active), a && (e.shiftKey ? x.verbose("Adding next label to selection") : (x.verbose("Selecting next label"), n.removeClass(S.active)), c ? u ? d ? n.removeClass(S.active) : x.focusSearch() : s ? i.next(A.siblingLabel).addClass(S.active) : i.addClass(S.active) : i.next(A.siblingLabel).addClass(S.active), e.preventDefault())) : t == k.deleteKey || t == k.backspace ? a ? (x.verbose("Removing active labels"), c && u && !d && x.focusSearch(), i.last().next(A.siblingLabel).addClass(S.active), x.remove.activeLabels(i), e.preventDefault()) : h && !a && t == k.backspace && (x.verbose("Removing last label on input backspace"), i = n.last().addClass(S.active), x.remove.activeLabels(i)) : i.removeClass(S.active);
                    }
                  }
                },
                keydown: function keydown(e) {
                  var t = e.which;

                  if (x.is.inObject(t, k)) {
                    var n,
                        i = Y.not(A.unselectable).filter("." + S.selected).eq(0),
                        r = U.children("." + S.active).eq(0),
                        o = i.length > 0 ? i : r,
                        a = o.length > 0 ? o.siblings(":not(." + S.filtered + ")").addBack() : U.children(":not(." + S.filtered + ")"),
                        s = o.children(A.menu),
                        l = o.closest(A.menu),
                        c = l.hasClass(S.visible) || l.hasClass(S.animating) || l.parent(A.menu).length > 0,
                        u = s.length > 0,
                        d = o.length > 0,
                        p = o.not(A.unselectable).length > 0,
                        h = t == k.delimiter && C.allowAdditions && x.is.multiple();

                    if (C.allowAdditions && C.hideAdditions && (t == k.enter || h) && p && (x.verbose("Selecting item from keyboard shortcut", o), x.event.item.click.call(o, e), x.is.searchSelection() && x.remove.searchTerm()), x.is.visible()) {
                      if ((t == k.enter || h) && (t == k.enter && d && u && !C.allowCategorySelection ? (x.verbose("Pressed enter on unselectable category, opening sub menu"), t = k.rightArrow) : p && (x.verbose("Selecting item from keyboard shortcut", o), x.event.item.click.call(o, e), x.is.searchSelection() && x.remove.searchTerm()), e.preventDefault()), d && (t == k.leftArrow && l[0] !== U[0] && (x.verbose("Left key pressed, closing sub-menu"), x.animate.hide(!1, l), o.removeClass(S.selected), l.closest(A.item).addClass(S.selected), e.preventDefault()), t == k.rightArrow && u && (x.verbose("Right key pressed, opening sub-menu"), x.animate.show(!1, s), o.removeClass(S.selected), s.find(A.item).eq(0).addClass(S.selected), e.preventDefault())), t == k.upArrow) {
                        if (n = d && c ? o.prevAll(A.item + ":not(" + A.unselectable + ")").eq(0) : Y.eq(0), a.index(n) < 0) return x.verbose("Up key pressed but reached top of current menu"), void e.preventDefault();
                        x.verbose("Up key pressed, changing active item"), o.removeClass(S.selected), n.addClass(S.selected), x.set.scrollPosition(n), C.selectOnKeydown && x.is.single() && x.set.selectedItem(n), e.preventDefault();
                      }

                      if (t == k.downArrow) {
                        if (0 === (n = d && c ? n = o.nextAll(A.item + ":not(" + A.unselectable + ")").eq(0) : Y.eq(0)).length) return x.verbose("Down key pressed but reached bottom of current menu"), void e.preventDefault();
                        x.verbose("Down key pressed, changing active item"), Y.removeClass(S.selected), n.addClass(S.selected), x.set.scrollPosition(n), C.selectOnKeydown && x.is.single() && x.set.selectedItem(n), e.preventDefault();
                      }

                      t == k.pageUp && (x.scrollPage("up"), e.preventDefault()), t == k.pageDown && (x.scrollPage("down"), e.preventDefault()), t == k.escape && (x.verbose("Escape key pressed, closing dropdown"), x.hide());
                    } else h && e.preventDefault(), t != k.downArrow || x.is.visible() || (x.verbose("Down key pressed, showing dropdown"), x.show(), e.preventDefault());
                  } else x.has.search() || x.set.selectedLetter(String.fromCharCode(t));
                }
              },
              trigger: {
                change: function change() {
                  var e = n.createEvent("HTMLEvents"),
                      t = q[0];
                  t && (x.verbose("Triggering native change event"), e.initEvent("change", !0, !1), t.dispatchEvent(e));
                }
              },
              determine: {
                selectAction: function selectAction(t, n) {
                  x.verbose("Determining action", C.action), e.isFunction(x.action[C.action]) ? (x.verbose("Triggering preset action", C.action, t, n), x.action[C.action].call(K, t, n, this)) : e.isFunction(C.action) ? (x.verbose("Triggering user action", C.action, t, n), C.action.call(K, t, n, this)) : x.error(M.action, C.action);
                },
                eventInModule: function eventInModule(t, i) {
                  var r = e(t.target),
                      o = r.closest(n.documentElement).length > 0,
                      a = r.closest(j).length > 0;
                  return i = e.isFunction(i) ? i : function () {}, o && !a ? (x.verbose("Triggering event", i), i(), !0) : (x.verbose("Event occurred in dropdown, canceling callback"), !1);
                },
                eventOnElement: function eventOnElement(t, i) {
                  var r = e(t.target),
                      o = r.closest(A.siblingLabel),
                      a = n.body.contains(t.target),
                      s = 0 === j.find(o).length,
                      l = 0 === r.closest(U).length;
                  return i = e.isFunction(i) ? i : function () {}, a && s && l ? (x.verbose("Triggering event", i), i(), !0) : (x.verbose("Event occurred in dropdown menu, canceling callback"), !1);
                }
              },
              action: {
                nothing: function nothing() {},
                activate: function activate(t, n, i) {
                  if (n = void 0 !== n ? n : t, x.can.activate(e(i))) {
                    if (x.set.selected(n, e(i)), x.is.multiple() && !x.is.allFiltered()) return;
                    x.hideAndClear();
                  }
                },
                select: function select(t, n, i) {
                  if (n = void 0 !== n ? n : t, x.can.activate(e(i))) {
                    if (x.set.value(n, e(i)), x.is.multiple() && !x.is.allFiltered()) return;
                    x.hideAndClear();
                  }
                },
                combo: function combo(t, n, i) {
                  n = void 0 !== n ? n : t, x.set.selected(n, e(i)), x.hideAndClear();
                },
                hide: function hide(e, t, n) {
                  x.set.value(t, e), x.hideAndClear();
                }
              },
              get: {
                id: function id() {
                  return y;
                },
                defaultText: function defaultText() {
                  return j.data(T.defaultText);
                },
                defaultValue: function defaultValue() {
                  return j.data(T.defaultValue);
                },
                placeholderText: function placeholderText() {
                  return "auto" != C.placeholder && "string" == typeof C.placeholder ? C.placeholder : j.data(T.placeholderText) || "";
                },
                text: function text() {
                  return R.text();
                },
                query: function query() {
                  return e.trim(H.val());
                },
                searchWidth: function searchWidth(e) {
                  return e = void 0 !== e ? e : H.val(), B.text(e), Math.ceil(B.width() + 1);
                },
                selectionCount: function selectionCount() {
                  var t = x.get.values();
                  return x.is.multiple() ? e.isArray(t) ? t.length : 0 : "" !== x.get.value() ? 1 : 0;
                },
                transition: function transition(e) {
                  return "auto" == C.transition ? x.is.upward(e) ? "slide up" : "slide down" : C.transition;
                },
                userValues: function userValues() {
                  var t = x.get.values();
                  return !!t && (t = e.isArray(t) ? t : [t], e.grep(t, function (e) {
                    return !1 === x.get.item(e);
                  }));
                },
                uniqueArray: function uniqueArray(t) {
                  return e.grep(t, function (n, i) {
                    return e.inArray(n, t) === i;
                  });
                },
                caretPosition: function caretPosition() {
                  var e,
                      t,
                      i = H.get(0);
                  return "selectionStart" in i ? i.selectionStart : n.selection ? (i.focus(), t = (e = n.selection.createRange()).text.length, e.moveStart("character", -i.value.length), e.text.length - t) : void 0;
                },
                value: function value() {
                  var t = q.length > 0 ? q.val() : j.data(T.value),
                      n = e.isArray(t) && 1 === t.length && "" === t[0];
                  return void 0 === t || n ? "" : t;
                },
                values: function values() {
                  var e = x.get.value();
                  return "" === e ? "" : !x.has.selectInput() && x.is.multiple() ? "string" == typeof e ? e.split(C.delimiter) : "" : e;
                },
                remoteValues: function remoteValues() {
                  var t = x.get.values(),
                      n = !1;
                  return t && ("string" == typeof t && (t = [t]), e.each(t, function (e, t) {
                    var i = x.read.remoteData(t);
                    x.verbose("Restoring value from session data", i, t), i && (n || (n = {}), n[t] = i);
                  })), n;
                },
                choiceText: function choiceText(t, n) {
                  if (n = void 0 !== n ? n : C.preserveHTML, t) return t.find(A.menu).length > 0 && (x.verbose("Retrieving text of element with sub-menu"), (t = t.clone()).find(A.menu).remove(), t.find(A.menuIcon).remove()), void 0 !== t.data(T.text) ? t.data(T.text) : n ? e.trim(t.html()) : e.trim(t.text());
                },
                choiceValue: function choiceValue(t, n) {
                  return n = n || x.get.choiceText(t), !!t && (void 0 !== t.data(T.value) ? String(t.data(T.value)) : "string" == typeof n ? e.trim(n.toLowerCase()) : String(n));
                },
                inputEvent: function inputEvent() {
                  var e = H[0];
                  return !!e && (void 0 !== e.oninput ? "input" : void 0 !== e.onpropertychange ? "propertychange" : "keyup");
                },
                selectValues: function selectValues() {
                  var t = {
                    values: []
                  };
                  return j.find("option").each(function () {
                    var n = e(this),
                        i = n.html(),
                        r = n.attr("disabled"),
                        o = void 0 !== n.attr("value") ? n.attr("value") : i;
                    "auto" === C.placeholder && "" === o ? t.placeholder = i : t.values.push({
                      name: i,
                      value: o,
                      disabled: r
                    });
                  }), C.placeholder && "auto" !== C.placeholder && (x.debug("Setting placeholder value to", C.placeholder), t.placeholder = C.placeholder), C.sortSelect ? (t.values.sort(function (e, t) {
                    return e.name > t.name ? 1 : -1;
                  }), x.debug("Retrieved and sorted values from select", t)) : x.debug("Retrieved values from select", t), t;
                },
                activeItem: function activeItem() {
                  return Y.filter("." + S.active);
                },
                selectedItem: function selectedItem() {
                  var e = Y.not(A.unselectable).filter("." + S.selected);
                  return e.length > 0 ? e : Y.eq(0);
                },
                itemWithAdditions: function itemWithAdditions(e) {
                  var t = x.get.item(e),
                      n = x.create.userChoice(e);
                  return n && n.length > 0 && (t = t.length > 0 ? t.add(n) : n), t;
                },
                item: function item(t, n) {
                  var i,
                      r,
                      o = !1;
                  return t = void 0 !== t ? t : void 0 !== x.get.values() ? x.get.values() : x.get.text(), i = r ? t.length > 0 : null != t, r = x.is.multiple() && e.isArray(t), n = "" === t || 0 === t || n || !1, i && Y.each(function () {
                    var i = e(this),
                        a = x.get.choiceText(i),
                        s = x.get.choiceValue(i, a);
                    if (null != s) if (r) -1 === e.inArray(String(s), t) && -1 === e.inArray(a, t) || (o = o ? o.add(i) : i);else if (n) {
                      if (x.verbose("Ambiguous dropdown value using strict type check", i, t), s === t || a === t) return o = i, !0;
                    } else if (String(s) == String(t) || a == t) return x.verbose("Found select item by value", s, t), o = i, !0;
                  }), o;
                }
              },
              check: {
                maxSelections: function maxSelections(e) {
                  return !C.maxSelections || ((e = void 0 !== e ? e : x.get.selectionCount()) >= C.maxSelections ? (x.debug("Maximum selection count reached"), C.useLabels && (Y.addClass(S.filtered), x.add.message(D.maxSelections)), !0) : (x.verbose("No longer at maximum selection count"), x.remove.message(), x.remove.filteredItem(), x.is.searchSelection() && x.filterItems(), !1));
                }
              },
              restore: {
                defaults: function defaults() {
                  x.clear(), x.restore.defaultText(), x.restore.defaultValue();
                },
                defaultText: function defaultText() {
                  var e = x.get.defaultText();
                  e === x.get.placeholderText ? (x.debug("Restoring default placeholder text", e), x.set.placeholderText(e)) : (x.debug("Restoring default text", e), x.set.text(e));
                },
                placeholderText: function placeholderText() {
                  x.set.placeholderText();
                },
                defaultValue: function defaultValue() {
                  var e = x.get.defaultValue();
                  void 0 !== e && (x.debug("Restoring default value", e), "" !== e ? (x.set.value(e), x.set.selected()) : (x.remove.activeItem(), x.remove.selectedItem()));
                },
                labels: function labels() {
                  C.allowAdditions && (C.useLabels || (x.error(M.labels), C.useLabels = !0), x.debug("Restoring selected values"), x.create.userLabels()), x.check.maxSelections();
                },
                selected: function selected() {
                  x.restore.values(), x.is.multiple() ? (x.debug("Restoring previously selected values and labels"), x.restore.labels()) : x.debug("Restoring previously selected values");
                },
                values: function values() {
                  x.set.initialLoad(), C.apiSettings && C.saveRemoteData && x.get.remoteValues() ? x.restore.remoteValues() : x.set.selected(), x.remove.initialLoad();
                },
                remoteValues: function remoteValues() {
                  var t = x.get.remoteValues();
                  x.debug("Recreating selected from session data", t), t && (x.is.single() ? e.each(t, function (e, t) {
                    x.set.text(t);
                  }) : e.each(t, function (e, t) {
                    x.add.label(e, t);
                  }));
                }
              },
              read: {
                remoteData: function remoteData(e) {
                  var n;
                  if (void 0 !== t.Storage) return void 0 !== (n = sessionStorage.getItem(e)) && n;
                  x.error(M.noStorage);
                }
              },
              save: {
                defaults: function defaults() {
                  x.save.defaultText(), x.save.placeholderText(), x.save.defaultValue();
                },
                defaultValue: function defaultValue() {
                  var e = x.get.value();
                  x.verbose("Saving default value as", e), j.data(T.defaultValue, e);
                },
                defaultText: function defaultText() {
                  var e = x.get.text();
                  x.verbose("Saving default text as", e), j.data(T.defaultText, e);
                },
                placeholderText: function placeholderText() {
                  var e;
                  !1 !== C.placeholder && R.hasClass(S.placeholder) && (e = x.get.text(), x.verbose("Saving placeholder text as", e), j.data(T.placeholderText, e));
                },
                remoteData: function remoteData(e, n) {
                  void 0 !== t.Storage ? (x.verbose("Saving remote data to session storage", n, e), sessionStorage.setItem(n, e)) : x.error(M.noStorage);
                }
              },
              clear: function clear() {
                x.is.multiple() && C.useLabels ? x.remove.labels() : (x.remove.activeItem(), x.remove.selectedItem()), x.set.placeholderText(), x.clearValue();
              },
              clearValue: function clearValue() {
                x.set.value("");
              },
              scrollPage: function scrollPage(e, t) {
                var n,
                    i,
                    r = t || x.get.selectedItem(),
                    o = r.closest(A.menu),
                    a = o.outerHeight(),
                    s = o.scrollTop(),
                    l = Y.eq(0).outerHeight(),
                    c = Math.floor(a / l),
                    u = (o.prop("scrollHeight"), "up" == e ? s - l * c : s + l * c),
                    d = Y.not(A.unselectable);
                i = "up" == e ? d.index(r) - c : d.index(r) + c, (n = ("up" == e ? i >= 0 : i < d.length) ? d.eq(i) : "up" == e ? d.first() : d.last()).length > 0 && (x.debug("Scrolling page", e, n), r.removeClass(S.selected), n.addClass(S.selected), C.selectOnKeydown && x.is.single() && x.set.selectedItem(n), o.scrollTop(u));
              },
              set: {
                filtered: function filtered() {
                  var e = x.is.multiple(),
                      t = x.is.searchSelection(),
                      n = e && t,
                      i = t ? x.get.query() : "",
                      r = "string" == typeof i && i.length > 0,
                      o = x.get.searchWidth(),
                      a = "" !== i;
                  e && r && (x.verbose("Adjusting input width", o, C.glyphWidth), H.css("width", o)), r || n && a ? (x.verbose("Hiding placeholder text"), R.addClass(S.filtered)) : (!e || n && !a) && (x.verbose("Showing placeholder text"), R.removeClass(S.filtered));
                },
                empty: function empty() {
                  j.addClass(S.empty);
                },
                loading: function loading() {
                  j.addClass(S.loading);
                },
                placeholderText: function placeholderText(e) {
                  e = e || x.get.placeholderText(), x.debug("Setting placeholder text", e), x.set.text(e), R.addClass(S.placeholder);
                },
                tabbable: function tabbable() {
                  x.is.searchSelection() ? (x.debug("Added tabindex to searchable dropdown"), H.val("").attr("tabindex", 0), U.attr("tabindex", -1)) : (x.debug("Added tabindex to dropdown"), void 0 === j.attr("tabindex") && (j.attr("tabindex", 0), U.attr("tabindex", -1)));
                },
                initialLoad: function initialLoad() {
                  x.verbose("Setting initial load"), m = !0;
                },
                activeItem: function activeItem(e) {
                  C.allowAdditions && e.filter(A.addition).length > 0 ? e.addClass(S.filtered) : e.addClass(S.active);
                },
                partialSearch: function partialSearch(e) {
                  var t = x.get.query().length;
                  H.val(e.substr(0, t));
                },
                scrollPosition: function scrollPosition(e, t) {
                  var n, i, r, o, a, s;
                  n = (e = e || x.get.selectedItem()).closest(A.menu), i = e && e.length > 0, t = void 0 !== t && t, e && n.length > 0 && i && (e.position().top, n.addClass(S.loading), r = (o = n.scrollTop()) - n.offset().top + e.offset().top, t || (s = o + n.height() < r + 5, a = r - 5 < o), x.debug("Scrolling to active item", r), (t || a || s) && n.scrollTop(r), n.removeClass(S.loading));
                },
                text: function text(e) {
                  "select" !== C.action && ("combo" == C.action ? (x.debug("Changing combo button text", e, W), C.preserveHTML ? W.html(e) : W.text(e)) : (e !== x.get.placeholderText() && R.removeClass(S.placeholder), x.debug("Changing text", e, R), R.removeClass(S.filtered), C.preserveHTML ? R.html(e) : R.text(e)));
                },
                selectedItem: function selectedItem(e) {
                  var t = x.get.choiceValue(e),
                      n = x.get.choiceText(e, !1),
                      i = x.get.choiceText(e, !0);
                  x.debug("Setting user selection to item", e), x.remove.activeItem(), x.set.partialSearch(n), x.set.activeItem(e), x.set.selected(t, e), x.set.text(i);
                },
                selectedLetter: function selectedLetter(t) {
                  var n,
                      i = Y.filter("." + S.selected),
                      r = i.length > 0 && x.has.firstLetter(i, t),
                      o = !1;
                  r && (n = i.nextAll(Y).eq(0), x.has.firstLetter(n, t) && (o = n)), o || Y.each(function () {
                    if (x.has.firstLetter(e(this), t)) return o = e(this), !1;
                  }), o && (x.verbose("Scrolling to next value with letter", t), x.set.scrollPosition(o), i.removeClass(S.selected), o.addClass(S.selected), C.selectOnKeydown && x.is.single() && x.set.selectedItem(o));
                },
                direction: function direction(e) {
                  "auto" == C.direction ? (x.remove.upward(), x.can.openDownward(e) ? x.remove.upward(e) : x.set.upward(e), x.is.leftward(e) || x.can.openRightward(e) || x.set.leftward(e)) : "upward" == C.direction && x.set.upward(e);
                },
                upward: function upward(e) {
                  (e || j).addClass(S.upward);
                },
                leftward: function leftward(e) {
                  (e || U).addClass(S.leftward);
                },
                value: function value(e, t, n) {
                  var i = x.escape.value(e),
                      r = q.length > 0,
                      o = (x.has.value(e), x.get.values()),
                      a = void 0 !== e ? String(e) : e;

                  if (r) {
                    if (!C.allowReselection && a == o && (x.verbose("Skipping value update already same value", e, o), !x.is.initialLoad())) return;
                    x.is.single() && x.has.selectInput() && x.can.extendSelect() && (x.debug("Adding user option", e), x.add.optionValue(e)), x.debug("Updating input value", i, o), V = !0, q.val(i), !1 === C.fireOnInit && x.is.initialLoad() ? x.debug("Input native change event ignored on initial load") : x.trigger.change(), V = !1;
                  } else x.verbose("Storing value in metadata", i, q), i !== o && j.data(T.value, a);

                  !1 === C.fireOnInit && x.is.initialLoad() ? x.verbose("No callback on initial load", C.onChange) : C.onChange.call(K, e, t, n);
                },
                active: function active() {
                  j.addClass(S.active);
                },
                multiple: function multiple() {
                  j.addClass(S.multiple);
                },
                visible: function visible() {
                  j.addClass(S.visible);
                },
                exactly: function exactly(e, t) {
                  x.debug("Setting selected to exact values"), x.clear(), x.set.selected(e, t);
                },
                selected: function selected(t, n) {
                  var i = x.is.multiple();
                  (n = C.allowAdditions ? n || x.get.itemWithAdditions(t) : n || x.get.item(t)) && (x.debug("Setting selected menu item to", n), x.is.multiple() && x.remove.searchWidth(), x.is.single() ? (x.remove.activeItem(), x.remove.selectedItem()) : C.useLabels && x.remove.selectedItem(), n.each(function () {
                    var t = e(this),
                        r = x.get.choiceText(t),
                        o = x.get.choiceValue(t, r),
                        a = t.hasClass(S.filtered),
                        s = t.hasClass(S.active),
                        l = t.hasClass(S.addition),
                        c = i && 1 == n.length;
                    i ? !s || l ? (C.apiSettings && C.saveRemoteData && x.save.remoteData(r, o), C.useLabels ? (x.add.value(o, r, t), x.add.label(o, r, c), x.set.activeItem(t), x.filterActive(), x.select.nextAvailable(n)) : (x.add.value(o, r, t), x.set.text(x.add.variables(D.count)), x.set.activeItem(t))) : a || (x.debug("Selected active value, removing label"), x.remove.selected(o)) : (C.apiSettings && C.saveRemoteData && x.save.remoteData(r, o), x.set.text(r), x.set.value(o, r, t), t.addClass(S.active).addClass(S.selected));
                  }));
                }
              },
              add: {
                label: function label(t, n, i) {
                  var r,
                      o = x.is.searchSelection() ? H : R,
                      a = x.escape.value(t);
                  r = e("<a />").addClass(S.label).attr("data-" + T.value, a).html(N.label(a, n)), r = C.onLabelCreate.call(r, a, n), x.has.label(t) ? x.debug("Label already exists, skipping", a) : (C.label.variation && r.addClass(C.label.variation), !0 === i ? (x.debug("Animating in label", r), r.addClass(S.hidden).insertBefore(o).transition(C.label.transition, C.label.duration)) : (x.debug("Adding selection label", r), r.insertBefore(o)));
                },
                message: function message(t) {
                  var n = U.children(A.message),
                      i = C.templates.message(x.add.variables(t));
                  n.length > 0 ? n.html(i) : n = e("<div/>").html(i).addClass(S.message).appendTo(U);
                },
                optionValue: function optionValue(t) {
                  var n = x.escape.value(t);
                  q.find('option[value="' + x.escape.string(n) + '"]').length > 0 || (x.disconnect.selectObserver(), x.is.single() && (x.verbose("Removing previous user addition"), q.find("option." + S.addition).remove()), e("<option/>").prop("value", n).addClass(S.addition).html(t).appendTo(q), x.verbose("Adding user addition as an <option>", t), x.observe.select());
                },
                userSuggestion: function userSuggestion(e) {
                  var t,
                      n = U.children(A.addition),
                      i = x.get.item(e),
                      r = i && i.not(A.addition).length,
                      o = n.length > 0;
                  C.useLabels && x.has.maxSelections() || ("" === e || r ? n.remove() : (o ? (n.data(T.value, e).data(T.text, e).attr("data-" + T.value, e).attr("data-" + T.text, e).removeClass(S.filtered), C.hideAdditions || (t = C.templates.addition(x.add.variables(D.addResult, e)), n.html(t)), x.verbose("Replacing user suggestion with new value", n)) : ((n = x.create.userChoice(e)).prependTo(U), x.verbose("Adding item choice to menu corresponding with user choice addition", n)), C.hideAdditions && !x.is.allFiltered() || n.addClass(S.selected).siblings().removeClass(S.selected), x.refreshItems()));
                },
                variables: function variables(e, t) {
                  var n,
                      i,
                      r = -1 !== e.search("{count}"),
                      o = -1 !== e.search("{maxCount}"),
                      a = -1 !== e.search("{term}");
                  return x.verbose("Adding templated variables to message", e), r && (n = x.get.selectionCount(), e = e.replace("{count}", n)), o && (n = x.get.selectionCount(), e = e.replace("{maxCount}", C.maxSelections)), a && (i = t || x.get.query(), e = e.replace("{term}", i)), e;
                },
                value: function value(t, n, i) {
                  var r,
                      o = x.get.values();
                  "" !== t ? (e.isArray(o) ? (r = o.concat([t]), r = x.get.uniqueArray(r)) : r = [t], x.has.selectInput() ? x.can.extendSelect() && (x.debug("Adding value to select", t, r, q), x.add.optionValue(t)) : (r = r.join(C.delimiter), x.debug("Setting hidden input to delimited value", r, q)), !1 === C.fireOnInit && x.is.initialLoad() ? x.verbose("Skipping onadd callback on initial load", C.onAdd) : C.onAdd.call(K, t, n, i), x.set.value(r, t, n, i), x.check.maxSelections()) : x.debug("Cannot select blank values from multiselect");
                }
              },
              remove: {
                active: function active() {
                  j.removeClass(S.active);
                },
                activeLabel: function activeLabel() {
                  j.find(A.label).removeClass(S.active);
                },
                empty: function empty() {
                  j.removeClass(S.empty);
                },
                loading: function loading() {
                  j.removeClass(S.loading);
                },
                initialLoad: function initialLoad() {
                  m = !1;
                },
                upward: function upward(e) {
                  (e || j).removeClass(S.upward);
                },
                leftward: function leftward(e) {
                  (e || U).removeClass(S.leftward);
                },
                visible: function visible() {
                  j.removeClass(S.visible);
                },
                activeItem: function activeItem() {
                  Y.removeClass(S.active);
                },
                filteredItem: function filteredItem() {
                  C.useLabels && x.has.maxSelections() || (C.useLabels && x.is.multiple() ? Y.not("." + S.active).removeClass(S.filtered) : Y.removeClass(S.filtered), x.remove.empty());
                },
                optionValue: function optionValue(e) {
                  var t = x.escape.value(e),
                      n = q.find('option[value="' + x.escape.string(t) + '"]');
                  n.length > 0 && n.hasClass(S.addition) && (_ && (_.disconnect(), x.verbose("Temporarily disconnecting mutation observer")), n.remove(), x.verbose("Removing user addition as an <option>", t), _ && _.observe(q[0], {
                    childList: !0,
                    subtree: !0
                  }));
                },
                message: function message() {
                  U.children(A.message).remove();
                },
                searchWidth: function searchWidth() {
                  H.css("width", "");
                },
                searchTerm: function searchTerm() {
                  x.verbose("Cleared search term"), H.val(""), x.set.filtered();
                },
                userAddition: function userAddition() {
                  Y.filter(A.addition).remove();
                },
                selected: function selected(t, n) {
                  if (!(n = C.allowAdditions ? n || x.get.itemWithAdditions(t) : n || x.get.item(t))) return !1;
                  n.each(function () {
                    var t = e(this),
                        n = x.get.choiceText(t),
                        i = x.get.choiceValue(t, n);
                    x.is.multiple() ? C.useLabels ? (x.remove.value(i, n, t), x.remove.label(i)) : (x.remove.value(i, n, t), 0 === x.get.selectionCount() ? x.set.placeholderText() : x.set.text(x.add.variables(D.count))) : x.remove.value(i, n, t), t.removeClass(S.filtered).removeClass(S.active), C.useLabels && t.removeClass(S.selected);
                  });
                },
                selectedItem: function selectedItem() {
                  Y.removeClass(S.selected);
                },
                value: function value(e, t, n) {
                  var i,
                      r = x.get.values();
                  x.has.selectInput() ? (x.verbose("Input is <select> removing selected option", e), i = x.remove.arrayValue(e, r), x.remove.optionValue(e)) : (x.verbose("Removing from delimited values", e), i = (i = x.remove.arrayValue(e, r)).join(C.delimiter)), !1 === C.fireOnInit && x.is.initialLoad() ? x.verbose("No callback on initial load", C.onRemove) : C.onRemove.call(K, e, t, n), x.set.value(i, t, n), x.check.maxSelections();
                },
                arrayValue: function arrayValue(t, n) {
                  return e.isArray(n) || (n = [n]), n = e.grep(n, function (e) {
                    return t != e;
                  }), x.verbose("Removed value from delimited string", t, n), n;
                },
                label: function label(e, t) {
                  var n = j.find(A.label).filter("[data-" + T.value + '="' + x.escape.string(e) + '"]');
                  x.verbose("Removing label", n), n.remove();
                },
                activeLabels: function activeLabels(e) {
                  e = e || j.find(A.label).filter("." + S.active), x.verbose("Removing active label selections", e), x.remove.labels(e);
                },
                labels: function labels(t) {
                  t = t || j.find(A.label), x.verbose("Removing labels", t), t.each(function () {
                    var t = e(this),
                        n = t.data(T.value),
                        i = void 0 !== n ? String(n) : n,
                        r = x.is.userValue(i);
                    !1 !== C.onLabelRemove.call(t, n) ? (x.remove.message(), r ? (x.remove.value(i), x.remove.label(i)) : x.remove.selected(i)) : x.debug("Label remove callback cancelled removal");
                  });
                },
                tabbable: function tabbable() {
                  x.is.searchSelection() ? (x.debug("Searchable dropdown initialized"), H.removeAttr("tabindex"), U.removeAttr("tabindex")) : (x.debug("Simple selection dropdown initialized"), j.removeAttr("tabindex"), U.removeAttr("tabindex"));
                }
              },
              has: {
                menuSearch: function menuSearch() {
                  return x.has.search() && H.closest(U).length > 0;
                },
                search: function search() {
                  return H.length > 0;
                },
                sizer: function sizer() {
                  return B.length > 0;
                },
                selectInput: function selectInput() {
                  return q.is("select");
                },
                minCharacters: function minCharacters(e) {
                  return !C.minCharacters || (e = void 0 !== e ? String(e) : String(x.get.query())).length >= C.minCharacters;
                },
                firstLetter: function firstLetter(e, t) {
                  var n;
                  return !(!e || 0 === e.length || "string" != typeof t) && (n = x.get.choiceText(e, !1), (t = t.toLowerCase()) == String(n).charAt(0).toLowerCase());
                },
                input: function input() {
                  return q.length > 0;
                },
                items: function items() {
                  return Y.length > 0;
                },
                menu: function menu() {
                  return U.length > 0;
                },
                message: function message() {
                  return 0 !== U.children(A.message).length;
                },
                label: function label(e) {
                  var t = x.escape.value(e);
                  return j.find(A.label).filter("[data-" + T.value + '="' + x.escape.string(t) + '"]').length > 0;
                },
                maxSelections: function maxSelections() {
                  return C.maxSelections && x.get.selectionCount() >= C.maxSelections;
                },
                allResultsFiltered: function allResultsFiltered() {
                  var e = Y.not(A.addition);
                  return e.filter(A.unselectable).length === e.length;
                },
                userSuggestion: function userSuggestion() {
                  return U.children(A.addition).length > 0;
                },
                query: function query() {
                  return "" !== x.get.query();
                },
                value: function value(t) {
                  var n = x.get.values();
                  return !!(e.isArray(n) ? n && -1 !== e.inArray(t, n) : n == t);
                }
              },
              is: {
                active: function active() {
                  return j.hasClass(S.active);
                },
                bubbledLabelClick: function bubbledLabelClick(t) {
                  return e(t.target).is("select, input") && j.closest("label").length > 0;
                },
                bubbledIconClick: function bubbledIconClick(t) {
                  return e(t.target).closest($).length > 0;
                },
                alreadySetup: function alreadySetup() {
                  return j.is("select") && void 0 !== j.parent(A.dropdown).data(F) && 0 === j.prev().length;
                },
                animating: function animating(e) {
                  return e ? e.transition && e.transition("is animating") : U.transition && U.transition("is animating");
                },
                leftward: function leftward(e) {
                  return (e || U).hasClass(S.leftward);
                },
                disabled: function disabled() {
                  return j.hasClass(S.disabled);
                },
                focused: function focused() {
                  return n.activeElement === j[0];
                },
                focusedOnSearch: function focusedOnSearch() {
                  return n.activeElement === H[0];
                },
                allFiltered: function allFiltered() {
                  return (x.is.multiple() || x.has.search()) && !(0 == C.hideAdditions && x.has.userSuggestion()) && !x.has.message() && x.has.allResultsFiltered();
                },
                hidden: function hidden(e) {
                  return !x.is.visible(e);
                },
                initialLoad: function initialLoad() {
                  return m;
                },
                inObject: function inObject(t, n) {
                  var i = !1;
                  return e.each(n, function (e, n) {
                    if (n == t) return i = !0, !0;
                  }), i;
                },
                multiple: function multiple() {
                  return j.hasClass(S.multiple);
                },
                remote: function remote() {
                  return C.apiSettings && x.can.useAPI();
                },
                single: function single() {
                  return !x.is.multiple();
                },
                selectMutation: function selectMutation(t) {
                  var n = !1;
                  return e.each(t, function (t, i) {
                    if (i.target && e(i.target).is("select")) return n = !0, !0;
                  }), n;
                },
                search: function search() {
                  return j.hasClass(S.search);
                },
                searchSelection: function searchSelection() {
                  return x.has.search() && 1 === H.parent(A.dropdown).length;
                },
                selection: function selection() {
                  return j.hasClass(S.selection);
                },
                userValue: function userValue(t) {
                  return -1 !== e.inArray(t, x.get.userValues());
                },
                upward: function upward(e) {
                  return (e || j).hasClass(S.upward);
                },
                visible: function visible(e) {
                  return e ? e.hasClass(S.visible) : U.hasClass(S.visible);
                },
                verticallyScrollableContext: function verticallyScrollableContext() {
                  var e = L.get(0) !== t && L.css("overflow-y");
                  return "auto" == e || "scroll" == e;
                },
                horizontallyScrollableContext: function horizontallyScrollableContext() {
                  var e = L.get(0) !== t && L.css("overflow-X");
                  return "auto" == e || "scroll" == e;
                }
              },
              can: {
                activate: function activate(e) {
                  return !!C.useLabels || !x.has.maxSelections() || !(!x.has.maxSelections() || !e.hasClass(S.active));
                },
                openDownward: function openDownward(e) {
                  var t,
                      n,
                      i = e || U,
                      r = !0;
                  return i.addClass(S.loading), n = {
                    context: {
                      scrollTop: L.scrollTop(),
                      height: L.outerHeight()
                    },
                    menu: {
                      offset: i.offset(),
                      height: i.outerHeight()
                    }
                  }, x.is.verticallyScrollableContext() && (n.menu.offset.top += n.context.scrollTop), (t = {
                    above: n.context.scrollTop <= n.menu.offset.top - n.menu.height,
                    below: n.context.scrollTop + n.context.height >= n.menu.offset.top + n.menu.height
                  }).below ? (x.verbose("Dropdown can fit in context downward", t), r = !0) : t.below || t.above ? (x.verbose("Dropdown cannot fit below, opening upward", t), r = !1) : (x.verbose("Dropdown cannot fit in either direction, favoring downward", t), r = !0), i.removeClass(S.loading), r;
                },
                openRightward: function openRightward(e) {
                  var t,
                      n,
                      i = e || U,
                      r = !0;
                  return i.addClass(S.loading), n = {
                    context: {
                      scrollLeft: L.scrollLeft(),
                      width: L.outerWidth()
                    },
                    menu: {
                      offset: i.offset(),
                      width: i.outerWidth()
                    }
                  }, x.is.horizontallyScrollableContext() && (n.menu.offset.left += n.context.scrollLeft), (t = n.menu.offset.left + n.menu.width >= n.context.scrollLeft + n.context.width) && (x.verbose("Dropdown cannot fit in context rightward", t), r = !1), i.removeClass(S.loading), r;
                },
                click: function click() {
                  return l || "click" == C.on;
                },
                extendSelect: function extendSelect() {
                  return C.allowAdditions || C.apiSettings;
                },
                show: function show() {
                  return !x.is.disabled() && (x.has.items() || x.has.message());
                },
                useAPI: function useAPI() {
                  return void 0 !== e.fn.api;
                }
              },
              animate: {
                show: function show(t, n) {
                  var i,
                      r = n || U,
                      o = n ? function () {} : function () {
                    x.hideSubMenus(), x.hideOthers(), x.set.active();
                  };
                  t = e.isFunction(t) ? t : function () {}, x.verbose("Doing menu show animation", r), x.set.direction(n), i = x.get.transition(n), x.is.selection() && x.set.scrollPosition(x.get.selectedItem(), !0), (x.is.hidden(r) || x.is.animating(r)) && ("none" == i ? (o(), r.transition("show"), t.call(K)) : void 0 !== e.fn.transition && j.transition("is supported") ? r.transition({
                    animation: i + " in",
                    debug: C.debug,
                    verbose: C.verbose,
                    duration: C.duration,
                    queue: !0,
                    onStart: o,
                    onComplete: function onComplete() {
                      t.call(K);
                    }
                  }) : x.error(M.noTransition, i));
                },
                hide: function hide(t, n) {
                  var i = n || U,
                      r = (n ? C.duration : C.duration, n ? function () {} : function () {
                    x.can.click() && x.unbind.intent(), x.remove.active();
                  }),
                      o = x.get.transition(n);
                  t = e.isFunction(t) ? t : function () {}, (x.is.visible(i) || x.is.animating(i)) && (x.verbose("Doing menu hide animation", i), "none" == o ? (r(), i.transition("hide"), t.call(K)) : void 0 !== e.fn.transition && j.transition("is supported") ? i.transition({
                    animation: o + " out",
                    duration: C.duration,
                    debug: C.debug,
                    verbose: C.verbose,
                    queue: !0,
                    onStart: r,
                    onComplete: function onComplete() {
                      t.call(K);
                    }
                  }) : x.error(M.transition));
                }
              },
              hideAndClear: function hideAndClear() {
                x.remove.searchTerm(), x.has.maxSelections() || (x.has.search() ? x.hide(function () {
                  x.remove.filteredItem();
                }) : x.hide());
              },
              delay: {
                show: function show() {
                  x.verbose("Delaying show event to ensure user intent"), clearTimeout(x.timer), x.timer = setTimeout(x.show, C.delay.show);
                },
                hide: function hide() {
                  x.verbose("Delaying hide event to ensure user intent"), clearTimeout(x.timer), x.timer = setTimeout(x.hide, C.delay.hide);
                }
              },
              escape: {
                value: function value(t) {
                  var n = e.isArray(t),
                      i = "string" == typeof t,
                      r = !i && !n,
                      o = i && -1 !== t.search(P.quote),
                      a = [];
                  return r || !o ? t : (x.debug("Encoding quote values for use in select", t), n ? (e.each(t, function (e, t) {
                    a.push(t.replace(P.quote, "&quot;"));
                  }), a) : t.replace(P.quote, "&quot;"));
                },
                string: function string(e) {
                  return (e = String(e)).replace(P.escape, "\\$&");
                }
              },
              setting: function setting(t, n) {
                if (x.debug("Changing setting", t, n), e.isPlainObject(t)) e.extend(!0, C, t);else {
                  if (void 0 === n) return C[t];
                  e.isPlainObject(C[t]) ? e.extend(!0, C[t], n) : C[t] = n;
                }
              },
              internal: function internal(t, n) {
                if (e.isPlainObject(t)) e.extend(!0, x, t);else {
                  if (void 0 === n) return x[t];
                  x[t] = n;
                }
              },
              debug: function debug() {
                !C.silent && C.debug && (C.performance ? x.performance.log(arguments) : (x.debug = Function.prototype.bind.call(console.info, console, C.name + ":"), x.debug.apply(console, arguments)));
              },
              verbose: function verbose() {
                !C.silent && C.verbose && C.debug && (C.performance ? x.performance.log(arguments) : (x.verbose = Function.prototype.bind.call(console.info, console, C.name + ":"), x.verbose.apply(console, arguments)));
              },
              error: function error() {
                C.silent || (x.error = Function.prototype.bind.call(console.error, console, C.name + ":"), x.error.apply(console, arguments));
              },
              performance: {
                log: function log(e) {
                  var t, n;
                  C.performance && (n = (t = new Date().getTime()) - (c || t), c = t, u.push({
                    Name: e[0],
                    Arguments: [].slice.call(e, 1) || "",
                    Element: K,
                    "Execution Time": n
                  })), clearTimeout(x.performance.timer), x.performance.timer = setTimeout(x.performance.display, 500);
                },
                display: function display() {
                  var t = C.name + ":",
                      n = 0;
                  c = !1, clearTimeout(x.performance.timer), e.each(u, function (e, t) {
                    n += t["Execution Time"];
                  }), t += " " + n + "ms", s && (t += " '" + s + "'"), (void 0 !== console.group || void 0 !== console.table) && u.length > 0 && (console.groupCollapsed(t), console.table ? console.table(u) : e.each(u, function (e, t) {
                    console.log(t.Name + ": " + t["Execution Time"] + "ms");
                  }), console.groupEnd()), u = [];
                }
              },
              invoke: function invoke(t, n, i) {
                var o,
                    a,
                    s,
                    l = Q;
                return n = n || h, i = K || i, "string" == typeof t && void 0 !== l && (t = t.split(/[\. ]/), o = t.length - 1, e.each(t, function (n, i) {
                  var r = n != o ? i + t[n + 1].charAt(0).toUpperCase() + t[n + 1].slice(1) : t;
                  if (e.isPlainObject(l[r]) && n != o) l = l[r];else {
                    if (void 0 !== l[r]) return a = l[r], !1;
                    if (!e.isPlainObject(l[i]) || n == o) return void 0 !== l[i] ? (a = l[i], !1) : (x.error(M.method, t), !1);
                    l = l[i];
                  }
                })), e.isFunction(a) ? s = a.apply(i, n) : void 0 !== a && (s = a), e.isArray(r) ? r.push(s) : void 0 !== r ? r = [r, s] : void 0 !== s && (r = s), a;
              }
            }, p ? (void 0 === Q && x.initialize(), x.invoke(d)) : (void 0 !== Q && Q.invoke("destroy"), x.initialize());
          }), void 0 !== r ? r : o;
        }, e.fn.dropdown.settings = {
          silent: !1,
          debug: !1,
          verbose: !1,
          performance: !0,
          on: "click",
          action: "activate",
          values: !1,
          apiSettings: !1,
          selectOnKeydown: !0,
          minCharacters: 0,
          filterRemoteData: !1,
          saveRemoteData: !0,
          throttle: 200,
          context: t,
          direction: "auto",
          keepOnScreen: !0,
          match: "both",
          fullTextSearch: !1,
          placeholder: "auto",
          preserveHTML: !0,
          sortSelect: !1,
          forceSelection: !0,
          allowAdditions: !1,
          hideAdditions: !0,
          maxSelections: !1,
          useLabels: !0,
          delimiter: ",",
          showOnFocus: !0,
          allowReselection: !1,
          allowTab: !0,
          allowCategorySelection: !1,
          fireOnInit: !1,
          transition: "auto",
          duration: 200,
          glyphWidth: 1.037,
          label: {
            transition: "scale",
            duration: 200,
            variation: !1
          },
          delay: {
            hide: 300,
            show: 200,
            search: 20,
            touch: 50
          },
          onChange: function onChange(e, t, n) {},
          onAdd: function onAdd(e, t, n) {},
          onRemove: function onRemove(e, t, n) {},
          onLabelSelect: function onLabelSelect(e) {},
          onLabelCreate: function onLabelCreate(t, n) {
            return e(this);
          },
          onLabelRemove: function onLabelRemove(e) {
            return !0;
          },
          onNoResults: function onNoResults(e) {
            return !0;
          },
          onShow: function onShow() {},
          onHide: function onHide() {},
          name: "Dropdown",
          namespace: "dropdown",
          message: {
            addResult: "Add <b>{term}</b>",
            count: "{count} selected",
            maxSelections: "Max {maxCount} selections",
            noResults: "No results found.",
            serverError: "There was an error contacting the server"
          },
          error: {
            action: "You called a dropdown action that was not defined",
            alreadySetup: "Once a select has been initialized behaviors must be called on the created ui dropdown",
            labels: "Allowing user additions currently requires the use of labels.",
            missingMultiple: "<select> requires multiple property to be set to correctly preserve multiple values",
            method: "The method you called is not defined.",
            noAPI: "The API module is required to load resources remotely",
            noStorage: "Saving remote data requires session storage",
            noTransition: "This module requires ui transitions <https://github.com/Semantic-Org/UI-Transition>"
          },
          regExp: {
            escape: /[-[\]{}()*+?.,\\^$|#\s]/g,
            quote: /"/g
          },
          metadata: {
            defaultText: "defaultText",
            defaultValue: "defaultValue",
            placeholderText: "placeholder",
            text: "text",
            value: "value"
          },
          fields: {
            remoteValues: "results",
            values: "values",
            disabled: "disabled",
            name: "name",
            value: "value",
            text: "text"
          },
          keys: {
            backspace: 8,
            delimiter: 188,
            deleteKey: 46,
            enter: 13,
            escape: 27,
            pageUp: 33,
            pageDown: 34,
            leftArrow: 37,
            upArrow: 38,
            rightArrow: 39,
            downArrow: 40
          },
          selector: {
            addition: ".addition",
            dropdown: ".apparatus.ui.dropdown",
            hidden: ".hidden",
            icon: "> .dropdown.icon",
            input: '> input[type="hidden"], > select',
            item: ".item",
            label: "> .label",
            remove: "> .label > .delete.icon",
            siblingLabel: ".label",
            menu: ".menu",
            message: ".message",
            menuIcon: ".dropdown.icon",
            search: "input.search, .menu > .search > input, .menu input.search",
            sizer: "> input.sizer",
            text: "> .text:not(.icon)",
            unselectable: ".disabled, .filtered"
          },
          className: {
            active: "active",
            addition: "addition",
            animating: "animating",
            disabled: "disabled",
            empty: "empty",
            dropdown: "ui dropdown",
            filtered: "filtered",
            hidden: "hidden transition",
            item: "item",
            label: "ui label",
            loading: "loading",
            menu: "menu",
            message: "message",
            multiple: "multiple",
            placeholder: "default",
            sizer: "sizer",
            search: "search",
            selected: "selected",
            selection: "selection",
            upward: "upward",
            leftward: "left",
            visible: "visible"
          }
        }, e.fn.dropdown.settings.templates = {
          dropdown: function dropdown(t) {
            var n = t.placeholder || !1,
                i = (t.values, "");
            return i += '<i class="dropdown icon"></i>', t.placeholder ? i += '<div class="default text">' + n + "</div>" : i += '<div class="text"></div>', i += '<div class="menu">', e.each(t.values, function (e, t) {
              i += t.disabled ? '<div class="disabled item" data-value="' + t.value + '">' + t.name + "</div>" : '<div class="item" data-value="' + t.value + '">' + t.name + "</div>";
            }), i += "</div>";
          },
          menu: function menu(t, n) {
            var i = t[n.values] || {},
                r = "";
            return e.each(i, function (e, t) {
              var i = t[n.text] ? 'data-text="' + t[n.text] + '"' : "",
                  o = t[n.disabled] ? "disabled " : "";
              r += '<div class="' + o + 'item" data-value="' + t[n.value] + '"' + i + ">", r += t[n.name], r += "</div>";
            }), r;
          },
          label: function label(e, t) {
            return t + '<i class="delete icon"></i>';
          },
          message: function message(e) {
            return e;
          },
          addition: function addition(e) {
            return e;
          }
        };
      }(e, window, document);
    }).call(this, n(0));
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return l;
    });
    var i = n(1);

    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var l = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, l, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, i["b"]), n = t, (l = [{
        key: "connect",
        value: function value() {}
      }, {
        key: "setWidthMax",
        value: function value() {
          this.widthTarget.value > this.columnsTarget.value && (this.widthTarget.value = this.columnsTarget.value), this.widthTarget.setAttribute("max", this.columnsTarget.value);
        }
      }, {
        key: "setWidth",
        value: function value(e) {
          var t = e.currentTarget.dataset.width;
          this.widthTarget.value = t, this.previewTarget.dataset.width = t;
        }
      }, {
        key: "updatePreview",
        value: function value() {
          this.previewTarget.dataset.width = this.widthTarget.value;
        }
      }]) && r(n.prototype, l), c && r(n, c), t;
    }();

    var c, u, d;
    d = ["width", "max", "preview"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[u] = d;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return l;
    });
    var i = n(1);

    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var l = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, l, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, i["b"]), n = t, (l = [{
        key: "connect",
        value: function value() {
          this.updatePreview();
        }
      }, {
        key: "setWidthMax",
        value: function value() {
          parseInt(this.widthInputTarget.value) > parseInt(this.maxInputTarget.value) && (this.widthInputTarget.value = this.maxInputTarget.value), this.widthInputTarget.setAttribute("max", this.maxInputTarget.value);
        }
      }, {
        key: "updatePreview",
        value: function value() {
          this.previewWrapperTarget.dataset.columns = this.maxInputTarget.value, this.previewTarget.style.width = "".concat(this.calculatePreviewWidth(), "%");
        }
      }, {
        key: "calculatePreviewWidth",
        value: function value() {
          return this.widthInputTarget.value / this.maxInputTarget.value * 100;
        }
      }, {
        key: "calculateColumnWidth",
        value: function value() {
          return Math.floor(this.previewWrapperTarget.offsetWidth / this.maxInputTarget.value);
        }
      }]) && r(n.prototype, l), c && r(n, c), t;
    }();

    var c, u, d;
    d = ["widthInput", "maxInput", "previewWrapper", "preview"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[u] = d;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return c;
    });
    var i = n(2);

    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e, t, n) {
      return (a = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
        var i = function (e, t) {
          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = s(e));) {
            ;
          }

          return e;
        }(e, t);

        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, t);
          return r.get ? r.get.call(n) : r.value;
        }
      })(e, t, n || e);
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function l(e, t) {
      return (l = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var c = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o(this, s(t).apply(this, arguments));
      }

      var n, c, u;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && l(e, t);
      }(t, i["a"]), n = t, (c = [{
        key: "connect",
        value: function value() {
          this.config = {
            altInput: !0,
            enableTime: !1,
            showMonths: 1
          }, a(s(t.prototype), "connect", this).call(this);
        }
      }]) && r(n.prototype, c), u && r(n, u), t;
    }();
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return c;
    });
    var i = n(2);

    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e, t, n) {
      return (a = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
        var i = function (e, t) {
          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = s(e));) {
            ;
          }

          return e;
        }(e, t);

        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, t);
          return r.get ? r.get.call(n) : r.value;
        }
      })(e, t, n || e);
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function l(e, t) {
      return (l = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var c = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o(this, s(t).apply(this, arguments));
      }

      var n, c, u;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && l(e, t);
      }(t, i["a"]), n = t, (c = [{
        key: "connect",
        value: function value() {
          this.config = {
            altInput: !0,
            enableTime: !0,
            time_24hr: !0,
            showMonths: 1
          }, a(s(t.prototype), "connect", this).call(this);
        }
      }]) && r(n.prototype, c), u && r(n, u), t;
    }();
  }, function (e, t, n) {
    "use strict";

    n.r(t), function (e) {
      n.d(t, "default", function () {
        return l;
      });
      var i = n(1);

      function r(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
        }
      }

      function o(e, t) {
        return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }

      function a(e) {
        return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function s(e, t) {
        return (s = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      var l = function (t) {
        function n() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, n), o(this, a(n).apply(this, arguments));
        }

        var l, c, u;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && s(e, t);
        }(n, i["b"]), l = n, (c = [{
          key: "connect",
          value: function value() {
            console.log("Instantiated as Toggle"), this.element.classList.contains(this.data.get("disabled-class"));
          }
        }, {
          key: "setLoadingState",
          value: function value(t) {
            e(this.element).toggleClass(this.data.get("loading-class"), t);
          }
        }, {
          key: "toggleState",
          value: function value() {
            this.on ? this.setOff() : this.setOn();
          }
        }, {
          key: "setOn",
          value: function value() {
            e(this.element).removeClass(this.data.get("off-class")), e(this.element).addClass(this.data.get("on-class"));
          }
        }, {
          key: "setOff",
          value: function value() {
            e(this.element).removeClass(this.data.get("on-class")), e(this.element).addClass(this.data.get("off-class"));
          }
        }, {
          key: "on",
          get: function get() {
            return this.element.classList.contains(this.data.get("on-class"));
          }
        }, {
          key: "off",
          get: function get() {
            return this.element.classList.contains(this.data.get("off-class"));
          }
        }]) && r(l.prototype, c), u && r(l, u), n;
      }();
    }.call(this, n(0));
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    n(8), n(11), n(12), n(13), n(15), n(16), n(30), n(31), n(34), n(35);
    var i = n(1).a.start(),
        r = n(36);
    i.load(function (e) {
      return e.keys().map(function (t) {
        return function (e, t) {
          var n = function (e) {
            var t = (e.match(/^(?:\.\/)?(.+)(?:[_-]controller\..+?)$/) || [])[1];
            if (t) return t.replace(/_/g, "-").replace(/\//g, "--");
          }(t);

          if (n) return function (e, t) {
            var n = e["default"];
            if ("function" == typeof n) return {
              identifier: t,
              controllerConstructor: n
            };
          }(e(t), n);
        }(e, t);
      }).filter(function (e) {
        return e;
      });
    }(r));
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var i = n(1);
    /**!
     * Sortable 1.10.0-rc3
     * @author	RubaXa   <trash@rubaxa.org>
     * @author	owenm    <owen23355@gmail.com>
     * @license MIT
     */

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function o(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function a() {
      return (a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function s(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
            i = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), i.forEach(function (t) {
          o(e, t, n[t]);
        });
      }

      return e;
    }

    function l(e, t) {
      if (null == e) return {};

      var n,
          i,
          r = function (e, t) {
        if (null == e) return {};
        var n,
            i,
            r = {},
            o = Object.keys(e);

        for (i = 0; i < o.length; i++) {
          n = o[i], t.indexOf(n) >= 0 || (r[n] = e[n]);
        }

        return r;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (i = 0; i < o.length; i++) {
          n = o[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
        }
      }

      return r;
    }

    function c(e) {
      return !!navigator.userAgent.match(e);
    }

    var u = c(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i),
        d = c(/Edge/i),
        p = c(/firefox/i),
        h = c(/safari/i) && !c(/chrome/i) && !c(/android/i),
        f = c(/iP(ad|od|hone)/i),
        m = c(/chrome/i) && c(/android/i),
        g = {
      capture: !1,
      passive: !1
    };

    function v(e, t, n) {
      e.addEventListener(t, n, !u && g);
    }

    function b(e, t, n) {
      e.removeEventListener(t, n, !u && g);
    }

    function y(e, t) {
      if (t) {
        if (">" === t[0] && (t = t.substring(1)), e) try {
          if (e.matches) return e.matches(t);
          if (e.msMatchesSelector) return e.msMatchesSelector(t);
          if (e.webkitMatchesSelector) return e.webkitMatchesSelector(t);
        } catch (e) {
          return !1;
        }
        return !1;
      }
    }

    function _(e) {
      return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
    }

    function w(e, t, n, i) {
      if (e) {
        n = n || document;

        do {
          if (null != t && (">" === t[0] ? e.parentNode === n && y(e, t) : y(e, t)) || i && e === n) return e;
          if (e === n) break;
        } while (e = _(e));
      }

      return null;
    }

    var x,
        C = /\s+/g;

    function S(e, t, n) {
      if (e && t) if (e.classList) e.classList[n ? "add" : "remove"](t);else {
        var i = (" " + e.className + " ").replace(C, " ").replace(" " + t + " ", " ");
        e.className = (i + (n ? " " + t : "")).replace(C, " ");
      }
    }

    function D(e, t, n) {
      var i = e && e.style;

      if (i) {
        if (void 0 === n) return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), void 0 === t ? n : n[t];
        t in i || -1 !== t.indexOf("webkit") || (t = "-webkit-" + t), i[t] = n + ("string" == typeof n ? "" : "px");
      }
    }

    function E(e, t) {
      var n = "";

      do {
        var i = D(e, "transform");
        i && "none" !== i && (n = i + " " + n);
      } while (!t && (e = e.parentNode));

      var r = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix;
      return r && new r(n);
    }

    function k(e, t, n) {
      if (e) {
        var i = e.getElementsByTagName(t),
            r = 0,
            o = i.length;
        if (n) for (; r < o; r++) {
          n(i[r], r);
        }
        return i;
      }

      return [];
    }

    function T() {
      return u ? document.documentElement : document.scrollingElement;
    }

    function O(e, t, n, i, r) {
      if (e.getBoundingClientRect || e === window) {
        var o, a, s, l, c, d, p;
        if (e !== window && e !== T() ? (a = (o = e.getBoundingClientRect()).top, s = o.left, l = o.bottom, c = o.right, d = o.height, p = o.width) : (a = 0, s = 0, l = window.innerHeight, c = window.innerWidth, d = window.innerHeight, p = window.innerWidth), (t || n) && e !== window && (r = r || e.parentNode, !u)) do {
          if (r && r.getBoundingClientRect && ("none" !== D(r, "transform") || n && "static" !== D(r, "position"))) {
            var h = r.getBoundingClientRect();
            a -= h.top + parseInt(D(r, "border-top-width")), s -= h.left + parseInt(D(r, "border-left-width")), l = a + o.height, c = s + o.width;
            break;
          }
        } while (r = r.parentNode);

        if (i && e !== window) {
          var f = E(r || e),
              m = f && f.a,
              g = f && f.d;
          f && (l = (a /= g) + (d /= g), c = (s /= m) + (p /= m));
        }

        return {
          top: a,
          left: s,
          bottom: l,
          right: c,
          width: p,
          height: d
        };
      }
    }

    function P(e, t, n, i) {
      for (var r = F(e, !0), o = (t || O(e))[n]; r;) {
        var a = O(r)[i];
        if (!("top" === i || "left" === i ? o >= a : o <= a)) return r;
        if (r === T()) break;
        r = F(r, !1);
      }

      return !1;
    }

    function A(e, t, n) {
      for (var i = 0, r = 0, o = e.children; r < o.length;) {
        if ("none" !== o[r].style.display && o[r] !== Ne.ghost && o[r] !== Ne.dragged && w(o[r], n.draggable, e, !1)) {
          if (i === t) return o[r];
          i++;
        }

        r++;
      }

      return null;
    }

    function M(e, t) {
      for (var n = e.lastElementChild; n && (n === Ne.ghost || "none" === D(n, "display") || t && !y(n, t));) {
        n = n.previousElementSibling;
      }

      return n || null;
    }

    function N(e, t) {
      var n = 0;
      if (!e || !e.parentNode) return -1;

      for (; e = e.previousElementSibling;) {
        "TEMPLATE" === e.nodeName.toUpperCase() || e === Ne.clone || t && !y(e, t) || n++;
      }

      return n;
    }

    function I(e) {
      var t = 0,
          n = 0,
          i = T();
      if (e) do {
        var r = E(e),
            o = r.a,
            a = r.d;
        t += e.scrollLeft * o, n += e.scrollTop * a;
      } while (e !== i && (e = e.parentNode));
      return [t, n];
    }

    function F(e, t) {
      if (!e || !e.getBoundingClientRect) return T();
      var n = e,
          i = !1;

      do {
        if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
          var r = D(n);

          if (n.clientWidth < n.scrollWidth && ("auto" == r.overflowX || "scroll" == r.overflowX) || n.clientHeight < n.scrollHeight && ("auto" == r.overflowY || "scroll" == r.overflowY)) {
            if (!n.getBoundingClientRect || n === document.body) return T();
            if (i || t) return n;
            i = !0;
          }
        }
      } while (n = n.parentNode);

      return T();
    }

    function j(e, t) {
      return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
    }

    function L(e, t) {
      return function () {
        if (!x) {
          var n = arguments,
              i = this;
          1 === n.length ? e.call(i, n[0]) : e.apply(i, n), x = setTimeout(function () {
            x = void 0;
          }, t);
        }
      };
    }

    function R(e, t, n) {
      e.scrollLeft += t, e.scrollTop += n;
    }

    function H(e) {
      var t = window.Polymer,
          n = window.jQuery || window.Zepto;
      return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
    }

    var B = "Sortable" + new Date().getTime();

    function q() {
      var e,
          t = [];
      return {
        captureAnimationState: function captureAnimationState() {
          (t = [], this.options.animation) && [].slice.call(this.el.children).forEach(function (e) {
            if ("none" !== D(e, "display") && e !== Ne.ghost) {
              t.push({
                target: e,
                rect: O(e)
              });
              var n = O(e);

              if (e.thisAnimationDuration) {
                var i = E(e, !0);
                i && (n.top -= i.f, n.left -= i.e);
              }

              e.fromRect = n;
            }
          });
        },
        addAnimationState: function addAnimationState(e) {
          t.push(e);
        },
        removeAnimationState: function removeAnimationState(e) {
          t.splice(function (e, t) {
            for (var n in e) {
              if (e.hasOwnProperty(n)) for (var i in t) {
                if (t.hasOwnProperty(i) && t[i] === e[n][i]) return Number(n);
              }
            }

            return -1;
          }(t, {
            target: e
          }), 1);
        },
        animateAll: function animateAll(n) {
          var i = this;
          if (!this.options.animation) return clearTimeout(e), void ("function" == typeof n && n());
          var r = !1,
              o = 0;
          t.forEach(function (e) {
            var t = 0,
                n = e.target,
                a = n.fromRect,
                s = O(n),
                l = n.prevFromRect,
                c = n.prevToRect,
                u = e.rect,
                d = E(n, !0);
            d && (s.top -= d.f, s.left -= d.e), n.toRect = s, (P(n, s, "bottom", "top") || P(n, s, "top", "bottom") || P(n, s, "right", "left") || P(n, s, "left", "right")) && (P(n, u, "bottom", "top") || P(n, u, "top", "bottom") || P(n, u, "right", "left") || P(n, u, "left", "right")) && (P(n, a, "bottom", "top") || P(n, a, "top", "bottom") || P(n, a, "right", "left") || P(n, a, "left", "right")) || (n.thisAnimationDuration && j(l, s) && !j(a, s) && (u.top - s.top) / (u.left - s.left) == (a.top - s.top) / (a.left - s.left) && (t = function (e, t, n, i) {
              return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * i.animation;
            }(u, l, c, i.options)), j(s, a) || (n.prevFromRect = a, n.prevToRect = s, t || (t = i.options.animation), i.animate(n, u, t)), t && (r = !0, o = Math.max(o, t), clearTimeout(n.animationResetTimer), n.animationResetTimer = setTimeout(function () {
              n.animationTime = 0, n.prevFromRect = null, n.fromRect = null, n.prevToRect = null, n.thisAnimationDuration = null;
            }, t), n.thisAnimationDuration = t));
          }), clearTimeout(e), r ? e = setTimeout(function () {
            "function" == typeof n && n();
          }, o) : "function" == typeof n && n(), t = [];
        },
        animate: function animate(e, t, n) {
          if (n) {
            D(e, "transition", ""), D(e, "transform", "");
            var i = O(e),
                r = E(this.el),
                o = r && r.a,
                a = r && r.d,
                s = (t.left - i.left) / (o || 1),
                l = (t.top - i.top) / (a || 1);
            e.animatingX = !!s, e.animatingY = !!l, D(e, "transform", "translate3d(" + s + "px," + l + "px,0)"), function (e) {
              e.offsetWidth;
            }(e), D(e, "transition", "transform " + n + "ms" + (this.options.easing ? " " + this.options.easing : "")), D(e, "transform", "translate3d(0,0,0)"), "number" == typeof e.animated && clearTimeout(e.animated), e.animated = setTimeout(function () {
              D(e, "transition", ""), D(e, "transform", ""), e.animated = !1, e.animatingX = !1, e.animatingY = !1;
            }, n);
          }
        }
      };
    }

    var $ = [],
        W = {
      initializeByDefault: !0
    },
        U = {
      mount: function mount(e) {
        for (var t in W) {
          !W.hasOwnProperty(t) || t in e || (e[t] = W[t]);
        }

        $.push(e);
      },
      pluginEvent: function pluginEvent(e, t, n) {
        var i = this;
        this.eventCanceled = !1;
        var r = e + "Global";
        $.forEach(function (o) {
          t[o.pluginName] && (t[o.pluginName][r] && (i.eventCanceled = !!t[o.pluginName][r](s({
            sortable: t
          }, n))), t.options[o.pluginName] && t[o.pluginName][e] && (i.eventCanceled = i.eventCanceled || !!t[o.pluginName][e](s({
            sortable: t
          }, n))));
        });
      },
      initializePlugins: function initializePlugins(e, t, n) {
        for (var i in $.forEach(function (i) {
          var r = i.pluginName;

          if (e.options[r] || i.initializeByDefault) {
            var o = new i(e, t);
            o.sortable = e, e[r] = o, a(n, o.options);
          }
        }), e.options) {
          if (e.options.hasOwnProperty(i)) {
            var r = this.modifyOption(e, i, e.options[i]);
            void 0 !== r && (e.options[i] = r);
          }
        }
      },
      getEventOptions: function getEventOptions(e, t) {
        var n = {};
        return $.forEach(function (i) {
          "function" == typeof i.eventOptions && a(n, i.eventOptions.call(t, e));
        }), n;
      },
      modifyOption: function modifyOption(e, t, n) {
        var i;
        return $.forEach(function (r) {
          e[r.pluginName] && r.optionListeners && "function" == typeof r.optionListeners[t] && (i = r.optionListeners[t].call(e[r.pluginName], n));
        }), i;
      }
    };

    function Y(e) {
      var t,
          n = e.sortable,
          i = e.rootEl,
          r = e.name,
          o = e.targetEl,
          a = e.cloneEl,
          l = e.toEl,
          c = e.fromEl,
          p = e.oldIndex,
          h = e.newIndex,
          f = e.oldDraggableIndex,
          m = e.newDraggableIndex,
          g = e.originalEvent,
          v = e.putSortable,
          b = e.eventOptions,
          y = (n = n || i[B]).options,
          _ = "on" + r.charAt(0).toUpperCase() + r.substr(1);

      !window.CustomEvent || u || d ? (t = document.createEvent("Event")).initEvent(r, !0, !0) : t = new CustomEvent(r, {
        bubbles: !0,
        cancelable: !0
      }), t.to = l || i, t.from = c || i, t.item = o || i, t.clone = a, t.oldIndex = p, t.newIndex = h, t.oldDraggableIndex = f, t.newDraggableIndex = m, t.originalEvent = g, t.pullMode = v ? v.lastPutMode : void 0;
      var w = s({}, b, U.getEventOptions(r, n));

      for (var x in w) {
        t[x] = w[x];
      }

      i && i.dispatchEvent(t), y[_] && y[_].call(n, t);
    }

    var X = function X(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = n.evt,
          r = l(n, ["evt"]);
      U.pluginEvent.bind(Ne)(e, t, s({
        dragEl: V,
        parentEl: K,
        ghostEl: Q,
        rootEl: Z,
        nextEl: G,
        lastDownEl: J,
        cloneEl: ee,
        cloneHidden: te,
        dragStarted: ue,
        putSortable: se,
        activeSortable: Ne.active,
        originalEvent: i,
        oldIndex: ne,
        oldDraggableIndex: re,
        newIndex: ie,
        newDraggableIndex: oe,
        hideGhostForTarget: Oe,
        unhideGhostForTarget: Pe,
        cloneNowHidden: function cloneNowHidden() {
          te = !0;
        },
        cloneNowShown: function cloneNowShown() {
          te = !1;
        },
        dispatchSortableEvent: function dispatchSortableEvent(e) {
          z({
            sortable: t,
            name: e,
            originalEvent: i
          });
        }
      }, r));
    };

    function z(e) {
      Y(s({
        putSortable: se,
        cloneEl: ee,
        targetEl: V,
        rootEl: Z,
        oldIndex: ne,
        oldDraggableIndex: re,
        newIndex: ie,
        newDraggableIndex: oe
      }, e));
    }

    if ("undefined" == typeof window || !window.document) throw new Error("Sortable.js requires a window with a document");

    var V,
        K,
        Q,
        Z,
        G,
        J,
        ee,
        te,
        ne,
        ie,
        re,
        oe,
        ae,
        se,
        le,
        ce,
        ue,
        de,
        pe,
        he,
        fe,
        me = !1,
        ge = !1,
        ve = [],
        be = !1,
        ye = !1,
        _e = [],
        we = !1,
        xe = [],
        Ce = f,
        Se = d || u ? "cssFloat" : "float",
        De = !m && !f && "draggable" in document.createElement("div"),
        Ee = function () {
      if (u) return !1;
      var e = document.createElement("x");
      return e.style.cssText = "pointer-events:auto", "auto" === e.style.pointerEvents;
    }(),
        ke = function ke(e, t) {
      var n = D(e),
          i = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth),
          r = A(e, 0, t),
          o = A(e, 1, t),
          a = r && D(r),
          s = o && D(o),
          l = a && parseInt(a.marginLeft) + parseInt(a.marginRight) + O(r).width,
          c = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + O(o).width;
      if ("flex" === n.display) return "column" === n.flexDirection || "column-reverse" === n.flexDirection ? "vertical" : "horizontal";
      if ("grid" === n.display) return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";

      if (r && "none" !== a["float"]) {
        var u = "left" === a["float"] ? "left" : "right";
        return !o || "both" !== s.clear && s.clear !== u ? "horizontal" : "vertical";
      }

      return r && ("block" === a.display || "flex" === a.display || "table" === a.display || "grid" === a.display || l >= i && "none" === n[Se] || o && "none" === n[Se] && l + c > i) ? "vertical" : "horizontal";
    },
        Te = function Te(e) {
      function t(e, n) {
        return function (i, r, o, a) {
          var s = i.options.group.name && r.options.group.name && i.options.group.name === r.options.group.name;
          if (null == e && (n || s)) return !0;
          if (null == e || !1 === e) return !1;
          if (n && "clone" === e) return e;
          if ("function" == typeof e) return t(e(i, r, o, a), n)(i, r, o, a);
          var l = (n ? i : r).options.group.name;
          return !0 === e || "string" == typeof e && e === l || e.join && e.indexOf(l) > -1;
        };
      }

      var n = {},
          i = e.group;
      i && "object" == r(i) || (i = {
        name: i
      }), n.name = i.name, n.checkPull = t(i.pull, !0), n.checkPut = t(i.put), n.revertClone = i.revertClone, e.group = n;
    },
        Oe = function Oe() {
      !Ee && Q && D(Q, "display", "none");
    },
        Pe = function Pe() {
      !Ee && Q && D(Q, "display", "");
    };

    document.addEventListener("click", function (e) {
      if (ge) return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), ge = !1, !1;
    }, !0);

    var Ae = function Ae(e) {
      if (V) {
        e = e.touches ? e.touches[0] : e;
        var t = (r = e.clientX, o = e.clientY, ve.some(function (e) {
          if (!M(e)) {
            var t = O(e),
                n = e[B].options.emptyInsertThreshold,
                i = r >= t.left - n && r <= t.right + n,
                s = o >= t.top - n && o <= t.bottom + n;
            return n && i && s ? a = e : void 0;
          }
        }), a);

        if (t) {
          var n = {};

          for (var i in e) {
            e.hasOwnProperty(i) && (n[i] = e[i]);
          }

          n.target = n.rootEl = t, n.preventDefault = void 0, n.stopPropagation = void 0, t[B]._onDragOver(n);
        }
      }

      var r, o, a;
    },
        Me = function Me(e) {
      V && V.parentNode[B]._isOutsideThisEl(e.target);
    };

    function Ne(e, t) {
      if (!e || !e.nodeType || 1 !== e.nodeType) throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
      this.el = e, this.options = t = a({}, t), e[B] = this;
      var n = {
        group: null,
        sort: !0,
        disabled: !1,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        invertSwap: !1,
        invertedSwapThreshold: null,
        removeCloneOnHide: !0,
        direction: function direction() {
          return ke(e, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: !0,
        animation: 0,
        easing: null,
        setData: function setData(e, t) {
          e.setData("Text", t.textContent);
        },
        dropBubble: !1,
        dragoverBubble: !1,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: !1,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: !1,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: !1,
        fallbackTolerance: 0,
        fallbackOffset: {
          x: 0,
          y: 0
        },
        supportPointer: !1 !== Ne.supportPointer && "PointerEvent" in window,
        emptyInsertThreshold: 5
      };

      for (var i in U.initializePlugins(this, e, n), n) {
        !(i in t) && (t[i] = n[i]);
      }

      for (var r in Te(t), this) {
        "_" === r.charAt(0) && "function" == typeof this[r] && (this[r] = this[r].bind(this));
      }

      this.nativeDraggable = !t.forceFallback && De, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? v(e, "pointerdown", this._onTapStart) : (v(e, "mousedown", this._onTapStart), v(e, "touchstart", this._onTapStart)), this.nativeDraggable && (v(e, "dragover", this), v(e, "dragenter", this)), ve.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), a(this, q());
    }

    function Ie(e, t, n, i, r, o, a, s) {
      var l,
          c,
          p = e[B],
          h = p.options.onMove;
      return !window.CustomEvent || u || d ? (l = document.createEvent("Event")).initEvent("move", !0, !0) : l = new CustomEvent("move", {
        bubbles: !0,
        cancelable: !0
      }), l.to = t, l.from = e, l.dragged = n, l.draggedRect = i, l.related = r || t, l.relatedRect = o || O(t), l.willInsertAfter = s, l.originalEvent = a, e.dispatchEvent(l), h && (c = h.call(p, l, a)), c;
    }

    function Fe(e) {
      e.draggable = !1;
    }

    function je() {
      we = !1;
    }

    function Le(e) {
      for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, i = 0; n--;) {
        i += t.charCodeAt(n);
      }

      return i.toString(36);
    }

    function Re(e) {
      return setTimeout(e, 0);
    }

    function He(e) {
      return clearTimeout(e);
    }

    Ne.prototype = {
      constructor: Ne,
      _isOutsideThisEl: function _isOutsideThisEl(e) {
        this.el.contains(e) || e === this.el || (de = null);
      },
      _getDirection: function _getDirection(e, t) {
        return "function" == typeof this.options.direction ? this.options.direction.call(this, e, t, V) : this.options.direction;
      },
      _onTapStart: function _onTapStart(e) {
        if (e.cancelable) {
          var t = this,
              n = this.el,
              i = this.options,
              r = i.preventOnFilter,
              o = e.type,
              a = e.touches && e.touches[0],
              s = (a || e).target,
              l = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || s,
              c = i.filter;

          if (function (e) {
            xe.length = 0;
            var t = e.getElementsByTagName("input"),
                n = t.length;

            for (; n--;) {
              var i = t[n];
              i.checked && xe.push(i);
            }
          }(n), !V && !(/mousedown|pointerdown/.test(o) && 0 !== e.button || i.disabled || l.isContentEditable || (s = w(s, i.draggable, n, !1)) && s.animated || J === s)) {
            if (ne = N(s), re = N(s, i.draggable), "function" == typeof c) {
              if (c.call(this, e, s, this)) return z({
                sortable: t,
                rootEl: l,
                name: "filter",
                targetEl: s,
                toEl: n,
                fromEl: n
              }), X("filter", t, {
                evt: e
              }), void (r && e.cancelable && e.preventDefault());
            } else if (c && (c = c.split(",").some(function (i) {
              if (i = w(l, i.trim(), n, !1)) return z({
                sortable: t,
                rootEl: i,
                name: "filter",
                targetEl: s,
                fromEl: n,
                toEl: n
              }), X("filter", t, {
                evt: e
              }), !0;
            }))) return void (r && e.cancelable && e.preventDefault());

            i.handle && !w(l, i.handle, n, !1) || this._prepareDragStart(e, a, s);
          }
        }
      },
      _prepareDragStart: function _prepareDragStart(e, t, n) {
        var i,
            r = this,
            o = r.el,
            a = r.options,
            s = o.ownerDocument;
        if (n && !V && n.parentNode === o) if (Z = o, K = (V = n).parentNode, G = V.nextSibling, J = n, ae = a.group, Ne.dragged = V, le = {
          target: V,
          clientX: (t || e).clientX,
          clientY: (t || e).clientY
        }, this._lastX = (t || e).clientX, this._lastY = (t || e).clientY, V.style["will-change"] = "all", i = function i() {
          X("delayEnded", r, {
            evt: e
          }), Ne.eventCanceled ? r._onDrop() : (r._disableDelayedDragEvents(), !p && r.nativeDraggable && (V.draggable = !0), r._triggerDragStart(e, t), z({
            sortable: r,
            name: "choose",
            originalEvent: e
          }), S(V, a.chosenClass, !0));
        }, a.ignore.split(",").forEach(function (e) {
          k(V, e.trim(), Fe);
        }), v(s, "dragover", Ae), v(s, "mousemove", Ae), v(s, "touchmove", Ae), v(s, "mouseup", r._onDrop), v(s, "touchend", r._onDrop), v(s, "touchcancel", r._onDrop), p && this.nativeDraggable && (this.options.touchStartThreshold = 4, V.draggable = !0), X("delayStart", this, {
          evt: e
        }), !a.delay || a.delayOnTouchOnly && !t || this.nativeDraggable && (d || u)) i();else {
          if (Ne.eventCanceled) return void this._onDrop();
          v(s, "mouseup", r._disableDelayedDrag), v(s, "touchend", r._disableDelayedDrag), v(s, "touchcancel", r._disableDelayedDrag), v(s, "mousemove", r._delayedDragTouchMoveHandler), v(s, "touchmove", r._delayedDragTouchMoveHandler), a.supportPointer && v(s, "pointermove", r._delayedDragTouchMoveHandler), r._dragStartTimer = setTimeout(i, a.delay);
        }
      },
      _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
        var t = e.touches ? e.touches[0] : e;
        Math.max(Math.abs(t.clientX - this._lastX), Math.abs(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
      },
      _disableDelayedDrag: function _disableDelayedDrag() {
        V && Fe(V), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
      },
      _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var e = this.el.ownerDocument;
        b(e, "mouseup", this._disableDelayedDrag), b(e, "touchend", this._disableDelayedDrag), b(e, "touchcancel", this._disableDelayedDrag), b(e, "mousemove", this._delayedDragTouchMoveHandler), b(e, "touchmove", this._delayedDragTouchMoveHandler), b(e, "pointermove", this._delayedDragTouchMoveHandler);
      },
      _triggerDragStart: function _triggerDragStart(e, t) {
        t = t || "touch" == e.pointerType && e, !this.nativeDraggable || t ? this.options.supportPointer ? v(document, "pointermove", this._onTouchMove) : v(document, t ? "touchmove" : "mousemove", this._onTouchMove) : (v(V, "dragend", this), v(Z, "dragstart", this._onDragStart));

        try {
          document.selection ? Re(function () {
            document.selection.empty();
          }) : window.getSelection().removeAllRanges();
        } catch (e) {}
      },
      _dragStarted: function _dragStarted(e, t) {
        if (me = !1, Z && V) {
          X("dragStarted", this, {
            evt: t
          }), this.nativeDraggable && v(document, "dragover", Me);
          var n = this.options;
          !e && S(V, n.dragClass, !1), S(V, n.ghostClass, !0), Ne.active = this, e && this._appendGhost(), z({
            sortable: this,
            name: "start",
            originalEvent: t
          });
        } else this._nulling();
      },
      _emulateDragOver: function _emulateDragOver() {
        if (ce) {
          this._lastX = ce.clientX, this._lastY = ce.clientY, Oe();

          for (var e = document.elementFromPoint(ce.clientX, ce.clientY), t = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(ce.clientX, ce.clientY)) !== t;) {
            t = e;
          }

          if (V.parentNode[B]._isOutsideThisEl(e), t) do {
            if (t[B]) {
              if (t[B]._onDragOver({
                clientX: ce.clientX,
                clientY: ce.clientY,
                target: e,
                rootEl: t
              }) && !this.options.dragoverBubble) break;
            }

            e = t;
          } while (t = t.parentNode);
          Pe();
        }
      },
      _onTouchMove: function _onTouchMove(e) {
        if (le) {
          var t = this.options,
              n = t.fallbackTolerance,
              i = t.fallbackOffset,
              r = e.touches ? e.touches[0] : e,
              o = Q && E(Q),
              a = Q && o && o.a,
              s = Q && o && o.d,
              l = Ce && fe && I(fe),
              c = (r.clientX - le.clientX + i.x) / (a || 1) + (l ? l[0] - _e[0] : 0) / (a || 1),
              u = (r.clientY - le.clientY + i.y) / (s || 1) + (l ? l[1] - _e[1] : 0) / (s || 1),
              d = e.touches ? "translate3d(" + c + "px," + u + "px,0)" : "translate(" + c + "px," + u + "px)";

          if (!Ne.active && !me) {
            if (n && Math.max(Math.abs(r.clientX - this._lastX), Math.abs(r.clientY - this._lastY)) < n) return;

            this._onDragStart(e, !0);
          }

          ce = r, D(Q, "webkitTransform", d), D(Q, "mozTransform", d), D(Q, "msTransform", d), D(Q, "transform", d), e.cancelable && e.preventDefault();
        }
      },
      _appendGhost: function _appendGhost() {
        if (!Q) {
          var e = this.options.fallbackOnBody ? document.body : Z,
              t = O(V, !0, Ce, !0, e),
              n = this.options;

          if (Ce) {
            for (fe = e; "static" === D(fe, "position") && "none" === D(fe, "transform") && fe !== document;) {
              fe = fe.parentNode;
            }

            fe !== document.body && fe !== document.documentElement ? (fe === document && (fe = T()), t.top += fe.scrollTop, t.left += fe.scrollLeft) : fe = T(), _e = I(fe);
          }

          S(Q = V.cloneNode(!0), n.ghostClass, !1), S(Q, n.fallbackClass, !0), S(Q, n.dragClass, !0), D(Q, "transition", ""), D(Q, "transform", ""), D(Q, "box-sizing", "border-box"), D(Q, "margin", 0), D(Q, "top", t.top), D(Q, "left", t.left), D(Q, "width", t.width), D(Q, "height", t.height), D(Q, "opacity", "0.8"), D(Q, "position", Ce ? "absolute" : "fixed"), D(Q, "zIndex", "100000"), D(Q, "pointerEvents", "none"), Ne.ghost = Q, e.appendChild(Q);
        }
      },
      _onDragStart: function _onDragStart(e, t) {
        var n = this,
            i = e.dataTransfer,
            r = n.options;
        X("dragStart", this, {
          evt: e
        }), Ne.eventCanceled ? this._onDrop() : (X("setupClone", this), Ne.eventCanceled || ((ee = H(V)).draggable = !1, ee.style["will-change"] = "", this._hideClone(), S(ee, this.options.chosenClass, !1), Ne.clone = ee), n.cloneId = Re(function () {
          X("clone", n), Ne.eventCanceled || (n.options.removeCloneOnHide || Z.insertBefore(ee, V), n._hideClone(), z({
            sortable: n,
            name: "clone"
          }));
        }), !t && S(V, r.dragClass, !0), t ? (ge = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (b(document, "mouseup", n._onDrop), b(document, "touchend", n._onDrop), b(document, "touchcancel", n._onDrop), i && (i.effectAllowed = "move", r.setData && r.setData.call(n, i, V)), v(document, "drop", n), D(V, "transform", "translateZ(0)")), me = !0, n._dragStartId = Re(n._dragStarted.bind(n, t, e)), v(document, "selectstart", n), ue = !0, h && D(document.body, "user-select", "none"));
      },
      _onDragOver: function _onDragOver(e) {
        var t,
            n,
            i,
            r,
            o = this.el,
            a = e.target,
            l = this.options,
            c = l.group,
            u = Ne.active,
            d = ae === c,
            p = l.sort,
            h = se || u,
            f = this,
            m = !1;

        if (!we) {
          if (void 0 !== e.preventDefault && e.cancelable && e.preventDefault(), a = w(a, l.draggable, o, !0), j("dragOver"), Ne.eventCanceled) return m;
          if (V.contains(e.target) || a.animated && a.animatingX && a.animatingY || f._ignoreWhileAnimating === a) return H(!1);

          if (ge = !1, u && !l.disabled && (d ? p || (i = !Z.contains(V)) : se === this || (this.lastPutMode = ae.checkPull(this, u, V, e)) && c.checkPut(this, u, V, e))) {
            if (r = "vertical" === this._getDirection(e, a), t = O(V), j("dragOverValid"), Ne.eventCanceled) return m;
            if (i) return K = Z, L(), this._hideClone(), j("revert"), Ne.eventCanceled || (G ? Z.insertBefore(V, G) : Z.appendChild(V)), H(!0);
            var g = M(o, l.draggable);

            if (!g || function (e, t, n) {
              var i = O(M(n.el, n.options.draggable));
              return t ? e.clientX > i.right + 10 || e.clientX <= i.right && e.clientY > i.bottom && e.clientX >= i.left : e.clientX > i.right && e.clientY > i.top || e.clientX <= i.right && e.clientY > i.bottom + 10;
            }(e, r, this) && !g.animated) {
              if (g === V) return H(!1);
              if (g && o === e.target && (a = g), a && (n = O(a)), !1 !== Ie(Z, o, V, t, a, n, e, !!a)) return L(), o.appendChild(V), K = o, q(), H(!0);
            } else if (a.parentNode === o) {
              n = O(a);

              var v,
                  b,
                  y,
                  _ = V.parentNode !== o,
                  x = !function (e, t, n) {
                var i = n ? e.left : e.top,
                    r = n ? e.right : e.bottom,
                    o = n ? e.width : e.height,
                    a = n ? t.left : t.top,
                    s = n ? t.right : t.bottom,
                    l = n ? t.width : t.height;
                return i === a || r === s || i + o / 2 === a + l / 2;
              }(V.animated && V.toRect || t, a.animated && a.toRect || n, r),
                  C = r ? "top" : "left",
                  E = P(a, null, "top", "top") || P(V, null, "top", "top"),
                  k = E ? E.scrollTop : void 0;

              if (de !== a && (b = n[C], be = !1, ye = !x && l.invertSwap || _), 0 !== (v = function (e, t, n, i, r, o, a, s) {
                var l = i ? e.clientY : e.clientX,
                    c = i ? n.height : n.width,
                    u = i ? n.top : n.left,
                    d = i ? n.bottom : n.right,
                    p = !1;
                if (!a) if (s && he < c * r) {
                  if (!be && (1 === pe ? l > u + c * o / 2 : l < d - c * o / 2) && (be = !0), be) p = !0;else if (1 === pe ? l < u + he : l > d - he) return -pe;
                } else if (l > u + c * (1 - r) / 2 && l < d - c * (1 - r) / 2) return function (e) {
                  return N(V) < N(e) ? 1 : -1;
                }(t);
                if ((p = p || a) && (l < u + c * o / 2 || l > d - c * o / 2)) return l > u + c / 2 ? 1 : -1;
                return 0;
              }(e, a, n, r, x ? 1 : l.swapThreshold, null == l.invertedSwapThreshold ? l.swapThreshold : l.invertedSwapThreshold, ye, de === a))) {
                var T = N(V);

                do {
                  T -= v, y = K.children[T];
                } while (y && ("none" === D(y, "display") || y === Q));
              }

              if (0 === v || y === a) return H(!1);
              de = a, pe = v;
              var A = a.nextElementSibling,
                  I = !1,
                  F = Ie(Z, o, V, t, a, n, e, I = 1 === v);
              if (!1 !== F) return 1 !== F && -1 !== F || (I = 1 === F), we = !0, setTimeout(je, 30), L(), I && !A ? o.appendChild(V) : a.parentNode.insertBefore(V, I ? A : a), E && R(E, 0, k - E.scrollTop), K = V.parentNode, void 0 === b || ye || (he = Math.abs(b - O(a)[C])), q(), H(!0);
            }

            if (o.contains(V)) return H(!1);
          }

          return !1;
        }

        function j(l, c) {
          X(l, f, s({
            evt: e,
            isOwner: d,
            axis: r ? "vertical" : "horizontal",
            revert: i,
            dragRect: t,
            targetRect: n,
            canSort: p,
            fromSortable: h,
            target: a,
            completed: H,
            onMove: function onMove(n, i) {
              return Ie(Z, o, V, t, n, O(n), e, i);
            },
            changed: q
          }, c));
        }

        function L() {
          j("dragOverAnimationCapture"), f.captureAnimationState(), f !== h && h.captureAnimationState();
        }

        function H(t) {
          return j("dragOverCompleted", {
            insertion: t
          }), t && (d ? u._hideClone() : u._showClone(f), f !== h && (S(V, se ? se.options.ghostClass : u.options.ghostClass, !1), S(V, l.ghostClass, !0)), se !== f && f !== Ne.active ? se = f : f === Ne.active && se && (se = null), h === f && (f._ignoreWhileAnimating = a), f.animateAll(function () {
            j("dragOverAnimationComplete"), f._ignoreWhileAnimating = null;
          }), f !== h && (h.animateAll(), h._ignoreWhileAnimating = null)), (a === V && !V.animated || a === o && !a.animated) && (de = null), l.dragoverBubble || e.rootEl || a === document || (V.parentNode[B]._isOutsideThisEl(e.target), !t && Ae(e)), !l.dragoverBubble && e.stopPropagation && e.stopPropagation(), m = !0;
        }

        function q() {
          ie = N(V), oe = N(V, l.draggable), z({
            sortable: f,
            name: "change",
            toEl: o,
            newIndex: ie,
            newDraggableIndex: oe,
            originalEvent: e
          });
        }
      },
      _ignoreWhileAnimating: null,
      _offMoveEvents: function _offMoveEvents() {
        b(document, "mousemove", this._onTouchMove), b(document, "touchmove", this._onTouchMove), b(document, "pointermove", this._onTouchMove), b(document, "dragover", Ae), b(document, "mousemove", Ae), b(document, "touchmove", Ae);
      },
      _offUpEvents: function _offUpEvents() {
        var e = this.el.ownerDocument;
        b(e, "mouseup", this._onDrop), b(e, "touchend", this._onDrop), b(e, "pointerup", this._onDrop), b(e, "touchcancel", this._onDrop), b(document, "selectstart", this);
      },
      _onDrop: function _onDrop(e) {
        var t = this.el,
            n = this.options;
        ie = N(V), oe = N(V, n.draggable), X("drop", this, {
          evt: e
        }), ie = N(V), oe = N(V, n.draggable), Ne.eventCanceled ? this._nulling() : (me = !1, ye = !1, be = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), He(this.cloneId), He(this._dragStartId), this.nativeDraggable && (b(document, "drop", this), b(t, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), h && D(document.body, "user-select", ""), e && (ue && (e.cancelable && e.preventDefault(), !n.dropBubble && e.stopPropagation()), Q && Q.parentNode && Q.parentNode.removeChild(Q), (Z === K || se && "clone" !== se.lastPutMode) && ee && ee.parentNode && ee.parentNode.removeChild(ee), V && (this.nativeDraggable && b(V, "dragend", this), Fe(V), V.style["will-change"] = "", ue && !me && S(V, se ? se.options.ghostClass : this.options.ghostClass, !1), S(V, this.options.chosenClass, !1), z({
          sortable: this,
          name: "unchoose",
          toEl: K,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: e
        }), Z !== K ? (ie >= 0 && (z({
          rootEl: K,
          name: "add",
          toEl: K,
          fromEl: Z,
          originalEvent: e
        }), z({
          sortable: this,
          name: "remove",
          toEl: K,
          originalEvent: e
        }), z({
          rootEl: K,
          name: "sort",
          toEl: K,
          fromEl: Z,
          originalEvent: e
        }), z({
          sortable: this,
          name: "sort",
          toEl: K,
          originalEvent: e
        })), se && se.save()) : ie !== ne && ie >= 0 && (z({
          sortable: this,
          name: "update",
          toEl: K,
          originalEvent: e
        }), z({
          sortable: this,
          name: "sort",
          toEl: K,
          originalEvent: e
        })), Ne.active && (null != ie && -1 !== ie || (ie = ne, oe = re), z({
          sortable: this,
          name: "end",
          toEl: K,
          originalEvent: e
        }), this.save()))), this._nulling());
      },
      _nulling: function _nulling() {
        X("nulling", this), Z = V = K = Q = G = ee = J = te = le = ce = ue = ie = oe = ne = re = de = pe = se = ae = Ne.dragged = Ne.ghost = Ne.clone = Ne.active = null, xe.forEach(function (e) {
          e.checked = !0;
        }), xe.length = 0;
      },
      handleEvent: function handleEvent(e) {
        switch (e.type) {
          case "drop":
          case "dragend":
            this._onDrop(e);

            break;

          case "dragenter":
          case "dragover":
            V && (this._onDragOver(e), function (e) {
              e.dataTransfer && (e.dataTransfer.dropEffect = "move");
              e.cancelable && e.preventDefault();
            }(e));
            break;

          case "selectstart":
            e.preventDefault();
        }
      },
      toArray: function toArray() {
        for (var e, t = [], n = this.el.children, i = 0, r = n.length, o = this.options; i < r; i++) {
          w(e = n[i], o.draggable, this.el, !1) && t.push(e.getAttribute(o.dataIdAttr) || Le(e));
        }

        return t;
      },
      sort: function sort(e) {
        var t = {},
            n = this.el;
        this.toArray().forEach(function (e, i) {
          var r = n.children[i];
          w(r, this.options.draggable, n, !1) && (t[e] = r);
        }, this), e.forEach(function (e) {
          t[e] && (n.removeChild(t[e]), n.appendChild(t[e]));
        });
      },
      save: function save() {
        var e = this.options.store;
        e && e.set && e.set(this);
      },
      closest: function closest(e, t) {
        return w(e, t || this.options.draggable, this.el, !1);
      },
      option: function option(e, t) {
        var n = this.options;
        if (void 0 === t) return n[e];
        var i = U.modifyOption(this, e, t);
        n[e] = void 0 !== i ? i : t, "group" === e && Te(n);
      },
      destroy: function destroy() {
        X("destroy", this);
        var e = this.el;
        e[B] = null, b(e, "mousedown", this._onTapStart), b(e, "touchstart", this._onTapStart), b(e, "pointerdown", this._onTapStart), this.nativeDraggable && (b(e, "dragover", this), b(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function (e) {
          e.removeAttribute("draggable");
        }), this._onDrop(), ve.splice(ve.indexOf(this.el), 1), this.el = e = null;
      },
      _hideClone: function _hideClone() {
        if (!te) {
          if (X("hideClone", this), Ne.eventCanceled) return;
          D(ee, "display", "none"), this.options.removeCloneOnHide && ee.parentNode && ee.parentNode.removeChild(ee), te = !0;
        }
      },
      _showClone: function _showClone(e) {
        if ("clone" === e.lastPutMode) {
          if (te) {
            if (X("showClone", this), Ne.eventCanceled) return;
            Z.contains(V) && !this.options.group.revertClone ? Z.insertBefore(ee, V) : G ? Z.insertBefore(ee, G) : Z.appendChild(ee), this.options.group.revertClone && this._animate(V, ee), D(ee, "display", ""), te = !1;
          }
        } else this._hideClone();
      }
    }, v(document, "touchmove", function (e) {
      (Ne.active || me) && e.cancelable && e.preventDefault();
    }), Ne.utils = {
      on: v,
      off: b,
      css: D,
      find: k,
      is: function is(e, t) {
        return !!w(e, t, e, !1);
      },
      extend: function extend(e, t) {
        if (e && t) for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
        return e;
      },
      throttle: L,
      closest: w,
      toggleClass: S,
      clone: H,
      index: N,
      nextTick: Re,
      cancelNextTick: He,
      detectDirection: ke,
      getChild: A
    }, Ne.mount = function () {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      t[0].constructor === Array && (t = t[0]), t.forEach(function (e) {
        if (!e.prototype || !e.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(el));
        e.utils && (Ne.utils = s({}, Ne.utils, e.utils)), U.mount(e);
      });
    }, Ne.create = function (e, t) {
      return new Ne(e, t);
    }, Ne.version = "1.10.0-rc3";
    var Be,
        qe,
        $e,
        We,
        Ue,
        Ye,
        Xe = [],
        ze = !1;

    function Ve() {
      Xe.forEach(function (e) {
        clearInterval(e.pid);
      }), Xe = [];
    }

    function Ke() {
      clearInterval(Ye);
    }

    var Qe = L(function (e, t, n, i) {
      if (t.scroll) {
        var r,
            o = t.scrollSensitivity,
            a = t.scrollSpeed,
            s = T(),
            l = !1;
        qe !== n && (qe = n, Ve(), Be = t.scroll, r = t.scrollFn, !0 === Be && (Be = F(n, !0)));
        var c = 0,
            u = Be;

        do {
          var d = u,
              p = O(d),
              h = p.top,
              f = p.bottom,
              m = p.left,
              g = p.right,
              v = p.width,
              b = p.height,
              y = void 0,
              _ = void 0,
              w = d.scrollWidth,
              x = d.scrollHeight,
              C = D(d),
              S = d.scrollLeft,
              E = d.scrollTop;

          d === s ? (y = v < w && ("auto" === C.overflowX || "scroll" === C.overflowX || "visible" === C.overflowX), _ = b < x && ("auto" === C.overflowY || "scroll" === C.overflowY || "visible" === C.overflowY)) : (y = v < w && ("auto" === C.overflowX || "scroll" === C.overflowX), _ = b < x && ("auto" === C.overflowY || "scroll" === C.overflowY));

          var k = y && (Math.abs(g - e.clientX) <= o && S + v < w) - (Math.abs(m - e.clientX) <= o && !!S),
              P = _ && (Math.abs(f - e.clientY) <= o && E + b < x) - (Math.abs(h - e.clientY) <= o && !!E);

          if (!Xe[c]) for (var A = 0; A <= c; A++) {
            Xe[A] || (Xe[A] = {});
          }
          Xe[c].vx == k && Xe[c].vy == P && Xe[c].el === d || (Xe[c].el = d, Xe[c].vx = k, Xe[c].vy = P, clearInterval(Xe[c].pid), 0 == k && 0 == P || (l = !0, Xe[c].pid = setInterval(function () {
            i && 0 === this.layer && Ne.active._onTouchMove(Ue);
            var t = Xe[this.layer].vy ? Xe[this.layer].vy * a : 0,
                n = Xe[this.layer].vx ? Xe[this.layer].vx * a : 0;
            "function" == typeof r && "continue" !== r.call(Ne.dragged.parentNode[B], n, t, e, Ue, Xe[this.layer].el) || R(Xe[this.layer].el, n, t);
          }.bind({
            layer: c
          }), 24))), c++;
        } while (t.bubbleScroll && u !== s && (u = F(u, !1)));

        ze = l;
      }
    }, 30),
        Ze = function Ze(e) {
      var t = e.originalEvent,
          n = e.putSortable,
          i = e.dragEl,
          r = e.activeSortable,
          o = e.dispatchSortableEvent,
          a = e.hideGhostForTarget,
          s = e.unhideGhostForTarget,
          l = n || r;
      a();
      var c = document.elementFromPoint(t.clientX, t.clientY);
      s(), l && !l.el.contains(c) && (o("spill"), this.onSpill(i));
    };

    function Ge() {}

    function Je() {}

    Ge.prototype = {
      startIndex: null,
      dragStart: function dragStart(e) {
        var t = e.oldDraggableIndex;
        this.startIndex = t;
      },
      onSpill: function onSpill(e) {
        this.sortable.captureAnimationState();
        var t = A(this.sortable.el, this.startIndex, this.sortable.options);
        t ? this.sortable.el.insertBefore(e, t) : this.sortable.el.appendChild(e), this.sortable.animateAll();
      },
      drop: Ze
    }, a(Ge, {
      pluginName: "revertOnSpill"
    }), Je.prototype = {
      onSpill: function onSpill(e) {
        this.sortable.captureAnimationState(), e.parentNode && e.parentNode.removeChild(e), this.sortable.animateAll();
      },
      drop: Ze
    }, a(Je, {
      pluginName: "removeOnSpill"
    });
    Ne.mount(new function () {
      function e() {
        for (var e in this.options = {
          scroll: !0,
          scrollSensitivity: 30,
          scrollSpeed: 10,
          bubbleScroll: !0
        }, this) {
          "_" === e.charAt(0) && "function" == typeof this[e] && (this[e] = this[e].bind(this));
        }
      }

      return e.prototype = {
        dragStarted: function dragStarted(e) {
          var t = e.originalEvent;
          this.sortable.nativeDraggable ? v(document, "dragover", this._handleAutoScroll) : this.sortable.options.supportPointer ? v(document, "pointermove", this._handleFallbackAutoScroll) : t.touches ? v(document, "touchmove", this._handleFallbackAutoScroll) : v(document, "mousemove", this._handleFallbackAutoScroll);
        },
        dragOverCompleted: function dragOverCompleted(e) {
          var t = e.originalEvent;
          this.sortable.options.dragOverBubble || t.rootEl || this._handleAutoScroll(t);
        },
        drop: function drop() {
          this.sortable.nativeDraggable ? b(document, "dragover", this._handleAutoScroll) : (b(document, "pointermove", this._handleFallbackAutoScroll), b(document, "touchmove", this._handleFallbackAutoScroll), b(document, "mousemove", this._handleFallbackAutoScroll)), Ke(), Ve(), clearTimeout(x), x = void 0;
        },
        nulling: function nulling() {
          Ue = qe = Be = ze = Ye = $e = We = null, Xe.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(e) {
          this._handleAutoScroll(e, !0);
        },
        _handleAutoScroll: function _handleAutoScroll(e, t) {
          var n = this,
              i = e.clientX,
              r = e.clientY,
              o = document.elementFromPoint(i, r);

          if (Ue = e, t || d || u || h) {
            Qe(e, this.options, o, t);
            var a = F(o, !0);
            !ze || Ye && i === $e && r === We || (Ye && Ke(), Ye = setInterval(function () {
              var o = F(document.elementFromPoint(i, r), !0);
              o !== a && (a = o, Ve()), Qe(e, n.options, o, t);
            }, 10), $e = i, We = r);
          } else {
            if (!this.sortable.options.bubbleScroll || F(o, !0) === T()) return void Ve();
            Qe(e, this.options, F(o, !1), !1);
          }
        }
      }, a(e, {
        pluginName: "scroll",
        initializeByDefault: !0
      });
    }()), Ne.mount(Je, Ge);
    var et = Ne;

    function tt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function nt(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function it(e) {
      return (it = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function rt(e, t) {
      return (rt = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.d(t, "default", function () {
      return ot;
    });

    var ot = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), nt(this, it(t).apply(this, arguments));
      }

      var n, r, o;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && rt(e, t);
      }(t, i["b"]), n = t, (r = [{
        key: "connect",
        value: function value() {
          var _this9 = this;

          new et(this.itemsTarget, {
            animation: 150,
            draggable: ".sortable_association__item",
            ghostClass: "sortable_association__item--ghost",
            handle: ".sortable_association__handle",
            onUpdate: function onUpdate(e) {
              _this9._updateItemOrder();
            }
          });
        }
      }, {
        key: "_updateItemOrder",
        value: function value() {
          var _this10 = this;

          var e = this.itemTargets.map(function (e) {
            return e.dataset.id;
          });
          var t = [];

          var _loop = function _loop(_n3) {
            var i = e[_n3],
                r = _toConsumableArray(_this10.options).filter(function (e) {
              return e.value === i;
            })[0];

            t.push(r);
          };

          for (var _n3 in e) {
            _loop(_n3);
          }

          this.selectTarget.innerHTML = "";

          for (var _e6 in t) {
            this.selectTarget.appendChild(t[_e6]);
          }
        }
      }, {
        key: "options",
        get: function get() {
          return this.selectTarget.querySelectorAll("option");
        }
      }]) && tt(n.prototype, r), o && tt(n, o), t;
    }();

    var at, st, lt;
    lt = ["item", "items", "select"], (st = "targets") in (at = ot) ? Object.defineProperty(at, st, {
      value: lt,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : at[st] = lt;
  }]);
});